//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import {immerable} from "immer"

export class AdminClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listAccounts(email: string | null | undefined, maxEntries: number | null | undefined, cancelToken?: CancelToken): Promise<UserAccount[]> {
        let url_ = this.baseUrl + "/api/Admin/list-accounts?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (maxEntries !== undefined && maxEntries !== null)
            url_ += "MaxEntries=" + encodeURIComponent("" + maxEntries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAccounts(_response);
        });
    }

    protected processListAccounts(response: AxiosResponse): Promise<UserAccount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAccount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserAccount[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAccount[]>(null as any);
    }

    createCompany(payload: CreateCompanyWithOwnerPayload, cancelToken?: CancelToken): Promise<CreateCompanyWithOwnerResult> {
        let url_ = this.baseUrl + "/api/Admin/create-company-with-owner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompany(_response);
        });
    }

    protected processCreateCompany(response: AxiosResponse): Promise<CreateCompanyWithOwnerResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateCompanyWithOwnerResult.fromJS(resultData200);
            return Promise.resolve<CreateCompanyWithOwnerResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateCompanyWithOwnerResult>(null as any);
    }

    changeAccountEmail(payload: AdminChangeEmailPayload, cancelToken?: CancelToken): Promise<AdminChangeEmailResultType> {
        let url_ = this.baseUrl + "/api/Admin/change-account-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeAccountEmail(_response);
        });
    }

    protected processChangeAccountEmail(response: AxiosResponse): Promise<AdminChangeEmailResultType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<AdminChangeEmailResultType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminChangeEmailResultType>(null as any);
    }

    startImpersonation(payload: StartImpersonationPayload, cancelToken?: CancelToken): Promise<StartImpersonationResult> {
        let url_ = this.baseUrl + "/api/Admin/start-impersonation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartImpersonation(_response);
        });
    }

    protected processStartImpersonation(response: AxiosResponse): Promise<StartImpersonationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StartImpersonationResult.fromJS(resultData200);
            return Promise.resolve<StartImpersonationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StartImpersonationResult>(null as any);
    }

    listCompanies( cancelToken?: CancelToken): Promise<ManagementCompanyDetails[]> {
        let url_ = this.baseUrl + "/api/Admin/list-companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCompanies(_response);
        });
    }

    protected processListCompanies(response: AxiosResponse): Promise<ManagementCompanyDetails[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ManagementCompanyDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ManagementCompanyDetails[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManagementCompanyDetails[]>(null as any);
    }

    deleteCompany(companyId: string | undefined, confirmation: string | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Admin/delete-company?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (confirmation !== undefined && confirmation !== null)
            url_ += "confirmation=" + encodeURIComponent("" + confirmation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompany(_response);
        });
    }

    protected processDeleteCompany(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getIssueIdFromNumber(identifier: string | null | undefined, cancelToken?: CancelToken): Promise<GetIssueIdFromNumberResult> {
        let url_ = this.baseUrl + "/api/Admin/get-issue-id?";
        if (identifier !== undefined && identifier !== null)
            url_ += "identifier=" + encodeURIComponent("" + identifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueIdFromNumber(_response);
        });
    }

    protected processGetIssueIdFromNumber(response: AxiosResponse): Promise<GetIssueIdFromNumberResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueIdFromNumberResult.fromJS(resultData200);
            return Promise.resolve<GetIssueIdFromNumberResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueIdFromNumberResult>(null as any);
    }

    toggleUserEnabled(payload: ToggleUserEnabledPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Admin/toggle-user-enabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleUserEnabled(_response);
        });
    }

    protected processToggleUserEnabled(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    toggleVendorIsGc(payload: ToggleVendorIsGcPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Admin/toggle-vendor-is-gc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleVendorIsGc(_response);
        });
    }

    protected processToggleVendorIsGc(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    listSoftwareClients( cancelToken?: CancelToken): Promise<SoftwareClientDetails[]> {
        let url_ = this.baseUrl + "/api/Admin/list-software-clients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSoftwareClients(_response);
        });
    }

    protected processListSoftwareClients(response: AxiosResponse): Promise<SoftwareClientDetails[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SoftwareClientDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SoftwareClientDetails[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SoftwareClientDetails[]>(null as any);
    }

    listVendors( cancelToken?: CancelToken): Promise<AdminVendorView[]> {
        let url_ = this.baseUrl + "/api/Admin/list-vendors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListVendors(_response);
        });
    }

    protected processListVendors(response: AxiosResponse): Promise<AdminVendorView[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminVendorView.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AdminVendorView[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminVendorView[]>(null as any);
    }
}

export class AuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    logIn(payload: LogInPayload, cancelToken?: CancelToken): Promise<LogInResponse> {
        let url_ = this.baseUrl + "/api/Auth/log-in";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogIn(_response);
        });
    }

    protected processLogIn(response: AxiosResponse): Promise<LogInResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LogInResponse.fromJS(resultData200);
            return Promise.resolve<LogInResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LogInResponse>(null as any);
    }

    checkPassword(password: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Auth/check-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(password);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckPassword(_response);
        });
    }

    protected processCheckPassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    logInImplicit(payload: LogInImplicitPayload, cancelToken?: CancelToken): Promise<LogInResponse> {
        let url_ = this.baseUrl + "/api/Auth/log-in-implicit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogInImplicit(_response);
        });
    }

    protected processLogInImplicit(response: AxiosResponse): Promise<LogInResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LogInResponse.fromJS(resultData200);
            return Promise.resolve<LogInResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LogInResponse>(null as any);
    }

    logInSso(payload: LogInSsoPayload, cancelToken?: CancelToken): Promise<LogInResponse> {
        let url_ = this.baseUrl + "/api/Auth/log-in-sso";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogInSso(_response);
        });
    }

    protected processLogInSso(response: AxiosResponse): Promise<LogInResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LogInResponse.fromJS(resultData200);
            return Promise.resolve<LogInResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LogInResponse>(null as any);
    }

    logInTwoFactor(payload: LogInTwoFactorPayload, cancelToken?: CancelToken): Promise<LogInResponse> {
        let url_ = this.baseUrl + "/api/Auth/log-in-two-factor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogInTwoFactor(_response);
        });
    }

    protected processLogInTwoFactor(response: AxiosResponse): Promise<LogInResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LogInResponse.fromJS(resultData200);
            return Promise.resolve<LogInResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LogInResponse>(null as any);
    }

    startSession(payload: StartSessionPayload, cancelToken?: CancelToken): Promise<StartSessionResult> {
        let url_ = this.baseUrl + "/api/Auth/start-session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartSession(_response);
        });
    }

    protected processStartSession(response: AxiosResponse): Promise<StartSessionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StartSessionResult.fromJS(resultData200);
            return Promise.resolve<StartSessionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StartSessionResult>(null as any);
    }

    register(payload: CreateCompanyWithOwnerPayload, cancelToken?: CancelToken): Promise<CreateCompanyWithResponseWithAuth> {
        let url_ = this.baseUrl + "/api/Auth/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<CreateCompanyWithResponseWithAuth> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateCompanyWithResponseWithAuth.fromJS(resultData200);
            return Promise.resolve<CreateCompanyWithResponseWithAuth>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateCompanyWithResponseWithAuth>(null as any);
    }

    requestPasswordReset(payload: RequestPasswordResetPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/request-password-reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestPasswordReset(_response);
        });
    }

    protected processRequestPasswordReset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resetPassword(payload: ResetPasswordPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getThemeFromSso(sso: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Auth/get-theme-from-sso?";
        if (sso !== undefined && sso !== null)
            url_ += "sso=" + encodeURIComponent("" + sso) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetThemeFromSso(_response);
        });
    }

    protected processGetThemeFromSso(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getCurrentUser( cancelToken?: CancelToken): Promise<string | null> {
        let url_ = this.baseUrl + "/api/Auth/get-current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    requestMagicLink(payload: RequestMagicLinkPayload, cancelToken?: CancelToken): Promise<RequestMagicLinkResult> {
        let url_ = this.baseUrl + "/api/Auth/request-magic-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestMagicLink(_response);
        });
    }

    protected processRequestMagicLink(response: AxiosResponse): Promise<RequestMagicLinkResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<RequestMagicLinkResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestMagicLinkResult>(null as any);
    }

    validateAuthToken(payload: ValidateAuthTokenPayload, cancelToken?: CancelToken): Promise<ValidateAuthTokenResult> {
        let url_ = this.baseUrl + "/api/Auth/validate-auth-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateAuthToken(_response);
        });
    }

    protected processValidateAuthToken(response: AxiosResponse): Promise<ValidateAuthTokenResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateAuthTokenResult.fromJS(resultData200);
            return Promise.resolve<ValidateAuthTokenResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateAuthTokenResult>(null as any);
    }
}

export class CommissionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCommissionReport(payload: GetCommissionReportPayload, cancelToken?: CancelToken): Promise<CommissionIssueEntry[]> {
        let url_ = this.baseUrl + "/api/Commissions/get-commission-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommissionReport(_response);
        });
    }

    protected processGetCommissionReport(response: AxiosResponse): Promise<CommissionIssueEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommissionIssueEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CommissionIssueEntry[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommissionIssueEntry[]>(null as any);
    }

    markCommissionPayment(payload: MarkCommissionPaymentPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Commissions/mark-commission-payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkCommissionPayment(_response);
        });
    }

    protected processMarkCommissionPayment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DashboardClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPMChart(payload: GetIssueStatsByPMPayload, cancelToken?: CancelToken): Promise<PMChartData[]> {
        let url_ = this.baseUrl + "/api/Dashboard/get-pm-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPMChart(_response);
        });
    }

    protected processGetPMChart(response: AxiosResponse): Promise<PMChartData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PMChartData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PMChartData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PMChartData[]>(null as any);
    }

    getPMChartDrillDown(payload: GetIssueStatsByPMPayload, cancelToken?: CancelToken): Promise<PMChartData[]> {
        let url_ = this.baseUrl + "/api/Dashboard/get-pm-chart-drilldown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPMChartDrillDown(_response);
        });
    }

    protected processGetPMChartDrillDown(response: AxiosResponse): Promise<PMChartData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PMChartData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PMChartData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PMChartData[]>(null as any);
    }

    vendorsWithOpenIssues(payload: GetIssueStatusByVendorPayload, cancelToken?: CancelToken): Promise<VendorCountInfo[]> {
        let url_ = this.baseUrl + "/api/Dashboard/vendors-with-open-issues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVendorsWithOpenIssues(_response);
        });
    }

    protected processVendorsWithOpenIssues(response: AxiosResponse): Promise<VendorCountInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorCountInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VendorCountInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorCountInfo[]>(null as any);
    }

    vendorsWithOpenIssuesDrillDown(vendorId: string | undefined, cancelToken?: CancelToken): Promise<VendorCountInfoDrillDown[]> {
        let url_ = this.baseUrl + "/api/Dashboard/vendors-with-open-issues-drilldown?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVendorsWithOpenIssuesDrillDown(_response);
        });
    }

    protected processVendorsWithOpenIssuesDrillDown(response: AxiosResponse): Promise<VendorCountInfoDrillDown[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorCountInfoDrillDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VendorCountInfoDrillDown[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorCountInfoDrillDown[]>(null as any);
    }

    searchScheduledIssues(criteria: SearchScheduledIssueCriteria, cancelToken?: CancelToken): Promise<Issue[]> {
        let url_ = this.baseUrl + "/api/Dashboard/search-scheduled-issues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchScheduledIssues(_response);
        });
    }

    protected processSearchScheduledIssues(response: AxiosResponse): Promise<Issue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Issue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Issue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Issue[]>(null as any);
    }
}

export class FixupsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    recreateEstimatePdf(estimateId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Fixups/recreate-estimate-pdf?";
        if (estimateId === null)
            throw new Error("The parameter 'estimateId' cannot be null.");
        else if (estimateId !== undefined)
            url_ += "estimateId=" + encodeURIComponent("" + estimateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecreateEstimatePdf(_response);
        });
    }

    protected processRecreateEstimatePdf(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    recreateBidPdf(bidId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Fixups/recreate-bid-pdf?";
        if (bidId === null)
            throw new Error("The parameter 'bidId' cannot be null.");
        else if (bidId !== undefined)
            url_ += "bidId=" + encodeURIComponent("" + bidId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecreateBidPdf(_response);
        });
    }

    protected processRecreateBidPdf(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    recreateInvoicePdf(invoiceId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Fixups/recreate-invoice-pdf?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecreateInvoicePdf(_response);
        });
    }

    protected processRecreateInvoicePdf(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveInspectionPdfLinks( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Fixups/save-inspection-pdf-links";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveInspectionPdfLinks(_response);
        });
    }

    protected processSaveInspectionPdfLinks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createMissingChangeRequestPdfs( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Fixups/recreate-missing-change-request-pdfs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMissingChangeRequestPdfs(_response);
        });
    }

    protected processCreateMissingChangeRequestPdfs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    fixLargePdfs( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Fixups/fix-large-pdfs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFixLargePdfs(_response);
        });
    }

    protected processFixLargePdfs(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UselessClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getForcedIncludes( cancelToken?: CancelToken): Promise<ForcedIncludes> {
        let url_ = this.baseUrl + "/api/Useless";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForcedIncludes(_response);
        });
    }

    protected processGetForcedIncludes(response: AxiosResponse): Promise<ForcedIncludes> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForcedIncludes.fromJS(resultData200);
            return Promise.resolve<ForcedIncludes>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForcedIncludes>(null as any);
    }
}

export class FeedbackClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createFeedback(payload: CreateFeedbackPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Feedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFeedback(_response);
        });
    }

    protected processCreateFeedback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FilesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    deleteFile(fileId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Files/delete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getForEntity(entityType: AttachmentEntityType | undefined, entityId: string | undefined, cancelToken?: CancelToken): Promise<EntityAttachment[]> {
        let url_ = this.baseUrl + "/Files/get-for-entity?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEntity(_response);
        });
    }

    protected processGetForEntity(response: AxiosResponse): Promise<EntityAttachment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityAttachment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EntityAttachment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityAttachment[]>(null as any);
    }

    getForGallery(entityType: AttachmentEntityType | undefined, entityId: string | undefined, cancelToken?: CancelToken): Promise<GalleryFile[]> {
        let url_ = this.baseUrl + "/Files/get-for-gallery?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForGallery(_response);
        });
    }

    protected processGetForGallery(response: AxiosResponse): Promise<GalleryFile[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GalleryFile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GalleryFile[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GalleryFile[]>(null as any);
    }
}

export class FlagsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getForEntity(payload: GetFlagPayload, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Flags/get-for-entity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEntity(_response);
        });
    }

    protected processGetForEntity(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    set(payload: SetFlagPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Flags/set";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSet(_response);
        });
    }

    protected processSet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class GeneralContractorsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    attachClient(payload: AttachContractorClientPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/GeneralContractors/attach-client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAttachClient(_response);
        });
    }

    protected processAttachClient(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createClient(payload: CreateContractorClientPayload, cancelToken?: CancelToken): Promise<CreateContractorClientResponse> {
        let url_ = this.baseUrl + "/api/GeneralContractors/create-client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateClient(_response);
        });
    }

    protected processCreateClient(response: AxiosResponse): Promise<CreateContractorClientResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateContractorClientResponse.fromJS(resultData200);
            return Promise.resolve<CreateContractorClientResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateContractorClientResponse>(null as any);
    }

    getClientContacts(managementCompanyId: string | undefined, cancelToken?: CancelToken): Promise<ClientContact[]> {
        let url_ = this.baseUrl + "/api/GeneralContractors/get-client-contacts?";
        if (managementCompanyId === null)
            throw new Error("The parameter 'managementCompanyId' cannot be null.");
        else if (managementCompanyId !== undefined)
            url_ += "managementCompanyId=" + encodeURIComponent("" + managementCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientContacts(_response);
        });
    }

    protected processGetClientContacts(response: AxiosResponse): Promise<ClientContact[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientContact.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClientContact[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientContact[]>(null as any);
    }

    addClientContact(payload: AddClientContactPayload, cancelToken?: CancelToken): Promise<AddClientContactResult> {
        let url_ = this.baseUrl + "/api/GeneralContractors/add-client-contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddClientContact(_response);
        });
    }

    protected processAddClientContact(response: AxiosResponse): Promise<AddClientContactResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddClientContactResult.fromJS(resultData200);
            return Promise.resolve<AddClientContactResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddClientContactResult>(null as any);
    }

    getClients(filters: GetClientsFilters, cancelToken?: CancelToken): Promise<VendorClientModel[]> {
        let url_ = this.baseUrl + "/api/GeneralContractors/get-clients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClients(_response);
        });
    }

    protected processGetClients(response: AxiosResponse): Promise<VendorClientModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorClientModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VendorClientModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorClientModel[]>(null as any);
    }

    setContactDesignation(payload: SetContactDesignationPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/GeneralContractors/set-client-designation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetContactDesignation(_response);
        });
    }

    protected processSetContactDesignation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getAvailableDesignations( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/GeneralContractors/get-available-designations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableDesignations(_response);
        });
    }

    protected processGetAvailableDesignations(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getClientConfiguration(companyId: string | undefined, cancelToken?: CancelToken): Promise<VendorClientConfiguration> {
        let url_ = this.baseUrl + "/api/GeneralContractors/get-client-configuration?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientConfiguration(_response);
        });
    }

    protected processGetClientConfiguration(response: AxiosResponse): Promise<VendorClientConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VendorClientConfiguration.fromJS(resultData200);
            return Promise.resolve<VendorClientConfiguration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorClientConfiguration>(null as any);
    }

    setClientConfiguration(payload: SetClientConfigurationPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/GeneralContractors/set-client-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetClientConfiguration(_response);
        });
    }

    protected processSetClientConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getContractorCanManageCompany(payload: ContractorCanManageCompanyPayload, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/GeneralContractors/get-can-manage-company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractorCanManageCompany(_response);
        });
    }

    protected processGetContractorCanManageCompany(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getClientIssueNotice(clientId: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/GeneralContractors/get-client-issue-notice?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientIssueNotice(_response);
        });
    }

    protected processGetClientIssueNotice(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    setClientIssueNotice(payload: SetIssueNoticePayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/GeneralContractors/set-client-issue-notice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetClientIssueNotice(_response);
        });
    }

    protected processSetClientIssueNotice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class InspectionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listInspections( cancelToken?: CancelToken): Promise<InspectionSummary[]> {
        let url_ = this.baseUrl + "/api/Inspections/list-inspections";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListInspections(_response);
        });
    }

    protected processListInspections(response: AxiosResponse): Promise<InspectionSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InspectionSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionSummary[]>(null as any);
    }

    createWorkorder(payload: CreateWorkorderFromInspectionPayload, cancelToken?: CancelToken): Promise<CreateWorkorderFromInspectionResult> {
        let url_ = this.baseUrl + "/api/Inspections/create-workorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateWorkorder(_response);
        });
    }

    protected processCreateWorkorder(response: AxiosResponse): Promise<CreateWorkorderFromInspectionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateWorkorderFromInspectionResult.fromJS(resultData200);
            return Promise.resolve<CreateWorkorderFromInspectionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateWorkorderFromInspectionResult>(null as any);
    }

    getDetails(id: string | undefined, cancelToken?: CancelToken): Promise<InspectionDetails> {
        let url_ = this.baseUrl + "/api/Inspections/get-details?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<InspectionDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InspectionDetails.fromJS(resultData200);
            return Promise.resolve<InspectionDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionDetails>(null as any);
    }

    getUserView(id: string | undefined, cancelToken?: CancelToken): Promise<InspectionUserView> {
        let url_ = this.baseUrl + "/api/Inspections/get-user-view?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserView(_response);
        });
    }

    protected processGetUserView(response: AxiosResponse): Promise<InspectionUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InspectionUserView.fromJS(resultData200);
            return Promise.resolve<InspectionUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionUserView>(null as any);
    }

    createInspection(payload: CreateInspectionPayload, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Inspections/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInspection(_response);
        });
    }

    protected processCreateInspection(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateInspectionDocument(payload: UpdateInspectionDocumentPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/update-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInspectionDocument(_response);
        });
    }

    protected processUpdateInspectionDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    acceptInspection(payload: AcceptInspectionPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/accept-inspection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptInspection(_response);
        });
    }

    protected processAcceptInspection(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    reassignInspection(payload: ReassignInspectionPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/reassign-inspection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReassignInspection(_response);
        });
    }

    protected processReassignInspection(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    declineInspection(payload: DeclineInspectionPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/decline-inspection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeclineInspection(_response);
        });
    }

    protected processDeclineInspection(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    completeInspection(payload: CompleteInspectionPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/complete-inspection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteInspection(_response);
        });
    }

    protected processCompleteInspection(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getRecipients(inspectionId: string | undefined, cancelToken?: CancelToken): Promise<InspectionRecipient[]> {
        let url_ = this.baseUrl + "/api/Inspections/get-recipients?";
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecipients(_response);
        });
    }

    protected processGetRecipients(response: AxiosResponse): Promise<InspectionRecipient[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionRecipient.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InspectionRecipient[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionRecipient[]>(null as any);
    }

    createRecipient(payload: CreateInspectionExtraRecipientPayload, cancelToken?: CancelToken): Promise<CreateInspectionExtraRecipientStatus> {
        let url_ = this.baseUrl + "/api/Inspections/create-recipient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRecipient(_response);
        });
    }

    protected processCreateRecipient(response: AxiosResponse): Promise<CreateInspectionExtraRecipientStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<CreateInspectionExtraRecipientStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateInspectionExtraRecipientStatus>(null as any);
    }

    deleteRecipient(payload: DeleteInspectionExtraRecipientPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/delete-recipient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRecipient(_response);
        });
    }

    protected processDeleteRecipient(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    sendReports(payload: SendInspectionReportsPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Inspections/send-reports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendReports(_response);
        });
    }

    protected processSendReports(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getTemplate( cancelToken?: CancelToken): Promise<InsTemplateEnvelope> {
        let url_ = this.baseUrl + "/api/Inspections/get-template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplate(_response);
        });
    }

    protected processGetTemplate(response: AxiosResponse): Promise<InsTemplateEnvelope> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsTemplateEnvelope.fromJS(resultData200);
            return Promise.resolve<InsTemplateEnvelope>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsTemplateEnvelope>(null as any);
    }
}

export class LookupClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAll( cancelToken?: CancelToken): Promise<LookupContainer> {
        let url_ = this.baseUrl + "/api/Lookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<LookupContainer> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LookupContainer.fromJS(resultData200);
            return Promise.resolve<LookupContainer>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LookupContainer>(null as any);
    }
}

export class ManagementCompaniesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(id: string, cancelToken?: CancelToken): Promise<ManagementCompany> {
        let url_ = this.baseUrl + "/api/ManagementCompanies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ManagementCompany> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ManagementCompany.fromJS(resultData200);
            return Promise.resolve<ManagementCompany>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManagementCompany>(null as any);
    }

    updateContactInfo(payload: UpdateCompanyContactInfoPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ManagementCompanies/update-contact-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContactInfo(_response);
        });
    }

    protected processUpdateContactInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateAddress(payload: UpdateCompanyAddressPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ManagementCompanies/update-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAddress(_response);
        });
    }

    protected processUpdateAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateTenantCopySettings(payload: UpdateCompanyTenantCopyPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ManagementCompanies/update-tenant-copy-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTenantCopySettings(_response);
        });
    }

    protected processUpdateTenantCopySettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateMiscSettings(payload: UpdateCompanyMiscSettingsPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ManagementCompanies/update-misc-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMiscSettings(_response);
        });
    }

    protected processUpdateMiscSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MessagesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getIssueConversations(issueId: string | undefined, cancelToken?: CancelToken): Promise<IssueContact[]> {
        let url_ = this.baseUrl + "/api/Messages/get-issue-conversations?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueConversations(_response);
        });
    }

    protected processGetIssueConversations(response: AxiosResponse): Promise<IssueContact[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IssueContact.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IssueContact[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueContact[]>(null as any);
    }

    getMessages(payload: FindLatestMessagesPayload, cancelToken?: CancelToken): Promise<MessageList> {
        let url_ = this.baseUrl + "/api/Messages/find-latest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessages(_response);
        });
    }

    protected processGetMessages(response: AxiosResponse): Promise<MessageList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageList.fromJS(resultData200);
            return Promise.resolve<MessageList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageList>(null as any);
    }

    markAsRead(payload: MarkMessagesReadPayload, cancelToken?: CancelToken): Promise<Receipt[]> {
        let url_ = this.baseUrl + "/api/Messages/mark-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAsRead(_response);
        });
    }

    protected processMarkAsRead(response: AxiosResponse): Promise<Receipt[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Receipt.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Receipt[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Receipt[]>(null as any);
    }

    addMessage(payload: AddIssueMessagePayload, cancelToken?: CancelToken): Promise<MessageList> {
        let url_ = this.baseUrl + "/api/Messages/add-message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMessage(_response);
        });
    }

    protected processAddMessage(response: AxiosResponse): Promise<MessageList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageList.fromJS(resultData200);
            return Promise.resolve<MessageList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageList>(null as any);
    }

    getFromActivityLog(activityId: string | undefined, cancelToken?: CancelToken): Promise<MessageDetail> {
        let url_ = this.baseUrl + "/api/Messages/get-from-activity?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFromActivityLog(_response);
        });
    }

    protected processGetFromActivityLog(response: AxiosResponse): Promise<MessageDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageDetail.fromJS(resultData200);
            return Promise.resolve<MessageDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageDetail>(null as any);
    }
}

export class NotesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getForEntity(payload: GetNotePayload, cancelToken?: CancelToken): Promise<EntityNote[]> {
        let url_ = this.baseUrl + "/api/Notes/get-for-entity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEntity(_response);
        });
    }

    protected processGetForEntity(response: AxiosResponse): Promise<EntityNote[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityNote.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EntityNote[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote[]>(null as any);
    }

    getForEntities(payload: GetNotePayload[], cancelToken?: CancelToken): Promise<EntityNote[]> {
        let url_ = this.baseUrl + "/api/Notes/get-for-entities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEntities(_response);
        });
    }

    protected processGetForEntities(response: AxiosResponse): Promise<EntityNote[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityNote.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EntityNote[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote[]>(null as any);
    }

    add(payload: AddNotePayload, cancelToken?: CancelToken): Promise<EntityNote> {
        let url_ = this.baseUrl + "/api/Notes/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<EntityNote> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityNote.fromJS(resultData200);
            return Promise.resolve<EntityNote>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote>(null as any);
    }

    delete(noteId: string, cancelToken?: CancelToken): Promise<EntityNote> {
        let url_ = this.baseUrl + "/api/Notes/delete/{noteId}";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<EntityNote> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityNote.fromJS(resultData200);
            return Promise.resolve<EntityNote>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote>(null as any);
    }
}

export class PropertiesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getById(id: string, cancelToken?: CancelToken): Promise<Property> {
        let url_ = this.baseUrl + "/api/Properties/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<Property> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Property.fromJS(resultData200);
            return Promise.resolve<Property>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Property>(null as any);
    }

    getAll(userId: string | undefined, cancelToken?: CancelToken): Promise<Property[]> {
        let url_ = this.baseUrl + "/api/Properties?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<Property[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Property.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Property[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Property[]>(null as any);
    }

    create(payload: CreatePropertyPayload, cancelToken?: CancelToken): Promise<CreatePropertyResult> {
        let url_ = this.baseUrl + "/api/Properties/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatePropertyResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreatePropertyResult.fromJS(resultData200);
            return Promise.resolve<CreatePropertyResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatePropertyResult>(null as any);
    }

    update(payload: UpdatePropertyPayload, cancelToken?: CancelToken): Promise<Property> {
        let url_ = this.baseUrl + "/api/Properties/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Property> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Property.fromJS(resultData200);
            return Promise.resolve<Property>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Property>(null as any);
    }

    setCoverImage(payload: SetPropertyCoverImagePayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Properties/set-cover-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCoverImage(_response);
        });
    }

    protected processSetCoverImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(payload: DeletePropertyPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Properties/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SearchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    generalSearch(searchText: string, cancelToken?: CancelToken): Promise<SearchResultsCollection> {
        let url_ = this.baseUrl + "/api/Search/general-search/{searchText}";
        if (searchText === undefined || searchText === null)
            throw new Error("The parameter 'searchText' must be defined.");
        url_ = url_.replace("{searchText}", encodeURIComponent("" + searchText));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeneralSearch(_response);
        });
    }

    protected processGeneralSearch(response: AxiosResponse): Promise<SearchResultsCollection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchResultsCollection.fromJS(resultData200);
            return Promise.resolve<SearchResultsCollection>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchResultsCollection>(null as any);
    }

    searchProperties(searchText: string | null | undefined, cancelToken?: CancelToken): Promise<PropertySummary[]> {
        let url_ = this.baseUrl + "/api/Search/search-properties?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchProperties(_response);
        });
    }

    protected processSearchProperties(response: AxiosResponse): Promise<PropertySummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertySummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PropertySummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertySummary[]>(null as any);
    }

    searchVendors(searchText: string | null | undefined, cancelToken?: CancelToken): Promise<Vendor[]> {
        let url_ = this.baseUrl + "/api/Search/search-vendors?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchVendors(_response);
        });
    }

    protected processSearchVendors(response: AxiosResponse): Promise<Vendor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vendor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Vendor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vendor[]>(null as any);
    }
}

export class ShortenedLinkClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    doRedirect(token: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/s/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoRedirect(_response);
        });
    }

    protected processDoRedirect(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserProfileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    updateBasics(payload: UpdateProfileBasicsPayload, cancelToken?: CancelToken): Promise<User> {
        let url_ = this.baseUrl + "/api/UserProfile/update-basics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBasics(_response);
        });
    }

    protected processUpdateBasics(response: AxiosResponse): Promise<User> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = User.fromJS(resultData200);
            return Promise.resolve<User>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<User>(null as any);
    }

    updateContact(payload: UpdateProfileContactInfoPayload, cancelToken?: CancelToken): Promise<User> {
        let url_ = this.baseUrl + "/api/UserProfile/update-contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContact(_response);
        });
    }

    protected processUpdateContact(response: AxiosResponse): Promise<User> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = User.fromJS(resultData200);
            return Promise.resolve<User>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<User>(null as any);
    }

    updatePassword(payload: UpdateProfilePasswordPayload, cancelToken?: CancelToken): Promise<User> {
        let url_ = this.baseUrl + "/api/UserProfile/update-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: AxiosResponse): Promise<User> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = User.fromJS(resultData200);
            return Promise.resolve<User>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<User>(null as any);
    }

    updatePreferences(payload: UpdateProfilePreferencesPayload, cancelToken?: CancelToken): Promise<User> {
        let url_ = this.baseUrl + "/api/UserProfile/update-preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePreferences(_response);
        });
    }

    protected processUpdatePreferences(response: AxiosResponse): Promise<User> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = User.fromJS(resultData200);
            return Promise.resolve<User>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<User>(null as any);
    }

    canForceChangeEmail(payload: CanForceChangeEmailPayload, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/UserProfile/can-force-change-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCanForceChangeEmail(_response);
        });
    }

    protected processCanForceChangeEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    forceChangeEmail(payload: ForceChangeEmailPayload, cancelToken?: CancelToken): Promise<ForceChangeEmailResultType> {
        let url_ = this.baseUrl + "/api/UserProfile/force-change-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForceChangeEmail(_response);
        });
    }

    protected processForceChangeEmail(response: AxiosResponse): Promise<ForceChangeEmailResultType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<ForceChangeEmailResultType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForceChangeEmailResultType>(null as any);
    }

    getDwollaCustomerInfoForVendor(vendorId: string | undefined, cancelToken?: CancelToken): Promise<DwollaCustomerInfo> {
        let url_ = this.baseUrl + "/api/UserProfile/get-dwolla-customer-info?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDwollaCustomerInfoForVendor(_response);
        });
    }

    protected processGetDwollaCustomerInfoForVendor(response: AxiosResponse): Promise<DwollaCustomerInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DwollaCustomerInfo.fromJS(resultData200);
            return Promise.resolve<DwollaCustomerInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DwollaCustomerInfo>(null as any);
    }

    addUpdateDwollaCustomer(payload: DwollaCustomerInfo, cancelToken?: CancelToken): Promise<DwollaCustomerInfo> {
        let url_ = this.baseUrl + "/api/UserProfile/add-update-dwolla-customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUpdateDwollaCustomer(_response);
        });
    }

    protected processAddUpdateDwollaCustomer(response: AxiosResponse): Promise<DwollaCustomerInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DwollaCustomerInfo.fromJS(resultData200);
            return Promise.resolve<DwollaCustomerInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DwollaCustomerInfo>(null as any);
    }

    addDwollaFundingSource(payload: DwollaFundingSourceInfo, cancelToken?: CancelToken): Promise<DwollaCustomerInfo> {
        let url_ = this.baseUrl + "/api/UserProfile/add-dwolla-funding-source";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDwollaFundingSource(_response);
        });
    }

    protected processAddDwollaFundingSource(response: AxiosResponse): Promise<DwollaCustomerInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DwollaCustomerInfo.fromJS(resultData200);
            return Promise.resolve<DwollaCustomerInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DwollaCustomerInfo>(null as any);
    }

    removeFundingSource(vendorId: string | undefined, cancelToken?: CancelToken): Promise<DwollaCustomerInfo> {
        let url_ = this.baseUrl + "/api/UserProfile/remove-dwolla-funding-source?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFundingSource(_response);
        });
    }

    protected processRemoveFundingSource(response: AxiosResponse): Promise<DwollaCustomerInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DwollaCustomerInfo.fromJS(resultData200);
            return Promise.resolve<DwollaCustomerInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DwollaCustomerInfo>(null as any);
    }

    getDwollaMasterInfo( cancelToken?: CancelToken): Promise<DwollaMasterInfo> {
        let url_ = this.baseUrl + "/api/UserProfile/get-dwolla-master-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDwollaMasterInfo(_response);
        });
    }

    protected processGetDwollaMasterInfo(response: AxiosResponse): Promise<DwollaMasterInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DwollaMasterInfo.fromJS(resultData200);
            return Promise.resolve<DwollaMasterInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DwollaMasterInfo>(null as any);
    }

    listDwollaTransfers( cancelToken?: CancelToken): Promise<DwollaTransferInfo[]> {
        let url_ = this.baseUrl + "/api/UserProfile/list-dwolla-transfers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListDwollaTransfers(_response);
        });
    }

    protected processListDwollaTransfers(response: AxiosResponse): Promise<DwollaTransferInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DwollaTransferInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DwollaTransferInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DwollaTransferInfo[]>(null as any);
    }

    simulateDwolla( cancelToken?: CancelToken): Promise<SimulationResponse> {
        let url_ = this.baseUrl + "/api/UserProfile/simulate-dwolla";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSimulateDwolla(_response);
        });
    }

    protected processSimulateDwolla(response: AxiosResponse): Promise<SimulationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SimulationResponse.fromJS(resultData200);
            return Promise.resolve<SimulationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimulationResponse>(null as any);
    }

    addToMasterBalanceIfNeeded( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/UserProfile/add-to-balance-if-needed-dwolla";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToMasterBalanceIfNeeded(_response);
        });
    }

    protected processAddToMasterBalanceIfNeeded(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    connectVendorToStripe(vendorId: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/UserProfile/connect-vendor-to-stripe?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConnectVendorToStripe(_response);
        });
    }

    protected processConnectVendorToStripe(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getStripeAccountInfoForVendor(vendorId: string | undefined, cancelToken?: CancelToken): Promise<StripeAccountInfo> {
        let url_ = this.baseUrl + "/api/UserProfile/get-stripe-account-info?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStripeAccountInfoForVendor(_response);
        });
    }

    protected processGetStripeAccountInfoForVendor(response: AxiosResponse): Promise<StripeAccountInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StripeAccountInfo.fromJS(resultData200);
            return Promise.resolve<StripeAccountInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StripeAccountInfo>(null as any);
    }
}

export class UsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDetails(id: string | undefined, cancelToken?: CancelToken): Promise<UserDetails> {
        let url_ = this.baseUrl + "/api/Users?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<UserDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDetails.fromJS(resultData200);
            return Promise.resolve<UserDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDetails>(null as any);
    }

    getManagementCompanies( cancelToken?: CancelToken): Promise<ManagementCompany[]> {
        let url_ = this.baseUrl + "/api/Users/get-management-companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManagementCompanies(_response);
        });
    }

    protected processGetManagementCompanies(response: AxiosResponse): Promise<ManagementCompany[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ManagementCompany.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ManagementCompany[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManagementCompany[]>(null as any);
    }

    getManagedCompanies( cancelToken?: CancelToken): Promise<ManagementCompany[]> {
        let url_ = this.baseUrl + "/api/Users/get-managed-companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManagedCompanies(_response);
        });
    }

    protected processGetManagedCompanies(response: AxiosResponse): Promise<ManagementCompany[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ManagementCompany.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ManagementCompany[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManagementCompany[]>(null as any);
    }

    setPassword(newPassword: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/set-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newPassword);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPassword(_response);
        });
    }

    protected processSetPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateUser(user: UpdateUserPayload, cancelToken?: CancelToken): Promise<User> {
        let url_ = this.baseUrl + "/api/Users/update-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<User> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = User.fromJS(resultData200);
            return Promise.resolve<User>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<User>(null as any);
    }

    getNotificationStatuses( cancelToken?: CancelToken): Promise<NotificationStatus[]> {
        let url_ = this.baseUrl + "/api/Users/notification-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationStatuses(_response);
        });
    }

    protected processGetNotificationStatuses(response: AxiosResponse): Promise<NotificationStatus[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NotificationStatus[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationStatus[]>(null as any);
    }

    inviteUser(payload: InviteUserPayload, cancelToken?: CancelToken): Promise<InviteUserResult> {
        let url_ = this.baseUrl + "/api/Users/invite-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInviteUser(_response);
        });
    }

    protected processInviteUser(response: AxiosResponse): Promise<InviteUserResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InviteUserResult.fromJS(resultData200);
            return Promise.resolve<InviteUserResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteUserResult>(null as any);
    }

    getManagers(managementCompanyId: string | undefined, cancelToken?: CancelToken): Promise<User[]> {
        let url_ = this.baseUrl + "/api/Users/get-managers?";
        if (managementCompanyId === null)
            throw new Error("The parameter 'managementCompanyId' cannot be null.");
        else if (managementCompanyId !== undefined)
            url_ += "managementCompanyId=" + encodeURIComponent("" + managementCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManagers(_response);
        });
    }

    protected processGetManagers(response: AxiosResponse): Promise<User[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<User[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<User[]>(null as any);
    }

    removeCapability(payload: RemoveCapabilityPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/remove-capability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCapability(_response);
        });
    }

    protected processRemoveCapability(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resendUserInvitation(payload: ResendUserInvitationPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/resend-invitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendUserInvitation(_response);
        });
    }

    protected processResendUserInvitation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    sendEmailConfirmationToken( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/send-email-confirmation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmailConfirmationToken(_response);
        });
    }

    protected processSendEmailConfirmationToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    confirmEmail(token: string | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/use-email-token?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmEmail(_response);
        });
    }

    protected processConfirmEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAccountInfo(userId: string | undefined, cancelToken?: CancelToken): Promise<DetailedAccountInfo> {
        let url_ = this.baseUrl + "/api/Users/get-account-info?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountInfo(_response);
        });
    }

    protected processGetAccountInfo(response: AxiosResponse): Promise<DetailedAccountInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DetailedAccountInfo.fromJS(resultData200);
            return Promise.resolve<DetailedAccountInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DetailedAccountInfo>(null as any);
    }

    helpPropertyManager(managementCompanyId: string | undefined, notes: string | null | undefined, file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/help-property-manager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (managementCompanyId === null || managementCompanyId === undefined)
            throw new Error("The parameter 'managementCompanyId' cannot be null.");
        else
            content_.append("ManagementCompanyId", managementCompanyId.toString());
        if (notes !== null && notes !== undefined)
            content_.append("Notes", notes.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHelpPropertyManager(_response);
        });
    }

    protected processHelpPropertyManager(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    acceptEula( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/accept-eula";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptEula(_response);
        });
    }

    protected processAcceptEula(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setUserPermissions(payload: SetUserPermissionsPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/set-user-permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetUserPermissions(_response);
        });
    }

    protected processSetUserPermissions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    listAccounts(managementCompanyId: string | undefined, cancelToken?: CancelToken): Promise<CompanyUserAccount[]> {
        let url_ = this.baseUrl + "/api/Users/pm-list-accounts?";
        if (managementCompanyId === null)
            throw new Error("The parameter 'managementCompanyId' cannot be null.");
        else if (managementCompanyId !== undefined)
            url_ += "managementCompanyId=" + encodeURIComponent("" + managementCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAccounts(_response);
        });
    }

    protected processListAccounts(response: AxiosResponse): Promise<CompanyUserAccount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyUserAccount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CompanyUserAccount[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyUserAccount[]>(null as any);
    }
}

export class VendorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(id: string, cancelToken?: CancelToken): Promise<Vendor> {
        let url_ = this.baseUrl + "/api/Vendor/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<Vendor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Vendor.fromJS(resultData200);
            return Promise.resolve<Vendor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vendor>(null as any);
    }

    create(payload: CreateVendorPayload, cancelToken?: CancelToken): Promise<Vendor> {
        let url_ = this.baseUrl + "/api/Vendor/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<Vendor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Vendor.fromJS(resultData200);
            return Promise.resolve<Vendor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vendor>(null as any);
    }

    bulkCreate(payload: BulkCreateVendorsPayload, cancelToken?: CancelToken): Promise<BulkCreateVendorResult[]> {
        let url_ = this.baseUrl + "/api/Vendor/bulk-create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkCreate(_response);
        });
    }

    protected processBulkCreate(response: AxiosResponse): Promise<BulkCreateVendorResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BulkCreateVendorResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BulkCreateVendorResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkCreateVendorResult[]>(null as any);
    }

    addMember(payload: AddVendorMemberPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Vendor/add-member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMember(_response);
        });
    }

    protected processAddMember(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeMember(payload: RemoveVendorMemberPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Vendor/remove-member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveMember(_response);
        });
    }

    protected processRemoveMember(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateMemberSettings(payload: UpdateVendorMemberSettingsPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Vendor/update-member-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberSettings(_response);
        });
    }

    protected processUpdateMemberSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getMembers(vendorId: string | undefined, cancelToken?: CancelToken): Promise<VendorMember[]> {
        let url_ = this.baseUrl + "/api/Vendor/get-members?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMembers(_response);
        });
    }

    protected processGetMembers(response: AxiosResponse): Promise<VendorMember[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorMember.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VendorMember[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorMember[]>(null as any);
    }

    vendorsForUser(userId: string | undefined, cancelToken?: CancelToken): Promise<Vendor[]> {
        let url_ = this.baseUrl + "/api/Vendor/vendors-for-user?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVendorsForUser(_response);
        });
    }

    protected processVendorsForUser(response: AxiosResponse): Promise<Vendor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vendor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Vendor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vendor[]>(null as any);
    }

    vendorPoolForUser(userId: string | undefined, cancelToken?: CancelToken): Promise<Vendor[]> {
        let url_ = this.baseUrl + "/api/Vendor/vendor-pool-for-user?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVendorPoolForUser(_response);
        });
    }

    protected processVendorPoolForUser(response: AxiosResponse): Promise<Vendor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vendor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Vendor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vendor[]>(null as any);
    }

    getPriceGuide( cancelToken?: CancelToken): Promise<PriceGuideEntry[]> {
        let url_ = this.baseUrl + "/api/Vendor/get-price-guide";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPriceGuide(_response);
        });
    }

    protected processGetPriceGuide(response: AxiosResponse): Promise<PriceGuideEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriceGuideEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PriceGuideEntry[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriceGuideEntry[]>(null as any);
    }

    updateContactInfo(payload: UpdateVendorContactInfoPayload, cancelToken?: CancelToken): Promise<Vendor> {
        let url_ = this.baseUrl + "/api/Vendor/update-contact-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContactInfo(_response);
        });
    }

    protected processUpdateContactInfo(response: AxiosResponse): Promise<Vendor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Vendor.fromJS(resultData200);
            return Promise.resolve<Vendor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vendor>(null as any);
    }

    updateAddress(payload: UpdateVendorAddressPayload, cancelToken?: CancelToken): Promise<Vendor> {
        let url_ = this.baseUrl + "/api/Vendor/update-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAddress(_response);
        });
    }

    protected processUpdateAddress(response: AxiosResponse): Promise<Vendor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Vendor.fromJS(resultData200);
            return Promise.resolve<Vendor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vendor>(null as any);
    }

    updateServices(payload: UpdateVendorServicesPayload, cancelToken?: CancelToken): Promise<Vendor> {
        let url_ = this.baseUrl + "/api/Vendor/update-services";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateServices(_response);
        });
    }

    protected processUpdateServices(response: AxiosResponse): Promise<Vendor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Vendor.fromJS(resultData200);
            return Promise.resolve<Vendor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vendor>(null as any);
    }

    updatePreferences(payload: UpdateVendorPreferencesPayload, cancelToken?: CancelToken): Promise<Vendor> {
        let url_ = this.baseUrl + "/api/Vendor/update-preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePreferences(_response);
        });
    }

    protected processUpdatePreferences(response: AxiosResponse): Promise<Vendor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Vendor.fromJS(resultData200);
            return Promise.resolve<Vendor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vendor>(null as any);
    }
}

export class WorkordersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getForUser(payload: WorkordersForUserPayload, cancelToken?: CancelToken): Promise<WorkordersForUserResult> {
        let url_ = this.baseUrl + "/api/Workorders/get-for-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForUser(_response);
        });
    }

    protected processGetForUser(response: AxiosResponse): Promise<WorkordersForUserResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkordersForUserResult.fromJS(resultData200);
            return Promise.resolve<WorkordersForUserResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkordersForUserResult>(null as any);
    }

    getDashboardStatsNew(filter: TasksForUsersFilter, cancelToken?: CancelToken): Promise<DescribedDashboardStat[]> {
        let url_ = this.baseUrl + "/api/Workorders/get-dashboard-stats-new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDashboardStatsNew(_response);
        });
    }

    protected processGetDashboardStatsNew(response: AxiosResponse): Promise<DescribedDashboardStat[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DescribedDashboardStat.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DescribedDashboardStat[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DescribedDashboardStat[]>(null as any);
    }

    getById(id: string, cancelToken?: CancelToken): Promise<Workorder> {
        let url_ = this.baseUrl + "/api/Workorders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<Workorder> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Workorder.fromJS(resultData200);
            return Promise.resolve<Workorder>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Workorder>(null as any);
    }

    create(payload: CreateWorkorderPayload, cancelToken?: CancelToken): Promise<Workorder> {
        let url_ = this.baseUrl + "/api/Workorders/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<Workorder> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Workorder.fromJS(resultData200);
            return Promise.resolve<Workorder>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Workorder>(null as any);
    }

    update(payload: UpdateWorkorderPayload, cancelToken?: CancelToken): Promise<Workorder> {
        let url_ = this.baseUrl + "/api/Workorders/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Workorder> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Workorder.fromJS(resultData200);
            return Promise.resolve<Workorder>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Workorder>(null as any);
    }

    getActivityLog(workorderId: string, cancelToken?: CancelToken): Promise<WorkorderActivityLogEntry[]> {
        let url_ = this.baseUrl + "/api/Workorders/workorder-history/{workorderId}";
        if (workorderId === undefined || workorderId === null)
            throw new Error("The parameter 'workorderId' must be defined.");
        url_ = url_.replace("{workorderId}", encodeURIComponent("" + workorderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityLog(_response);
        });
    }

    protected processGetActivityLog(response: AxiosResponse): Promise<WorkorderActivityLogEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkorderActivityLogEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WorkorderActivityLogEntry[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkorderActivityLogEntry[]>(null as any);
    }
}

export class ZillowClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getInfoForProperty(propertyId: string | undefined, cancelToken?: CancelToken): Promise<ZillowInfo> {
        let url_ = this.baseUrl + "/api/Zillow/get-info-for-property?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInfoForProperty(_response);
        });
    }

    protected processGetInfoForProperty(response: AxiosResponse): Promise<ZillowInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ZillowInfo.fromJS(resultData200);
            return Promise.resolve<ZillowInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZillowInfo>(null as any);
    }
}

export class AssignmentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    reviewDirectAssignment(payload: ReviewDirectAssignmentPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Assignments/review-direct-assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReviewDirectAssignment(_response);
        });
    }

    protected processReviewDirectAssignment(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    assignIssue(payload: AssignIssuePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Assignments/assign-issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignIssue(_response);
        });
    }

    protected processAssignIssue(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    unassignIssue(payload: UnassignIssuePayload, cancelToken?: CancelToken): Promise<CloneIssueResult> {
        let url_ = this.baseUrl + "/api/issues/Assignments/unassign-issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnassignIssue(_response);
        });
    }

    protected processUnassignIssue(response: AxiosResponse): Promise<CloneIssueResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CloneIssueResult.fromJS(resultData200);
            return Promise.resolve<CloneIssueResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloneIssueResult>(null as any);
    }

    inviteCandidates(payload: InviteVendorsPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Assignments/invite-candidates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInviteCandidates(_response);
        });
    }

    protected processInviteCandidates(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    reviewCandidateInvitation(payload: ReviewCandidateInvitationPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Assignments/review-candidate-invitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReviewCandidateInvitation(_response);
        });
    }

    protected processReviewCandidateInvitation(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }
}

export class BidsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getFormDefaults(payload: GetBidDefaultsPayload, cancelToken?: CancelToken): Promise<BidDefaultsResponse> {
        let url_ = this.baseUrl + "/api/issues/Bids/get-form-defaults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormDefaults(_response);
        });
    }

    protected processGetFormDefaults(response: AxiosResponse): Promise<BidDefaultsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BidDefaultsResponse.fromJS(resultData200);
            return Promise.resolve<BidDefaultsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BidDefaultsResponse>(null as any);
    }

    getBidComparison(issueId: string | undefined, shallow: boolean | undefined, cancelToken?: CancelToken): Promise<BidComparison> {
        let url_ = this.baseUrl + "/api/issues/Bids/bid-comparison?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        if (shallow === null)
            throw new Error("The parameter 'shallow' cannot be null.");
        else if (shallow !== undefined)
            url_ += "shallow=" + encodeURIComponent("" + shallow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBidComparison(_response);
        });
    }

    protected processGetBidComparison(response: AxiosResponse): Promise<BidComparison> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BidComparison.fromJS(resultData200);
            return Promise.resolve<BidComparison>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BidComparison>(null as any);
    }

    sendComparisonEmail(issueId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/issues/Bids/send-comparison-email?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendComparisonEmail(_response);
        });
    }

    protected processSendComparisonEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    declineBid(payload: DeclineBidPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Bids/decline-bid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeclineBid(_response);
        });
    }

    protected processDeclineBid(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    skipBidding(payload: SkipBiddingPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Bids/skip-bidding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSkipBidding(_response);
        });
    }

    protected processSkipBidding(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    uninviteBidder(payload: UninviteBidderPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Bids/uninvite-bidder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUninviteBidder(_response);
        });
    }

    protected processUninviteBidder(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    setBidSchedule(payload: SetBidSchedulePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Bids/set-bid-schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetBidSchedule(_response);
        });
    }

    protected processSetBidSchedule(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    requestBids(payload: RequestBidsPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Bids/request-bids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestBids(_response);
        });
    }

    protected processRequestBids(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    submitBid(payload: SubmitBidPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Bids/submit-bid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitBid(_response);
        });
    }

    protected processSubmitBid(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    reviewBid(payload: ReviewBidPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Bids/review-bid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReviewBid(_response);
        });
    }

    protected processReviewBid(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    setRequireScheduleBeforeBid(payload: SetRequireScheduleBeforeBidPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/issues/Bids/set-require-schedule-before-bid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetRequireScheduleBeforeBid(_response);
        });
    }

    protected processSetRequireScheduleBeforeBid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateBidSplit(payload: UpdateBidSplitPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Bids/update-bid-split";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBidSplit(_response);
        });
    }

    protected processUpdateBidSplit(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    renderSplitPdf(splitId: string | undefined, party: SplitDocumentParty | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/issues/Bids/render-split-pdf?";
        if (splitId === null)
            throw new Error("The parameter 'splitId' cannot be null.");
        else if (splitId !== undefined)
            url_ += "splitId=" + encodeURIComponent("" + splitId) + "&";
        if (party === null)
            throw new Error("The parameter 'party' cannot be null.");
        else if (party !== undefined)
            url_ += "party=" + encodeURIComponent("" + party) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderSplitPdf(_response);
        });
    }

    protected processRenderSplitPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadSplitPdf(splitId: string | undefined, party: SplitDocumentParty | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/issues/Bids/download-split-pdf?";
        if (splitId === null)
            throw new Error("The parameter 'splitId' cannot be null.");
        else if (splitId !== undefined)
            url_ += "splitId=" + encodeURIComponent("" + splitId) + "&";
        if (party === null)
            throw new Error("The parameter 'party' cannot be null.");
        else if (party !== undefined)
            url_ += "party=" + encodeURIComponent("" + party) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSplitPdf(_response);
        });
    }

    protected processDownloadSplitPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBidSplitData(estimateId: string | undefined, cancelToken?: CancelToken): Promise<GetDataForBidSplitResponse> {
        let url_ = this.baseUrl + "/api/issues/Bids/get-bid-split-data?";
        if (estimateId === null)
            throw new Error("The parameter 'estimateId' cannot be null.");
        else if (estimateId !== undefined)
            url_ += "estimateId=" + encodeURIComponent("" + estimateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBidSplitData(_response);
        });
    }

    protected processGetBidSplitData(response: AxiosResponse): Promise<GetDataForBidSplitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataForBidSplitResponse.fromJS(resultData200);
            return Promise.resolve<GetDataForBidSplitResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataForBidSplitResponse>(null as any);
    }
}

export class ChangeRequestsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getFormDefaults(payload: GetChangeRequestDefaultsPayload, cancelToken?: CancelToken): Promise<ChangeRequestDefaultsResponse> {
        let url_ = this.baseUrl + "/api/issues/ChangeRequests/get-form-defaults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormDefaults(_response);
        });
    }

    protected processGetFormDefaults(response: AxiosResponse): Promise<ChangeRequestDefaultsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeRequestDefaultsResponse.fromJS(resultData200);
            return Promise.resolve<ChangeRequestDefaultsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeRequestDefaultsResponse>(null as any);
    }

    getIncludeCandidates(issueId: string | undefined, cancelToken?: CancelToken): Promise<ChangeRequestIncludeCandidate[]> {
        let url_ = this.baseUrl + "/api/issues/ChangeRequests/get-include-candidates?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIncludeCandidates(_response);
        });
    }

    protected processGetIncludeCandidates(response: AxiosResponse): Promise<ChangeRequestIncludeCandidate[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeRequestIncludeCandidate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeRequestIncludeCandidate[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeRequestIncludeCandidate[]>(null as any);
    }

    createOrUpdateChangeRequest(payload: CreateOrUpdateChangeRequestPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/ChangeRequests/create-or-update-change-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateChangeRequest(_response);
        });
    }

    protected processCreateOrUpdateChangeRequest(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    publishChangeRequest(payload: PublishChangeRequestPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/ChangeRequests/publish-change-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishChangeRequest(_response);
        });
    }

    protected processPublishChangeRequest(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    reviewChangeRequest(payload: ReviewChangeRequestPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/ChangeRequests/review-change-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReviewChangeRequest(_response);
        });
    }

    protected processReviewChangeRequest(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    deleteChangeRequest(payload: DeleteChangeRequestPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/ChangeRequests/delete-change-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteChangeRequest(_response);
        });
    }

    protected processDeleteChangeRequest(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }
}

export class EstimatesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createOrUpdateEstimate(payload: CreateOrUpdateEstimatePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Estimates/create-or-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateEstimate(_response);
        });
    }

    protected processCreateOrUpdateEstimate(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    publishEstimate(payload: PublishEstimatePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Estimates/publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishEstimate(_response);
        });
    }

    protected processPublishEstimate(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    reviewEstimate(payload: ReviewEstimatePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Estimates/review";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReviewEstimate(_response);
        });
    }

    protected processReviewEstimate(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    skipEstimation(payload: SkipEstimationPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Estimates/skip-estimation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSkipEstimation(_response);
        });
    }

    protected processSkipEstimation(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    markEstimateSent(issueId: string | undefined, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Estimates/mark-estimate-sent?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkEstimateSent(_response);
        });
    }

    protected processMarkEstimateSent(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    markEstimateNotSent(issueId: string | undefined, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Estimates/mark-estimate-not-sent?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkEstimateNotSent(_response);
        });
    }

    protected processMarkEstimateNotSent(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    updateEstimateSplit(payload: UpdateEstimateSplitPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Estimates/update-estimate-split";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEstimateSplit(_response);
        });
    }

    protected processUpdateEstimateSplit(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    renderSplitPdf(splitId: string | undefined, party: SplitDocumentParty | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/issues/Estimates/render-split-pdf?";
        if (splitId === null)
            throw new Error("The parameter 'splitId' cannot be null.");
        else if (splitId !== undefined)
            url_ += "splitId=" + encodeURIComponent("" + splitId) + "&";
        if (party === null)
            throw new Error("The parameter 'party' cannot be null.");
        else if (party !== undefined)
            url_ += "party=" + encodeURIComponent("" + party) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderSplitPdf(_response);
        });
    }

    protected processRenderSplitPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadSplitPdf(splitId: string | undefined, party: SplitDocumentParty | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/issues/Estimates/download-split-pdf?";
        if (splitId === null)
            throw new Error("The parameter 'splitId' cannot be null.");
        else if (splitId !== undefined)
            url_ += "splitId=" + encodeURIComponent("" + splitId) + "&";
        if (party === null)
            throw new Error("The parameter 'party' cannot be null.");
        else if (party !== undefined)
            url_ += "party=" + encodeURIComponent("" + party) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSplitPdf(_response);
        });
    }

    protected processDownloadSplitPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getEstimateSplitData(estimateId: string | undefined, cancelToken?: CancelToken): Promise<GetDataForEstimateSplitResponse> {
        let url_ = this.baseUrl + "/api/issues/Estimates/get-estimate-split-data?";
        if (estimateId === null)
            throw new Error("The parameter 'estimateId' cannot be null.");
        else if (estimateId !== undefined)
            url_ += "estimateId=" + encodeURIComponent("" + estimateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEstimateSplitData(_response);
        });
    }

    protected processGetEstimateSplitData(response: AxiosResponse): Promise<GetDataForEstimateSplitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataForEstimateSplitResponse.fromJS(resultData200);
            return Promise.resolve<GetDataForEstimateSplitResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataForEstimateSplitResponse>(null as any);
    }
}

export class InvoicesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getFormDefaults(payload: GetInvoiceDefaultsPayload, cancelToken?: CancelToken): Promise<InvoiceDefaultsResponse> {
        let url_ = this.baseUrl + "/api/issues/Invoices/get-form-defaults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormDefaults(_response);
        });
    }

    protected processGetFormDefaults(response: AxiosResponse): Promise<InvoiceDefaultsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceDefaultsResponse.fromJS(resultData200);
            return Promise.resolve<InvoiceDefaultsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceDefaultsResponse>(null as any);
    }

    createOrUpdateInvoice(payload: CreateOrUpdateInvoicePayload, cancelToken?: CancelToken): Promise<CreateOrUpdateInvoiceResult> {
        let url_ = this.baseUrl + "/api/issues/Invoices/create-or-update-invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateInvoice(_response);
        });
    }

    protected processCreateOrUpdateInvoice(response: AxiosResponse): Promise<CreateOrUpdateInvoiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdateInvoiceResult.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdateInvoiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdateInvoiceResult>(null as any);
    }

    publishInvoice(payload: PublishInvoicePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Invoices/publish-invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishInvoice(_response);
        });
    }

    protected processPublishInvoice(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    reviewInvoice(payload: ReviewInvoicePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Invoices/review-invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReviewInvoice(_response);
        });
    }

    protected processReviewInvoice(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    payInvoice(payload: PayInvoicePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Invoices/pay-invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayInvoice(_response);
        });
    }

    protected processPayInvoice(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    payInvoiceWithDwolla(payload: PayInvoicePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Invoices/pay-invoice-with-dwolla";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayInvoiceWithDwolla(_response);
        });
    }

    protected processPayInvoiceWithDwolla(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    payInvoiceReporting(payload: PayInvoicePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Invoices/pay-invoice-reporting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayInvoiceReporting(_response);
        });
    }

    protected processPayInvoiceReporting(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    updateInvoiceSplit(payload: UpdateInvoiceSplitPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Invoices/update-invoice-split";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInvoiceSplit(_response);
        });
    }

    protected processUpdateInvoiceSplit(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    renderSplitPdf(splitId: string | undefined, party: SplitDocumentParty | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/issues/Invoices/render-split-pdf?";
        if (splitId === null)
            throw new Error("The parameter 'splitId' cannot be null.");
        else if (splitId !== undefined)
            url_ += "splitId=" + encodeURIComponent("" + splitId) + "&";
        if (party === null)
            throw new Error("The parameter 'party' cannot be null.");
        else if (party !== undefined)
            url_ += "party=" + encodeURIComponent("" + party) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderSplitPdf(_response);
        });
    }

    protected processRenderSplitPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadSplitPdf(splitId: string | undefined, party: SplitDocumentParty | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/issues/Invoices/download-split-pdf?";
        if (splitId === null)
            throw new Error("The parameter 'splitId' cannot be null.");
        else if (splitId !== undefined)
            url_ += "splitId=" + encodeURIComponent("" + splitId) + "&";
        if (party === null)
            throw new Error("The parameter 'party' cannot be null.");
        else if (party !== undefined)
            url_ += "party=" + encodeURIComponent("" + party) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSplitPdf(_response);
        });
    }

    protected processDownloadSplitPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getInvoiceSplitData(invoiceId: string | undefined, cancelToken?: CancelToken): Promise<GetDataForInvoiceSplitResponse> {
        let url_ = this.baseUrl + "/api/issues/Invoices/get-invoice-split-data?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceSplitData(_response);
        });
    }

    protected processGetInvoiceSplitData(response: AxiosResponse): Promise<GetDataForInvoiceSplitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataForInvoiceSplitResponse.fromJS(resultData200);
            return Promise.resolve<GetDataForInvoiceSplitResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataForInvoiceSplitResponse>(null as any);
    }
}

export class IssuesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getForUser(issueId: string | undefined, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/Issues/for-user?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForUser(_response);
        });
    }

    protected processGetForUser(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    listForWorkorder(workorderId: string | undefined, cancelToken?: CancelToken): Promise<Issue[]> {
        let url_ = this.baseUrl + "/api/Issues/list-for-workorder?";
        if (workorderId === null)
            throw new Error("The parameter 'workorderId' cannot be null.");
        else if (workorderId !== undefined)
            url_ += "workorderId=" + encodeURIComponent("" + workorderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListForWorkorder(_response);
        });
    }

    protected processListForWorkorder(response: AxiosResponse): Promise<Issue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Issue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Issue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Issue[]>(null as any);
    }

    listForUser(payload: IssuesForUserPayload, cancelToken?: CancelToken): Promise<IssuesForUserResult> {
        let url_ = this.baseUrl + "/api/Issues/list-for-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListForUser(_response);
        });
    }

    protected processListForUser(response: AxiosResponse): Promise<IssuesForUserResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssuesForUserResult.fromJS(resultData200);
            return Promise.resolve<IssuesForUserResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssuesForUserResult>(null as any);
    }

    create(payload: CreateIssuePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/Issues/create-issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    update(payload: UpdateIssuePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/Issues/update-issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    setNotificationStatus(payload: SetIssueNotificationStatusPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Issues/set-notification-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetNotificationStatus(_response);
        });
    }

    protected processSetNotificationStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getActivityLog(issueId: string, cancelToken?: CancelToken): Promise<IssueActivityLogEntry[]> {
        let url_ = this.baseUrl + "/api/Issues/issue-history/{issueId}";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined.");
        url_ = url_.replace("{issueId}", encodeURIComponent("" + issueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityLog(_response);
        });
    }

    protected processGetActivityLog(response: AxiosResponse): Promise<IssueActivityLogEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IssueActivityLogEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IssueActivityLogEntry[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueActivityLogEntry[]>(null as any);
    }

    getNotifications(activityLogId: string | undefined, cancelToken?: CancelToken): Promise<SentNotificationSummary[]> {
        let url_ = this.baseUrl + "/api/Issues/notification-history?";
        if (activityLogId === null)
            throw new Error("The parameter 'activityLogId' cannot be null.");
        else if (activityLogId !== undefined)
            url_ += "activityLogId=" + encodeURIComponent("" + activityLogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: AxiosResponse): Promise<SentNotificationSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SentNotificationSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SentNotificationSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SentNotificationSummary[]>(null as any);
    }

    getNotificationDetails(notificationId: string | undefined, cancelToken?: CancelToken): Promise<SentNotificationDetails> {
        let url_ = this.baseUrl + "/api/Issues/notification-details?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationDetails(_response);
        });
    }

    protected processGetNotificationDetails(response: AxiosResponse): Promise<SentNotificationDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SentNotificationDetails.fromJS(resultData200);
            return Promise.resolve<SentNotificationDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SentNotificationDetails>(null as any);
    }

    tenantCancelIssue(payload: TenantCancelIssuePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/Issues/tenant-cancel-issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTenantCancelIssue(_response);
        });
    }

    protected processTenantCancelIssue(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    vendorCancelIssue(payload: VendorCancelIssuePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/Issues/vendor-cancel-issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVendorCancelIssue(_response);
        });
    }

    protected processVendorCancelIssue(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    createBoardPost(payload: CreateBoardPostPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/Issues/create-board-post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBoardPost(_response);
        });
    }

    protected processCreateBoardPost(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    deleteBoardPost(payload: DeleteBoardPostPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/Issues/delete-board-post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBoardPost(_response);
        });
    }

    protected processDeleteBoardPost(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }
}

export class PaymentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listForIssue(id: string, cancelToken?: CancelToken): Promise<Payment[]> {
        let url_ = this.baseUrl + "/api/issues/Payments/list-for-issue/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListForIssue(_response);
        });
    }

    protected processListForIssue(response: AxiosResponse): Promise<Payment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Payment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Payment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Payment[]>(null as any);
    }

    addOrUpdatePayment(payload: AddOrUpdatePaymentPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Payments/add-update-payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdatePayment(_response);
        });
    }

    protected processAddOrUpdatePayment(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    deletePayment(id: string | undefined, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Payments/delete-payment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePayment(_response);
        });
    }

    protected processDeletePayment(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    canVendorAccpetDwollaPayment(vendorId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/issues/Payments/can-vendor-accept-dwolla-payment?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCanVendorAccpetDwollaPayment(_response);
        });
    }

    protected processCanVendorAccpetDwollaPayment(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class ReportingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProfitLoss(payload: GetProfitLossPayload, cancelToken?: CancelToken): Promise<ProfitLossStatement> {
        let url_ = this.baseUrl + "/api/issues/Reporting/get-profit-loss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfitLoss(_response);
        });
    }

    protected processGetProfitLoss(response: AxiosResponse): Promise<ProfitLossStatement> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfitLossStatement.fromJS(resultData200);
            return Promise.resolve<ProfitLossStatement>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfitLossStatement>(null as any);
    }

    listForAccountsReceivable( cancelToken?: CancelToken): Promise<PaymentGroup> {
        let url_ = this.baseUrl + "/api/issues/Reporting/list-for-accounts-receivable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListForAccountsReceivable(_response);
        });
    }

    protected processListForAccountsReceivable(response: AxiosResponse): Promise<PaymentGroup> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentGroup.fromJS(resultData200);
            return Promise.resolve<PaymentGroup>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentGroup>(null as any);
    }

    listForAccountsPayable( cancelToken?: CancelToken): Promise<PaymentGroup> {
        let url_ = this.baseUrl + "/api/issues/Reporting/list-for-accounts-payable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListForAccountsPayable(_response);
        });
    }

    protected processListForAccountsPayable(response: AxiosResponse): Promise<PaymentGroup> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentGroup.fromJS(resultData200);
            return Promise.resolve<PaymentGroup>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentGroup>(null as any);
    }

    listForPayees(payload: ListForPayeePagePayload, cancelToken?: CancelToken): Promise<PayeeInfo[]> {
        let url_ = this.baseUrl + "/api/issues/Reporting/list-for-payees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListForPayees(_response);
        });
    }

    protected processListForPayees(response: AxiosResponse): Promise<PayeeInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayeeInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PayeeInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayeeInfo[]>(null as any);
    }

    exportPayeesPdf(payload: ExportPayeesPdfPayload, cancelToken?: CancelToken): Promise<AttachmentFile> {
        let url_ = this.baseUrl + "/api/issues/Reporting/export-payees-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPayeesPdf(_response);
        });
    }

    protected processExportPayeesPdf(response: AxiosResponse): Promise<AttachmentFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttachmentFile.fromJS(resultData200);
            return Promise.resolve<AttachmentFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentFile>(null as any);
    }

    exportPayeesCsv(payload: ExportPayeesCsvPayload, cancelToken?: CancelToken): Promise<AttachmentFile> {
        let url_ = this.baseUrl + "/api/issues/Reporting/export-payees-csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPayeesCsv(_response);
        });
    }

    protected processExportPayeesCsv(response: AxiosResponse): Promise<AttachmentFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttachmentFile.fromJS(resultData200);
            return Promise.resolve<AttachmentFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentFile>(null as any);
    }

    exportAccountsReceivable(payload: ExportAccountsReceivablePayload, cancelToken?: CancelToken): Promise<AttachmentFile> {
        let url_ = this.baseUrl + "/api/issues/Reporting/export-ar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportAccountsReceivable(_response);
        });
    }

    protected processExportAccountsReceivable(response: AxiosResponse): Promise<AttachmentFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttachmentFile.fromJS(resultData200);
            return Promise.resolve<AttachmentFile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentFile>(null as any);
    }

    serveAccountsReceivablePdf(companyId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/issues/Reporting/serve-ar-pdf?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServeAccountsReceivablePdf(_response);
        });
    }

    protected processServeAccountsReceivablePdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SchedulingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    setIssueSchedule(payload: SetIssueSchedulePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Scheduling/set-issue-schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetIssueSchedule(_response);
        });
    }

    protected processSetIssueSchedule(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    skipScheduling(payload: SkipSchedulingPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Scheduling/skip-scheduling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSkipScheduling(_response);
        });
    }

    protected processSkipScheduling(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    cancelSchedule(payload: CancelIssueSchedulePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Scheduling/cancel-schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelSchedule(_response);
        });
    }

    protected processCancelSchedule(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    reviewIssueSchedule(payload: ReviewIssueSchedulePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Scheduling/review-issue-schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReviewIssueSchedule(_response);
        });
    }

    protected processReviewIssueSchedule(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }
}

export class WorkflowClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getChecklistDefaults(payload: ChecklistDefaultsPayload, cancelToken?: CancelToken): Promise<ChecklistDefaultsResponse> {
        let url_ = this.baseUrl + "/api/issues/Workflow/get-checklist-defaults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChecklistDefaults(_response);
        });
    }

    protected processGetChecklistDefaults(response: AxiosResponse): Promise<ChecklistDefaultsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChecklistDefaultsResponse.fromJS(resultData200);
            return Promise.resolve<ChecklistDefaultsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistDefaultsResponse>(null as any);
    }

    markWorkComplete(payload: MarkWorkCompletePayload, cancelToken?: CancelToken): Promise<MarkWorkCompleteResult> {
        let url_ = this.baseUrl + "/api/issues/Workflow/mark-work-complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkWorkComplete(_response);
        });
    }

    protected processMarkWorkComplete(response: AxiosResponse): Promise<MarkWorkCompleteResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkWorkCompleteResult.fromJS(resultData200);
            return Promise.resolve<MarkWorkCompleteResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkWorkCompleteResult>(null as any);
    }

    getJumpStatuses(payload: GetAvailableJumpStatusesPayload, cancelToken?: CancelToken): Promise<StatusAvailabilityMeta[]> {
        let url_ = this.baseUrl + "/api/issues/Workflow/get-jump-statuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJumpStatuses(_response);
        });
    }

    protected processGetJumpStatuses(response: AxiosResponse): Promise<StatusAvailabilityMeta[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusAvailabilityMeta.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StatusAvailabilityMeta[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusAvailabilityMeta[]>(null as any);
    }

    setStatus(payload: SetIssueStatusPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Workflow/set-issue-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetStatus(_response);
        });
    }

    protected processSetStatus(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    closeIssue(payload: CloseIssuePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Workflow/close-issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseIssue(_response);
        });
    }

    protected processCloseIssue(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    markPaid(payload: MarkIssuePaidPayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Workflow/mark-paid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkPaid(_response);
        });
    }

    protected processMarkPaid(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }

    cancelIssue(payload: CancelIssuePayload, cancelToken?: CancelToken): Promise<IssueUserView> {
        let url_ = this.baseUrl + "/api/issues/Workflow/cancel-issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelIssue(_response);
        });
    }

    protected processCancelIssue(response: AxiosResponse): Promise<IssueUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueUserView.fromJS(resultData200);
            return Promise.resolve<IssueUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueUserView>(null as any);
    }
}

export class FormsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    contactForm(payload: ContactFormSubmissionPayload, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/external/forms/contact-form";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContactForm(_response);
        });
    }

    protected processContactForm(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StripeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    processWebhookEvent( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/external/web-hooks/stripe";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessWebhookEvent(_response);
        });
    }

    protected processProcessWebhookEvent(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPayInvoiceInfo(invoiceId: string, cancelToken?: CancelToken): Promise<PayInvoiceInfo> {
        let url_ = this.baseUrl + "/external/web-hooks/get-pay-invoice-info/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayInvoiceInfo(_response);
        });
    }

    protected processGetPayInvoiceInfo(response: AxiosResponse): Promise<PayInvoiceInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PayInvoiceInfo.fromJS(resultData200);
            return Promise.resolve<PayInvoiceInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayInvoiceInfo>(null as any);
    }

    getPayInvoiceUrl(method: string, invoiceId: string, userId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/external/web-hooks/get-pay-invoice-url/{method}/{invoiceId}/{userId}";
        if (method === undefined || method === null)
            throw new Error("The parameter 'method' must be defined.");
        url_ = url_.replace("{method}", encodeURIComponent("" + method));
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayInvoiceUrl(_response);
        });
    }

    protected processGetPayInvoiceUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class UserAccount implements IUserAccount {
    enabled: boolean;
    userId: string;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    createdDate: Date;
    lastLogin: Date | null;
    firstLogin: Date | null;
    vendor: VendorSummary | null;
    companies: CompanyMembershipInfo[] | null;
    capabilities: Capability[] | null;
    [immerable] = true;

    constructor(data?: IUserAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.vendor = data.vendor && !(<any>data.vendor).toJSON ? new VendorSummary(data.vendor) : <VendorSummary>this.vendor;
            if (data.companies) {
                this.companies = [];
                for (let i = 0; i < data.companies.length; i++) {
                    let item = data.companies[i];
                    this.companies[i] = item && !(<any>item).toJSON ? new CompanyMembershipInfo(item) : <CompanyMembershipInfo>item;
                }
            }
            if (data.capabilities) {
                this.capabilities = [];
                for (let i = 0; i < data.capabilities.length; i++) {
                    let item = data.capabilities[i];
                    this.capabilities[i] = item && !(<any>item).toJSON ? new Capability(item) : <Capability>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : <any>null;
            this.firstLogin = _data["firstLogin"] ? new Date(_data["firstLogin"].toString()) : <any>null;
            this.vendor = _data["vendor"] ? VendorSummary.fromJS(_data["vendor"]) : <any>null;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(CompanyMembershipInfo.fromJS(item));
            }
            else {
                this.companies = <any>null;
            }
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(Capability.fromJS(item));
            }
            else {
                this.capabilities = <any>null;
            }
        }
    }

    static fromJS(data: any): UserAccount {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>null;
        data["firstLogin"] = this.firstLogin ? this.firstLogin.toISOString() : <any>null;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>null;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserAccount {
    enabled: boolean;
    userId: string;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    createdDate: Date;
    lastLogin: Date | null;
    firstLogin: Date | null;
    vendor: IVendorSummary | null;
    companies: ICompanyMembershipInfo[] | null;
    capabilities: ICapability[] | null;
}

export class VendorSummary implements IVendorSummary {
    id: string;
    companyName: string | null;
    showInPool: boolean;
    isGeneralContractor: boolean;
    isPinned: boolean;
    [immerable] = true;

    constructor(data?: IVendorSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.showInPool = _data["showInPool"] !== undefined ? _data["showInPool"] : <any>null;
            this.isGeneralContractor = _data["isGeneralContractor"] !== undefined ? _data["isGeneralContractor"] : <any>null;
            this.isPinned = _data["isPinned"] !== undefined ? _data["isPinned"] : <any>null;
        }
    }

    static fromJS(data: any): VendorSummary {
        data = typeof data === 'object' ? data : {};
        let result = new VendorSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["showInPool"] = this.showInPool !== undefined ? this.showInPool : <any>null;
        data["isGeneralContractor"] = this.isGeneralContractor !== undefined ? this.isGeneralContractor : <any>null;
        data["isPinned"] = this.isPinned !== undefined ? this.isPinned : <any>null;
        return data;
    }
}

export interface IVendorSummary {
    id: string;
    companyName: string | null;
    showInPool: boolean;
    isGeneralContractor: boolean;
    isPinned: boolean;
}

export class CompanyMembershipInfo implements ICompanyMembershipInfo {
    managementCompanyId: string;
    companyName: string | null;
    capabilities: CapabilityType[] | null;
    [immerable] = true;

    constructor(data?: ICompanyMembershipInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(item);
            }
            else {
                this.capabilities = <any>null;
            }
        }
    }

    static fromJS(data: any): CompanyMembershipInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyMembershipInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item);
        }
        return data;
    }
}

export interface ICompanyMembershipInfo {
    managementCompanyId: string;
    companyName: string | null;
    capabilities: CapabilityType[] | null;
}

export enum CapabilityType {
    Unknown = 0,
    ManagementCompanyOwner = 1,
    PropertyManager = 2,
    PropertyOwner = 3,
    Tenant = 4,
    Vendor = 5,
    Tech = 6,
    GeneralContractor = 7,
}

export class Capability implements ICapability {
    type: CapabilityType;
    managementCompanyId: string;
    userId: string;
    [immerable] = true;

    constructor(data?: ICapability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): Capability {
        data = typeof data === 'object' ? data : {};
        let result = new Capability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface ICapability {
    type: CapabilityType;
    managementCompanyId: string;
    userId: string;
}

export class CreateCompanyWithOwnerResult implements ICreateCompanyWithOwnerResult {
    status: StatusType;
    userId: string | null;
    companyId: string | null;
    [immerable] = true;

    constructor(data?: ICreateCompanyWithOwnerResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateCompanyWithOwnerResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyWithOwnerResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        return data;
    }
}

export interface ICreateCompanyWithOwnerResult {
    status: StatusType;
    userId: string | null;
    companyId: string | null;
}

export enum StatusType {
    Success = 0,
    EmailAlreadyTaken = 1,
}

export class CreateCompanyWithOwnerPayload implements ICreateCompanyWithOwnerPayload {
    person: CreatePersonModel | null;
    password: string | null;
    companyName: string | null;
    autoConfirmOwnerEmail: boolean;
    muteCompanyNotifications: boolean;
    muteOwnerNotifications: boolean;
    [immerable] = true;

    constructor(data?: ICreateCompanyWithOwnerPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.person = data.person && !(<any>data.person).toJSON ? new CreatePersonModel(data.person) : <CreatePersonModel>this.person;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? CreatePersonModel.fromJS(_data["person"]) : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.autoConfirmOwnerEmail = _data["autoConfirmOwnerEmail"] !== undefined ? _data["autoConfirmOwnerEmail"] : <any>null;
            this.muteCompanyNotifications = _data["muteCompanyNotifications"] !== undefined ? _data["muteCompanyNotifications"] : <any>null;
            this.muteOwnerNotifications = _data["muteOwnerNotifications"] !== undefined ? _data["muteOwnerNotifications"] : <any>null;
        }
    }

    static fromJS(data: any): CreateCompanyWithOwnerPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyWithOwnerPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["autoConfirmOwnerEmail"] = this.autoConfirmOwnerEmail !== undefined ? this.autoConfirmOwnerEmail : <any>null;
        data["muteCompanyNotifications"] = this.muteCompanyNotifications !== undefined ? this.muteCompanyNotifications : <any>null;
        data["muteOwnerNotifications"] = this.muteOwnerNotifications !== undefined ? this.muteOwnerNotifications : <any>null;
        return data;
    }
}

export interface ICreateCompanyWithOwnerPayload {
    person: ICreatePersonModel | null;
    password: string | null;
    companyName: string | null;
    autoConfirmOwnerEmail: boolean;
    muteCompanyNotifications: boolean;
    muteOwnerNotifications: boolean;
}

export class CreatePersonModel implements ICreatePersonModel {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    phone: string | null;
    userId: string | null;
    [immerable] = true;

    constructor(data?: ICreatePersonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): CreatePersonModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface ICreatePersonModel {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    phone: string | null;
    userId: string | null;
}

export enum AdminChangeEmailResultType {
    Success = 0,
    EmailUnavailable = 1,
}

export class AdminChangeEmailPayload implements IAdminChangeEmailPayload {
    userId: string;
    oldEmail: string | null;
    newEmail: string | null;
    [immerable] = true;

    constructor(data?: IAdminChangeEmailPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.oldEmail = _data["oldEmail"] !== undefined ? _data["oldEmail"] : <any>null;
            this.newEmail = _data["newEmail"] !== undefined ? _data["newEmail"] : <any>null;
        }
    }

    static fromJS(data: any): AdminChangeEmailPayload {
        data = typeof data === 'object' ? data : {};
        let result = new AdminChangeEmailPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["oldEmail"] = this.oldEmail !== undefined ? this.oldEmail : <any>null;
        data["newEmail"] = this.newEmail !== undefined ? this.newEmail : <any>null;
        return data;
    }
}

export interface IAdminChangeEmailPayload {
    userId: string;
    oldEmail: string | null;
    newEmail: string | null;
}

export class StartImpersonationResult implements IStartImpersonationResult {
    userId: string;
    token: string | null;
    [immerable] = true;

    constructor(data?: IStartImpersonationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
        }
    }

    static fromJS(data: any): StartImpersonationResult {
        data = typeof data === 'object' ? data : {};
        let result = new StartImpersonationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        return data;
    }
}

export interface IStartImpersonationResult {
    userId: string;
    token: string | null;
}

export class StartImpersonationPayload implements IStartImpersonationPayload {
    userId: string;
    [immerable] = true;

    constructor(data?: IStartImpersonationPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): StartImpersonationPayload {
        data = typeof data === 'object' ? data : {};
        let result = new StartImpersonationPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IStartImpersonationPayload {
    userId: string;
}

export class ManagementCompany implements IManagementCompany {
    id: string;
    name: string | null;
    address: Address | null;
    contactInfo: ContactInfo | null;
    hasBuildium: boolean;
    theme: string | null;
    ownerId: string | null;
    copyTenantEmailsTo: string | null;
    copyTenantTextsTo: string | null;
    doorsUnderManagement: number | null;
    dollarsPerDoor: number | null;
    isSoftwareClient: boolean;
    [immerable] = true;

    constructor(data?: IManagementCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            this.contactInfo = data.contactInfo && !(<any>data.contactInfo).toJSON ? new ContactInfo(data.contactInfo) : <ContactInfo>this.contactInfo;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
            this.contactInfo = _data["contactInfo"] ? ContactInfo.fromJS(_data["contactInfo"]) : <any>null;
            this.hasBuildium = _data["hasBuildium"] !== undefined ? _data["hasBuildium"] : <any>null;
            this.theme = _data["theme"] !== undefined ? _data["theme"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.copyTenantEmailsTo = _data["copyTenantEmailsTo"] !== undefined ? _data["copyTenantEmailsTo"] : <any>null;
            this.copyTenantTextsTo = _data["copyTenantTextsTo"] !== undefined ? _data["copyTenantTextsTo"] : <any>null;
            this.doorsUnderManagement = _data["doorsUnderManagement"] !== undefined ? _data["doorsUnderManagement"] : <any>null;
            this.dollarsPerDoor = _data["dollarsPerDoor"] !== undefined ? _data["dollarsPerDoor"] : <any>null;
            this.isSoftwareClient = _data["isSoftwareClient"] !== undefined ? _data["isSoftwareClient"] : <any>null;
        }
    }

    static fromJS(data: any): ManagementCompany {
        data = typeof data === 'object' ? data : {};
        let result = new ManagementCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>null;
        data["hasBuildium"] = this.hasBuildium !== undefined ? this.hasBuildium : <any>null;
        data["theme"] = this.theme !== undefined ? this.theme : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["copyTenantEmailsTo"] = this.copyTenantEmailsTo !== undefined ? this.copyTenantEmailsTo : <any>null;
        data["copyTenantTextsTo"] = this.copyTenantTextsTo !== undefined ? this.copyTenantTextsTo : <any>null;
        data["doorsUnderManagement"] = this.doorsUnderManagement !== undefined ? this.doorsUnderManagement : <any>null;
        data["dollarsPerDoor"] = this.dollarsPerDoor !== undefined ? this.dollarsPerDoor : <any>null;
        data["isSoftwareClient"] = this.isSoftwareClient !== undefined ? this.isSoftwareClient : <any>null;
        return data;
    }
}

export interface IManagementCompany {
    id: string;
    name: string | null;
    address: IAddress | null;
    contactInfo: IContactInfo | null;
    hasBuildium: boolean;
    theme: string | null;
    ownerId: string | null;
    copyTenantEmailsTo: string | null;
    copyTenantTextsTo: string | null;
    doorsUnderManagement: number | null;
    dollarsPerDoor: number | null;
    isSoftwareClient: boolean;
}

export class ManagementCompanyDetails extends ManagementCompany implements IManagementCompanyDetails {
    owner: UserSummary | null;
    issues: number;
    managers: number;
    vendors: number;
    properties: number;
    propertyOwners: number;
    tenants: number;
    createdAt: Date;
    mutedNotifications: boolean;
    [immerable] = true;

    constructor(data?: IManagementCompanyDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
            this.owner = data.owner && !(<any>data.owner).toJSON ? new UserSummary(data.owner) : <UserSummary>this.owner;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.owner = _data["owner"] ? UserSummary.fromJS(_data["owner"]) : <any>null;
            this.issues = _data["issues"] !== undefined ? _data["issues"] : <any>null;
            this.managers = _data["managers"] !== undefined ? _data["managers"] : <any>null;
            this.vendors = _data["vendors"] !== undefined ? _data["vendors"] : <any>null;
            this.properties = _data["properties"] !== undefined ? _data["properties"] : <any>null;
            this.propertyOwners = _data["propertyOwners"] !== undefined ? _data["propertyOwners"] : <any>null;
            this.tenants = _data["tenants"] !== undefined ? _data["tenants"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.mutedNotifications = _data["mutedNotifications"] !== undefined ? _data["mutedNotifications"] : <any>null;
        }
    }

    static fromJS(data: any): ManagementCompanyDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ManagementCompanyDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["owner"] = this.owner ? this.owner.toJSON() : <any>null;
        data["issues"] = this.issues !== undefined ? this.issues : <any>null;
        data["managers"] = this.managers !== undefined ? this.managers : <any>null;
        data["vendors"] = this.vendors !== undefined ? this.vendors : <any>null;
        data["properties"] = this.properties !== undefined ? this.properties : <any>null;
        data["propertyOwners"] = this.propertyOwners !== undefined ? this.propertyOwners : <any>null;
        data["tenants"] = this.tenants !== undefined ? this.tenants : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["mutedNotifications"] = this.mutedNotifications !== undefined ? this.mutedNotifications : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IManagementCompanyDetails extends IManagementCompany {
    owner: IUserSummary | null;
    issues: number;
    managers: number;
    vendors: number;
    properties: number;
    propertyOwners: number;
    tenants: number;
    createdAt: Date;
    mutedNotifications: boolean;
}

export class UserSummary implements IUserSummary {
    id: string;
    address: Address | null;
    firstName: string | null;
    lastName: string | null;
    title: string | null;
    contactInfo: ContactInfo | null;
    fullName: string | null;
    accountRole: UserRole;
    receiveText: boolean;
    receiveEmail: boolean;
    avatarUrl: string | null;
    isActive: boolean;
    isDisabled: boolean;
    [immerable] = true;

    constructor(data?: IUserSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            this.contactInfo = data.contactInfo && !(<any>data.contactInfo).toJSON ? new ContactInfo(data.contactInfo) : <ContactInfo>this.contactInfo;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.contactInfo = _data["contactInfo"] ? ContactInfo.fromJS(_data["contactInfo"]) : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.accountRole = _data["accountRole"] !== undefined ? _data["accountRole"] : <any>null;
            this.receiveText = _data["receiveText"] !== undefined ? _data["receiveText"] : <any>null;
            this.receiveEmail = _data["receiveEmail"] !== undefined ? _data["receiveEmail"] : <any>null;
            this.avatarUrl = _data["avatarUrl"] !== undefined ? _data["avatarUrl"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : <any>null;
        }
    }

    static fromJS(data: any): UserSummary {
        data = typeof data === 'object' ? data : {};
        let result = new UserSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["accountRole"] = this.accountRole !== undefined ? this.accountRole : <any>null;
        data["receiveText"] = this.receiveText !== undefined ? this.receiveText : <any>null;
        data["receiveEmail"] = this.receiveEmail !== undefined ? this.receiveEmail : <any>null;
        data["avatarUrl"] = this.avatarUrl !== undefined ? this.avatarUrl : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : <any>null;
        return data;
    }
}

export interface IUserSummary {
    id: string;
    address: IAddress | null;
    firstName: string | null;
    lastName: string | null;
    title: string | null;
    contactInfo: IContactInfo | null;
    fullName: string | null;
    accountRole: UserRole;
    receiveText: boolean;
    receiveEmail: boolean;
    avatarUrl: string | null;
    isActive: boolean;
    isDisabled: boolean;
}

export class Address implements IAddress {
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    latitude: number | null;
    longitude: number | null;
    line1Formatted: string | null;
    line2Formatted: string | null;
    fullFormatted: string | null;
    [immerable] = true;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.line1Formatted = _data["line1Formatted"] !== undefined ? _data["line1Formatted"] : <any>null;
            this.line2Formatted = _data["line2Formatted"] !== undefined ? _data["line2Formatted"] : <any>null;
            this.fullFormatted = _data["fullFormatted"] !== undefined ? _data["fullFormatted"] : <any>null;
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["line1Formatted"] = this.line1Formatted !== undefined ? this.line1Formatted : <any>null;
        data["line2Formatted"] = this.line2Formatted !== undefined ? this.line2Formatted : <any>null;
        data["fullFormatted"] = this.fullFormatted !== undefined ? this.fullFormatted : <any>null;
        return data;
    }
}

export interface IAddress {
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    latitude: number | null;
    longitude: number | null;
    line1Formatted: string | null;
    line2Formatted: string | null;
    fullFormatted: string | null;
}

export class ContactInfo implements IContactInfo {
    email: string | null;
    phoneNumber: string | null;
    workPhone: string | null;
    [immerable] = true;

    constructor(data?: IContactInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : <any>null;
        }
    }

    static fromJS(data: any): ContactInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : <any>null;
        return data;
    }
}

export interface IContactInfo {
    email: string | null;
    phoneNumber: string | null;
    workPhone: string | null;
}

export enum UserRole {
    User = 0,
    Admin = 1,
    Dev = 2,
}

export class GetIssueIdFromNumberResult implements IGetIssueIdFromNumberResult {
    workorderId: string;
    issueId: string;
    [immerable] = true;

    constructor(data?: IGetIssueIdFromNumberResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
        }
    }

    static fromJS(data: any): GetIssueIdFromNumberResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueIdFromNumberResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        return data;
    }
}

export interface IGetIssueIdFromNumberResult {
    workorderId: string;
    issueId: string;
}

export class ToggleUserEnabledPayload implements IToggleUserEnabledPayload {
    userId: string;
    value: boolean;
    [immerable] = true;

    constructor(data?: IToggleUserEnabledPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): ToggleUserEnabledPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleUserEnabledPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IToggleUserEnabledPayload {
    userId: string;
    value: boolean;
}

export class ToggleVendorIsGcPayload implements IToggleVendorIsGcPayload {
    vendorId: string;
    value: boolean;
    [immerable] = true;

    constructor(data?: IToggleVendorIsGcPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): ToggleVendorIsGcPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleVendorIsGcPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IToggleVendorIsGcPayload {
    vendorId: string;
    value: boolean;
}

export class SoftwareClientDetails implements ISoftwareClientDetails {
    companyId: string;
    name: string | null;
    admin: UserSummary | null;
    adminFirstLogin: Date | null;
    adminLastLogin: Date | null;
    createdAt: Date;
    userCount: number;
    propertyCount: number;
    dollarsPerDoor: number | null;
    [immerable] = true;

    constructor(data?: ISoftwareClientDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.admin = data.admin && !(<any>data.admin).toJSON ? new UserSummary(data.admin) : <UserSummary>this.admin;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.admin = _data["admin"] ? UserSummary.fromJS(_data["admin"]) : <any>null;
            this.adminFirstLogin = _data["adminFirstLogin"] ? new Date(_data["adminFirstLogin"].toString()) : <any>null;
            this.adminLastLogin = _data["adminLastLogin"] ? new Date(_data["adminLastLogin"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.userCount = _data["userCount"] !== undefined ? _data["userCount"] : <any>null;
            this.propertyCount = _data["propertyCount"] !== undefined ? _data["propertyCount"] : <any>null;
            this.dollarsPerDoor = _data["dollarsPerDoor"] !== undefined ? _data["dollarsPerDoor"] : <any>null;
        }
    }

    static fromJS(data: any): SoftwareClientDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SoftwareClientDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["admin"] = this.admin ? this.admin.toJSON() : <any>null;
        data["adminFirstLogin"] = this.adminFirstLogin ? this.adminFirstLogin.toISOString() : <any>null;
        data["adminLastLogin"] = this.adminLastLogin ? this.adminLastLogin.toISOString() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["userCount"] = this.userCount !== undefined ? this.userCount : <any>null;
        data["propertyCount"] = this.propertyCount !== undefined ? this.propertyCount : <any>null;
        data["dollarsPerDoor"] = this.dollarsPerDoor !== undefined ? this.dollarsPerDoor : <any>null;
        return data;
    }
}

export interface ISoftwareClientDetails {
    companyId: string;
    name: string | null;
    admin: IUserSummary | null;
    adminFirstLogin: Date | null;
    adminLastLogin: Date | null;
    createdAt: Date;
    userCount: number;
    propertyCount: number;
    dollarsPerDoor: number | null;
}

export class AdminVendorView implements IAdminVendorView {
    id: string;
    companyName: string | null;
    isGeneralContractor: boolean;
    managedClients: number;
    managedVendors: number;
    createdAt: Date;
    [immerable] = true;

    constructor(data?: IAdminVendorView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.isGeneralContractor = _data["isGeneralContractor"] !== undefined ? _data["isGeneralContractor"] : <any>null;
            this.managedClients = _data["managedClients"] !== undefined ? _data["managedClients"] : <any>null;
            this.managedVendors = _data["managedVendors"] !== undefined ? _data["managedVendors"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AdminVendorView {
        data = typeof data === 'object' ? data : {};
        let result = new AdminVendorView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["isGeneralContractor"] = this.isGeneralContractor !== undefined ? this.isGeneralContractor : <any>null;
        data["managedClients"] = this.managedClients !== undefined ? this.managedClients : <any>null;
        data["managedVendors"] = this.managedVendors !== undefined ? this.managedVendors : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        return data;
    }
}

export interface IAdminVendorView {
    id: string;
    companyName: string | null;
    isGeneralContractor: boolean;
    managedClients: number;
    managedVendors: number;
    createdAt: Date;
}

export class LogInResponse implements ILogInResponse {
    token: string | null;
    success: boolean;
    needsTwoFactor: boolean;
    [immerable] = true;

    constructor(data?: ILogInResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.needsTwoFactor = _data["needsTwoFactor"] !== undefined ? _data["needsTwoFactor"] : <any>null;
        }
    }

    static fromJS(data: any): LogInResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LogInResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["needsTwoFactor"] = this.needsTwoFactor !== undefined ? this.needsTwoFactor : <any>null;
        return data;
    }
}

export interface ILogInResponse {
    token: string | null;
    success: boolean;
    needsTwoFactor: boolean;
}

export class LogInPayload implements ILogInPayload {
    email: string | null;
    password: string | null;
    [immerable] = true;

    constructor(data?: ILogInPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): LogInPayload {
        data = typeof data === 'object' ? data : {};
        let result = new LogInPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data;
    }
}

export interface ILogInPayload {
    email: string | null;
    password: string | null;
}

export class LogInImplicitPayload implements ILogInImplicitPayload {
    userId: string;
    [immerable] = true;

    constructor(data?: ILogInImplicitPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): LogInImplicitPayload {
        data = typeof data === 'object' ? data : {};
        let result = new LogInImplicitPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface ILogInImplicitPayload {
    userId: string;
}

export class LogInSsoPayload implements ILogInSsoPayload {
    email: string | null;
    ssoToken: string | null;
    [immerable] = true;

    constructor(data?: ILogInSsoPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.ssoToken = _data["ssoToken"] !== undefined ? _data["ssoToken"] : <any>null;
        }
    }

    static fromJS(data: any): LogInSsoPayload {
        data = typeof data === 'object' ? data : {};
        let result = new LogInSsoPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["ssoToken"] = this.ssoToken !== undefined ? this.ssoToken : <any>null;
        return data;
    }
}

export interface ILogInSsoPayload {
    email: string | null;
    ssoToken: string | null;
}

export class LogInTwoFactorPayload implements ILogInTwoFactorPayload {
    userId: string;
    token: string | null;
    [immerable] = true;

    constructor(data?: ILogInTwoFactorPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
        }
    }

    static fromJS(data: any): LogInTwoFactorPayload {
        data = typeof data === 'object' ? data : {};
        let result = new LogInTwoFactorPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        return data;
    }
}

export interface ILogInTwoFactorPayload {
    userId: string;
    token: string | null;
}

export class StartSessionResult implements IStartSessionResult {
    currentUser: UserDetails | null;
    isImpersonating: boolean;
    impersonator: ImpersonatorData | null;
    [immerable] = true;

    constructor(data?: IStartSessionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.currentUser = data.currentUser && !(<any>data.currentUser).toJSON ? new UserDetails(data.currentUser) : <UserDetails>this.currentUser;
            this.impersonator = data.impersonator && !(<any>data.impersonator).toJSON ? new ImpersonatorData(data.impersonator) : <ImpersonatorData>this.impersonator;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentUser = _data["currentUser"] ? UserDetails.fromJS(_data["currentUser"]) : <any>null;
            this.isImpersonating = _data["isImpersonating"] !== undefined ? _data["isImpersonating"] : <any>null;
            this.impersonator = _data["impersonator"] ? ImpersonatorData.fromJS(_data["impersonator"]) : <any>null;
        }
    }

    static fromJS(data: any): StartSessionResult {
        data = typeof data === 'object' ? data : {};
        let result = new StartSessionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentUser"] = this.currentUser ? this.currentUser.toJSON() : <any>null;
        data["isImpersonating"] = this.isImpersonating !== undefined ? this.isImpersonating : <any>null;
        data["impersonator"] = this.impersonator ? this.impersonator.toJSON() : <any>null;
        return data;
    }
}

export interface IStartSessionResult {
    currentUser: IUserDetails | null;
    isImpersonating: boolean;
    impersonator: IImpersonatorData | null;
}

export class UserDetails implements IUserDetails {
    user: User | null;
    vendorInfo: Vendor | null;
    memberships: Membership[] | null;
    companyContext: CompanyContext | null;
    hideReports: boolean;
    showCommissions: boolean;
    hideClients: boolean;
    [immerable] = true;

    constructor(data?: IUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
            this.vendorInfo = data.vendorInfo && !(<any>data.vendorInfo).toJSON ? new Vendor(data.vendorInfo) : <Vendor>this.vendorInfo;
            if (data.memberships) {
                this.memberships = [];
                for (let i = 0; i < data.memberships.length; i++) {
                    let item = data.memberships[i];
                    this.memberships[i] = item && !(<any>item).toJSON ? new Membership(item) : <Membership>item;
                }
            }
            this.companyContext = data.companyContext && !(<any>data.companyContext).toJSON ? new CompanyContext(data.companyContext) : <CompanyContext>this.companyContext;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>null;
            this.vendorInfo = _data["vendorInfo"] ? Vendor.fromJS(_data["vendorInfo"]) : <any>null;
            if (Array.isArray(_data["memberships"])) {
                this.memberships = [] as any;
                for (let item of _data["memberships"])
                    this.memberships!.push(Membership.fromJS(item));
            }
            else {
                this.memberships = <any>null;
            }
            this.companyContext = _data["companyContext"] ? CompanyContext.fromJS(_data["companyContext"]) : <any>null;
            this.hideReports = _data["hideReports"] !== undefined ? _data["hideReports"] : <any>null;
            this.showCommissions = _data["showCommissions"] !== undefined ? _data["showCommissions"] : <any>null;
            this.hideClients = _data["hideClients"] !== undefined ? _data["hideClients"] : <any>null;
        }
    }

    static fromJS(data: any): UserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["vendorInfo"] = this.vendorInfo ? this.vendorInfo.toJSON() : <any>null;
        if (Array.isArray(this.memberships)) {
            data["memberships"] = [];
            for (let item of this.memberships)
                data["memberships"].push(item.toJSON());
        }
        data["companyContext"] = this.companyContext ? this.companyContext.toJSON() : <any>null;
        data["hideReports"] = this.hideReports !== undefined ? this.hideReports : <any>null;
        data["showCommissions"] = this.showCommissions !== undefined ? this.showCommissions : <any>null;
        data["hideClients"] = this.hideClients !== undefined ? this.hideClients : <any>null;
        return data;
    }
}

export interface IUserDetails {
    user: IUser | null;
    vendorInfo: IVendor | null;
    memberships: IMembership[] | null;
    companyContext: ICompanyContext | null;
    hideReports: boolean;
    showCommissions: boolean;
    hideClients: boolean;
}

export class User extends UserSummary implements IUser {
    managementCompany: ManagementCompany | null;
    acceptedEulaAt: Date | null;
    emailConfirmed: boolean;
    [immerable] = true;

    constructor(data?: IUser) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
            this.managementCompany = data.managementCompany && !(<any>data.managementCompany).toJSON ? new ManagementCompany(data.managementCompany) : <ManagementCompany>this.managementCompany;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.managementCompany = _data["managementCompany"] ? ManagementCompany.fromJS(_data["managementCompany"]) : <any>null;
            this.acceptedEulaAt = _data["acceptedEulaAt"] ? new Date(_data["acceptedEulaAt"].toString()) : <any>null;
            this.emailConfirmed = _data["emailConfirmed"] !== undefined ? _data["emailConfirmed"] : <any>null;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managementCompany"] = this.managementCompany ? this.managementCompany.toJSON() : <any>null;
        data["acceptedEulaAt"] = this.acceptedEulaAt ? this.acceptedEulaAt.toISOString() : <any>null;
        data["emailConfirmed"] = this.emailConfirmed !== undefined ? this.emailConfirmed : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUser extends IUserSummary {
    managementCompany: IManagementCompany | null;
    acceptedEulaAt: Date | null;
    emailConfirmed: boolean;
}

export class Vendor implements IVendor {
    id: string;
    companyName: string | null;
    address: Address | null;
    showInPool: boolean;
    isPinned: boolean;
    isGeneralContractor: boolean;
    contactInfo: ContactInfo | null;
    userId: string;
    focuses: LookupItem[] | null;
    users: UserSummary[] | null;
    workingUsers: UserSummary[] | null;
    avatarUrl: string | null;
    vendorSource: VendorSource;
    score: number | null;
    completedJobs: number;
    [immerable] = true;

    constructor(data?: IVendor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            this.contactInfo = data.contactInfo && !(<any>data.contactInfo).toJSON ? new ContactInfo(data.contactInfo) : <ContactInfo>this.contactInfo;
            if (data.focuses) {
                this.focuses = [];
                for (let i = 0; i < data.focuses.length; i++) {
                    let item = data.focuses[i];
                    this.focuses[i] = item && !(<any>item).toJSON ? new LookupItem(item) : <LookupItem>item;
                }
            }
            if (data.users) {
                this.users = [];
                for (let i = 0; i < data.users.length; i++) {
                    let item = data.users[i];
                    this.users[i] = item && !(<any>item).toJSON ? new UserSummary(item) : <UserSummary>item;
                }
            }
            if (data.workingUsers) {
                this.workingUsers = [];
                for (let i = 0; i < data.workingUsers.length; i++) {
                    let item = data.workingUsers[i];
                    this.workingUsers[i] = item && !(<any>item).toJSON ? new UserSummary(item) : <UserSummary>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
            this.showInPool = _data["showInPool"] !== undefined ? _data["showInPool"] : <any>null;
            this.isPinned = _data["isPinned"] !== undefined ? _data["isPinned"] : <any>null;
            this.isGeneralContractor = _data["isGeneralContractor"] !== undefined ? _data["isGeneralContractor"] : <any>null;
            this.contactInfo = _data["contactInfo"] ? ContactInfo.fromJS(_data["contactInfo"]) : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            if (Array.isArray(_data["focuses"])) {
                this.focuses = [] as any;
                for (let item of _data["focuses"])
                    this.focuses!.push(LookupItem.fromJS(item));
            }
            else {
                this.focuses = <any>null;
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserSummary.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
            if (Array.isArray(_data["workingUsers"])) {
                this.workingUsers = [] as any;
                for (let item of _data["workingUsers"])
                    this.workingUsers!.push(UserSummary.fromJS(item));
            }
            else {
                this.workingUsers = <any>null;
            }
            this.avatarUrl = _data["avatarUrl"] !== undefined ? _data["avatarUrl"] : <any>null;
            this.vendorSource = _data["vendorSource"] !== undefined ? _data["vendorSource"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            this.completedJobs = _data["completedJobs"] !== undefined ? _data["completedJobs"] : <any>null;
        }
    }

    static fromJS(data: any): Vendor {
        data = typeof data === 'object' ? data : {};
        let result = new Vendor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["showInPool"] = this.showInPool !== undefined ? this.showInPool : <any>null;
        data["isPinned"] = this.isPinned !== undefined ? this.isPinned : <any>null;
        data["isGeneralContractor"] = this.isGeneralContractor !== undefined ? this.isGeneralContractor : <any>null;
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        if (Array.isArray(this.focuses)) {
            data["focuses"] = [];
            for (let item of this.focuses)
                data["focuses"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.workingUsers)) {
            data["workingUsers"] = [];
            for (let item of this.workingUsers)
                data["workingUsers"].push(item.toJSON());
        }
        data["avatarUrl"] = this.avatarUrl !== undefined ? this.avatarUrl : <any>null;
        data["vendorSource"] = this.vendorSource !== undefined ? this.vendorSource : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        data["completedJobs"] = this.completedJobs !== undefined ? this.completedJobs : <any>null;
        return data;
    }
}

export interface IVendor {
    id: string;
    companyName: string | null;
    address: IAddress | null;
    showInPool: boolean;
    isPinned: boolean;
    isGeneralContractor: boolean;
    contactInfo: IContactInfo | null;
    userId: string;
    focuses: ILookupItem[] | null;
    users: IUserSummary[] | null;
    workingUsers: IUserSummary[] | null;
    avatarUrl: string | null;
    vendorSource: VendorSource;
    score: number | null;
    completedJobs: number;
}

export class LookupItem implements ILookupItem {
    id: number;
    name: string | null;
    order: number | null;
    obsolete: boolean;
    [immerable] = true;

    constructor(data?: ILookupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.obsolete = _data["obsolete"] !== undefined ? _data["obsolete"] : <any>null;
        }
    }

    static fromJS(data: any): LookupItem {
        data = typeof data === 'object' ? data : {};
        let result = new LookupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["obsolete"] = this.obsolete !== undefined ? this.obsolete : <any>null;
        return data;
    }
}

export interface ILookupItem {
    id: number;
    name: string | null;
    order: number | null;
    obsolete: boolean;
}

export enum VendorSource {
    Contact = 0,
    VendorPool = 1,
}

export class Membership implements IMembership {
    userId: string;
    managementCompanyId: string;
    permissions: RooPermission[] | null;
    capabilities: CapabilityType[] | null;
    [immerable] = true;

    constructor(data?: IMembership) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            else {
                this.permissions = <any>null;
            }
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(item);
            }
            else {
                this.capabilities = <any>null;
            }
        }
    }

    static fromJS(data: any): Membership {
        data = typeof data === 'object' ? data : {};
        let result = new Membership();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item);
        }
        return data;
    }
}

export interface IMembership {
    userId: string;
    managementCompanyId: string;
    permissions: RooPermission[] | null;
    capabilities: CapabilityType[] | null;
}

export enum RooPermission {
    Unknown = 0,
    ViewPropertyList = 101,
    ViewAllProperties = 102,
    AddEditProperties = 103,
    ViewAllWorkorders = 201,
    TakeActionWorkorder = 202,
    AcceptWorkorders = 205,
    CreateUsers = 301,
    UploadLogo = 302,
    AddEditVendors = 401,
    AddEditOwners = 501,
    AddEditTenants = 601,
}

export class CompanyContext implements ICompanyContext {
    companyId: string;
    companyType: CompanyType;
    vendor: Vendor | null;
    managementCompany: ManagementCompany | null;
    coworkers: UserSummary[] | null;
    companyFeatureFlags: CompanyFeatureFlag[] | null;
    [immerable] = true;

    constructor(data?: ICompanyContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.vendor = data.vendor && !(<any>data.vendor).toJSON ? new Vendor(data.vendor) : <Vendor>this.vendor;
            this.managementCompany = data.managementCompany && !(<any>data.managementCompany).toJSON ? new ManagementCompany(data.managementCompany) : <ManagementCompany>this.managementCompany;
            if (data.coworkers) {
                this.coworkers = [];
                for (let i = 0; i < data.coworkers.length; i++) {
                    let item = data.coworkers[i];
                    this.coworkers[i] = item && !(<any>item).toJSON ? new UserSummary(item) : <UserSummary>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>null;
            this.managementCompany = _data["managementCompany"] ? ManagementCompany.fromJS(_data["managementCompany"]) : <any>null;
            if (Array.isArray(_data["coworkers"])) {
                this.coworkers = [] as any;
                for (let item of _data["coworkers"])
                    this.coworkers!.push(UserSummary.fromJS(item));
            }
            else {
                this.coworkers = <any>null;
            }
            if (Array.isArray(_data["companyFeatureFlags"])) {
                this.companyFeatureFlags = [] as any;
                for (let item of _data["companyFeatureFlags"])
                    this.companyFeatureFlags!.push(item);
            }
            else {
                this.companyFeatureFlags = <any>null;
            }
        }
    }

    static fromJS(data: any): CompanyContext {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>null;
        data["managementCompany"] = this.managementCompany ? this.managementCompany.toJSON() : <any>null;
        if (Array.isArray(this.coworkers)) {
            data["coworkers"] = [];
            for (let item of this.coworkers)
                data["coworkers"].push(item.toJSON());
        }
        if (Array.isArray(this.companyFeatureFlags)) {
            data["companyFeatureFlags"] = [];
            for (let item of this.companyFeatureFlags)
                data["companyFeatureFlags"].push(item);
        }
        return data;
    }
}

export interface ICompanyContext {
    companyId: string;
    companyType: CompanyType;
    vendor: IVendor | null;
    managementCompany: IManagementCompany | null;
    coworkers: IUserSummary[] | null;
    companyFeatureFlags: CompanyFeatureFlag[] | null;
}

export enum CompanyType {
    Unknown = 0,
    Vendor = 13,
    ManagementCompany = 14,
}

export enum CompanyFeatureFlag {
    Unknown = 0,
    BankPayments = 1,
    PriceGuide = 2,
    SoftwareClients = 3,
    Inspections = 4,
    VendorPool = 5,
}

export class ImpersonatorData implements IImpersonatorData {
    userId: string;
    role: UserRole;
    [immerable] = true;

    constructor(data?: IImpersonatorData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
        }
    }

    static fromJS(data: any): ImpersonatorData {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatorData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        return data;
    }
}

export interface IImpersonatorData {
    userId: string;
    role: UserRole;
}

export class StartSessionPayload implements IStartSessionPayload {
    userAgent: string | null;
    [immerable] = true;

    constructor(data?: IStartSessionPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userAgent = _data["userAgent"] !== undefined ? _data["userAgent"] : <any>null;
        }
    }

    static fromJS(data: any): StartSessionPayload {
        data = typeof data === 'object' ? data : {};
        let result = new StartSessionPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userAgent"] = this.userAgent !== undefined ? this.userAgent : <any>null;
        return data;
    }
}

export interface IStartSessionPayload {
    userAgent: string | null;
}

export class CreateCompanyWithResponseWithAuth extends CreateCompanyWithOwnerResult implements ICreateCompanyWithResponseWithAuth {
    authToken: string | null;
    [immerable] = true;

    constructor(data?: ICreateCompanyWithResponseWithAuth) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : <any>null;
        }
    }

    static fromJS(data: any): CreateCompanyWithResponseWithAuth {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyWithResponseWithAuth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authToken"] = this.authToken !== undefined ? this.authToken : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCompanyWithResponseWithAuth extends ICreateCompanyWithOwnerResult {
    authToken: string | null;
}

export class RequestPasswordResetPayload implements IRequestPasswordResetPayload {
    email: string | null;
    [immerable] = true;

    constructor(data?: IRequestPasswordResetPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): RequestPasswordResetPayload {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordResetPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface IRequestPasswordResetPayload {
    email: string | null;
}

export class ResetPasswordPayload implements IResetPasswordPayload {
    userId: string;
    token: string | null;
    email: string | null;
    newPassword: string | null;
    [immerable] = true;

    constructor(data?: IResetPasswordPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
        return data;
    }
}

export interface IResetPasswordPayload {
    userId: string;
    token: string | null;
    email: string | null;
    newPassword: string | null;
}

export enum RequestMagicLinkResult {
    Success = 0,
    AccountDisabled = 1,
    InvalidEmail = 2,
    EmailNotFound = 3,
}

export class RequestMagicLinkPayload implements IRequestMagicLinkPayload {
    email: string | null;
    returnUrl: string | null;
    [immerable] = true;

    constructor(data?: IRequestMagicLinkPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.returnUrl = _data["returnUrl"] !== undefined ? _data["returnUrl"] : <any>null;
        }
    }

    static fromJS(data: any): RequestMagicLinkPayload {
        data = typeof data === 'object' ? data : {};
        let result = new RequestMagicLinkPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["returnUrl"] = this.returnUrl !== undefined ? this.returnUrl : <any>null;
        return data;
    }
}

export interface IRequestMagicLinkPayload {
    email: string | null;
    returnUrl: string | null;
}

export class ValidateAuthTokenResult implements IValidateAuthTokenResult {
    result: AuthTokenValidationResult;
    jwt: string | null;
    [immerable] = true;

    constructor(data?: IValidateAuthTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : <any>null;
            this.jwt = _data["jwt"] !== undefined ? _data["jwt"] : <any>null;
        }
    }

    static fromJS(data: any): ValidateAuthTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateAuthTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : <any>null;
        data["jwt"] = this.jwt !== undefined ? this.jwt : <any>null;
        return data;
    }
}

export interface IValidateAuthTokenResult {
    result: AuthTokenValidationResult;
    jwt: string | null;
}

export enum AuthTokenValidationResult {
    Unknown = 0,
    CanApply = 1,
    TokenExpired = 2,
    AlreadyLoggedIn = 3,
    DifferentUser = 4,
    BadToken = 5,
}

export class ValidateAuthTokenPayload implements IValidateAuthTokenPayload {
    authToken: string | null;
    userId: string;
    [immerable] = true;

    constructor(data?: IValidateAuthTokenPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): ValidateAuthTokenPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateAuthTokenPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authToken"] = this.authToken !== undefined ? this.authToken : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IValidateAuthTokenPayload {
    authToken: string | null;
    userId: string;
}

export class CommissionIssueEntry implements ICommissionIssueEntry {
    issueId: string;
    workorderId: string;
    property: PropertySummary | null;
    accountManager: UserSummary | null;
    referenceDate: Instant | null;
    invoiceStatus: InvoiceStatus | null;
    paymentStatus: CommissionPaymentStatus;
    friendlyId: string | null;
    rooAmount: number;
    vendorAmount: number;
    profit: number;
    operatorShare: number;
    supportShare: number;
    rooShare: number;
    outgoingInvoices: CommissionInvoiceEntry[] | null;
    incomingInvoices: CommissionInvoiceEntry[] | null;
    [immerable] = true;

    constructor(data?: ICommissionIssueEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.property = data.property && !(<any>data.property).toJSON ? new PropertySummary(data.property) : <PropertySummary>this.property;
            this.accountManager = data.accountManager && !(<any>data.accountManager).toJSON ? new UserSummary(data.accountManager) : <UserSummary>this.accountManager;
            this.referenceDate = data.referenceDate && !(<any>data.referenceDate).toJSON ? new Instant(data.referenceDate) : <Instant>this.referenceDate;
            if (data.outgoingInvoices) {
                this.outgoingInvoices = [];
                for (let i = 0; i < data.outgoingInvoices.length; i++) {
                    let item = data.outgoingInvoices[i];
                    this.outgoingInvoices[i] = item && !(<any>item).toJSON ? new CommissionInvoiceEntry(item) : <CommissionInvoiceEntry>item;
                }
            }
            if (data.incomingInvoices) {
                this.incomingInvoices = [];
                for (let i = 0; i < data.incomingInvoices.length; i++) {
                    let item = data.incomingInvoices[i];
                    this.incomingInvoices[i] = item && !(<any>item).toJSON ? new CommissionInvoiceEntry(item) : <CommissionInvoiceEntry>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
            this.property = _data["property"] ? PropertySummary.fromJS(_data["property"]) : <any>null;
            this.accountManager = _data["accountManager"] ? UserSummary.fromJS(_data["accountManager"]) : <any>null;
            this.referenceDate = _data["referenceDate"] ? Instant.fromJS(_data["referenceDate"]) : <any>null;
            this.invoiceStatus = _data["invoiceStatus"] !== undefined ? _data["invoiceStatus"] : <any>null;
            this.paymentStatus = _data["paymentStatus"] !== undefined ? _data["paymentStatus"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.rooAmount = _data["rooAmount"] !== undefined ? _data["rooAmount"] : <any>null;
            this.vendorAmount = _data["vendorAmount"] !== undefined ? _data["vendorAmount"] : <any>null;
            this.profit = _data["profit"] !== undefined ? _data["profit"] : <any>null;
            this.operatorShare = _data["operatorShare"] !== undefined ? _data["operatorShare"] : <any>null;
            this.supportShare = _data["supportShare"] !== undefined ? _data["supportShare"] : <any>null;
            this.rooShare = _data["rooShare"] !== undefined ? _data["rooShare"] : <any>null;
            if (Array.isArray(_data["outgoingInvoices"])) {
                this.outgoingInvoices = [] as any;
                for (let item of _data["outgoingInvoices"])
                    this.outgoingInvoices!.push(CommissionInvoiceEntry.fromJS(item));
            }
            else {
                this.outgoingInvoices = <any>null;
            }
            if (Array.isArray(_data["incomingInvoices"])) {
                this.incomingInvoices = [] as any;
                for (let item of _data["incomingInvoices"])
                    this.incomingInvoices!.push(CommissionInvoiceEntry.fromJS(item));
            }
            else {
                this.incomingInvoices = <any>null;
            }
        }
    }

    static fromJS(data: any): CommissionIssueEntry {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionIssueEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        data["property"] = this.property ? this.property.toJSON() : <any>null;
        data["accountManager"] = this.accountManager ? this.accountManager.toJSON() : <any>null;
        data["referenceDate"] = this.referenceDate ? this.referenceDate.toJSON() : <any>null;
        data["invoiceStatus"] = this.invoiceStatus !== undefined ? this.invoiceStatus : <any>null;
        data["paymentStatus"] = this.paymentStatus !== undefined ? this.paymentStatus : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["rooAmount"] = this.rooAmount !== undefined ? this.rooAmount : <any>null;
        data["vendorAmount"] = this.vendorAmount !== undefined ? this.vendorAmount : <any>null;
        data["profit"] = this.profit !== undefined ? this.profit : <any>null;
        data["operatorShare"] = this.operatorShare !== undefined ? this.operatorShare : <any>null;
        data["supportShare"] = this.supportShare !== undefined ? this.supportShare : <any>null;
        data["rooShare"] = this.rooShare !== undefined ? this.rooShare : <any>null;
        if (Array.isArray(this.outgoingInvoices)) {
            data["outgoingInvoices"] = [];
            for (let item of this.outgoingInvoices)
                data["outgoingInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.incomingInvoices)) {
            data["incomingInvoices"] = [];
            for (let item of this.incomingInvoices)
                data["incomingInvoices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommissionIssueEntry {
    issueId: string;
    workorderId: string;
    property: IPropertySummary | null;
    accountManager: IUserSummary | null;
    referenceDate: IInstant | null;
    invoiceStatus: InvoiceStatus | null;
    paymentStatus: CommissionPaymentStatus;
    friendlyId: string | null;
    rooAmount: number;
    vendorAmount: number;
    profit: number;
    operatorShare: number;
    supportShare: number;
    rooShare: number;
    outgoingInvoices: ICommissionInvoiceEntry[] | null;
    incomingInvoices: ICommissionInvoiceEntry[] | null;
}

export class PropertySummary implements IPropertySummary {
    id: string;
    name: string | null;
    address: Address | null;
    isActive: boolean;
    isOccupied: boolean;
    managerId: string | null;
    displayAddress: string | null;
    hasPool: boolean;
    lotSize: number | null;
    propertyArea: number | null;
    bedroomNumber: number | null;
    bathroomNumber: number | null;
    gateCode: string | null;
    coverPhoto: AttachmentFile | null;
    [immerable] = true;

    constructor(data?: IPropertySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
            this.coverPhoto = data.coverPhoto && !(<any>data.coverPhoto).toJSON ? new AttachmentFile(data.coverPhoto) : <AttachmentFile>this.coverPhoto;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isOccupied = _data["isOccupied"] !== undefined ? _data["isOccupied"] : <any>null;
            this.managerId = _data["managerId"] !== undefined ? _data["managerId"] : <any>null;
            this.displayAddress = _data["displayAddress"] !== undefined ? _data["displayAddress"] : <any>null;
            this.hasPool = _data["hasPool"] !== undefined ? _data["hasPool"] : <any>null;
            this.lotSize = _data["lotSize"] !== undefined ? _data["lotSize"] : <any>null;
            this.propertyArea = _data["propertyArea"] !== undefined ? _data["propertyArea"] : <any>null;
            this.bedroomNumber = _data["bedroomNumber"] !== undefined ? _data["bedroomNumber"] : <any>null;
            this.bathroomNumber = _data["bathroomNumber"] !== undefined ? _data["bathroomNumber"] : <any>null;
            this.gateCode = _data["gateCode"] !== undefined ? _data["gateCode"] : <any>null;
            this.coverPhoto = _data["coverPhoto"] ? AttachmentFile.fromJS(_data["coverPhoto"]) : <any>null;
        }
    }

    static fromJS(data: any): PropertySummary {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isOccupied"] = this.isOccupied !== undefined ? this.isOccupied : <any>null;
        data["managerId"] = this.managerId !== undefined ? this.managerId : <any>null;
        data["displayAddress"] = this.displayAddress !== undefined ? this.displayAddress : <any>null;
        data["hasPool"] = this.hasPool !== undefined ? this.hasPool : <any>null;
        data["lotSize"] = this.lotSize !== undefined ? this.lotSize : <any>null;
        data["propertyArea"] = this.propertyArea !== undefined ? this.propertyArea : <any>null;
        data["bedroomNumber"] = this.bedroomNumber !== undefined ? this.bedroomNumber : <any>null;
        data["bathroomNumber"] = this.bathroomNumber !== undefined ? this.bathroomNumber : <any>null;
        data["gateCode"] = this.gateCode !== undefined ? this.gateCode : <any>null;
        data["coverPhoto"] = this.coverPhoto ? this.coverPhoto.toJSON() : <any>null;
        return data;
    }
}

export interface IPropertySummary {
    id: string;
    name: string | null;
    address: IAddress | null;
    isActive: boolean;
    isOccupied: boolean;
    managerId: string | null;
    displayAddress: string | null;
    hasPool: boolean;
    lotSize: number | null;
    propertyArea: number | null;
    bedroomNumber: number | null;
    bathroomNumber: number | null;
    gateCode: string | null;
    coverPhoto: IAttachmentFile | null;
}

export class AttachmentFile implements IAttachmentFile {
    id: string;
    fileName: string | null;
    size: number;
    mimeType: string | null;
    urls: AttachmentUrls | null;
    createdAt: Date;
    [immerable] = true;

    constructor(data?: IAttachmentFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.urls = data.urls && !(<any>data.urls).toJSON ? new AttachmentUrls(data.urls) : <AttachmentUrls>this.urls;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : <any>null;
            this.urls = _data["urls"] ? AttachmentUrls.fromJS(_data["urls"]) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AttachmentFile {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : <any>null;
        data["urls"] = this.urls ? this.urls.toJSON() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        return data;
    }
}

export interface IAttachmentFile {
    id: string;
    fileName: string | null;
    size: number;
    mimeType: string | null;
    urls: IAttachmentUrls | null;
    createdAt: Date;
}

export class AttachmentUrls implements IAttachmentUrls {
    downloadUrl: string | null;
    serveUrl: string | null;
    thumbnailUrl: string | null;
    [immerable] = true;

    constructor(data?: IAttachmentUrls) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadUrl = _data["downloadUrl"] !== undefined ? _data["downloadUrl"] : <any>null;
            this.serveUrl = _data["serveUrl"] !== undefined ? _data["serveUrl"] : <any>null;
            this.thumbnailUrl = _data["thumbnailUrl"] !== undefined ? _data["thumbnailUrl"] : <any>null;
        }
    }

    static fromJS(data: any): AttachmentUrls {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentUrls();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadUrl"] = this.downloadUrl !== undefined ? this.downloadUrl : <any>null;
        data["serveUrl"] = this.serveUrl !== undefined ? this.serveUrl : <any>null;
        data["thumbnailUrl"] = this.thumbnailUrl !== undefined ? this.thumbnailUrl : <any>null;
        return data;
    }
}

export interface IAttachmentUrls {
    downloadUrl: string | null;
    serveUrl: string | null;
    thumbnailUrl: string | null;
}

export class Instant implements IInstant {
    dateTime: Date;
    utcOffset: number;
    [immerable] = true;

    constructor(data?: IInstant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>null;
            this.utcOffset = _data["utcOffset"] !== undefined ? _data["utcOffset"] : <any>null;
        }
    }

    static fromJS(data: any): Instant {
        data = typeof data === 'object' ? data : {};
        let result = new Instant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>null;
        data["utcOffset"] = this.utcOffset !== undefined ? this.utcOffset : <any>null;
        return data;
    }
}

export interface IInstant {
    dateTime: Date;
    utcOffset: number;
}

export enum InvoiceStatus {
    Draft = 0,
    PendingReview = 1,
    Accepted = 2,
    Rejected = 3,
    Paid = 4,
    Edited = 5,
    PaymentSent = 6,
}

export enum CommissionPaymentStatus {
    NotPaid = 0,
    Paid = 1,
}

export class CommissionInvoiceEntry implements ICommissionInvoiceEntry {
    issueId: string;
    workorderId: string;
    friendlyIssueId: string | null;
    invoiceId: string;
    date: Instant | null;
    status: InvoiceStatus;
    friendlyId: string | null;
    finalTotal: number;
    [immerable] = true;

    constructor(data?: ICommissionInvoiceEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.date = data.date && !(<any>data.date).toJSON ? new Instant(data.date) : <Instant>this.date;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
            this.friendlyIssueId = _data["friendlyIssueId"] !== undefined ? _data["friendlyIssueId"] : <any>null;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.date = _data["date"] ? Instant.fromJS(_data["date"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.finalTotal = _data["finalTotal"] !== undefined ? _data["finalTotal"] : <any>null;
        }
    }

    static fromJS(data: any): CommissionInvoiceEntry {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionInvoiceEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        data["friendlyIssueId"] = this.friendlyIssueId !== undefined ? this.friendlyIssueId : <any>null;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["date"] = this.date ? this.date.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["finalTotal"] = this.finalTotal !== undefined ? this.finalTotal : <any>null;
        return data;
    }
}

export interface ICommissionInvoiceEntry {
    issueId: string;
    workorderId: string;
    friendlyIssueId: string | null;
    invoiceId: string;
    date: IInstant | null;
    status: InvoiceStatus;
    friendlyId: string | null;
    finalTotal: number;
}

export class GetCommissionReportPayload implements IGetCommissionReportPayload {
    accountManagerId: string | null;
    invoiceStatus: InvoiceStatus | null;
    paymentStatus: CommissionPaymentStatus | null;
    startDate: Instant | null;
    endDate: Instant | null;
    [immerable] = true;

    constructor(data?: IGetCommissionReportPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountManagerId = _data["accountManagerId"] !== undefined ? _data["accountManagerId"] : <any>null;
            this.invoiceStatus = _data["invoiceStatus"] !== undefined ? _data["invoiceStatus"] : <any>null;
            this.paymentStatus = _data["paymentStatus"] !== undefined ? _data["paymentStatus"] : <any>null;
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
        }
    }

    static fromJS(data: any): GetCommissionReportPayload {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommissionReportPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountManagerId"] = this.accountManagerId !== undefined ? this.accountManagerId : <any>null;
        data["invoiceStatus"] = this.invoiceStatus !== undefined ? this.invoiceStatus : <any>null;
        data["paymentStatus"] = this.paymentStatus !== undefined ? this.paymentStatus : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        return data;
    }
}

export interface IGetCommissionReportPayload {
    accountManagerId: string | null;
    invoiceStatus: InvoiceStatus | null;
    paymentStatus: CommissionPaymentStatus | null;
    startDate: IInstant | null;
    endDate: IInstant | null;
}

export class MarkCommissionPaymentPayload implements IMarkCommissionPaymentPayload {
    issueId: string;
    paid: boolean;
    [immerable] = true;

    constructor(data?: IMarkCommissionPaymentPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.paid = _data["paid"] !== undefined ? _data["paid"] : <any>null;
        }
    }

    static fromJS(data: any): MarkCommissionPaymentPayload {
        data = typeof data === 'object' ? data : {};
        let result = new MarkCommissionPaymentPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["paid"] = this.paid !== undefined ? this.paid : <any>null;
        return data;
    }
}

export interface IMarkCommissionPaymentPayload {
    issueId: string;
    paid: boolean;
}

export class PMChartData implements IPMChartData {
    id: string;
    name: string | null;
    count: number;
    count1: number;
    count2: number;
    [immerable] = true;

    constructor(data?: IPMChartData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.count1 = _data["count1"] !== undefined ? _data["count1"] : <any>null;
            this.count2 = _data["count2"] !== undefined ? _data["count2"] : <any>null;
        }
    }

    static fromJS(data: any): PMChartData {
        data = typeof data === 'object' ? data : {};
        let result = new PMChartData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["count1"] = this.count1 !== undefined ? this.count1 : <any>null;
        data["count2"] = this.count2 !== undefined ? this.count2 : <any>null;
        return data;
    }
}

export interface IPMChartData {
    id: string;
    name: string | null;
    count: number;
    count1: number;
    count2: number;
}

export class GetIssueStatsByPMPayload implements IGetIssueStatsByPMPayload {
    id: string | null;
    from: Date;
    to: Date;
    companyId: string | null;
    vendorIds: string[] | null;
    stateCode: string | null;
    city: string | null;
    [immerable] = true;

    constructor(data?: IGetIssueStatsByPMPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            else {
                this.vendorIds = <any>null;
            }
            this.stateCode = _data["stateCode"] !== undefined ? _data["stateCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
        }
    }

    static fromJS(data: any): GetIssueStatsByPMPayload {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueStatsByPMPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["from"] = this.from ? this.from.toISOString() : <any>null;
        data["to"] = this.to ? this.to.toISOString() : <any>null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        data["stateCode"] = this.stateCode !== undefined ? this.stateCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        return data;
    }
}

export interface IGetIssueStatsByPMPayload {
    id: string | null;
    from: Date;
    to: Date;
    companyId: string | null;
    vendorIds: string[] | null;
    stateCode: string | null;
    city: string | null;
}

export class VendorCountInfo implements IVendorCountInfo {
    id: string;
    companyName: string | null;
    count: number;
    count1: number;
    count2: number;
    count3: number;
    count4: number;
    [immerable] = true;

    constructor(data?: IVendorCountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.count1 = _data["count1"] !== undefined ? _data["count1"] : <any>null;
            this.count2 = _data["count2"] !== undefined ? _data["count2"] : <any>null;
            this.count3 = _data["count3"] !== undefined ? _data["count3"] : <any>null;
            this.count4 = _data["count4"] !== undefined ? _data["count4"] : <any>null;
        }
    }

    static fromJS(data: any): VendorCountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VendorCountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["count1"] = this.count1 !== undefined ? this.count1 : <any>null;
        data["count2"] = this.count2 !== undefined ? this.count2 : <any>null;
        data["count3"] = this.count3 !== undefined ? this.count3 : <any>null;
        data["count4"] = this.count4 !== undefined ? this.count4 : <any>null;
        return data;
    }
}

export interface IVendorCountInfo {
    id: string;
    companyName: string | null;
    count: number;
    count1: number;
    count2: number;
    count3: number;
    count4: number;
}

export class GetIssueStatusByVendorPayload implements IGetIssueStatusByVendorPayload {
    companyId: string | null;
    vendorIds: string[] | null;
    stateCode: string | null;
    city: string | null;
    userId: string | null;
    [immerable] = true;

    constructor(data?: IGetIssueStatusByVendorPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            else {
                this.vendorIds = <any>null;
            }
            this.stateCode = _data["stateCode"] !== undefined ? _data["stateCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): GetIssueStatusByVendorPayload {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueStatusByVendorPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        data["stateCode"] = this.stateCode !== undefined ? this.stateCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IGetIssueStatusByVendorPayload {
    companyId: string | null;
    vendorIds: string[] | null;
    stateCode: string | null;
    city: string | null;
    userId: string | null;
}

export class VendorCountInfoDrillDown implements IVendorCountInfoDrillDown {
    focusId: number;
    focusName: string | null;
    count: number;
    count1: number;
    count2: number;
    count3: number;
    count4: number;
    [immerable] = true;

    constructor(data?: IVendorCountInfoDrillDown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.focusId = _data["focusId"] !== undefined ? _data["focusId"] : <any>null;
            this.focusName = _data["focusName"] !== undefined ? _data["focusName"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.count1 = _data["count1"] !== undefined ? _data["count1"] : <any>null;
            this.count2 = _data["count2"] !== undefined ? _data["count2"] : <any>null;
            this.count3 = _data["count3"] !== undefined ? _data["count3"] : <any>null;
            this.count4 = _data["count4"] !== undefined ? _data["count4"] : <any>null;
        }
    }

    static fromJS(data: any): VendorCountInfoDrillDown {
        data = typeof data === 'object' ? data : {};
        let result = new VendorCountInfoDrillDown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["focusId"] = this.focusId !== undefined ? this.focusId : <any>null;
        data["focusName"] = this.focusName !== undefined ? this.focusName : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["count1"] = this.count1 !== undefined ? this.count1 : <any>null;
        data["count2"] = this.count2 !== undefined ? this.count2 : <any>null;
        data["count3"] = this.count3 !== undefined ? this.count3 : <any>null;
        data["count4"] = this.count4 !== undefined ? this.count4 : <any>null;
        return data;
    }
}

export interface IVendorCountInfoDrillDown {
    focusId: number;
    focusName: string | null;
    count: number;
    count1: number;
    count2: number;
    count3: number;
    count4: number;
}

export class IssueSummary implements IIssueSummary {
    id: string;
    parentId: string | null;
    title: string | null;
    description: string | null;
    friendlyId: string | null;
    numberInfo: IssueNumberInfo | null;
    sequentialId: number;
    childSequentialId: number | null;
    managementCompanyId: string;
    propertyId: string;
    workorderId: string;
    status: IssueStatus;
    dateCreated: Date;
    dateModified: Date | null;
    managingVendorId: string | null;
    linkedInspectionId: string | null;
    [immerable] = true;

    constructor(data?: IIssueSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.numberInfo = data.numberInfo && !(<any>data.numberInfo).toJSON ? new IssueNumberInfo(data.numberInfo) : <IssueNumberInfo>this.numberInfo;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.numberInfo = _data["numberInfo"] ? IssueNumberInfo.fromJS(_data["numberInfo"]) : <any>null;
            this.sequentialId = _data["sequentialId"] !== undefined ? _data["sequentialId"] : <any>null;
            this.childSequentialId = _data["childSequentialId"] !== undefined ? _data["childSequentialId"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            this.propertyId = _data["propertyId"] !== undefined ? _data["propertyId"] : <any>null;
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>null;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>null;
            this.managingVendorId = _data["managingVendorId"] !== undefined ? _data["managingVendorId"] : <any>null;
            this.linkedInspectionId = _data["linkedInspectionId"] !== undefined ? _data["linkedInspectionId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueSummary {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["parentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["numberInfo"] = this.numberInfo ? this.numberInfo.toJSON() : <any>null;
        data["sequentialId"] = this.sequentialId !== undefined ? this.sequentialId : <any>null;
        data["childSequentialId"] = this.childSequentialId !== undefined ? this.childSequentialId : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        data["propertyId"] = this.propertyId !== undefined ? this.propertyId : <any>null;
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>null;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>null;
        data["managingVendorId"] = this.managingVendorId !== undefined ? this.managingVendorId : <any>null;
        data["linkedInspectionId"] = this.linkedInspectionId !== undefined ? this.linkedInspectionId : <any>null;
        return data;
    }
}

export interface IIssueSummary {
    id: string;
    parentId: string | null;
    title: string | null;
    description: string | null;
    friendlyId: string | null;
    numberInfo: IIssueNumberInfo | null;
    sequentialId: number;
    childSequentialId: number | null;
    managementCompanyId: string;
    propertyId: string;
    workorderId: string;
    status: IssueStatus;
    dateCreated: Date;
    dateModified: Date | null;
    managingVendorId: string | null;
    linkedInspectionId: string | null;
}

export class Issue extends IssueSummary implements IIssue {
    requireScheduleBeforeBid: boolean | null;
    isLegacy: boolean;
    markedEstimateSent: boolean;
    locationType: LocationType;
    interiorLocation: LookupItem | null;
    exteriorLocation: LookupItem | null;
    workType: LookupItem | null;
    schedule: ScheduleProposal | null;
    vendorCandidates: VendorCandidate[] | null;
    createdBy: User | null;
    vendor: Vendor | null;
    managers: UserSummary[] | null;
    property: PropertySummary | null;
    [immerable] = true;

    constructor(data?: IIssue) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
            this.interiorLocation = data.interiorLocation && !(<any>data.interiorLocation).toJSON ? new LookupItem(data.interiorLocation) : <LookupItem>this.interiorLocation;
            this.exteriorLocation = data.exteriorLocation && !(<any>data.exteriorLocation).toJSON ? new LookupItem(data.exteriorLocation) : <LookupItem>this.exteriorLocation;
            this.workType = data.workType && !(<any>data.workType).toJSON ? new LookupItem(data.workType) : <LookupItem>this.workType;
            this.schedule = data.schedule && !(<any>data.schedule).toJSON ? new ScheduleProposal(data.schedule) : <ScheduleProposal>this.schedule;
            if (data.vendorCandidates) {
                this.vendorCandidates = [];
                for (let i = 0; i < data.vendorCandidates.length; i++) {
                    let item = data.vendorCandidates[i];
                    this.vendorCandidates[i] = item && !(<any>item).toJSON ? new VendorCandidate(item) : <VendorCandidate>item;
                }
            }
            this.createdBy = data.createdBy && !(<any>data.createdBy).toJSON ? new User(data.createdBy) : <User>this.createdBy;
            this.vendor = data.vendor && !(<any>data.vendor).toJSON ? new Vendor(data.vendor) : <Vendor>this.vendor;
            if (data.managers) {
                this.managers = [];
                for (let i = 0; i < data.managers.length; i++) {
                    let item = data.managers[i];
                    this.managers[i] = item && !(<any>item).toJSON ? new UserSummary(item) : <UserSummary>item;
                }
            }
            this.property = data.property && !(<any>data.property).toJSON ? new PropertySummary(data.property) : <PropertySummary>this.property;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requireScheduleBeforeBid = _data["requireScheduleBeforeBid"] !== undefined ? _data["requireScheduleBeforeBid"] : <any>null;
            this.isLegacy = _data["isLegacy"] !== undefined ? _data["isLegacy"] : <any>null;
            this.markedEstimateSent = _data["markedEstimateSent"] !== undefined ? _data["markedEstimateSent"] : <any>null;
            this.locationType = _data["locationType"] !== undefined ? _data["locationType"] : <any>null;
            this.interiorLocation = _data["interiorLocation"] ? LookupItem.fromJS(_data["interiorLocation"]) : <any>null;
            this.exteriorLocation = _data["exteriorLocation"] ? LookupItem.fromJS(_data["exteriorLocation"]) : <any>null;
            this.workType = _data["workType"] ? LookupItem.fromJS(_data["workType"]) : <any>null;
            this.schedule = _data["schedule"] ? ScheduleProposal.fromJS(_data["schedule"]) : <any>null;
            if (Array.isArray(_data["vendorCandidates"])) {
                this.vendorCandidates = [] as any;
                for (let item of _data["vendorCandidates"])
                    this.vendorCandidates!.push(VendorCandidate.fromJS(item));
            }
            else {
                this.vendorCandidates = <any>null;
            }
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>null;
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>null;
            if (Array.isArray(_data["managers"])) {
                this.managers = [] as any;
                for (let item of _data["managers"])
                    this.managers!.push(UserSummary.fromJS(item));
            }
            else {
                this.managers = <any>null;
            }
            this.property = _data["property"] ? PropertySummary.fromJS(_data["property"]) : <any>null;
        }
    }

    static fromJS(data: any): Issue {
        data = typeof data === 'object' ? data : {};
        let result = new Issue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireScheduleBeforeBid"] = this.requireScheduleBeforeBid !== undefined ? this.requireScheduleBeforeBid : <any>null;
        data["isLegacy"] = this.isLegacy !== undefined ? this.isLegacy : <any>null;
        data["markedEstimateSent"] = this.markedEstimateSent !== undefined ? this.markedEstimateSent : <any>null;
        data["locationType"] = this.locationType !== undefined ? this.locationType : <any>null;
        data["interiorLocation"] = this.interiorLocation ? this.interiorLocation.toJSON() : <any>null;
        data["exteriorLocation"] = this.exteriorLocation ? this.exteriorLocation.toJSON() : <any>null;
        data["workType"] = this.workType ? this.workType.toJSON() : <any>null;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>null;
        if (Array.isArray(this.vendorCandidates)) {
            data["vendorCandidates"] = [];
            for (let item of this.vendorCandidates)
                data["vendorCandidates"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>null;
        if (Array.isArray(this.managers)) {
            data["managers"] = [];
            for (let item of this.managers)
                data["managers"].push(item.toJSON());
        }
        data["property"] = this.property ? this.property.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssue extends IIssueSummary {
    requireScheduleBeforeBid: boolean | null;
    isLegacy: boolean;
    markedEstimateSent: boolean;
    locationType: LocationType;
    interiorLocation: ILookupItem | null;
    exteriorLocation: ILookupItem | null;
    workType: ILookupItem | null;
    schedule: IScheduleProposal | null;
    vendorCandidates: IVendorCandidate[] | null;
    createdBy: IUser | null;
    vendor: IVendor | null;
    managers: IUserSummary[] | null;
    property: IPropertySummary | null;
}

export enum LocationType {
    Unknown = 0,
    Interior = 1,
    Exterior = 2,
}

export class ScheduleProposal implements IScheduleProposal {
    id: string;
    scheduledInstant: Instant | null;
    timeBlocks: TimeBlock[] | null;
    notes: string | null;
    reviewerNotes: string | null;
    proposalType: ProposalType;
    status: ScheduleStatus;
    proposedByUser: UserSummary | null;
    proposedByVendor: Vendor | null;
    [immerable] = true;

    constructor(data?: IScheduleProposal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.scheduledInstant = data.scheduledInstant && !(<any>data.scheduledInstant).toJSON ? new Instant(data.scheduledInstant) : <Instant>this.scheduledInstant;
            if (data.timeBlocks) {
                this.timeBlocks = [];
                for (let i = 0; i < data.timeBlocks.length; i++) {
                    let item = data.timeBlocks[i];
                    this.timeBlocks[i] = item && !(<any>item).toJSON ? new TimeBlock(item) : <TimeBlock>item;
                }
            }
            this.proposedByUser = data.proposedByUser && !(<any>data.proposedByUser).toJSON ? new UserSummary(data.proposedByUser) : <UserSummary>this.proposedByUser;
            this.proposedByVendor = data.proposedByVendor && !(<any>data.proposedByVendor).toJSON ? new Vendor(data.proposedByVendor) : <Vendor>this.proposedByVendor;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.scheduledInstant = _data["scheduledInstant"] ? Instant.fromJS(_data["scheduledInstant"]) : <any>null;
            if (Array.isArray(_data["timeBlocks"])) {
                this.timeBlocks = [] as any;
                for (let item of _data["timeBlocks"])
                    this.timeBlocks!.push(TimeBlock.fromJS(item));
            }
            else {
                this.timeBlocks = <any>null;
            }
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.reviewerNotes = _data["reviewerNotes"] !== undefined ? _data["reviewerNotes"] : <any>null;
            this.proposalType = _data["proposalType"] !== undefined ? _data["proposalType"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.proposedByUser = _data["proposedByUser"] ? UserSummary.fromJS(_data["proposedByUser"]) : <any>null;
            this.proposedByVendor = _data["proposedByVendor"] ? Vendor.fromJS(_data["proposedByVendor"]) : <any>null;
        }
    }

    static fromJS(data: any): ScheduleProposal {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleProposal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["scheduledInstant"] = this.scheduledInstant ? this.scheduledInstant.toJSON() : <any>null;
        if (Array.isArray(this.timeBlocks)) {
            data["timeBlocks"] = [];
            for (let item of this.timeBlocks)
                data["timeBlocks"].push(item.toJSON());
        }
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["reviewerNotes"] = this.reviewerNotes !== undefined ? this.reviewerNotes : <any>null;
        data["proposalType"] = this.proposalType !== undefined ? this.proposalType : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["proposedByUser"] = this.proposedByUser ? this.proposedByUser.toJSON() : <any>null;
        data["proposedByVendor"] = this.proposedByVendor ? this.proposedByVendor.toJSON() : <any>null;
        return data;
    }
}

export interface IScheduleProposal {
    id: string;
    scheduledInstant: IInstant | null;
    timeBlocks: ITimeBlock[] | null;
    notes: string | null;
    reviewerNotes: string | null;
    proposalType: ProposalType;
    status: ScheduleStatus;
    proposedByUser: IUserSummary | null;
    proposedByVendor: IVendor | null;
}

export class TimeBlock implements ITimeBlock {
    startHour: number;
    startMinutes: number;
    durationMinutes: number;
    display: string | null;
    [immerable] = true;

    constructor(data?: ITimeBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startHour = _data["startHour"] !== undefined ? _data["startHour"] : <any>null;
            this.startMinutes = _data["startMinutes"] !== undefined ? _data["startMinutes"] : <any>null;
            this.durationMinutes = _data["durationMinutes"] !== undefined ? _data["durationMinutes"] : <any>null;
            this.display = _data["display"] !== undefined ? _data["display"] : <any>null;
        }
    }

    static fromJS(data: any): TimeBlock {
        data = typeof data === 'object' ? data : {};
        let result = new TimeBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startHour"] = this.startHour !== undefined ? this.startHour : <any>null;
        data["startMinutes"] = this.startMinutes !== undefined ? this.startMinutes : <any>null;
        data["durationMinutes"] = this.durationMinutes !== undefined ? this.durationMinutes : <any>null;
        data["display"] = this.display !== undefined ? this.display : <any>null;
        return data;
    }
}

export interface ITimeBlock {
    startHour: number;
    startMinutes: number;
    durationMinutes: number;
    display: string | null;
}

export enum ProposalType {
    Unknown = 0,
    Tentative = 1,
    Final = 2,
}

export enum ScheduleStatus {
    PendingReview = 0,
    Accepted = 1,
    Rejected = 2,
}

export class VendorCandidate implements IVendorCandidate {
    id: string;
    issueId: string;
    vendor: Vendor | null;
    status: CandidacyStatus;
    [immerable] = true;

    constructor(data?: IVendorCandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.vendor = data.vendor && !(<any>data.vendor).toJSON ? new Vendor(data.vendor) : <Vendor>this.vendor;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): VendorCandidate {
        data = typeof data === 'object' ? data : {};
        let result = new VendorCandidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IVendorCandidate {
    id: string;
    issueId: string;
    vendor: IVendor | null;
    status: CandidacyStatus;
}

export enum CandidacyStatus {
    Invited = 0,
    Accepted = 1,
    Declined = 2,
    Expired = 3,
    NoLongerAvailable = 4,
}

export class IssueNumberInfo implements IIssueNumberInfo {
    issueNumber: number;
    parentIssueNumber: number | null;
    childIssueNumber: number | null;
    [immerable] = true;

    constructor(data?: IIssueNumberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueNumber = _data["issueNumber"] !== undefined ? _data["issueNumber"] : <any>null;
            this.parentIssueNumber = _data["parentIssueNumber"] !== undefined ? _data["parentIssueNumber"] : <any>null;
            this.childIssueNumber = _data["childIssueNumber"] !== undefined ? _data["childIssueNumber"] : <any>null;
        }
    }

    static fromJS(data: any): IssueNumberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new IssueNumberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueNumber"] = this.issueNumber !== undefined ? this.issueNumber : <any>null;
        data["parentIssueNumber"] = this.parentIssueNumber !== undefined ? this.parentIssueNumber : <any>null;
        data["childIssueNumber"] = this.childIssueNumber !== undefined ? this.childIssueNumber : <any>null;
        return data;
    }
}

export interface IIssueNumberInfo {
    issueNumber: number;
    parentIssueNumber: number | null;
    childIssueNumber: number | null;
}

export enum IssueStatus {
    Unknown = 0,
    New = 1,
    AssignedToVendor = 2,
    VendorScheduling = 3,
    TenantScheduling = 4,
    VendorDeclined = 6,
    WorkInProgress = 7,
    NeedsInvoice = 8,
    Closed = 9,
    Obsolete_10 = 10,
    Obsolete_11 = 11,
    Bidding = 12,
    AssignedToMultipleVendors = 13,
    TenantCanceled = 14,
    VendorUnresponsive = 15,
    Estimating = 16,
    DispatchingCrew = 17,
    CanceledOwnerDeclined = 18,
    CanceledLostBid = 19,
    CanceledOther = 20,
    InvoiceReview = 21,
    PaymentPending = 22,
    Paid = 23,
    BidReview = 24,
    CanceledUnassigned = 25,
    NeedToEstimate = 26,
}

export class SearchScheduledIssueCriteria implements ISearchScheduledIssueCriteria {
    currentOffset: number | null;
    scheduleStartDate: Date | null;
    scheduleEndDate: Date | null;
    scheduleStatus: ScheduleStatus | null;
    proposalType: ProposalType | null;
    managementCompanyId: string | null;
    vendorIds: string[] | null;
    stateCode: string | null;
    city: string | null;
    [immerable] = true;

    constructor(data?: ISearchScheduledIssueCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentOffset = _data["currentOffset"] !== undefined ? _data["currentOffset"] : <any>null;
            this.scheduleStartDate = _data["scheduleStartDate"] ? new Date(_data["scheduleStartDate"].toString()) : <any>null;
            this.scheduleEndDate = _data["scheduleEndDate"] ? new Date(_data["scheduleEndDate"].toString()) : <any>null;
            this.scheduleStatus = _data["scheduleStatus"] !== undefined ? _data["scheduleStatus"] : <any>null;
            this.proposalType = _data["proposalType"] !== undefined ? _data["proposalType"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            else {
                this.vendorIds = <any>null;
            }
            this.stateCode = _data["stateCode"] !== undefined ? _data["stateCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
        }
    }

    static fromJS(data: any): SearchScheduledIssueCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchScheduledIssueCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentOffset"] = this.currentOffset !== undefined ? this.currentOffset : <any>null;
        data["scheduleStartDate"] = this.scheduleStartDate ? this.scheduleStartDate.toISOString() : <any>null;
        data["scheduleEndDate"] = this.scheduleEndDate ? this.scheduleEndDate.toISOString() : <any>null;
        data["scheduleStatus"] = this.scheduleStatus !== undefined ? this.scheduleStatus : <any>null;
        data["proposalType"] = this.proposalType !== undefined ? this.proposalType : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        data["stateCode"] = this.stateCode !== undefined ? this.stateCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        return data;
    }
}

export interface ISearchScheduledIssueCriteria {
    currentOffset: number | null;
    scheduleStartDate: Date | null;
    scheduleEndDate: Date | null;
    scheduleStatus: ScheduleStatus | null;
    proposalType: ProposalType | null;
    managementCompanyId: string | null;
    vendorIds: string[] | null;
    stateCode: string | null;
    city: string | null;
}

export class ForcedIncludes implements IForcedIncludes {
    attachmentFile: AttachmentFile | null;
    fileVisibility: FileVisibility;
    attachmentEntityType: AttachmentEntityType;
    entityType: EntityType;
    insDocumentEnvelope: InsDocumentEnvelope | null;
    [immerable] = true;

    constructor(data?: IForcedIncludes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.attachmentFile = data.attachmentFile && !(<any>data.attachmentFile).toJSON ? new AttachmentFile(data.attachmentFile) : <AttachmentFile>this.attachmentFile;
            this.insDocumentEnvelope = data.insDocumentEnvelope && !(<any>data.insDocumentEnvelope).toJSON ? new InsDocumentEnvelope(data.insDocumentEnvelope) : <InsDocumentEnvelope>this.insDocumentEnvelope;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentFile = _data["attachmentFile"] ? AttachmentFile.fromJS(_data["attachmentFile"]) : <any>null;
            this.fileVisibility = _data["fileVisibility"] !== undefined ? _data["fileVisibility"] : <any>null;
            this.attachmentEntityType = _data["attachmentEntityType"] !== undefined ? _data["attachmentEntityType"] : <any>null;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : <any>null;
            this.insDocumentEnvelope = _data["insDocumentEnvelope"] ? InsDocumentEnvelope.fromJS(_data["insDocumentEnvelope"]) : <any>null;
        }
    }

    static fromJS(data: any): ForcedIncludes {
        data = typeof data === 'object' ? data : {};
        let result = new ForcedIncludes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentFile"] = this.attachmentFile ? this.attachmentFile.toJSON() : <any>null;
        data["fileVisibility"] = this.fileVisibility !== undefined ? this.fileVisibility : <any>null;
        data["attachmentEntityType"] = this.attachmentEntityType !== undefined ? this.attachmentEntityType : <any>null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : <any>null;
        data["insDocumentEnvelope"] = this.insDocumentEnvelope ? this.insDocumentEnvelope.toJSON() : <any>null;
        return data;
    }
}

export interface IForcedIncludes {
    attachmentFile: IAttachmentFile | null;
    fileVisibility: FileVisibility;
    attachmentEntityType: AttachmentEntityType;
    entityType: EntityType;
    insDocumentEnvelope: IInsDocumentEnvelope | null;
}

export enum FileVisibility {
    Unknown = 0,
    Public = 1,
    Private = 2,
}

export enum AttachmentEntityType {
    Unknown = 0,
    Issue = 1,
    Workorder = 2,
    Bid = 3,
    Invoice = 4,
    ChangeRequest = 5,
    Property = 8,
    Estimate = 9,
    EstimateLineItem = 10,
    BidLineItem = 11,
    InvoiceLineItem = 12,
    Vendor = 13,
    ManagementCompany = 14,
    Message = 15,
    ChangeRequestLineItem = 16,
    Inspection = 18,
    OriginalFile = 10001,
    ThumbnailFile = 10002,
    ForPdfFile = 10003,
}

export enum EntityType {
    Unknown = 0,
    Issue = 1,
    Workorder = 2,
    Bid = 3,
    Invoice = 4,
    ChangeOrderRequest = 5,
    User = 6,
    IssueActivityLog = 7,
    Property = 8,
    Estimate = 9,
    EstimateLineItem = 10,
    BidLineItem = 11,
    InvoiceLineItem = 12,
    Vendor = 13,
    ManagementCompany = 14,
    Message = 15,
    ChangeRequestLineItem = 16,
    CompanyMember = 17,
    Inspection = 18,
}

export class InsDocumentEnvelope implements IInsDocumentEnvelope {
    inspectionId: string;
    userId: string;
    version: number;
    timestamp: number;
    document: InsDocument | null;
    [immerable] = true;

    constructor(data?: IInsDocumentEnvelope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.document = data.document && !(<any>data.document).toJSON ? new InsDocument(data.document) : <InsDocument>this.document;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : <any>null;
            this.document = _data["document"] ? InsDocument.fromJS(_data["document"]) : <any>null;
        }
    }

    static fromJS(data: any): InsDocumentEnvelope {
        data = typeof data === 'object' ? data : {};
        let result = new InsDocumentEnvelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        data["document"] = this.document ? this.document.toJSON() : <any>null;
        return data;
    }
}

export interface IInsDocumentEnvelope {
    inspectionId: string;
    userId: string;
    version: number;
    timestamp: number;
    document: IInsDocument | null;
}

export class InsDocument implements IInsDocument {
    templateInfo: InsTemplateInfo | null;
    properties: InsDocumentProperties | null;
    layout: InsLayout | null;
    sharedStore: InsSharedStore | null;
    nodeValues: { [key: string]: InsNodeValue; } | null;
    [immerable] = true;

    constructor(data?: IInsDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.templateInfo = data.templateInfo && !(<any>data.templateInfo).toJSON ? new InsTemplateInfo(data.templateInfo) : <InsTemplateInfo>this.templateInfo;
            this.properties = data.properties && !(<any>data.properties).toJSON ? new InsDocumentProperties(data.properties) : <InsDocumentProperties>this.properties;
            this.layout = data.layout && !(<any>data.layout).toJSON ? new InsLayout(data.layout) : <InsLayout>this.layout;
            this.sharedStore = data.sharedStore && !(<any>data.sharedStore).toJSON ? new InsSharedStore(data.sharedStore) : <InsSharedStore>this.sharedStore;
            if (data.nodeValues) {
                this.nodeValues = {};
                for (let key in data.nodeValues) {
                    if (data.nodeValues.hasOwnProperty(key)) {
                        let item = data.nodeValues[key];
                        this.nodeValues[key] = item && !(<any>item).toJSON ? new InsNodeValue(item) : <InsNodeValue>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateInfo = _data["templateInfo"] ? InsTemplateInfo.fromJS(_data["templateInfo"]) : <any>null;
            this.properties = _data["properties"] ? InsDocumentProperties.fromJS(_data["properties"]) : <any>null;
            this.layout = _data["layout"] ? InsLayout.fromJS(_data["layout"]) : <any>null;
            this.sharedStore = _data["sharedStore"] ? InsSharedStore.fromJS(_data["sharedStore"]) : <any>null;
            if (_data["nodeValues"]) {
                this.nodeValues = {} as any;
                for (let key in _data["nodeValues"]) {
                    if (_data["nodeValues"].hasOwnProperty(key))
                        (<any>this.nodeValues)![key] = _data["nodeValues"][key] ? InsNodeValue.fromJS(_data["nodeValues"][key]) : new InsNodeValue();
                }
            }
            else {
                this.nodeValues = <any>null;
            }
        }
    }

    static fromJS(data: any): InsDocument {
        data = typeof data === 'object' ? data : {};
        let result = new InsDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateInfo"] = this.templateInfo ? this.templateInfo.toJSON() : <any>null;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>null;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>null;
        data["sharedStore"] = this.sharedStore ? this.sharedStore.toJSON() : <any>null;
        if (this.nodeValues) {
            data["nodeValues"] = {};
            for (let key in this.nodeValues) {
                if (this.nodeValues.hasOwnProperty(key))
                    (<any>data["nodeValues"])[key] = this.nodeValues[key] ? this.nodeValues[key].toJSON() : <any>null;
            }
        }
        return data;
    }
}

export interface IInsDocument {
    templateInfo: IInsTemplateInfo | null;
    properties: IInsDocumentProperties | null;
    layout: IInsLayout | null;
    sharedStore: IInsSharedStore | null;
    nodeValues: { [key: string]: IInsNodeValue; } | null;
}

export class InsTemplateInfo implements IInsTemplateInfo {
    toolingVersion: number;
    hash: string | null;
    type: string | null;
    [immerable] = true;

    constructor(data?: IInsTemplateInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toolingVersion = _data["toolingVersion"] !== undefined ? _data["toolingVersion"] : <any>null;
            this.hash = _data["hash"] !== undefined ? _data["hash"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): InsTemplateInfo {
        data = typeof data === 'object' ? data : {};
        let result = new InsTemplateInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toolingVersion"] = this.toolingVersion !== undefined ? this.toolingVersion : <any>null;
        data["hash"] = this.hash !== undefined ? this.hash : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IInsTemplateInfo {
    toolingVersion: number;
    hash: string | null;
    type: string | null;
}

export class InsDocumentProperties implements IInsDocumentProperties {
    bedroomCount: number;
    bedroomChanged: boolean;
    bathroomCount: number;
    bathroomChanged: boolean;
    [immerable] = true;

    constructor(data?: IInsDocumentProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bedroomCount = _data["bedroomCount"] !== undefined ? _data["bedroomCount"] : <any>null;
            this.bedroomChanged = _data["bedroomChanged"] !== undefined ? _data["bedroomChanged"] : <any>null;
            this.bathroomCount = _data["bathroomCount"] !== undefined ? _data["bathroomCount"] : <any>null;
            this.bathroomChanged = _data["bathroomChanged"] !== undefined ? _data["bathroomChanged"] : <any>null;
        }
    }

    static fromJS(data: any): InsDocumentProperties {
        data = typeof data === 'object' ? data : {};
        let result = new InsDocumentProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bedroomCount"] = this.bedroomCount !== undefined ? this.bedroomCount : <any>null;
        data["bedroomChanged"] = this.bedroomChanged !== undefined ? this.bedroomChanged : <any>null;
        data["bathroomCount"] = this.bathroomCount !== undefined ? this.bathroomCount : <any>null;
        data["bathroomChanged"] = this.bathroomChanged !== undefined ? this.bathroomChanged : <any>null;
        return data;
    }
}

export interface IInsDocumentProperties {
    bedroomCount: number;
    bedroomChanged: boolean;
    bathroomCount: number;
    bathroomChanged: boolean;
}

export class InsLayout implements IInsLayout {
    root: InsNodeInstance | null;
    [immerable] = true;

    constructor(data?: IInsLayout) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.root = data.root && !(<any>data.root).toJSON ? new InsNodeInstance(data.root) : <InsNodeInstance>this.root;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? InsNodeInstance.fromJS(_data["root"]) : <any>null;
        }
    }

    static fromJS(data: any): InsLayout {
        data = typeof data === 'object' ? data : {};
        let result = new InsLayout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : <any>null;
        return data;
    }
}

export interface IInsLayout {
    root: IInsNodeInstance | null;
}

export class InsDefNodeBase implements IInsDefNodeBase {
    name: string | null;
    fieldKeys: string[] | null;
    creatableNodeKeys: string[] | null;
    info: InsInfoNode | null;
    [immerable] = true;

    constructor(data?: IInsDefNodeBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.info = data.info && !(<any>data.info).toJSON ? new InsInfoNode(data.info) : <InsInfoNode>this.info;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["fieldKeys"])) {
                this.fieldKeys = [] as any;
                for (let item of _data["fieldKeys"])
                    this.fieldKeys!.push(item);
            }
            else {
                this.fieldKeys = <any>null;
            }
            if (Array.isArray(_data["creatableNodeKeys"])) {
                this.creatableNodeKeys = [] as any;
                for (let item of _data["creatableNodeKeys"])
                    this.creatableNodeKeys!.push(item);
            }
            else {
                this.creatableNodeKeys = <any>null;
            }
            this.info = _data["info"] ? InsInfoNode.fromJS(_data["info"]) : <any>null;
        }
    }

    static fromJS(data: any): InsDefNodeBase {
        data = typeof data === 'object' ? data : {};
        let result = new InsDefNodeBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.fieldKeys)) {
            data["fieldKeys"] = [];
            for (let item of this.fieldKeys)
                data["fieldKeys"].push(item);
        }
        if (Array.isArray(this.creatableNodeKeys)) {
            data["creatableNodeKeys"] = [];
            for (let item of this.creatableNodeKeys)
                data["creatableNodeKeys"].push(item);
        }
        data["info"] = this.info ? this.info.toJSON() : <any>null;
        return data;
    }
}

export interface IInsDefNodeBase {
    name: string | null;
    fieldKeys: string[] | null;
    creatableNodeKeys: string[] | null;
    info: IInsInfoNode | null;
}

export class InsNodeInstance extends InsDefNodeBase implements IInsNodeInstance {
    id: string;
    children: InsNodeInstance[] | null;
    [immerable] = true;

    constructor(data?: IInsNodeInstance) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(InsNodeInstance.fromJS(item));
            }
            else {
                this.children = <any>null;
            }
        }
    }

    static fromJS(data: any): InsNodeInstance {
        data = typeof data === 'object' ? data : {};
        let result = new InsNodeInstance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInsNodeInstance extends IInsDefNodeBase {
    id: string;
    children: InsNodeInstance[] | null;
}

export class InsInfoNode implements IInsInfoNode {
    type: InsNodeType;
    forLine: Line | null;
    forDynamicNode: DynamicNode | null;
    [immerable] = true;

    constructor(data?: IInsInfoNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.forLine = data.forLine && !(<any>data.forLine).toJSON ? new Line(data.forLine) : <Line>this.forLine;
            this.forDynamicNode = data.forDynamicNode && !(<any>data.forDynamicNode).toJSON ? new DynamicNode(data.forDynamicNode) : <DynamicNode>this.forDynamicNode;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.forLine = _data["forLine"] ? Line.fromJS(_data["forLine"]) : <any>null;
            this.forDynamicNode = _data["forDynamicNode"] ? DynamicNode.fromJS(_data["forDynamicNode"]) : <any>null;
        }
    }

    static fromJS(data: any): InsInfoNode {
        data = typeof data === 'object' ? data : {};
        let result = new InsInfoNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["forLine"] = this.forLine ? this.forLine.toJSON() : <any>null;
        data["forDynamicNode"] = this.forDynamicNode ? this.forDynamicNode.toJSON() : <any>null;
        return data;
    }
}

export interface IInsInfoNode {
    type: InsNodeType;
    forLine: ILine | null;
    forDynamicNode: IDynamicNode | null;
}

export enum InsNodeType {
    Section = 0,
    Line = 1,
    BulkEditSection = 2,
    DynamicNodeContainer = 3,
}

export class Line implements ILine {
    availableConditionKeys: string[] | null;
    availableActionKeys: string[] | null;
    [immerable] = true;

    constructor(data?: ILine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableConditionKeys"])) {
                this.availableConditionKeys = [] as any;
                for (let item of _data["availableConditionKeys"])
                    this.availableConditionKeys!.push(item);
            }
            else {
                this.availableConditionKeys = <any>null;
            }
            if (Array.isArray(_data["availableActionKeys"])) {
                this.availableActionKeys = [] as any;
                for (let item of _data["availableActionKeys"])
                    this.availableActionKeys!.push(item);
            }
            else {
                this.availableActionKeys = <any>null;
            }
        }
    }

    static fromJS(data: any): Line {
        data = typeof data === 'object' ? data : {};
        let result = new Line();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableConditionKeys)) {
            data["availableConditionKeys"] = [];
            for (let item of this.availableConditionKeys)
                data["availableConditionKeys"].push(item);
        }
        if (Array.isArray(this.availableActionKeys)) {
            data["availableActionKeys"] = [];
            for (let item of this.availableActionKeys)
                data["availableActionKeys"].push(item);
        }
        return data;
    }
}

export interface ILine {
    availableConditionKeys: string[] | null;
    availableActionKeys: string[] | null;
}

export class DynamicNode implements IDynamicNode {
    nodeKey: string | null;
    [immerable] = true;

    constructor(data?: IDynamicNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeKey = _data["nodeKey"] !== undefined ? _data["nodeKey"] : <any>null;
        }
    }

    static fromJS(data: any): DynamicNode {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeKey"] = this.nodeKey !== undefined ? this.nodeKey : <any>null;
        return data;
    }
}

export interface IDynamicNode {
    nodeKey: string | null;
}

export class InsSharedStore implements IInsSharedStore {
    nodes: { [key: string]: InsDefNode; } | null;
    lineConditions: { [key: string]: InsDefLineCondition; } | null;
    lineActions: { [key: string]: InsDefLineAction; } | null;
    fields: { [key: string]: InsDefField; } | null;
    [immerable] = true;

    constructor(data?: IInsSharedStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.lineConditions) {
                this.lineConditions = {};
                for (let key in data.lineConditions) {
                    if (data.lineConditions.hasOwnProperty(key)) {
                        let item = data.lineConditions[key];
                        this.lineConditions[key] = item && !(<any>item).toJSON ? new InsDefLineCondition(item) : <InsDefLineCondition>item;
                    }
                }
            }
            if (data.lineActions) {
                this.lineActions = {};
                for (let key in data.lineActions) {
                    if (data.lineActions.hasOwnProperty(key)) {
                        let item = data.lineActions[key];
                        this.lineActions[key] = item && !(<any>item).toJSON ? new InsDefLineAction(item) : <InsDefLineAction>item;
                    }
                }
            }
            if (data.fields) {
                this.fields = {};
                for (let key in data.fields) {
                    if (data.fields.hasOwnProperty(key)) {
                        let item = data.fields[key];
                        this.fields[key] = item && !(<any>item).toJSON ? new InsDefField(item) : <InsDefField>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["nodes"]) {
                this.nodes = {} as any;
                for (let key in _data["nodes"]) {
                    if (_data["nodes"].hasOwnProperty(key))
                        (<any>this.nodes)![key] = _data["nodes"][key] ? InsDefNode.fromJS(_data["nodes"][key]) : new InsDefNode();
                }
            }
            else {
                this.nodes = <any>null;
            }
            if (_data["lineConditions"]) {
                this.lineConditions = {} as any;
                for (let key in _data["lineConditions"]) {
                    if (_data["lineConditions"].hasOwnProperty(key))
                        (<any>this.lineConditions)![key] = _data["lineConditions"][key] ? InsDefLineCondition.fromJS(_data["lineConditions"][key]) : new InsDefLineCondition();
                }
            }
            else {
                this.lineConditions = <any>null;
            }
            if (_data["lineActions"]) {
                this.lineActions = {} as any;
                for (let key in _data["lineActions"]) {
                    if (_data["lineActions"].hasOwnProperty(key))
                        (<any>this.lineActions)![key] = _data["lineActions"][key] ? InsDefLineAction.fromJS(_data["lineActions"][key]) : new InsDefLineAction();
                }
            }
            else {
                this.lineActions = <any>null;
            }
            if (_data["fields"]) {
                this.fields = {} as any;
                for (let key in _data["fields"]) {
                    if (_data["fields"].hasOwnProperty(key))
                        (<any>this.fields)![key] = _data["fields"][key] ? InsDefField.fromJS(_data["fields"][key]) : new InsDefField();
                }
            }
            else {
                this.fields = <any>null;
            }
        }
    }

    static fromJS(data: any): InsSharedStore {
        data = typeof data === 'object' ? data : {};
        let result = new InsSharedStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.nodes) {
            data["nodes"] = {};
            for (let key in this.nodes) {
                if (this.nodes.hasOwnProperty(key))
                    (<any>data["nodes"])[key] = this.nodes[key] ? this.nodes[key].toJSON() : <any>null;
            }
        }
        if (this.lineConditions) {
            data["lineConditions"] = {};
            for (let key in this.lineConditions) {
                if (this.lineConditions.hasOwnProperty(key))
                    (<any>data["lineConditions"])[key] = this.lineConditions[key] ? this.lineConditions[key].toJSON() : <any>null;
            }
        }
        if (this.lineActions) {
            data["lineActions"] = {};
            for (let key in this.lineActions) {
                if (this.lineActions.hasOwnProperty(key))
                    (<any>data["lineActions"])[key] = this.lineActions[key] ? this.lineActions[key].toJSON() : <any>null;
            }
        }
        if (this.fields) {
            data["fields"] = {};
            for (let key in this.fields) {
                if (this.fields.hasOwnProperty(key))
                    (<any>data["fields"])[key] = this.fields[key] ? this.fields[key].toJSON() : <any>null;
            }
        }
        return data;
    }
}

export interface IInsSharedStore {
    nodes: { [key: string]: InsDefNode; } | null;
    lineConditions: { [key: string]: IInsDefLineCondition; } | null;
    lineActions: { [key: string]: IInsDefLineAction; } | null;
    fields: { [key: string]: IInsDefField; } | null;
}

export class InsDefNode extends InsDefNodeBase implements IInsDefNode {
    name: string | null;
    children: InsDefNode[] | null;
    [immerable] = true;

    constructor(data?: IInsDefNode) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(InsDefNode.fromJS(item));
            }
            else {
                this.children = <any>null;
            }
        }
    }

    static fromJS(data: any): InsDefNode {
        data = typeof data === 'object' ? data : {};
        let result = new InsDefNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInsDefNode extends IInsDefNodeBase {
    name: string | null;
    children: InsDefNode[] | null;
}

export class InsDefLineCondition implements IInsDefLineCondition {
    key: string | null;
    label: string | null;
    type: InsConditionType;
    [immerable] = true;

    constructor(data?: IInsDefLineCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): InsDefLineCondition {
        data = typeof data === 'object' ? data : {};
        let result = new InsDefLineCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IInsDefLineCondition {
    key: string | null;
    label: string | null;
    type: InsConditionType;
}

export enum InsConditionType {
    Acceptable = 0,
    NeedsAttention = 1,
}

export class InsDefLineAction implements IInsDefLineAction {
    key: string | null;
    label: string | null;
    type: InsActionType;
    [immerable] = true;

    constructor(data?: IInsDefLineAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): InsDefLineAction {
        data = typeof data === 'object' ? data : {};
        let result = new InsDefLineAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IInsDefLineAction {
    key: string | null;
    label: string | null;
    type: InsActionType;
}

export enum InsActionType {
    None = 0,
    Actionable = 1,
}

export class InsDefField implements IInsDefField {
    key: string | null;
    label: string | null;
    placeholder: string | null;
    visibility: InsFieldVisibilityRule | null;
    info: InsInfoField | null;
    [immerable] = true;

    constructor(data?: IInsDefField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.visibility = data.visibility && !(<any>data.visibility).toJSON ? new InsFieldVisibilityRule(data.visibility) : <InsFieldVisibilityRule>this.visibility;
            this.info = data.info && !(<any>data.info).toJSON ? new InsInfoField(data.info) : <InsInfoField>this.info;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.placeholder = _data["placeholder"] !== undefined ? _data["placeholder"] : <any>null;
            this.visibility = _data["visibility"] ? InsFieldVisibilityRule.fromJS(_data["visibility"]) : <any>null;
            this.info = _data["info"] ? InsInfoField.fromJS(_data["info"]) : <any>null;
        }
    }

    static fromJS(data: any): InsDefField {
        data = typeof data === 'object' ? data : {};
        let result = new InsDefField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["placeholder"] = this.placeholder !== undefined ? this.placeholder : <any>null;
        data["visibility"] = this.visibility ? this.visibility.toJSON() : <any>null;
        data["info"] = this.info ? this.info.toJSON() : <any>null;
        return data;
    }
}

export interface IInsDefField {
    key: string | null;
    label: string | null;
    placeholder: string | null;
    visibility: IInsFieldVisibilityRule | null;
    info: IInsInfoField | null;
}

export class InsFieldVisibilityRule implements IInsFieldVisibilityRule {
    type: InsFieldVisibilityRuleType;
    forIfConditionType: IfConditionType | null;
    forIfActionType: IfActionType | null;
    forIfActionKey: IfActionKey | null;
    [immerable] = true;

    constructor(data?: IInsFieldVisibilityRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.forIfConditionType = data.forIfConditionType && !(<any>data.forIfConditionType).toJSON ? new IfConditionType(data.forIfConditionType) : <IfConditionType>this.forIfConditionType;
            this.forIfActionType = data.forIfActionType && !(<any>data.forIfActionType).toJSON ? new IfActionType(data.forIfActionType) : <IfActionType>this.forIfActionType;
            this.forIfActionKey = data.forIfActionKey && !(<any>data.forIfActionKey).toJSON ? new IfActionKey(data.forIfActionKey) : <IfActionKey>this.forIfActionKey;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.forIfConditionType = _data["forIfConditionType"] ? IfConditionType.fromJS(_data["forIfConditionType"]) : <any>null;
            this.forIfActionType = _data["forIfActionType"] ? IfActionType.fromJS(_data["forIfActionType"]) : <any>null;
            this.forIfActionKey = _data["forIfActionKey"] ? IfActionKey.fromJS(_data["forIfActionKey"]) : <any>null;
        }
    }

    static fromJS(data: any): InsFieldVisibilityRule {
        data = typeof data === 'object' ? data : {};
        let result = new InsFieldVisibilityRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["forIfConditionType"] = this.forIfConditionType ? this.forIfConditionType.toJSON() : <any>null;
        data["forIfActionType"] = this.forIfActionType ? this.forIfActionType.toJSON() : <any>null;
        data["forIfActionKey"] = this.forIfActionKey ? this.forIfActionKey.toJSON() : <any>null;
        return data;
    }
}

export interface IInsFieldVisibilityRule {
    type: InsFieldVisibilityRuleType;
    forIfConditionType: IIfConditionType | null;
    forIfActionType: IIfActionType | null;
    forIfActionKey: IIfActionKey | null;
}

export enum InsFieldVisibilityRuleType {
    Always = 0,
    IfActionType = 1,
    IfActionKey = 2,
    IfConditionType = 3,
}

export class IfConditionType implements IIfConditionType {
    type: InsConditionType;
    [immerable] = true;

    constructor(data?: IIfConditionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): IfConditionType {
        data = typeof data === 'object' ? data : {};
        let result = new IfConditionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IIfConditionType {
    type: InsConditionType;
}

export class IfActionType implements IIfActionType {
    type: InsActionType;
    [immerable] = true;

    constructor(data?: IIfActionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): IfActionType {
        data = typeof data === 'object' ? data : {};
        let result = new IfActionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IIfActionType {
    type: InsActionType;
}

export class IfActionKey implements IIfActionKey {
    actionKeys: string[] | null;
    [immerable] = true;

    constructor(data?: IIfActionKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["actionKeys"])) {
                this.actionKeys = [] as any;
                for (let item of _data["actionKeys"])
                    this.actionKeys!.push(item);
            }
            else {
                this.actionKeys = <any>null;
            }
        }
    }

    static fromJS(data: any): IfActionKey {
        data = typeof data === 'object' ? data : {};
        let result = new IfActionKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actionKeys)) {
            data["actionKeys"] = [];
            for (let item of this.actionKeys)
                data["actionKeys"].push(item);
        }
        return data;
    }
}

export interface IIfActionKey {
    actionKeys: string[] | null;
}

export class InsInfoField implements IInsInfoField {
    type: InsFieldType;
    forSingleSelect: SingleSelect | null;
    forPictures: Pictures | null;
    forMultiCheckbox: MultiCheckbox | null;
    [immerable] = true;

    constructor(data?: IInsInfoField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.forSingleSelect = data.forSingleSelect && !(<any>data.forSingleSelect).toJSON ? new SingleSelect(data.forSingleSelect) : <SingleSelect>this.forSingleSelect;
            this.forPictures = data.forPictures && !(<any>data.forPictures).toJSON ? new Pictures(data.forPictures) : <Pictures>this.forPictures;
            this.forMultiCheckbox = data.forMultiCheckbox && !(<any>data.forMultiCheckbox).toJSON ? new MultiCheckbox(data.forMultiCheckbox) : <MultiCheckbox>this.forMultiCheckbox;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.forSingleSelect = _data["forSingleSelect"] ? SingleSelect.fromJS(_data["forSingleSelect"]) : <any>null;
            this.forPictures = _data["forPictures"] ? Pictures.fromJS(_data["forPictures"]) : <any>null;
            this.forMultiCheckbox = _data["forMultiCheckbox"] ? MultiCheckbox.fromJS(_data["forMultiCheckbox"]) : <any>null;
        }
    }

    static fromJS(data: any): InsInfoField {
        data = typeof data === 'object' ? data : {};
        let result = new InsInfoField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["forSingleSelect"] = this.forSingleSelect ? this.forSingleSelect.toJSON() : <any>null;
        data["forPictures"] = this.forPictures ? this.forPictures.toJSON() : <any>null;
        data["forMultiCheckbox"] = this.forMultiCheckbox ? this.forMultiCheckbox.toJSON() : <any>null;
        return data;
    }
}

export interface IInsInfoField {
    type: InsFieldType;
    forSingleSelect: ISingleSelect | null;
    forPictures: IPictures | null;
    forMultiCheckbox: IMultiCheckbox | null;
}

export enum InsFieldType {
    TextLine = 0,
    TextArea = 1,
    Money = 2,
    Numeric = 3,
    SingleSelect = 4,
    MultiCheckbox = 5,
    Pictures = 6,
}

export class SingleSelect implements ISingleSelect {
    options: string[] | null;
    allowCustom: boolean;
    [immerable] = true;

    constructor(data?: ISingleSelect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            else {
                this.options = <any>null;
            }
            this.allowCustom = _data["allowCustom"] !== undefined ? _data["allowCustom"] : <any>null;
        }
    }

    static fromJS(data: any): SingleSelect {
        data = typeof data === 'object' ? data : {};
        let result = new SingleSelect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["allowCustom"] = this.allowCustom !== undefined ? this.allowCustom : <any>null;
        return data;
    }
}

export interface ISingleSelect {
    options: string[] | null;
    allowCustom: boolean;
}

export class Pictures implements IPictures {
    maxEntries: number;
    [immerable] = true;

    constructor(data?: IPictures) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxEntries = _data["maxEntries"] !== undefined ? _data["maxEntries"] : <any>null;
        }
    }

    static fromJS(data: any): Pictures {
        data = typeof data === 'object' ? data : {};
        let result = new Pictures();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxEntries"] = this.maxEntries !== undefined ? this.maxEntries : <any>null;
        return data;
    }
}

export interface IPictures {
    maxEntries: number;
}

export class MultiCheckbox implements IMultiCheckbox {
    options: string[] | null;
    [immerable] = true;

    constructor(data?: IMultiCheckbox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            else {
                this.options = <any>null;
            }
        }
    }

    static fromJS(data: any): MultiCheckbox {
        data = typeof data === 'object' ? data : {};
        let result = new MultiCheckbox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }
}

export interface IMultiCheckbox {
    options: string[] | null;
}

export class InsNodeValue implements IInsNodeValue {
    nodeId: string;
    selectedAction: string | null;
    selectedCondition: string | null;
    fieldValues: InsFieldValue[] | null;
    directEditTime: number | null;
    bulkEditTime: number | null;
    [immerable] = true;

    constructor(data?: IInsNodeValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.fieldValues) {
                this.fieldValues = [];
                for (let i = 0; i < data.fieldValues.length; i++) {
                    let item = data.fieldValues[i];
                    this.fieldValues[i] = item && !(<any>item).toJSON ? new InsFieldValue(item) : <InsFieldValue>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeId = _data["nodeId"] !== undefined ? _data["nodeId"] : <any>null;
            this.selectedAction = _data["selectedAction"] !== undefined ? _data["selectedAction"] : <any>null;
            this.selectedCondition = _data["selectedCondition"] !== undefined ? _data["selectedCondition"] : <any>null;
            if (Array.isArray(_data["fieldValues"])) {
                this.fieldValues = [] as any;
                for (let item of _data["fieldValues"])
                    this.fieldValues!.push(InsFieldValue.fromJS(item));
            }
            else {
                this.fieldValues = <any>null;
            }
            this.directEditTime = _data["directEditTime"] !== undefined ? _data["directEditTime"] : <any>null;
            this.bulkEditTime = _data["bulkEditTime"] !== undefined ? _data["bulkEditTime"] : <any>null;
        }
    }

    static fromJS(data: any): InsNodeValue {
        data = typeof data === 'object' ? data : {};
        let result = new InsNodeValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId !== undefined ? this.nodeId : <any>null;
        data["selectedAction"] = this.selectedAction !== undefined ? this.selectedAction : <any>null;
        data["selectedCondition"] = this.selectedCondition !== undefined ? this.selectedCondition : <any>null;
        if (Array.isArray(this.fieldValues)) {
            data["fieldValues"] = [];
            for (let item of this.fieldValues)
                data["fieldValues"].push(item.toJSON());
        }
        data["directEditTime"] = this.directEditTime !== undefined ? this.directEditTime : <any>null;
        data["bulkEditTime"] = this.bulkEditTime !== undefined ? this.bulkEditTime : <any>null;
        return data;
    }
}

export interface IInsNodeValue {
    nodeId: string;
    selectedAction: string | null;
    selectedCondition: string | null;
    fieldValues: IInsFieldValue[] | null;
    directEditTime: number | null;
    bulkEditTime: number | null;
}

export class InsFieldValue implements IInsFieldValue {
    key: string | null;
    value: string | null;
    isVisible: boolean;
    [immerable] = true;

    constructor(data?: IInsFieldValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.isVisible = _data["isVisible"] !== undefined ? _data["isVisible"] : <any>null;
        }
    }

    static fromJS(data: any): InsFieldValue {
        data = typeof data === 'object' ? data : {};
        let result = new InsFieldValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["isVisible"] = this.isVisible !== undefined ? this.isVisible : <any>null;
        return data;
    }
}

export interface IInsFieldValue {
    key: string | null;
    value: string | null;
    isVisible: boolean;
}

export class CreateFeedbackPayload implements ICreateFeedbackPayload {
    fullName: string | null;
    contactEmail: string | null;
    contactPhone: string | null;
    isImpersonating: boolean;
    feedbackText: string | null;
    image: string | null;
    metadata: FeedbackMetadata | null;
    [immerable] = true;

    constructor(data?: ICreateFeedbackPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metadata = data.metadata && !(<any>data.metadata).toJSON ? new FeedbackMetadata(data.metadata) : <FeedbackMetadata>this.metadata;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : <any>null;
            this.contactPhone = _data["contactPhone"] !== undefined ? _data["contactPhone"] : <any>null;
            this.isImpersonating = _data["isImpersonating"] !== undefined ? _data["isImpersonating"] : <any>null;
            this.feedbackText = _data["feedbackText"] !== undefined ? _data["feedbackText"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.metadata = _data["metadata"] ? FeedbackMetadata.fromJS(_data["metadata"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateFeedbackPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : <any>null;
        data["contactPhone"] = this.contactPhone !== undefined ? this.contactPhone : <any>null;
        data["isImpersonating"] = this.isImpersonating !== undefined ? this.isImpersonating : <any>null;
        data["feedbackText"] = this.feedbackText !== undefined ? this.feedbackText : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateFeedbackPayload {
    fullName: string | null;
    contactEmail: string | null;
    contactPhone: string | null;
    isImpersonating: boolean;
    feedbackText: string | null;
    image: string | null;
    metadata: IFeedbackMetadata | null;
}

export class FeedbackMetadata implements IFeedbackMetadata {
    url: string | null;
    referrer: string | null;
    userAgent: string | null;
    clientSizes: FeedbackSize[] | null;
    isTouchDevice: boolean;
    [immerable] = true;

    constructor(data?: IFeedbackMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.clientSizes) {
                this.clientSizes = [];
                for (let i = 0; i < data.clientSizes.length; i++) {
                    let item = data.clientSizes[i];
                    this.clientSizes[i] = item && !(<any>item).toJSON ? new FeedbackSize(item) : <FeedbackSize>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.referrer = _data["referrer"] !== undefined ? _data["referrer"] : <any>null;
            this.userAgent = _data["userAgent"] !== undefined ? _data["userAgent"] : <any>null;
            if (Array.isArray(_data["clientSizes"])) {
                this.clientSizes = [] as any;
                for (let item of _data["clientSizes"])
                    this.clientSizes!.push(FeedbackSize.fromJS(item));
            }
            else {
                this.clientSizes = <any>null;
            }
            this.isTouchDevice = _data["isTouchDevice"] !== undefined ? _data["isTouchDevice"] : <any>null;
        }
    }

    static fromJS(data: any): FeedbackMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["referrer"] = this.referrer !== undefined ? this.referrer : <any>null;
        data["userAgent"] = this.userAgent !== undefined ? this.userAgent : <any>null;
        if (Array.isArray(this.clientSizes)) {
            data["clientSizes"] = [];
            for (let item of this.clientSizes)
                data["clientSizes"].push(item.toJSON());
        }
        data["isTouchDevice"] = this.isTouchDevice !== undefined ? this.isTouchDevice : <any>null;
        return data;
    }
}

export interface IFeedbackMetadata {
    url: string | null;
    referrer: string | null;
    userAgent: string | null;
    clientSizes: IFeedbackSize[] | null;
    isTouchDevice: boolean;
}

export class FeedbackSize implements IFeedbackSize {
    width: number;
    height: number;
    key: string | null;
    [immerable] = true;

    constructor(data?: IFeedbackSize) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data: any): FeedbackSize {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackSize();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data;
    }
}

export interface IFeedbackSize {
    width: number;
    height: number;
    key: string | null;
}

export class EntityAttachment implements IEntityAttachment {
    entityType: AttachmentEntityType;
    entityId: string | null;
    createdAt: Date;
    createdBy: UserSummary | null;
    file: AttachmentFile | null;
    [immerable] = true;

    constructor(data?: IEntityAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.createdBy = data.createdBy && !(<any>data.createdBy).toJSON ? new UserSummary(data.createdBy) : <UserSummary>this.createdBy;
            this.file = data.file && !(<any>data.file).toJSON ? new AttachmentFile(data.file) : <AttachmentFile>this.file;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : <any>null;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.createdBy = _data["createdBy"] ? UserSummary.fromJS(_data["createdBy"]) : <any>null;
            this.file = _data["file"] ? AttachmentFile.fromJS(_data["file"]) : <any>null;
        }
    }

    static fromJS(data: any): EntityAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new EntityAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType !== undefined ? this.entityType : <any>null;
        data["entityId"] = this.entityId !== undefined ? this.entityId : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["file"] = this.file ? this.file.toJSON() : <any>null;
        return data;
    }
}

export interface IEntityAttachment {
    entityType: AttachmentEntityType;
    entityId: string | null;
    createdAt: Date;
    createdBy: IUserSummary | null;
    file: IAttachmentFile | null;
}

export class GalleryFile implements IGalleryFile {
    description: string | null;
    isFromSubissue: boolean;
    file: AttachmentFile | null;
    tag: string | null;
    chips: string[] | null;
    [immerable] = true;

    constructor(data?: IGalleryFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.file = data.file && !(<any>data.file).toJSON ? new AttachmentFile(data.file) : <AttachmentFile>this.file;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isFromSubissue = _data["isFromSubissue"] !== undefined ? _data["isFromSubissue"] : <any>null;
            this.file = _data["file"] ? AttachmentFile.fromJS(_data["file"]) : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            if (Array.isArray(_data["chips"])) {
                this.chips = [] as any;
                for (let item of _data["chips"])
                    this.chips!.push(item);
            }
            else {
                this.chips = <any>null;
            }
        }
    }

    static fromJS(data: any): GalleryFile {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isFromSubissue"] = this.isFromSubissue !== undefined ? this.isFromSubissue : <any>null;
        data["file"] = this.file ? this.file.toJSON() : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        if (Array.isArray(this.chips)) {
            data["chips"] = [];
            for (let item of this.chips)
                data["chips"].push(item);
        }
        return data;
    }
}

export interface IGalleryFile {
    description: string | null;
    isFromSubissue: boolean;
    file: IAttachmentFile | null;
    tag: string | null;
    chips: string[] | null;
}

export class GetFlagPayload implements IGetFlagPayload {
    flag: FlagType;
    entityType: FlaggedEntityType;
    entityId: string;
    [immerable] = true;

    constructor(data?: IGetFlagPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flag = _data["flag"] !== undefined ? _data["flag"] : <any>null;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : <any>null;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : <any>null;
        }
    }

    static fromJS(data: any): GetFlagPayload {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlagPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flag"] = this.flag !== undefined ? this.flag : <any>null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : <any>null;
        data["entityId"] = this.entityId !== undefined ? this.entityId : <any>null;
        return data;
    }
}

export interface IGetFlagPayload {
    flag: FlagType;
    entityType: FlaggedEntityType;
    entityId: string;
}

export enum FlagType {
    Unknown = 0,
    NeedsAttention = 1,
}

export enum FlaggedEntityType {
    Unknown = 0,
    Issue = 1,
}

export class SetFlagPayload implements ISetFlagPayload {
    value: boolean;
    flag: FlagType;
    entityType: FlaggedEntityType;
    entityId: string;
    [immerable] = true;

    constructor(data?: ISetFlagPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.flag = _data["flag"] !== undefined ? _data["flag"] : <any>null;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : <any>null;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : <any>null;
        }
    }

    static fromJS(data: any): SetFlagPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SetFlagPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["flag"] = this.flag !== undefined ? this.flag : <any>null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : <any>null;
        data["entityId"] = this.entityId !== undefined ? this.entityId : <any>null;
        return data;
    }
}

export interface ISetFlagPayload {
    value: boolean;
    flag: FlagType;
    entityType: FlaggedEntityType;
    entityId: string;
}

export class AttachContractorClientPayload implements IAttachContractorClientPayload {
    vendorId: string;
    companyId: string;
    [immerable] = true;

    constructor(data?: IAttachContractorClientPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
        }
    }

    static fromJS(data: any): AttachContractorClientPayload {
        data = typeof data === 'object' ? data : {};
        let result = new AttachContractorClientPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        return data;
    }
}

export interface IAttachContractorClientPayload {
    vendorId: string;
    companyId: string;
}

export class CreateContractorClientResponse extends CreateCompanyWithOwnerResult implements ICreateContractorClientResponse {
    companyName: string | null;
    [immerable] = true;

    constructor(data?: ICreateContractorClientResponse) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
        }
    }

    static fromJS(data: any): CreateContractorClientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractorClientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateContractorClientResponse extends ICreateCompanyWithOwnerResult {
    companyName: string | null;
}

export class CreateContractorClientPayload implements ICreateContractorClientPayload {
    person: CreatePersonModel | null;
    companyName: string | null;
    autoConfirmOwnerEmail: boolean;
    muteCompanyNotifications: boolean;
    muteOwnerNotifications: boolean;
    [immerable] = true;

    constructor(data?: ICreateContractorClientPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.person = data.person && !(<any>data.person).toJSON ? new CreatePersonModel(data.person) : <CreatePersonModel>this.person;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? CreatePersonModel.fromJS(_data["person"]) : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.autoConfirmOwnerEmail = _data["autoConfirmOwnerEmail"] !== undefined ? _data["autoConfirmOwnerEmail"] : <any>null;
            this.muteCompanyNotifications = _data["muteCompanyNotifications"] !== undefined ? _data["muteCompanyNotifications"] : <any>null;
            this.muteOwnerNotifications = _data["muteOwnerNotifications"] !== undefined ? _data["muteOwnerNotifications"] : <any>null;
        }
    }

    static fromJS(data: any): CreateContractorClientPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractorClientPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["autoConfirmOwnerEmail"] = this.autoConfirmOwnerEmail !== undefined ? this.autoConfirmOwnerEmail : <any>null;
        data["muteCompanyNotifications"] = this.muteCompanyNotifications !== undefined ? this.muteCompanyNotifications : <any>null;
        data["muteOwnerNotifications"] = this.muteOwnerNotifications !== undefined ? this.muteOwnerNotifications : <any>null;
        return data;
    }
}

export interface ICreateContractorClientPayload {
    person: ICreatePersonModel | null;
    companyName: string | null;
    autoConfirmOwnerEmail: boolean;
    muteCompanyNotifications: boolean;
    muteOwnerNotifications: boolean;
}

export class ClientContact implements IClientContact {
    user: UserSummary | null;
    isOwner: boolean;
    designation: string | null;
    companyId: string;
    [immerable] = true;

    constructor(data?: IClientContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new UserSummary(data.user) : <UserSummary>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserSummary.fromJS(_data["user"]) : <any>null;
            this.isOwner = _data["isOwner"] !== undefined ? _data["isOwner"] : <any>null;
            this.designation = _data["designation"] !== undefined ? _data["designation"] : <any>null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
        }
    }

    static fromJS(data: any): ClientContact {
        data = typeof data === 'object' ? data : {};
        let result = new ClientContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["isOwner"] = this.isOwner !== undefined ? this.isOwner : <any>null;
        data["designation"] = this.designation !== undefined ? this.designation : <any>null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        return data;
    }
}

export interface IClientContact {
    user: IUserSummary | null;
    isOwner: boolean;
    designation: string | null;
    companyId: string;
}

export class AddClientContactResult implements IAddClientContactResult {
    success: boolean;
    [immerable] = true;

    constructor(data?: IAddClientContactResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
        }
    }

    static fromJS(data: any): AddClientContactResult {
        data = typeof data === 'object' ? data : {};
        let result = new AddClientContactResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        return data;
    }
}

export interface IAddClientContactResult {
    success: boolean;
}

export class AddClientContactPayload implements IAddClientContactPayload {
    firstName: string | null;
    lastName: string | null;
    companyId: string;
    designation: string | null;
    phone: string | null;
    email: string | null;
    muteNotifications: boolean;
    [immerable] = true;

    constructor(data?: IAddClientContactPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            this.designation = _data["designation"] !== undefined ? _data["designation"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.muteNotifications = _data["muteNotifications"] !== undefined ? _data["muteNotifications"] : <any>null;
        }
    }

    static fromJS(data: any): AddClientContactPayload {
        data = typeof data === 'object' ? data : {};
        let result = new AddClientContactPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        data["designation"] = this.designation !== undefined ? this.designation : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["muteNotifications"] = this.muteNotifications !== undefined ? this.muteNotifications : <any>null;
        return data;
    }
}

export interface IAddClientContactPayload {
    firstName: string | null;
    lastName: string | null;
    companyId: string;
    designation: string | null;
    phone: string | null;
    email: string | null;
    muteNotifications: boolean;
}

export class VendorClientModel implements IVendorClientModel {
    company: ManagementCompany | null;
    issueCount: number;
    lastAssignmentDate: Date | null;
    totalInvoiced: number;
    clientConfiguration: VendorClientConfiguration | null;
    turnsEstimated: number;
    turnsApproved: number;
    [immerable] = true;

    constructor(data?: IVendorClientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.company = data.company && !(<any>data.company).toJSON ? new ManagementCompany(data.company) : <ManagementCompany>this.company;
            this.clientConfiguration = data.clientConfiguration && !(<any>data.clientConfiguration).toJSON ? new VendorClientConfiguration(data.clientConfiguration) : <VendorClientConfiguration>this.clientConfiguration;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? ManagementCompany.fromJS(_data["company"]) : <any>null;
            this.issueCount = _data["issueCount"] !== undefined ? _data["issueCount"] : <any>null;
            this.lastAssignmentDate = _data["lastAssignmentDate"] ? new Date(_data["lastAssignmentDate"].toString()) : <any>null;
            this.totalInvoiced = _data["totalInvoiced"] !== undefined ? _data["totalInvoiced"] : <any>null;
            this.clientConfiguration = _data["clientConfiguration"] ? VendorClientConfiguration.fromJS(_data["clientConfiguration"]) : <any>null;
            this.turnsEstimated = _data["turnsEstimated"] !== undefined ? _data["turnsEstimated"] : <any>null;
            this.turnsApproved = _data["turnsApproved"] !== undefined ? _data["turnsApproved"] : <any>null;
        }
    }

    static fromJS(data: any): VendorClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new VendorClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>null;
        data["issueCount"] = this.issueCount !== undefined ? this.issueCount : <any>null;
        data["lastAssignmentDate"] = this.lastAssignmentDate ? this.lastAssignmentDate.toISOString() : <any>null;
        data["totalInvoiced"] = this.totalInvoiced !== undefined ? this.totalInvoiced : <any>null;
        data["clientConfiguration"] = this.clientConfiguration ? this.clientConfiguration.toJSON() : <any>null;
        data["turnsEstimated"] = this.turnsEstimated !== undefined ? this.turnsEstimated : <any>null;
        data["turnsApproved"] = this.turnsApproved !== undefined ? this.turnsApproved : <any>null;
        return data;
    }
}

export interface IVendorClientModel {
    company: IManagementCompany | null;
    issueCount: number;
    lastAssignmentDate: Date | null;
    totalInvoiced: number;
    clientConfiguration: IVendorClientConfiguration | null;
    turnsEstimated: number;
    turnsApproved: number;
}

export class VendorClientConfiguration implements IVendorClientConfiguration {
    formDefaults: FormDefaults | null;
    accountManager: UserSummary | null;
    issueNotice: string | null;
    [immerable] = true;

    constructor(data?: IVendorClientConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.formDefaults = data.formDefaults && !(<any>data.formDefaults).toJSON ? new FormDefaults(data.formDefaults) : <FormDefaults>this.formDefaults;
            this.accountManager = data.accountManager && !(<any>data.accountManager).toJSON ? new UserSummary(data.accountManager) : <UserSummary>this.accountManager;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formDefaults = _data["formDefaults"] ? FormDefaults.fromJS(_data["formDefaults"]) : <any>null;
            this.accountManager = _data["accountManager"] ? UserSummary.fromJS(_data["accountManager"]) : <any>null;
            this.issueNotice = _data["issueNotice"] !== undefined ? _data["issueNotice"] : <any>null;
        }
    }

    static fromJS(data: any): VendorClientConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new VendorClientConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formDefaults"] = this.formDefaults ? this.formDefaults.toJSON() : <any>null;
        data["accountManager"] = this.accountManager ? this.accountManager.toJSON() : <any>null;
        data["issueNotice"] = this.issueNotice !== undefined ? this.issueNotice : <any>null;
        return data;
    }
}

export interface IVendorClientConfiguration {
    formDefaults: IFormDefaults | null;
    accountManager: IUserSummary | null;
    issueNotice: string | null;
}

export class FormDefaults implements IFormDefaults {
    discountPercent: number | null;
    taxPercent: number | null;
    [immerable] = true;

    constructor(data?: IFormDefaults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discountPercent = _data["discountPercent"] !== undefined ? _data["discountPercent"] : <any>null;
            this.taxPercent = _data["taxPercent"] !== undefined ? _data["taxPercent"] : <any>null;
        }
    }

    static fromJS(data: any): FormDefaults {
        data = typeof data === 'object' ? data : {};
        let result = new FormDefaults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountPercent"] = this.discountPercent !== undefined ? this.discountPercent : <any>null;
        data["taxPercent"] = this.taxPercent !== undefined ? this.taxPercent : <any>null;
        return data;
    }
}

export interface IFormDefaults {
    discountPercent: number | null;
    taxPercent: number | null;
}

export class GetClientsFilters implements IGetClientsFilters {
    startDate: Date | null;
    endDate: Date | null;
    [immerable] = true;

    constructor(data?: IGetClientsFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetClientsFilters {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientsFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        return data;
    }
}

export interface IGetClientsFilters {
    startDate: Date | null;
    endDate: Date | null;
}

export class SetContactDesignationPayload implements ISetContactDesignationPayload {
    userId: string;
    managementCompanyId: string;
    designation: string | null;
    [immerable] = true;

    constructor(data?: ISetContactDesignationPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            this.designation = _data["designation"] !== undefined ? _data["designation"] : <any>null;
        }
    }

    static fromJS(data: any): SetContactDesignationPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SetContactDesignationPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        data["designation"] = this.designation !== undefined ? this.designation : <any>null;
        return data;
    }
}

export interface ISetContactDesignationPayload {
    userId: string;
    managementCompanyId: string;
    designation: string | null;
}

export class SetClientConfigurationPayload implements ISetClientConfigurationPayload {
    companyId: string;
    formDefaults: FormDefaults | null;
    accountManagerId: string | null;
    [immerable] = true;

    constructor(data?: ISetClientConfigurationPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.formDefaults = data.formDefaults && !(<any>data.formDefaults).toJSON ? new FormDefaults(data.formDefaults) : <FormDefaults>this.formDefaults;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            this.formDefaults = _data["formDefaults"] ? FormDefaults.fromJS(_data["formDefaults"]) : <any>null;
            this.accountManagerId = _data["accountManagerId"] !== undefined ? _data["accountManagerId"] : <any>null;
        }
    }

    static fromJS(data: any): SetClientConfigurationPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SetClientConfigurationPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        data["formDefaults"] = this.formDefaults ? this.formDefaults.toJSON() : <any>null;
        data["accountManagerId"] = this.accountManagerId !== undefined ? this.accountManagerId : <any>null;
        return data;
    }
}

export interface ISetClientConfigurationPayload {
    companyId: string;
    formDefaults: IFormDefaults | null;
    accountManagerId: string | null;
}

export class ContractorCanManageCompanyPayload implements IContractorCanManageCompanyPayload {
    contractorId: string;
    companyId: string;
    companyType: CompanyType;
    [immerable] = true;

    constructor(data?: IContractorCanManageCompanyPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractorId = _data["contractorId"] !== undefined ? _data["contractorId"] : <any>null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): ContractorCanManageCompanyPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ContractorCanManageCompanyPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractorId"] = this.contractorId !== undefined ? this.contractorId : <any>null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        return data;
    }
}

export interface IContractorCanManageCompanyPayload {
    contractorId: string;
    companyId: string;
    companyType: CompanyType;
}

export class SetIssueNoticePayload implements ISetIssueNoticePayload {
    companyId: string;
    note: string | null;
    [immerable] = true;

    constructor(data?: ISetIssueNoticePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): SetIssueNoticePayload {
        data = typeof data === 'object' ? data : {};
        let result = new SetIssueNoticePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        return data;
    }
}

export interface ISetIssueNoticePayload {
    companyId: string;
    note: string | null;
}

export class InspectionSummary implements IInspectionSummary {
    id: string;
    friendlyId: string | null;
    status: InspectionStatus;
    createdAt: Date;
    modifiedAt: Date | null;
    dueDate: Date | null;
    estimatedCompletionDate: Date | null;
    completionDate: Date | null;
    property: PropertySummary | null;
    createdBy: UserSummary | null;
    assignedUser: UserSummary | null;
    assignedCompany: ManagementCompany | null;
    assignedVendor: Vendor | null;
    lastRenderedPdf: AttachmentFile | null;
    [immerable] = true;

    constructor(data?: IInspectionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.property = data.property && !(<any>data.property).toJSON ? new PropertySummary(data.property) : <PropertySummary>this.property;
            this.createdBy = data.createdBy && !(<any>data.createdBy).toJSON ? new UserSummary(data.createdBy) : <UserSummary>this.createdBy;
            this.assignedUser = data.assignedUser && !(<any>data.assignedUser).toJSON ? new UserSummary(data.assignedUser) : <UserSummary>this.assignedUser;
            this.assignedCompany = data.assignedCompany && !(<any>data.assignedCompany).toJSON ? new ManagementCompany(data.assignedCompany) : <ManagementCompany>this.assignedCompany;
            this.assignedVendor = data.assignedVendor && !(<any>data.assignedVendor).toJSON ? new Vendor(data.assignedVendor) : <Vendor>this.assignedVendor;
            this.lastRenderedPdf = data.lastRenderedPdf && !(<any>data.lastRenderedPdf).toJSON ? new AttachmentFile(data.lastRenderedPdf) : <AttachmentFile>this.lastRenderedPdf;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>null;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>null;
            this.estimatedCompletionDate = _data["estimatedCompletionDate"] ? new Date(_data["estimatedCompletionDate"].toString()) : <any>null;
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : <any>null;
            this.property = _data["property"] ? PropertySummary.fromJS(_data["property"]) : <any>null;
            this.createdBy = _data["createdBy"] ? UserSummary.fromJS(_data["createdBy"]) : <any>null;
            this.assignedUser = _data["assignedUser"] ? UserSummary.fromJS(_data["assignedUser"]) : <any>null;
            this.assignedCompany = _data["assignedCompany"] ? ManagementCompany.fromJS(_data["assignedCompany"]) : <any>null;
            this.assignedVendor = _data["assignedVendor"] ? Vendor.fromJS(_data["assignedVendor"]) : <any>null;
            this.lastRenderedPdf = _data["lastRenderedPdf"] ? AttachmentFile.fromJS(_data["lastRenderedPdf"]) : <any>null;
        }
    }

    static fromJS(data: any): InspectionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>null;
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : <any>null;
        data["estimatedCompletionDate"] = this.estimatedCompletionDate ? formatDate(this.estimatedCompletionDate) : <any>null;
        data["completionDate"] = this.completionDate ? formatDate(this.completionDate) : <any>null;
        data["property"] = this.property ? this.property.toJSON() : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>null;
        data["assignedCompany"] = this.assignedCompany ? this.assignedCompany.toJSON() : <any>null;
        data["assignedVendor"] = this.assignedVendor ? this.assignedVendor.toJSON() : <any>null;
        data["lastRenderedPdf"] = this.lastRenderedPdf ? this.lastRenderedPdf.toJSON() : <any>null;
        return data;
    }
}

export interface IInspectionSummary {
    id: string;
    friendlyId: string | null;
    status: InspectionStatus;
    createdAt: Date;
    modifiedAt: Date | null;
    dueDate: Date | null;
    estimatedCompletionDate: Date | null;
    completionDate: Date | null;
    property: IPropertySummary | null;
    createdBy: IUserSummary | null;
    assignedUser: IUserSummary | null;
    assignedCompany: IManagementCompany | null;
    assignedVendor: IVendor | null;
    lastRenderedPdf: IAttachmentFile | null;
}

export enum InspectionStatus {
    Unknown = 0,
    Created = 1,
    Invited = 2,
    Accepted = 3,
    Declined = 4,
    Started = 5,
    Done = 6,
}

export class CreateWorkorderFromInspectionResult implements ICreateWorkorderFromInspectionResult {
    created: boolean;
    createdIds: CreatedWorkorderIssueIds | null;
    [immerable] = true;

    constructor(data?: ICreateWorkorderFromInspectionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.createdIds = data.createdIds && !(<any>data.createdIds).toJSON ? new CreatedWorkorderIssueIds(data.createdIds) : <CreatedWorkorderIssueIds>this.createdIds;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.createdIds = _data["createdIds"] ? CreatedWorkorderIssueIds.fromJS(_data["createdIds"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateWorkorderFromInspectionResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkorderFromInspectionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["createdIds"] = this.createdIds ? this.createdIds.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateWorkorderFromInspectionResult {
    created: boolean;
    createdIds: ICreatedWorkorderIssueIds | null;
}

export class CreatedWorkorderIssueIds implements ICreatedWorkorderIssueIds {
    workorderId: string;
    issueId: string;
    [immerable] = true;

    constructor(data?: ICreatedWorkorderIssueIds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
        }
    }

    static fromJS(data: any): CreatedWorkorderIssueIds {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedWorkorderIssueIds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        return data;
    }
}

export interface ICreatedWorkorderIssueIds {
    workorderId: string;
    issueId: string;
}

export class CreateWorkorderFromInspectionPayload implements ICreateWorkorderFromInspectionPayload {
    inspectionId: string;
    [immerable] = true;

    constructor(data?: ICreateWorkorderFromInspectionPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateWorkorderFromInspectionPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkorderFromInspectionPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        return data;
    }
}

export interface ICreateWorkorderFromInspectionPayload {
    inspectionId: string;
}

export class InspectionDetails extends InspectionSummary implements IInspectionDetails {
    linkedIssueId: string | null;
    linkedWorkorderId: string | null;
    contentJson: string | null;
    currentContentTimestamp: number | null;
    [immerable] = true;

    constructor(data?: IInspectionDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkedIssueId = _data["linkedIssueId"] !== undefined ? _data["linkedIssueId"] : <any>null;
            this.linkedWorkorderId = _data["linkedWorkorderId"] !== undefined ? _data["linkedWorkorderId"] : <any>null;
            this.contentJson = _data["contentJson"] !== undefined ? _data["contentJson"] : <any>null;
            this.currentContentTimestamp = _data["currentContentTimestamp"] !== undefined ? _data["currentContentTimestamp"] : <any>null;
        }
    }

    static fromJS(data: any): InspectionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkedIssueId"] = this.linkedIssueId !== undefined ? this.linkedIssueId : <any>null;
        data["linkedWorkorderId"] = this.linkedWorkorderId !== undefined ? this.linkedWorkorderId : <any>null;
        data["contentJson"] = this.contentJson !== undefined ? this.contentJson : <any>null;
        data["currentContentTimestamp"] = this.currentContentTimestamp !== undefined ? this.currentContentTimestamp : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionDetails extends IInspectionSummary {
    linkedIssueId: string | null;
    linkedWorkorderId: string | null;
    contentJson: string | null;
    currentContentTimestamp: number | null;
}

export class InspectionUserView implements IInspectionUserView {
    inspection: InspectionDetails | null;
    role: InspectionRole;
    [immerable] = true;

    constructor(data?: IInspectionUserView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.inspection = data.inspection && !(<any>data.inspection).toJSON ? new InspectionDetails(data.inspection) : <InspectionDetails>this.inspection;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspection = _data["inspection"] ? InspectionDetails.fromJS(_data["inspection"]) : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
        }
    }

    static fromJS(data: any): InspectionUserView {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionUserView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        return data;
    }
}

export interface IInspectionUserView {
    inspection: IInspectionDetails | null;
    role: InspectionRole;
}

export enum InspectionRole {
    Requester = 0,
    Assignee = 1,
    Viewer = 2,
    SelfAssigned = 3,
}

export class CreateInspectionPayload implements ICreateInspectionPayload {
    propertyId: string;
    notes: string | null;
    dueDate: Date | null;
    assignedCompanyId: string | null;
    assignedVendorId: string | null;
    assignedUserId: string | null;
    [immerable] = true;

    constructor(data?: ICreateInspectionPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"] !== undefined ? _data["propertyId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>null;
            this.assignedCompanyId = _data["assignedCompanyId"] !== undefined ? _data["assignedCompanyId"] : <any>null;
            this.assignedVendorId = _data["assignedVendorId"] !== undefined ? _data["assignedVendorId"] : <any>null;
            this.assignedUserId = _data["assignedUserId"] !== undefined ? _data["assignedUserId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateInspectionPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInspectionPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId !== undefined ? this.propertyId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : <any>null;
        data["assignedCompanyId"] = this.assignedCompanyId !== undefined ? this.assignedCompanyId : <any>null;
        data["assignedVendorId"] = this.assignedVendorId !== undefined ? this.assignedVendorId : <any>null;
        data["assignedUserId"] = this.assignedUserId !== undefined ? this.assignedUserId : <any>null;
        return data;
    }
}

export interface ICreateInspectionPayload {
    propertyId: string;
    notes: string | null;
    dueDate: Date | null;
    assignedCompanyId: string | null;
    assignedVendorId: string | null;
    assignedUserId: string | null;
}

export class UpdateInspectionDocumentPayload implements IUpdateInspectionDocumentPayload {
    inspectionId: string;
    contentJson: string | null;
    clientTimestamp: number;
    [immerable] = true;

    constructor(data?: IUpdateInspectionDocumentPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
            this.contentJson = _data["contentJson"] !== undefined ? _data["contentJson"] : <any>null;
            this.clientTimestamp = _data["clientTimestamp"] !== undefined ? _data["clientTimestamp"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateInspectionDocumentPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInspectionDocumentPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        data["contentJson"] = this.contentJson !== undefined ? this.contentJson : <any>null;
        data["clientTimestamp"] = this.clientTimestamp !== undefined ? this.clientTimestamp : <any>null;
        return data;
    }
}

export interface IUpdateInspectionDocumentPayload {
    inspectionId: string;
    contentJson: string | null;
    clientTimestamp: number;
}

export class AcceptInspectionPayload implements IAcceptInspectionPayload {
    inspectionId: string;
    estimatedCompletionDate: Date | null;
    [immerable] = true;

    constructor(data?: IAcceptInspectionPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
            this.estimatedCompletionDate = _data["estimatedCompletionDate"] ? new Date(_data["estimatedCompletionDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AcceptInspectionPayload {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptInspectionPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        data["estimatedCompletionDate"] = this.estimatedCompletionDate ? formatDate(this.estimatedCompletionDate) : <any>null;
        return data;
    }
}

export interface IAcceptInspectionPayload {
    inspectionId: string;
    estimatedCompletionDate: Date | null;
}

export class ReassignInspectionPayload implements IReassignInspectionPayload {
    inspectionId: string;
    assignedCompanyId: string | null;
    assignedVendorId: string | null;
    assignedUserId: string | null;
    [immerable] = true;

    constructor(data?: IReassignInspectionPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
            this.assignedCompanyId = _data["assignedCompanyId"] !== undefined ? _data["assignedCompanyId"] : <any>null;
            this.assignedVendorId = _data["assignedVendorId"] !== undefined ? _data["assignedVendorId"] : <any>null;
            this.assignedUserId = _data["assignedUserId"] !== undefined ? _data["assignedUserId"] : <any>null;
        }
    }

    static fromJS(data: any): ReassignInspectionPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ReassignInspectionPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        data["assignedCompanyId"] = this.assignedCompanyId !== undefined ? this.assignedCompanyId : <any>null;
        data["assignedVendorId"] = this.assignedVendorId !== undefined ? this.assignedVendorId : <any>null;
        data["assignedUserId"] = this.assignedUserId !== undefined ? this.assignedUserId : <any>null;
        return data;
    }
}

export interface IReassignInspectionPayload {
    inspectionId: string;
    assignedCompanyId: string | null;
    assignedVendorId: string | null;
    assignedUserId: string | null;
}

export class DeclineInspectionPayload implements IDeclineInspectionPayload {
    inspectionId: string;
    [immerable] = true;

    constructor(data?: IDeclineInspectionPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
        }
    }

    static fromJS(data: any): DeclineInspectionPayload {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineInspectionPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        return data;
    }
}

export interface IDeclineInspectionPayload {
    inspectionId: string;
}

export class CompleteInspectionPayload implements ICompleteInspectionPayload {
    inspectionId: string;
    contentJson: string | null;
    clientTimestamp: number;
    [immerable] = true;

    constructor(data?: ICompleteInspectionPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
            this.contentJson = _data["contentJson"] !== undefined ? _data["contentJson"] : <any>null;
            this.clientTimestamp = _data["clientTimestamp"] !== undefined ? _data["clientTimestamp"] : <any>null;
        }
    }

    static fromJS(data: any): CompleteInspectionPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteInspectionPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        data["contentJson"] = this.contentJson !== undefined ? this.contentJson : <any>null;
        data["clientTimestamp"] = this.clientTimestamp !== undefined ? this.clientTimestamp : <any>null;
        return data;
    }
}

export interface ICompleteInspectionPayload {
    inspectionId: string;
    contentJson: string | null;
    clientTimestamp: number;
}

export class InspectionRecipient implements IInspectionRecipient {
    userId: string | null;
    extraRecipientId: string | null;
    fullName: string | null;
    email: string | null;
    lastSend: Date | null;
    [immerable] = true;

    constructor(data?: IInspectionRecipient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.extraRecipientId = _data["extraRecipientId"] !== undefined ? _data["extraRecipientId"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.lastSend = _data["lastSend"] ? new Date(_data["lastSend"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): InspectionRecipient {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionRecipient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["extraRecipientId"] = this.extraRecipientId !== undefined ? this.extraRecipientId : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["lastSend"] = this.lastSend ? this.lastSend.toISOString() : <any>null;
        return data;
    }
}

export interface IInspectionRecipient {
    userId: string | null;
    extraRecipientId: string | null;
    fullName: string | null;
    email: string | null;
    lastSend: Date | null;
}

export enum CreateInspectionExtraRecipientStatus {
    Created = 0,
    InvalidEmail = 1,
    EmailAlreadyExists = 2,
}

export class CreateInspectionExtraRecipientPayload implements ICreateInspectionExtraRecipientPayload {
    inspectionId: string;
    fullName: string | null;
    email: string | null;
    [immerable] = true;

    constructor(data?: ICreateInspectionExtraRecipientPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): CreateInspectionExtraRecipientPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInspectionExtraRecipientPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface ICreateInspectionExtraRecipientPayload {
    inspectionId: string;
    fullName: string | null;
    email: string | null;
}

export class DeleteInspectionExtraRecipientPayload implements IDeleteInspectionExtraRecipientPayload {
    inspectionId: string;
    extraRecipientId: string;
    [immerable] = true;

    constructor(data?: IDeleteInspectionExtraRecipientPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
            this.extraRecipientId = _data["extraRecipientId"] !== undefined ? _data["extraRecipientId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteInspectionExtraRecipientPayload {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInspectionExtraRecipientPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        data["extraRecipientId"] = this.extraRecipientId !== undefined ? this.extraRecipientId : <any>null;
        return data;
    }
}

export interface IDeleteInspectionExtraRecipientPayload {
    inspectionId: string;
    extraRecipientId: string;
}

export class SendInspectionReportsPayload implements ISendInspectionReportsPayload {
    inspectionId: string;
    filterExtraRecipientId: string | null;
    [immerable] = true;

    constructor(data?: ISendInspectionReportsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
            this.filterExtraRecipientId = _data["filterExtraRecipientId"] !== undefined ? _data["filterExtraRecipientId"] : <any>null;
        }
    }

    static fromJS(data: any): SendInspectionReportsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SendInspectionReportsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        data["filterExtraRecipientId"] = this.filterExtraRecipientId !== undefined ? this.filterExtraRecipientId : <any>null;
        return data;
    }
}

export interface ISendInspectionReportsPayload {
    inspectionId: string;
    filterExtraRecipientId: string | null;
}

export class InsTemplateEnvelope implements IInsTemplateEnvelope {
    toolingVersion: number;
    templateHash: string | null;
    template: InsTemplate | null;
    templateType: string | null;
    [immerable] = true;

    constructor(data?: IInsTemplateEnvelope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.template = data.template && !(<any>data.template).toJSON ? new InsTemplate(data.template) : <InsTemplate>this.template;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toolingVersion = _data["toolingVersion"] !== undefined ? _data["toolingVersion"] : <any>null;
            this.templateHash = _data["templateHash"] !== undefined ? _data["templateHash"] : <any>null;
            this.template = _data["template"] ? InsTemplate.fromJS(_data["template"]) : <any>null;
            this.templateType = _data["templateType"] !== undefined ? _data["templateType"] : <any>null;
        }
    }

    static fromJS(data: any): InsTemplateEnvelope {
        data = typeof data === 'object' ? data : {};
        let result = new InsTemplateEnvelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toolingVersion"] = this.toolingVersion !== undefined ? this.toolingVersion : <any>null;
        data["templateHash"] = this.templateHash !== undefined ? this.templateHash : <any>null;
        data["template"] = this.template ? this.template.toJSON() : <any>null;
        data["templateType"] = this.templateType !== undefined ? this.templateType : <any>null;
        return data;
    }
}

export interface IInsTemplateEnvelope {
    toolingVersion: number;
    templateHash: string | null;
    template: IInsTemplate | null;
    templateType: string | null;
}

export class InsTemplate implements IInsTemplate {
    root: InsDefNode | null;
    sharedStore: InsSharedStore | null;
    [immerable] = true;

    constructor(data?: IInsTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.root = data.root && !(<any>data.root).toJSON ? new InsDefNode(data.root) : <InsDefNode>this.root;
            this.sharedStore = data.sharedStore && !(<any>data.sharedStore).toJSON ? new InsSharedStore(data.sharedStore) : <InsSharedStore>this.sharedStore;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.root = _data["root"] ? InsDefNode.fromJS(_data["root"]) : <any>null;
            this.sharedStore = _data["sharedStore"] ? InsSharedStore.fromJS(_data["sharedStore"]) : <any>null;
        }
    }

    static fromJS(data: any): InsTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new InsTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["root"] = this.root ? this.root.toJSON() : <any>null;
        data["sharedStore"] = this.sharedStore ? this.sharedStore.toJSON() : <any>null;
        return data;
    }
}

export interface IInsTemplate {
    root: IInsDefNode | null;
    sharedStore: IInsSharedStore | null;
}

export class LookupContainer implements ILookupContainer {
    states: State[] | null;
    focusTypes: LookupItem[] | null;
    interiorLocations: LookupItem[] | null;
    exteriorLocations: LookupItem[] | null;
    capabilityPermissionsMap: KeyValuePairOfCapabilityTypeAndListOfRooPermission[] | null;
    [immerable] = true;

    constructor(data?: ILookupContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.states) {
                this.states = [];
                for (let i = 0; i < data.states.length; i++) {
                    let item = data.states[i];
                    this.states[i] = item && !(<any>item).toJSON ? new State(item) : <State>item;
                }
            }
            if (data.focusTypes) {
                this.focusTypes = [];
                for (let i = 0; i < data.focusTypes.length; i++) {
                    let item = data.focusTypes[i];
                    this.focusTypes[i] = item && !(<any>item).toJSON ? new LookupItem(item) : <LookupItem>item;
                }
            }
            if (data.interiorLocations) {
                this.interiorLocations = [];
                for (let i = 0; i < data.interiorLocations.length; i++) {
                    let item = data.interiorLocations[i];
                    this.interiorLocations[i] = item && !(<any>item).toJSON ? new LookupItem(item) : <LookupItem>item;
                }
            }
            if (data.exteriorLocations) {
                this.exteriorLocations = [];
                for (let i = 0; i < data.exteriorLocations.length; i++) {
                    let item = data.exteriorLocations[i];
                    this.exteriorLocations[i] = item && !(<any>item).toJSON ? new LookupItem(item) : <LookupItem>item;
                }
            }
            if (data.capabilityPermissionsMap) {
                this.capabilityPermissionsMap = [];
                for (let i = 0; i < data.capabilityPermissionsMap.length; i++) {
                    let item = data.capabilityPermissionsMap[i];
                    this.capabilityPermissionsMap[i] = item && !(<any>item).toJSON ? new KeyValuePairOfCapabilityTypeAndListOfRooPermission(item) : <KeyValuePairOfCapabilityTypeAndListOfRooPermission>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(State.fromJS(item));
            }
            else {
                this.states = <any>null;
            }
            if (Array.isArray(_data["focusTypes"])) {
                this.focusTypes = [] as any;
                for (let item of _data["focusTypes"])
                    this.focusTypes!.push(LookupItem.fromJS(item));
            }
            else {
                this.focusTypes = <any>null;
            }
            if (Array.isArray(_data["interiorLocations"])) {
                this.interiorLocations = [] as any;
                for (let item of _data["interiorLocations"])
                    this.interiorLocations!.push(LookupItem.fromJS(item));
            }
            else {
                this.interiorLocations = <any>null;
            }
            if (Array.isArray(_data["exteriorLocations"])) {
                this.exteriorLocations = [] as any;
                for (let item of _data["exteriorLocations"])
                    this.exteriorLocations!.push(LookupItem.fromJS(item));
            }
            else {
                this.exteriorLocations = <any>null;
            }
            if (Array.isArray(_data["capabilityPermissionsMap"])) {
                this.capabilityPermissionsMap = [] as any;
                for (let item of _data["capabilityPermissionsMap"])
                    this.capabilityPermissionsMap!.push(KeyValuePairOfCapabilityTypeAndListOfRooPermission.fromJS(item));
            }
            else {
                this.capabilityPermissionsMap = <any>null;
            }
        }
    }

    static fromJS(data: any): LookupContainer {
        data = typeof data === 'object' ? data : {};
        let result = new LookupContainer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        if (Array.isArray(this.focusTypes)) {
            data["focusTypes"] = [];
            for (let item of this.focusTypes)
                data["focusTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.interiorLocations)) {
            data["interiorLocations"] = [];
            for (let item of this.interiorLocations)
                data["interiorLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.exteriorLocations)) {
            data["exteriorLocations"] = [];
            for (let item of this.exteriorLocations)
                data["exteriorLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.capabilityPermissionsMap)) {
            data["capabilityPermissionsMap"] = [];
            for (let item of this.capabilityPermissionsMap)
                data["capabilityPermissionsMap"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILookupContainer {
    states: IState[] | null;
    focusTypes: ILookupItem[] | null;
    interiorLocations: ILookupItem[] | null;
    exteriorLocations: ILookupItem[] | null;
    capabilityPermissionsMap: IKeyValuePairOfCapabilityTypeAndListOfRooPermission[] | null;
}

export class State implements IState {
    code: string | null;
    name: string | null;
    nameShort: string | null;
    [immerable] = true;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.nameShort = _data["nameShort"] !== undefined ? _data["nameShort"] : <any>null;
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["nameShort"] = this.nameShort !== undefined ? this.nameShort : <any>null;
        return data;
    }
}

export interface IState {
    code: string | null;
    name: string | null;
    nameShort: string | null;
}

export class KeyValuePairOfCapabilityTypeAndListOfRooPermission implements IKeyValuePairOfCapabilityTypeAndListOfRooPermission {
    key: CapabilityType;
    value: RooPermission[] | null;
    [immerable] = true;

    constructor(data?: IKeyValuePairOfCapabilityTypeAndListOfRooPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): KeyValuePairOfCapabilityTypeAndListOfRooPermission {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfCapabilityTypeAndListOfRooPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IKeyValuePairOfCapabilityTypeAndListOfRooPermission {
    key: CapabilityType;
    value: RooPermission[] | null;
}

export class UpdateCompanyContactInfoPayload implements IUpdateCompanyContactInfoPayload {
    companyId: string;
    email: string | null;
    phone: string | null;
    name: string | null;
    [immerable] = true;

    constructor(data?: IUpdateCompanyContactInfoPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCompanyContactInfoPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyContactInfoPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IUpdateCompanyContactInfoPayload {
    companyId: string;
    email: string | null;
    phone: string | null;
    name: string | null;
}

export class UpdateCompanyAddressPayload implements IUpdateCompanyAddressPayload {
    companyId: string;
    addressPayload: ModifyAddressPayload | null;
    [immerable] = true;

    constructor(data?: IUpdateCompanyAddressPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.addressPayload = data.addressPayload && !(<any>data.addressPayload).toJSON ? new ModifyAddressPayload(data.addressPayload) : <ModifyAddressPayload>this.addressPayload;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            this.addressPayload = _data["addressPayload"] ? ModifyAddressPayload.fromJS(_data["addressPayload"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateCompanyAddressPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyAddressPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        data["addressPayload"] = this.addressPayload ? this.addressPayload.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateCompanyAddressPayload {
    companyId: string;
    addressPayload: IModifyAddressPayload | null;
}

export class ModifyAddressPayload implements IModifyAddressPayload {
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    [immerable] = true;

    constructor(data?: IModifyAddressPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
        }
    }

    static fromJS(data: any): ModifyAddressPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyAddressPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        return data;
    }
}

export interface IModifyAddressPayload {
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
}

export class UpdateCompanyTenantCopyPayload implements IUpdateCompanyTenantCopyPayload {
    companyId: string;
    copyTenantEmailsTo: string | null;
    copyTenantTextsTo: string | null;
    [immerable] = true;

    constructor(data?: IUpdateCompanyTenantCopyPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            this.copyTenantEmailsTo = _data["copyTenantEmailsTo"] !== undefined ? _data["copyTenantEmailsTo"] : <any>null;
            this.copyTenantTextsTo = _data["copyTenantTextsTo"] !== undefined ? _data["copyTenantTextsTo"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCompanyTenantCopyPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyTenantCopyPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        data["copyTenantEmailsTo"] = this.copyTenantEmailsTo !== undefined ? this.copyTenantEmailsTo : <any>null;
        data["copyTenantTextsTo"] = this.copyTenantTextsTo !== undefined ? this.copyTenantTextsTo : <any>null;
        return data;
    }
}

export interface IUpdateCompanyTenantCopyPayload {
    companyId: string;
    copyTenantEmailsTo: string | null;
    copyTenantTextsTo: string | null;
}

export class UpdateCompanyMiscSettingsPayload implements IUpdateCompanyMiscSettingsPayload {
    companyId: string;
    doorsUnderManagement: number | null;
    dollarsPerDoor: number | null;
    isSoftwareClient: boolean;
    [immerable] = true;

    constructor(data?: IUpdateCompanyMiscSettingsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            this.doorsUnderManagement = _data["doorsUnderManagement"] !== undefined ? _data["doorsUnderManagement"] : <any>null;
            this.dollarsPerDoor = _data["dollarsPerDoor"] !== undefined ? _data["dollarsPerDoor"] : <any>null;
            this.isSoftwareClient = _data["isSoftwareClient"] !== undefined ? _data["isSoftwareClient"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCompanyMiscSettingsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyMiscSettingsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        data["doorsUnderManagement"] = this.doorsUnderManagement !== undefined ? this.doorsUnderManagement : <any>null;
        data["dollarsPerDoor"] = this.dollarsPerDoor !== undefined ? this.dollarsPerDoor : <any>null;
        data["isSoftwareClient"] = this.isSoftwareClient !== undefined ? this.isSoftwareClient : <any>null;
        return data;
    }
}

export interface IUpdateCompanyMiscSettingsPayload {
    companyId: string;
    doorsUnderManagement: number | null;
    dollarsPerDoor: number | null;
    isSoftwareClient: boolean;
}

export class IssueContact implements IIssueContact {
    user: UserSummary | null;
    group: string | null;
    showInChat: boolean;
    [immerable] = true;

    constructor(data?: IIssueContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new UserSummary(data.user) : <UserSummary>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserSummary.fromJS(_data["user"]) : <any>null;
            this.group = _data["group"] !== undefined ? _data["group"] : <any>null;
            this.showInChat = _data["showInChat"] !== undefined ? _data["showInChat"] : <any>null;
        }
    }

    static fromJS(data: any): IssueContact {
        data = typeof data === 'object' ? data : {};
        let result = new IssueContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["group"] = this.group !== undefined ? this.group : <any>null;
        data["showInChat"] = this.showInChat !== undefined ? this.showInChat : <any>null;
        return data;
    }
}

export interface IIssueContact {
    user: IUserSummary | null;
    group: string | null;
    showInChat: boolean;
}

export class MessageList implements IMessageList {
    messages: Message[] | null;
    participants: ChatParticipant[] | null;
    issues: IssueSummary[] | null;
    workorders: WorkorderSummary[] | null;
    properties: PropertySummary[] | null;
    receipts: Receipt[] | null;
    lastMessageSeqId: number | null;
    lastReceiptSeqId: number | null;
    [immerable] = true;

    constructor(data?: IMessageList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.messages) {
                this.messages = [];
                for (let i = 0; i < data.messages.length; i++) {
                    let item = data.messages[i];
                    this.messages[i] = item && !(<any>item).toJSON ? new Message(item) : <Message>item;
                }
            }
            if (data.participants) {
                this.participants = [];
                for (let i = 0; i < data.participants.length; i++) {
                    let item = data.participants[i];
                    this.participants[i] = item && !(<any>item).toJSON ? new ChatParticipant(item) : <ChatParticipant>item;
                }
            }
            if (data.issues) {
                this.issues = [];
                for (let i = 0; i < data.issues.length; i++) {
                    let item = data.issues[i];
                    this.issues[i] = item && !(<any>item).toJSON ? new IssueSummary(item) : <IssueSummary>item;
                }
            }
            if (data.workorders) {
                this.workorders = [];
                for (let i = 0; i < data.workorders.length; i++) {
                    let item = data.workorders[i];
                    this.workorders[i] = item && !(<any>item).toJSON ? new WorkorderSummary(item) : <WorkorderSummary>item;
                }
            }
            if (data.properties) {
                this.properties = [];
                for (let i = 0; i < data.properties.length; i++) {
                    let item = data.properties[i];
                    this.properties[i] = item && !(<any>item).toJSON ? new PropertySummary(item) : <PropertySummary>item;
                }
            }
            if (data.receipts) {
                this.receipts = [];
                for (let i = 0; i < data.receipts.length; i++) {
                    let item = data.receipts[i];
                    this.receipts[i] = item && !(<any>item).toJSON ? new Receipt(item) : <Receipt>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(Message.fromJS(item));
            }
            else {
                this.messages = <any>null;
            }
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ChatParticipant.fromJS(item));
            }
            else {
                this.participants = <any>null;
            }
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(IssueSummary.fromJS(item));
            }
            else {
                this.issues = <any>null;
            }
            if (Array.isArray(_data["workorders"])) {
                this.workorders = [] as any;
                for (let item of _data["workorders"])
                    this.workorders!.push(WorkorderSummary.fromJS(item));
            }
            else {
                this.workorders = <any>null;
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertySummary.fromJS(item));
            }
            else {
                this.properties = <any>null;
            }
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts!.push(Receipt.fromJS(item));
            }
            else {
                this.receipts = <any>null;
            }
            this.lastMessageSeqId = _data["lastMessageSeqId"] !== undefined ? _data["lastMessageSeqId"] : <any>null;
            this.lastReceiptSeqId = _data["lastReceiptSeqId"] !== undefined ? _data["lastReceiptSeqId"] : <any>null;
        }
    }

    static fromJS(data: any): MessageList {
        data = typeof data === 'object' ? data : {};
        let result = new MessageList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        if (Array.isArray(this.workorders)) {
            data["workorders"] = [];
            for (let item of this.workorders)
                data["workorders"].push(item.toJSON());
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item.toJSON());
        }
        data["lastMessageSeqId"] = this.lastMessageSeqId !== undefined ? this.lastMessageSeqId : <any>null;
        data["lastReceiptSeqId"] = this.lastReceiptSeqId !== undefined ? this.lastReceiptSeqId : <any>null;
        return data;
    }
}

export interface IMessageList {
    messages: IMessage[] | null;
    participants: IChatParticipant[] | null;
    issues: IIssueSummary[] | null;
    workorders: IWorkorderSummary[] | null;
    properties: IPropertySummary[] | null;
    receipts: IReceipt[] | null;
    lastMessageSeqId: number | null;
    lastReceiptSeqId: number | null;
}

export class Message implements IMessage {
    id: string;
    seqId: number;
    clientTempId: string | null;
    body: string | null;
    fromId: string;
    toId: string;
    issueId: string;
    workorderId: string;
    propertyId: string;
    read: boolean;
    sentAt: Date;
    files: AttachmentFile[] | null;
    [immerable] = true;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.files) {
                this.files = [];
                for (let i = 0; i < data.files.length; i++) {
                    let item = data.files[i];
                    this.files[i] = item && !(<any>item).toJSON ? new AttachmentFile(item) : <AttachmentFile>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.seqId = _data["seqId"] !== undefined ? _data["seqId"] : <any>null;
            this.clientTempId = _data["clientTempId"] !== undefined ? _data["clientTempId"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
            this.fromId = _data["fromId"] !== undefined ? _data["fromId"] : <any>null;
            this.toId = _data["toId"] !== undefined ? _data["toId"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
            this.propertyId = _data["propertyId"] !== undefined ? _data["propertyId"] : <any>null;
            this.read = _data["read"] !== undefined ? _data["read"] : <any>null;
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : <any>null;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(AttachmentFile.fromJS(item));
            }
            else {
                this.files = <any>null;
            }
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["seqId"] = this.seqId !== undefined ? this.seqId : <any>null;
        data["clientTempId"] = this.clientTempId !== undefined ? this.clientTempId : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["fromId"] = this.fromId !== undefined ? this.fromId : <any>null;
        data["toId"] = this.toId !== undefined ? this.toId : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        data["propertyId"] = this.propertyId !== undefined ? this.propertyId : <any>null;
        data["read"] = this.read !== undefined ? this.read : <any>null;
        data["sentAt"] = this.sentAt ? this.sentAt.toISOString() : <any>null;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessage {
    id: string;
    seqId: number;
    clientTempId: string | null;
    body: string | null;
    fromId: string;
    toId: string;
    issueId: string;
    workorderId: string;
    propertyId: string;
    read: boolean;
    sentAt: Date;
    files: IAttachmentFile[] | null;
}

export class ChatParticipant implements IChatParticipant {
    userSummary: UserSummary | null;
    category: string | null;
    mainCapability: CapabilityType;
    [immerable] = true;

    constructor(data?: IChatParticipant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.userSummary = data.userSummary && !(<any>data.userSummary).toJSON ? new UserSummary(data.userSummary) : <UserSummary>this.userSummary;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSummary = _data["userSummary"] ? UserSummary.fromJS(_data["userSummary"]) : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.mainCapability = _data["mainCapability"] !== undefined ? _data["mainCapability"] : <any>null;
        }
    }

    static fromJS(data: any): ChatParticipant {
        data = typeof data === 'object' ? data : {};
        let result = new ChatParticipant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSummary"] = this.userSummary ? this.userSummary.toJSON() : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["mainCapability"] = this.mainCapability !== undefined ? this.mainCapability : <any>null;
        return data;
    }
}

export interface IChatParticipant {
    userSummary: IUserSummary | null;
    category: string | null;
    mainCapability: CapabilityType;
}

export class WorkorderSummary implements IWorkorderSummary {
    id: string;
    sequentialId: number;
    friendlyId: string | null;
    notes: string | null;
    propertyId: string;
    gateCode: string | null;
    externalReference: string | null;
    lockBox: string | null;
    status: WorkorderStatus;
    priority: Priority;
    priorityDisplay: string | null;
    [immerable] = true;

    constructor(data?: IWorkorderSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.sequentialId = _data["sequentialId"] !== undefined ? _data["sequentialId"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.propertyId = _data["propertyId"] !== undefined ? _data["propertyId"] : <any>null;
            this.gateCode = _data["gateCode"] !== undefined ? _data["gateCode"] : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.lockBox = _data["lockBox"] !== undefined ? _data["lockBox"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.priorityDisplay = _data["priorityDisplay"] !== undefined ? _data["priorityDisplay"] : <any>null;
        }
    }

    static fromJS(data: any): WorkorderSummary {
        data = typeof data === 'object' ? data : {};
        let result = new WorkorderSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["sequentialId"] = this.sequentialId !== undefined ? this.sequentialId : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["propertyId"] = this.propertyId !== undefined ? this.propertyId : <any>null;
        data["gateCode"] = this.gateCode !== undefined ? this.gateCode : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["lockBox"] = this.lockBox !== undefined ? this.lockBox : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["priorityDisplay"] = this.priorityDisplay !== undefined ? this.priorityDisplay : <any>null;
        return data;
    }
}

export interface IWorkorderSummary {
    id: string;
    sequentialId: number;
    friendlyId: string | null;
    notes: string | null;
    propertyId: string;
    gateCode: string | null;
    externalReference: string | null;
    lockBox: string | null;
    status: WorkorderStatus;
    priority: Priority;
    priorityDisplay: string | null;
}

export enum WorkorderStatus {
    Unknown = 0,
    New = 20,
    InProgress = 21,
    Closed = 22,
}

export enum Priority {
    Unknown = 0,
    Critical = 1,
    High = 2,
    Medium = 3,
    Low = 4,
    Trivial = 5,
}

export class Receipt implements IReceipt {
    id: string;
    messageId: string;
    seqId: number;
    [immerable] = true;

    constructor(data?: IReceipt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.messageId = _data["messageId"] !== undefined ? _data["messageId"] : <any>null;
            this.seqId = _data["seqId"] !== undefined ? _data["seqId"] : <any>null;
        }
    }

    static fromJS(data: any): Receipt {
        data = typeof data === 'object' ? data : {};
        let result = new Receipt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["messageId"] = this.messageId !== undefined ? this.messageId : <any>null;
        data["seqId"] = this.seqId !== undefined ? this.seqId : <any>null;
        return data;
    }
}

export interface IReceipt {
    id: string;
    messageId: string;
    seqId: number;
}

export class FindLatestMessagesPayload implements IFindLatestMessagesPayload {
    lastMessageSeqId: number | null;
    lastReceiptSeqId: number | null;
    messageIds: string[] | null;
    [immerable] = true;

    constructor(data?: IFindLatestMessagesPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastMessageSeqId = _data["lastMessageSeqId"] !== undefined ? _data["lastMessageSeqId"] : <any>null;
            this.lastReceiptSeqId = _data["lastReceiptSeqId"] !== undefined ? _data["lastReceiptSeqId"] : <any>null;
            if (Array.isArray(_data["messageIds"])) {
                this.messageIds = [] as any;
                for (let item of _data["messageIds"])
                    this.messageIds!.push(item);
            }
            else {
                this.messageIds = <any>null;
            }
        }
    }

    static fromJS(data: any): FindLatestMessagesPayload {
        data = typeof data === 'object' ? data : {};
        let result = new FindLatestMessagesPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastMessageSeqId"] = this.lastMessageSeqId !== undefined ? this.lastMessageSeqId : <any>null;
        data["lastReceiptSeqId"] = this.lastReceiptSeqId !== undefined ? this.lastReceiptSeqId : <any>null;
        if (Array.isArray(this.messageIds)) {
            data["messageIds"] = [];
            for (let item of this.messageIds)
                data["messageIds"].push(item);
        }
        return data;
    }
}

export interface IFindLatestMessagesPayload {
    lastMessageSeqId: number | null;
    lastReceiptSeqId: number | null;
    messageIds: string[] | null;
}

export class MarkMessagesReadPayload implements IMarkMessagesReadPayload {
    messageIds: string[] | null;
    lastReceiptId: number | null;
    [immerable] = true;

    constructor(data?: IMarkMessagesReadPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageIds"])) {
                this.messageIds = [] as any;
                for (let item of _data["messageIds"])
                    this.messageIds!.push(item);
            }
            else {
                this.messageIds = <any>null;
            }
            this.lastReceiptId = _data["lastReceiptId"] !== undefined ? _data["lastReceiptId"] : <any>null;
        }
    }

    static fromJS(data: any): MarkMessagesReadPayload {
        data = typeof data === 'object' ? data : {};
        let result = new MarkMessagesReadPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageIds)) {
            data["messageIds"] = [];
            for (let item of this.messageIds)
                data["messageIds"].push(item);
        }
        data["lastReceiptId"] = this.lastReceiptId !== undefined ? this.lastReceiptId : <any>null;
        return data;
    }
}

export interface IMarkMessagesReadPayload {
    messageIds: string[] | null;
    lastReceiptId: number | null;
}

export class AddIssueMessagePayload implements IAddIssueMessagePayload {
    issueId: string;
    messageBody: string | null;
    recipients: AddMessageRecipient[] | null;
    fileIds: string[] | null;
    [immerable] = true;

    constructor(data?: IAddIssueMessagePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.recipients) {
                this.recipients = [];
                for (let i = 0; i < data.recipients.length; i++) {
                    let item = data.recipients[i];
                    this.recipients[i] = item && !(<any>item).toJSON ? new AddMessageRecipient(item) : <AddMessageRecipient>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.messageBody = _data["messageBody"] !== undefined ? _data["messageBody"] : <any>null;
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(AddMessageRecipient.fromJS(item));
            }
            else {
                this.recipients = <any>null;
            }
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
            else {
                this.fileIds = <any>null;
            }
        }
    }

    static fromJS(data: any): AddIssueMessagePayload {
        data = typeof data === 'object' ? data : {};
        let result = new AddIssueMessagePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["messageBody"] = this.messageBody !== undefined ? this.messageBody : <any>null;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        return data;
    }
}

export interface IAddIssueMessagePayload {
    issueId: string;
    messageBody: string | null;
    recipients: IAddMessageRecipient[] | null;
    fileIds: string[] | null;
}

export class AddMessageRecipient implements IAddMessageRecipient {
    userId: string;
    clientMessageId: string;
    [immerable] = true;

    constructor(data?: IAddMessageRecipient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.clientMessageId = _data["clientMessageId"] !== undefined ? _data["clientMessageId"] : <any>null;
        }
    }

    static fromJS(data: any): AddMessageRecipient {
        data = typeof data === 'object' ? data : {};
        let result = new AddMessageRecipient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["clientMessageId"] = this.clientMessageId !== undefined ? this.clientMessageId : <any>null;
        return data;
    }
}

export interface IAddMessageRecipient {
    userId: string;
    clientMessageId: string;
}

export class MessageDetail implements IMessageDetail {
    id: string;
    body: string | null;
    from: UserSummary | null;
    to: UserSummary | null;
    issueId: string;
    read: boolean;
    sentAt: Date;
    files: AttachmentFile[] | null;
    [immerable] = true;

    constructor(data?: IMessageDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.from = data.from && !(<any>data.from).toJSON ? new UserSummary(data.from) : <UserSummary>this.from;
            this.to = data.to && !(<any>data.to).toJSON ? new UserSummary(data.to) : <UserSummary>this.to;
            if (data.files) {
                this.files = [];
                for (let i = 0; i < data.files.length; i++) {
                    let item = data.files[i];
                    this.files[i] = item && !(<any>item).toJSON ? new AttachmentFile(item) : <AttachmentFile>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
            this.from = _data["from"] ? UserSummary.fromJS(_data["from"]) : <any>null;
            this.to = _data["to"] ? UserSummary.fromJS(_data["to"]) : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.read = _data["read"] !== undefined ? _data["read"] : <any>null;
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : <any>null;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(AttachmentFile.fromJS(item));
            }
            else {
                this.files = <any>null;
            }
        }
    }

    static fromJS(data: any): MessageDetail {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["from"] = this.from ? this.from.toJSON() : <any>null;
        data["to"] = this.to ? this.to.toJSON() : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["read"] = this.read !== undefined ? this.read : <any>null;
        data["sentAt"] = this.sentAt ? this.sentAt.toISOString() : <any>null;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageDetail {
    id: string;
    body: string | null;
    from: IUserSummary | null;
    to: IUserSummary | null;
    issueId: string;
    read: boolean;
    sentAt: Date;
    files: IAttachmentFile[] | null;
}

export class EntityNote implements IEntityNote {
    id: string;
    entityId: string;
    text: string | null;
    author: UserSummary | null;
    entityType: NoteEntityType;
    createdAt: Date;
    [immerable] = true;

    constructor(data?: IEntityNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.author = data.author && !(<any>data.author).toJSON ? new UserSummary(data.author) : <UserSummary>this.author;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.author = _data["author"] ? UserSummary.fromJS(_data["author"]) : <any>null;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EntityNote {
        data = typeof data === 'object' ? data : {};
        let result = new EntityNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["entityId"] = this.entityId !== undefined ? this.entityId : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["author"] = this.author ? this.author.toJSON() : <any>null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        return data;
    }
}

export interface IEntityNote {
    id: string;
    entityId: string;
    text: string | null;
    author: IUserSummary | null;
    entityType: NoteEntityType;
    createdAt: Date;
}

export enum NoteEntityType {
    Unknown = 0,
    Issue = 1,
    Workorder = 2,
    Vendor = 13,
    ManagementCompany = 14,
    CompanyMember = 17,
}

export class GetNotePayload implements IGetNotePayload {
    entityType: NoteEntityType;
    entityId: string;
    [immerable] = true;

    constructor(data?: IGetNotePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : <any>null;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : <any>null;
        }
    }

    static fromJS(data: any): GetNotePayload {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType !== undefined ? this.entityType : <any>null;
        data["entityId"] = this.entityId !== undefined ? this.entityId : <any>null;
        return data;
    }
}

export interface IGetNotePayload {
    entityType: NoteEntityType;
    entityId: string;
}

export class AddNotePayload implements IAddNotePayload {
    entityId: string;
    entityType: NoteEntityType;
    noteSource: NoteSource;
    note: string | null;
    [immerable] = true;

    constructor(data?: IAddNotePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : <any>null;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : <any>null;
            this.noteSource = _data["noteSource"] !== undefined ? _data["noteSource"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): AddNotePayload {
        data = typeof data === 'object' ? data : {};
        let result = new AddNotePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId !== undefined ? this.entityId : <any>null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : <any>null;
        data["noteSource"] = this.noteSource !== undefined ? this.noteSource : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        return data;
    }
}

export interface IAddNotePayload {
    entityId: string;
    entityType: NoteEntityType;
    noteSource: NoteSource;
    note: string | null;
}

export enum NoteSource {
    Unknown = 0,
    MainPage = 1,
    Reporting = 2,
    ClientsList = 3,
    CompanyProfile = 4,
    UserProfile = 5,
    VendorProfile = 6,
}

export class Property extends PropertySummary implements IProperty {
    maintenanceLimit: number | null;
    tenants: Tenant[] | null;
    managementCompany: ManagementCompany | null;
    owner: UserSummary | null;
    manager: UserSummary | null;
    createdAt: Date;
    createdBy: UserSummary | null;
    [immerable] = true;

    constructor(data?: IProperty) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.tenants) {
                this.tenants = [];
                for (let i = 0; i < data.tenants.length; i++) {
                    let item = data.tenants[i];
                    this.tenants[i] = item && !(<any>item).toJSON ? new Tenant(item) : <Tenant>item;
                }
            }
            this.managementCompany = data.managementCompany && !(<any>data.managementCompany).toJSON ? new ManagementCompany(data.managementCompany) : <ManagementCompany>this.managementCompany;
            this.owner = data.owner && !(<any>data.owner).toJSON ? new UserSummary(data.owner) : <UserSummary>this.owner;
            this.manager = data.manager && !(<any>data.manager).toJSON ? new UserSummary(data.manager) : <UserSummary>this.manager;
            this.createdBy = data.createdBy && !(<any>data.createdBy).toJSON ? new UserSummary(data.createdBy) : <UserSummary>this.createdBy;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.maintenanceLimit = _data["maintenanceLimit"] !== undefined ? _data["maintenanceLimit"] : <any>null;
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(Tenant.fromJS(item));
            }
            else {
                this.tenants = <any>null;
            }
            this.managementCompany = _data["managementCompany"] ? ManagementCompany.fromJS(_data["managementCompany"]) : <any>null;
            this.owner = _data["owner"] ? UserSummary.fromJS(_data["owner"]) : <any>null;
            this.manager = _data["manager"] ? UserSummary.fromJS(_data["manager"]) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.createdBy = _data["createdBy"] ? UserSummary.fromJS(_data["createdBy"]) : <any>null;
        }
    }

    static fromJS(data: any): Property {
        data = typeof data === 'object' ? data : {};
        let result = new Property();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maintenanceLimit"] = this.maintenanceLimit !== undefined ? this.maintenanceLimit : <any>null;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        data["managementCompany"] = this.managementCompany ? this.managementCompany.toJSON() : <any>null;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>null;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IProperty extends IPropertySummary {
    maintenanceLimit: number | null;
    tenants: ITenant[] | null;
    managementCompany: IManagementCompany | null;
    owner: IUserSummary | null;
    manager: IUserSummary | null;
    createdAt: Date;
    createdBy: IUserSummary | null;
}

export class Tenant implements ITenant {
    user: UserSummary | null;
    moveInDate: Instant | null;
    moveOutDate: Instant | null;
    [immerable] = true;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new UserSummary(data.user) : <UserSummary>this.user;
            this.moveInDate = data.moveInDate && !(<any>data.moveInDate).toJSON ? new Instant(data.moveInDate) : <Instant>this.moveInDate;
            this.moveOutDate = data.moveOutDate && !(<any>data.moveOutDate).toJSON ? new Instant(data.moveOutDate) : <Instant>this.moveOutDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserSummary.fromJS(_data["user"]) : <any>null;
            this.moveInDate = _data["moveInDate"] ? Instant.fromJS(_data["moveInDate"]) : <any>null;
            this.moveOutDate = _data["moveOutDate"] ? Instant.fromJS(_data["moveOutDate"]) : <any>null;
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["moveInDate"] = this.moveInDate ? this.moveInDate.toJSON() : <any>null;
        data["moveOutDate"] = this.moveOutDate ? this.moveOutDate.toJSON() : <any>null;
        return data;
    }
}

export interface ITenant {
    user: IUserSummary | null;
    moveInDate: IInstant | null;
    moveOutDate: IInstant | null;
}

export class CreatePropertyResult implements ICreatePropertyResult {
    success: boolean;
    property: Property | null;
    duplicates: DuplicateProperty[] | null;
    [immerable] = true;

    constructor(data?: ICreatePropertyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.property = data.property && !(<any>data.property).toJSON ? new Property(data.property) : <Property>this.property;
            if (data.duplicates) {
                this.duplicates = [];
                for (let i = 0; i < data.duplicates.length; i++) {
                    let item = data.duplicates[i];
                    this.duplicates[i] = item && !(<any>item).toJSON ? new DuplicateProperty(item) : <DuplicateProperty>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.property = _data["property"] ? Property.fromJS(_data["property"]) : <any>null;
            if (Array.isArray(_data["duplicates"])) {
                this.duplicates = [] as any;
                for (let item of _data["duplicates"])
                    this.duplicates!.push(DuplicateProperty.fromJS(item));
            }
            else {
                this.duplicates = <any>null;
            }
        }
    }

    static fromJS(data: any): CreatePropertyResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePropertyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["property"] = this.property ? this.property.toJSON() : <any>null;
        if (Array.isArray(this.duplicates)) {
            data["duplicates"] = [];
            for (let item of this.duplicates)
                data["duplicates"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreatePropertyResult {
    success: boolean;
    property: IProperty | null;
    duplicates: IDuplicateProperty[] | null;
}

export class DuplicateProperty implements IDuplicateProperty {
    propertyId: string;
    address: Address | null;
    [immerable] = true;

    constructor(data?: IDuplicateProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new Address(data.address) : <Address>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"] !== undefined ? _data["propertyId"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
        }
    }

    static fromJS(data: any): DuplicateProperty {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId !== undefined ? this.propertyId : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        return data;
    }
}

export interface IDuplicateProperty {
    propertyId: string;
    address: IAddress | null;
}

export class CreatePropertyPayload implements ICreatePropertyPayload {
    managementCompanyId: string | null;
    owner: CreatePersonModel | null;
    tenants: CreateTenantModel[] | null;
    managerId: string | null;
    name: string | null;
    maintenanceLimit: number;
    isOccupied: boolean;
    address: ModifyAddressPayload | null;
    gateCode: string | null;
    bedroomNumber: number | null;
    bathroomNumber: number | null;
    propertyArea: number | null;
    lotSize: number | null;
    hasPool: boolean;
    [immerable] = true;

    constructor(data?: ICreatePropertyPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.owner = data.owner && !(<any>data.owner).toJSON ? new CreatePersonModel(data.owner) : <CreatePersonModel>this.owner;
            if (data.tenants) {
                this.tenants = [];
                for (let i = 0; i < data.tenants.length; i++) {
                    let item = data.tenants[i];
                    this.tenants[i] = item && !(<any>item).toJSON ? new CreateTenantModel(item) : <CreateTenantModel>item;
                }
            }
            this.address = data.address && !(<any>data.address).toJSON ? new ModifyAddressPayload(data.address) : <ModifyAddressPayload>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            this.owner = _data["owner"] ? CreatePersonModel.fromJS(_data["owner"]) : <any>null;
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(CreateTenantModel.fromJS(item));
            }
            else {
                this.tenants = <any>null;
            }
            this.managerId = _data["managerId"] !== undefined ? _data["managerId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.maintenanceLimit = _data["maintenanceLimit"] !== undefined ? _data["maintenanceLimit"] : <any>null;
            this.isOccupied = _data["isOccupied"] !== undefined ? _data["isOccupied"] : <any>null;
            this.address = _data["address"] ? ModifyAddressPayload.fromJS(_data["address"]) : <any>null;
            this.gateCode = _data["gateCode"] !== undefined ? _data["gateCode"] : <any>null;
            this.bedroomNumber = _data["bedroomNumber"] !== undefined ? _data["bedroomNumber"] : <any>null;
            this.bathroomNumber = _data["bathroomNumber"] !== undefined ? _data["bathroomNumber"] : <any>null;
            this.propertyArea = _data["propertyArea"] !== undefined ? _data["propertyArea"] : <any>null;
            this.lotSize = _data["lotSize"] !== undefined ? _data["lotSize"] : <any>null;
            this.hasPool = _data["hasPool"] !== undefined ? _data["hasPool"] : <any>null;
        }
    }

    static fromJS(data: any): CreatePropertyPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePropertyPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>null;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        data["managerId"] = this.managerId !== undefined ? this.managerId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["maintenanceLimit"] = this.maintenanceLimit !== undefined ? this.maintenanceLimit : <any>null;
        data["isOccupied"] = this.isOccupied !== undefined ? this.isOccupied : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["gateCode"] = this.gateCode !== undefined ? this.gateCode : <any>null;
        data["bedroomNumber"] = this.bedroomNumber !== undefined ? this.bedroomNumber : <any>null;
        data["bathroomNumber"] = this.bathroomNumber !== undefined ? this.bathroomNumber : <any>null;
        data["propertyArea"] = this.propertyArea !== undefined ? this.propertyArea : <any>null;
        data["lotSize"] = this.lotSize !== undefined ? this.lotSize : <any>null;
        data["hasPool"] = this.hasPool !== undefined ? this.hasPool : <any>null;
        return data;
    }
}

export interface ICreatePropertyPayload {
    managementCompanyId: string | null;
    owner: ICreatePersonModel | null;
    tenants: ICreateTenantModel[] | null;
    managerId: string | null;
    name: string | null;
    maintenanceLimit: number;
    isOccupied: boolean;
    address: IModifyAddressPayload | null;
    gateCode: string | null;
    bedroomNumber: number | null;
    bathroomNumber: number | null;
    propertyArea: number | null;
    lotSize: number | null;
    hasPool: boolean;
}

export class CreateTenantModel implements ICreateTenantModel {
    moveInDate: Instant | null;
    moveOutDate: Instant | null;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    phone: string | null;
    userId: string | null;
    [immerable] = true;

    constructor(data?: ICreateTenantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.moveInDate = data.moveInDate && !(<any>data.moveInDate).toJSON ? new Instant(data.moveInDate) : <Instant>this.moveInDate;
            this.moveOutDate = data.moveOutDate && !(<any>data.moveOutDate).toJSON ? new Instant(data.moveOutDate) : <Instant>this.moveOutDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moveInDate = _data["moveInDate"] ? Instant.fromJS(_data["moveInDate"]) : <any>null;
            this.moveOutDate = _data["moveOutDate"] ? Instant.fromJS(_data["moveOutDate"]) : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateTenantModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moveInDate"] = this.moveInDate ? this.moveInDate.toJSON() : <any>null;
        data["moveOutDate"] = this.moveOutDate ? this.moveOutDate.toJSON() : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface ICreateTenantModel {
    moveInDate: IInstant | null;
    moveOutDate: IInstant | null;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    phone: string | null;
    userId: string | null;
}

export class UpdatePropertyPayload implements IUpdatePropertyPayload {
    id: string;
    managementCompanyId: string;
    tenants: CreateTenantModel[] | null;
    owner: CreatePersonModel | null;
    managerId: string | null;
    name: string | null;
    maintenanceLimit: number;
    isOccupied: boolean;
    address: ModifyAddressPayload | null;
    gateCode: string | null;
    bedroomNumber: number | null;
    bathroomNumber: number | null;
    propertyArea: number | null;
    lotSize: number | null;
    hasPool: boolean;
    [immerable] = true;

    constructor(data?: IUpdatePropertyPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.tenants) {
                this.tenants = [];
                for (let i = 0; i < data.tenants.length; i++) {
                    let item = data.tenants[i];
                    this.tenants[i] = item && !(<any>item).toJSON ? new CreateTenantModel(item) : <CreateTenantModel>item;
                }
            }
            this.owner = data.owner && !(<any>data.owner).toJSON ? new CreatePersonModel(data.owner) : <CreatePersonModel>this.owner;
            this.address = data.address && !(<any>data.address).toJSON ? new ModifyAddressPayload(data.address) : <ModifyAddressPayload>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(CreateTenantModel.fromJS(item));
            }
            else {
                this.tenants = <any>null;
            }
            this.owner = _data["owner"] ? CreatePersonModel.fromJS(_data["owner"]) : <any>null;
            this.managerId = _data["managerId"] !== undefined ? _data["managerId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.maintenanceLimit = _data["maintenanceLimit"] !== undefined ? _data["maintenanceLimit"] : <any>null;
            this.isOccupied = _data["isOccupied"] !== undefined ? _data["isOccupied"] : <any>null;
            this.address = _data["address"] ? ModifyAddressPayload.fromJS(_data["address"]) : <any>null;
            this.gateCode = _data["gateCode"] !== undefined ? _data["gateCode"] : <any>null;
            this.bedroomNumber = _data["bedroomNumber"] !== undefined ? _data["bedroomNumber"] : <any>null;
            this.bathroomNumber = _data["bathroomNumber"] !== undefined ? _data["bathroomNumber"] : <any>null;
            this.propertyArea = _data["propertyArea"] !== undefined ? _data["propertyArea"] : <any>null;
            this.lotSize = _data["lotSize"] !== undefined ? _data["lotSize"] : <any>null;
            this.hasPool = _data["hasPool"] !== undefined ? _data["hasPool"] : <any>null;
        }
    }

    static fromJS(data: any): UpdatePropertyPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePropertyPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        data["owner"] = this.owner ? this.owner.toJSON() : <any>null;
        data["managerId"] = this.managerId !== undefined ? this.managerId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["maintenanceLimit"] = this.maintenanceLimit !== undefined ? this.maintenanceLimit : <any>null;
        data["isOccupied"] = this.isOccupied !== undefined ? this.isOccupied : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["gateCode"] = this.gateCode !== undefined ? this.gateCode : <any>null;
        data["bedroomNumber"] = this.bedroomNumber !== undefined ? this.bedroomNumber : <any>null;
        data["bathroomNumber"] = this.bathroomNumber !== undefined ? this.bathroomNumber : <any>null;
        data["propertyArea"] = this.propertyArea !== undefined ? this.propertyArea : <any>null;
        data["lotSize"] = this.lotSize !== undefined ? this.lotSize : <any>null;
        data["hasPool"] = this.hasPool !== undefined ? this.hasPool : <any>null;
        return data;
    }
}

export interface IUpdatePropertyPayload {
    id: string;
    managementCompanyId: string;
    tenants: ICreateTenantModel[] | null;
    owner: ICreatePersonModel | null;
    managerId: string | null;
    name: string | null;
    maintenanceLimit: number;
    isOccupied: boolean;
    address: IModifyAddressPayload | null;
    gateCode: string | null;
    bedroomNumber: number | null;
    bathroomNumber: number | null;
    propertyArea: number | null;
    lotSize: number | null;
    hasPool: boolean;
}

export class SetPropertyCoverImagePayload implements ISetPropertyCoverImagePayload {
    propertyId: string;
    fileId: string | null;
    [immerable] = true;

    constructor(data?: ISetPropertyCoverImagePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"] !== undefined ? _data["propertyId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): SetPropertyCoverImagePayload {
        data = typeof data === 'object' ? data : {};
        let result = new SetPropertyCoverImagePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId !== undefined ? this.propertyId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        return data;
    }
}

export interface ISetPropertyCoverImagePayload {
    propertyId: string;
    fileId: string | null;
}

export class DeletePropertyPayload implements IDeletePropertyPayload {
    id: string;
    [immerable] = true;

    constructor(data?: IDeletePropertyPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeletePropertyPayload {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePropertyPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IDeletePropertyPayload {
    id: string;
}

export class SearchResultsCollection implements ISearchResultsCollection {
    workorders: WorkorderWithIssues[] | null;
    properties: Property[] | null;
    vendors: Vendor[] | null;
    tenants: UserInfo[] | null;
    [immerable] = true;

    constructor(data?: ISearchResultsCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.vendors) {
                this.vendors = [];
                for (let i = 0; i < data.vendors.length; i++) {
                    let item = data.vendors[i];
                    this.vendors[i] = item && !(<any>item).toJSON ? new Vendor(item) : <Vendor>item;
                }
            }
            if (data.tenants) {
                this.tenants = [];
                for (let i = 0; i < data.tenants.length; i++) {
                    let item = data.tenants[i];
                    this.tenants[i] = item && !(<any>item).toJSON ? new UserInfo(item) : <UserInfo>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workorders"])) {
                this.workorders = [] as any;
                for (let item of _data["workorders"])
                    this.workorders!.push(WorkorderWithIssues.fromJS(item));
            }
            else {
                this.workorders = <any>null;
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(Property.fromJS(item));
            }
            else {
                this.properties = <any>null;
            }
            if (Array.isArray(_data["vendors"])) {
                this.vendors = [] as any;
                for (let item of _data["vendors"])
                    this.vendors!.push(Vendor.fromJS(item));
            }
            else {
                this.vendors = <any>null;
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(UserInfo.fromJS(item));
            }
            else {
                this.tenants = <any>null;
            }
        }
    }

    static fromJS(data: any): SearchResultsCollection {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultsCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workorders)) {
            data["workorders"] = [];
            for (let item of this.workorders)
                data["workorders"].push(item.toJSON());
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        if (Array.isArray(this.vendors)) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item.toJSON());
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResultsCollection {
    workorders: WorkorderWithIssues[] | null;
    properties: Property[] | null;
    vendors: IVendor[] | null;
    tenants: IUserInfo[] | null;
}

export class Workorder extends WorkorderSummary implements IWorkorder {
    isLegacy: boolean;
    property: Property | null;
    managementCompany: ManagementCompany | null;
    createdBy: User | null;
    dateCreated: Date;
    dateClosed: Date | null;
    dateModified: Date | null;
    manager: User | null;
    [immerable] = true;

    constructor(data?: IWorkorder) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
            this.property = data.property && !(<any>data.property).toJSON ? new Property(data.property) : <Property>this.property;
            this.managementCompany = data.managementCompany && !(<any>data.managementCompany).toJSON ? new ManagementCompany(data.managementCompany) : <ManagementCompany>this.managementCompany;
            this.createdBy = data.createdBy && !(<any>data.createdBy).toJSON ? new User(data.createdBy) : <User>this.createdBy;
            this.manager = data.manager && !(<any>data.manager).toJSON ? new User(data.manager) : <User>this.manager;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isLegacy = _data["isLegacy"] !== undefined ? _data["isLegacy"] : <any>null;
            this.property = _data["property"] ? Property.fromJS(_data["property"]) : <any>null;
            this.managementCompany = _data["managementCompany"] ? ManagementCompany.fromJS(_data["managementCompany"]) : <any>null;
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>null;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>null;
            this.dateClosed = _data["dateClosed"] ? new Date(_data["dateClosed"].toString()) : <any>null;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>null;
            this.manager = _data["manager"] ? User.fromJS(_data["manager"]) : <any>null;
        }
    }

    static fromJS(data: any): Workorder {
        data = typeof data === 'object' ? data : {};
        let result = new Workorder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLegacy"] = this.isLegacy !== undefined ? this.isLegacy : <any>null;
        data["property"] = this.property ? this.property.toJSON() : <any>null;
        data["managementCompany"] = this.managementCompany ? this.managementCompany.toJSON() : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>null;
        data["dateClosed"] = this.dateClosed ? this.dateClosed.toISOString() : <any>null;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>null;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IWorkorder extends IWorkorderSummary {
    isLegacy: boolean;
    property: IProperty | null;
    managementCompany: IManagementCompany | null;
    createdBy: IUser | null;
    dateCreated: Date;
    dateClosed: Date | null;
    dateModified: Date | null;
    manager: IUser | null;
}

export class WorkorderWithIssues extends Workorder implements IWorkorderWithIssues {
    issues: Issue[] | null;
    [immerable] = true;

    constructor(data?: IWorkorderWithIssues) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(Issue.fromJS(item));
            }
            else {
                this.issues = <any>null;
            }
        }
    }

    static fromJS(data: any): WorkorderWithIssues {
        data = typeof data === 'object' ? data : {};
        let result = new WorkorderWithIssues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWorkorderWithIssues extends IWorkorder {
    issues: Issue[] | null;
}

export class UserInfo implements IUserInfo {
    id: string;
    firstName: string | null;
    lastName: string | null;
    fullName: string | null;
    [immerable] = true;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        return data;
    }
}

export interface IUserInfo {
    id: string;
    firstName: string | null;
    lastName: string | null;
    fullName: string | null;
}

export class UpdateProfileBasicsPayload implements IUpdateProfileBasicsPayload {
    title: string | null;
    firstName: string | null;
    lastName: string | null;
    [immerable] = true;

    constructor(data?: IUpdateProfileBasicsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateProfileBasicsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileBasicsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data;
    }
}

export interface IUpdateProfileBasicsPayload {
    title: string | null;
    firstName: string | null;
    lastName: string | null;
}

export class UpdateProfileContactInfoPayload implements IUpdateProfileContactInfoPayload {
    phone: string | null;
    workPhone: string | null;
    address: ModifyAddressPayload | null;
    [immerable] = true;

    constructor(data?: IUpdateProfileContactInfoPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new ModifyAddressPayload(data.address) : <ModifyAddressPayload>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : <any>null;
            this.address = _data["address"] ? ModifyAddressPayload.fromJS(_data["address"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateProfileContactInfoPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileContactInfoPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateProfileContactInfoPayload {
    phone: string | null;
    workPhone: string | null;
    address: IModifyAddressPayload | null;
}

export class UpdateProfilePasswordPayload implements IUpdateProfilePasswordPayload {
    newPassword: string | null;
    [immerable] = true;

    constructor(data?: IUpdateProfilePasswordPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateProfilePasswordPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePasswordPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
        return data;
    }
}

export interface IUpdateProfilePasswordPayload {
    newPassword: string | null;
}

export class UpdateProfilePreferencesPayload implements IUpdateProfilePreferencesPayload {
    receiveEmail: boolean;
    receiveText: boolean;
    [immerable] = true;

    constructor(data?: IUpdateProfilePreferencesPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveEmail = _data["receiveEmail"] !== undefined ? _data["receiveEmail"] : <any>null;
            this.receiveText = _data["receiveText"] !== undefined ? _data["receiveText"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateProfilePreferencesPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePreferencesPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveEmail"] = this.receiveEmail !== undefined ? this.receiveEmail : <any>null;
        data["receiveText"] = this.receiveText !== undefined ? this.receiveText : <any>null;
        return data;
    }
}

export interface IUpdateProfilePreferencesPayload {
    receiveEmail: boolean;
    receiveText: boolean;
}

export class CanForceChangeEmailPayload implements ICanForceChangeEmailPayload {
    targetUserId: string;
    managementCompanyId: string;
    [immerable] = true;

    constructor(data?: ICanForceChangeEmailPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUserId = _data["targetUserId"] !== undefined ? _data["targetUserId"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
        }
    }

    static fromJS(data: any): CanForceChangeEmailPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CanForceChangeEmailPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserId"] = this.targetUserId !== undefined ? this.targetUserId : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        return data;
    }
}

export interface ICanForceChangeEmailPayload {
    targetUserId: string;
    managementCompanyId: string;
}

export enum ForceChangeEmailResultType {
    Success = 0,
    EmailUnavailable = 1,
}

export class ForceChangeEmailPayload implements IForceChangeEmailPayload {
    userId: string;
    oldEmail: string | null;
    newEmail: string | null;
    [immerable] = true;

    constructor(data?: IForceChangeEmailPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.oldEmail = _data["oldEmail"] !== undefined ? _data["oldEmail"] : <any>null;
            this.newEmail = _data["newEmail"] !== undefined ? _data["newEmail"] : <any>null;
        }
    }

    static fromJS(data: any): ForceChangeEmailPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ForceChangeEmailPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["oldEmail"] = this.oldEmail !== undefined ? this.oldEmail : <any>null;
        data["newEmail"] = this.newEmail !== undefined ? this.newEmail : <any>null;
        return data;
    }
}

export interface IForceChangeEmailPayload {
    userId: string;
    oldEmail: string | null;
    newEmail: string | null;
}

export class DwollaCustomerInfo implements IDwollaCustomerInfo {
    vendorId: string;
    id: string | null;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    status: string | null;
    bankAccount: DwollaFundingSourceInfo | null;
    [immerable] = true;

    constructor(data?: IDwollaCustomerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.bankAccount = data.bankAccount && !(<any>data.bankAccount).toJSON ? new DwollaFundingSourceInfo(data.bankAccount) : <DwollaFundingSourceInfo>this.bankAccount;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.bankAccount = _data["bankAccount"] ? DwollaFundingSourceInfo.fromJS(_data["bankAccount"]) : <any>null;
        }
    }

    static fromJS(data: any): DwollaCustomerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DwollaCustomerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>null;
        return data;
    }
}

export interface IDwollaCustomerInfo {
    vendorId: string;
    id: string | null;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    status: string | null;
    bankAccount: IDwollaFundingSourceInfo | null;
}

export class DwollaFundingSourceInfo implements IDwollaFundingSourceInfo {
    vendorId: string;
    id: string | null;
    accountName: string | null;
    accountType: string | null;
    routingNumber: string | null;
    accountNumber: string | null;
    status: string | null;
    [immerable] = true;

    constructor(data?: IDwollaFundingSourceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : <any>null;
            this.accountType = _data["accountType"] !== undefined ? _data["accountType"] : <any>null;
            this.routingNumber = _data["routingNumber"] !== undefined ? _data["routingNumber"] : <any>null;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): DwollaFundingSourceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DwollaFundingSourceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["accountName"] = this.accountName !== undefined ? this.accountName : <any>null;
        data["accountType"] = this.accountType !== undefined ? this.accountType : <any>null;
        data["routingNumber"] = this.routingNumber !== undefined ? this.routingNumber : <any>null;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IDwollaFundingSourceInfo {
    vendorId: string;
    id: string | null;
    accountName: string | null;
    accountType: string | null;
    routingNumber: string | null;
    accountNumber: string | null;
    status: string | null;
}

export class DwollaMasterInfo implements IDwollaMasterInfo {
    available: number;
    pending: number;
    total: number;
    isSandbox: boolean;
    minimalAmount: number;
    amountToAdd: number;
    [immerable] = true;

    constructor(data?: IDwollaMasterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.available = _data["available"] !== undefined ? _data["available"] : <any>null;
            this.pending = _data["pending"] !== undefined ? _data["pending"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.isSandbox = _data["isSandbox"] !== undefined ? _data["isSandbox"] : <any>null;
            this.minimalAmount = _data["minimalAmount"] !== undefined ? _data["minimalAmount"] : <any>null;
            this.amountToAdd = _data["amountToAdd"] !== undefined ? _data["amountToAdd"] : <any>null;
        }
    }

    static fromJS(data: any): DwollaMasterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DwollaMasterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["available"] = this.available !== undefined ? this.available : <any>null;
        data["pending"] = this.pending !== undefined ? this.pending : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["isSandbox"] = this.isSandbox !== undefined ? this.isSandbox : <any>null;
        data["minimalAmount"] = this.minimalAmount !== undefined ? this.minimalAmount : <any>null;
        data["amountToAdd"] = this.amountToAdd !== undefined ? this.amountToAdd : <any>null;
        return data;
    }
}

export interface IDwollaMasterInfo {
    available: number;
    pending: number;
    total: number;
    isSandbox: boolean;
    minimalAmount: number;
    amountToAdd: number;
}

export class DwollaTransferInfo implements IDwollaTransferInfo {
    created: Date;
    status: string | null;
    amount: number;
    source: string | null;
    destination: string | null;
    address1: string | null;
    [immerable] = true;

    constructor(data?: IDwollaTransferInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.source = _data["source"] !== undefined ? _data["source"] : <any>null;
            this.destination = _data["destination"] !== undefined ? _data["destination"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
        }
    }

    static fromJS(data: any): DwollaTransferInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DwollaTransferInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["source"] = this.source !== undefined ? this.source : <any>null;
        data["destination"] = this.destination !== undefined ? this.destination : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        return data;
    }
}

export interface IDwollaTransferInfo {
    created: Date;
    status: string | null;
    amount: number;
    source: string | null;
    destination: string | null;
    address1: string | null;
}

export class SimulationResponse implements ISimulationResponse {
    total: number;
    [immerable] = true;

    constructor(data?: ISimulationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): SimulationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total !== undefined ? this.total : <any>null;
        return data;
    }
}

export interface ISimulationResponse {
    total: number;
}

export class StripeAccountInfo implements IStripeAccountInfo {
    chargesEnabled: boolean;
    detailsSubmitted: boolean;
    [immerable] = true;

    constructor(data?: IStripeAccountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargesEnabled = _data["chargesEnabled"] !== undefined ? _data["chargesEnabled"] : <any>null;
            this.detailsSubmitted = _data["detailsSubmitted"] !== undefined ? _data["detailsSubmitted"] : <any>null;
        }
    }

    static fromJS(data: any): StripeAccountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StripeAccountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargesEnabled"] = this.chargesEnabled !== undefined ? this.chargesEnabled : <any>null;
        data["detailsSubmitted"] = this.detailsSubmitted !== undefined ? this.detailsSubmitted : <any>null;
        return data;
    }
}

export interface IStripeAccountInfo {
    chargesEnabled: boolean;
    detailsSubmitted: boolean;
}

export class UpdateUserPayload implements IUpdateUserPayload {
    title: string | null;
    firstName: string | null;
    lastName: string | null;
    phone: string | null;
    workPhone: string | null;
    address: ModifyAddressPayload | null;
    receiveEmail: boolean;
    receiveText: boolean;
    [immerable] = true;

    constructor(data?: IUpdateUserPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new ModifyAddressPayload(data.address) : <ModifyAddressPayload>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : <any>null;
            this.address = _data["address"] ? ModifyAddressPayload.fromJS(_data["address"]) : <any>null;
            this.receiveEmail = _data["receiveEmail"] !== undefined ? _data["receiveEmail"] : <any>null;
            this.receiveText = _data["receiveText"] !== undefined ? _data["receiveText"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateUserPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["receiveEmail"] = this.receiveEmail !== undefined ? this.receiveEmail : <any>null;
        data["receiveText"] = this.receiveText !== undefined ? this.receiveText : <any>null;
        return data;
    }
}

export interface IUpdateUserPayload {
    title: string | null;
    firstName: string | null;
    lastName: string | null;
    phone: string | null;
    workPhone: string | null;
    address: IModifyAddressPayload | null;
    receiveEmail: boolean;
    receiveText: boolean;
}

export class NotificationStatus implements INotificationStatus {
    userId: string;
    entityId: string;
    entityType: NotificationStatusEntityType;
    enabled: boolean;
    [immerable] = true;

    constructor(data?: INotificationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : <any>null;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : <any>null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : <any>null;
        }
    }

    static fromJS(data: any): NotificationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["entityId"] = this.entityId !== undefined ? this.entityId : <any>null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : <any>null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        return data;
    }
}

export interface INotificationStatus {
    userId: string;
    entityId: string;
    entityType: NotificationStatusEntityType;
    enabled: boolean;
}

export enum NotificationStatusEntityType {
    Unknown = 0,
    Issue = 1,
}

export class InviteUserResult implements IInviteUserResult {
    user: User | null;
    status: InviteUserStatus;
    [immerable] = true;

    constructor(data?: IInviteUserResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): InviteUserResult {
        data = typeof data === 'object' ? data : {};
        let result = new InviteUserResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IInviteUserResult {
    user: IUser | null;
    status: InviteUserStatus;
}

export enum InviteUserStatus {
    Success = 0,
    DuplicateEmail = 1,
}

export class InviteUserPayload implements IInviteUserPayload {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    phone: string | null;
    managementCompanyId: string;
    capabilityType: CapabilityType;
    [immerable] = true;

    constructor(data?: IInviteUserPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            this.capabilityType = _data["capabilityType"] !== undefined ? _data["capabilityType"] : <any>null;
        }
    }

    static fromJS(data: any): InviteUserPayload {
        data = typeof data === 'object' ? data : {};
        let result = new InviteUserPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        data["capabilityType"] = this.capabilityType !== undefined ? this.capabilityType : <any>null;
        return data;
    }
}

export interface IInviteUserPayload {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    phone: string | null;
    managementCompanyId: string;
    capabilityType: CapabilityType;
}

export class RemoveCapabilityPayload implements IRemoveCapabilityPayload {
    userId: string;
    capabilityType: CapabilityType;
    managementCompanyId: string;
    [immerable] = true;

    constructor(data?: IRemoveCapabilityPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.capabilityType = _data["capabilityType"] !== undefined ? _data["capabilityType"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveCapabilityPayload {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveCapabilityPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["capabilityType"] = this.capabilityType !== undefined ? this.capabilityType : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        return data;
    }
}

export interface IRemoveCapabilityPayload {
    userId: string;
    capabilityType: CapabilityType;
    managementCompanyId: string;
}

export class ResendUserInvitationPayload implements IResendUserInvitationPayload {
    userId: string;
    managementCompanyId: string;
    capabilityType: CapabilityType;
    [immerable] = true;

    constructor(data?: IResendUserInvitationPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            this.capabilityType = _data["capabilityType"] !== undefined ? _data["capabilityType"] : <any>null;
        }
    }

    static fromJS(data: any): ResendUserInvitationPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ResendUserInvitationPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        data["capabilityType"] = this.capabilityType !== undefined ? this.capabilityType : <any>null;
        return data;
    }
}

export interface IResendUserInvitationPayload {
    userId: string;
    managementCompanyId: string;
    capabilityType: CapabilityType;
}

export class DetailedAccountInfo implements IDetailedAccountInfo {
    companies: AccountInfoCompany[] | null;
    vendor: Vendor | null;
    [immerable] = true;

    constructor(data?: IDetailedAccountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.companies) {
                this.companies = [];
                for (let i = 0; i < data.companies.length; i++) {
                    let item = data.companies[i];
                    this.companies[i] = item && !(<any>item).toJSON ? new AccountInfoCompany(item) : <AccountInfoCompany>item;
                }
            }
            this.vendor = data.vendor && !(<any>data.vendor).toJSON ? new Vendor(data.vendor) : <Vendor>this.vendor;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(AccountInfoCompany.fromJS(item));
            }
            else {
                this.companies = <any>null;
            }
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>null;
        }
    }

    static fromJS(data: any): DetailedAccountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DetailedAccountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>null;
        return data;
    }
}

export interface IDetailedAccountInfo {
    companies: IAccountInfoCompany[] | null;
    vendor: IVendor | null;
}

export class AccountInfoCompany implements IAccountInfoCompany {
    capabilities: CapabilityType[] | null;
    managementCompany: ManagementCompany | null;
    properties: Property[] | null;
    [immerable] = true;

    constructor(data?: IAccountInfoCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.managementCompany = data.managementCompany && !(<any>data.managementCompany).toJSON ? new ManagementCompany(data.managementCompany) : <ManagementCompany>this.managementCompany;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(item);
            }
            else {
                this.capabilities = <any>null;
            }
            this.managementCompany = _data["managementCompany"] ? ManagementCompany.fromJS(_data["managementCompany"]) : <any>null;
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(Property.fromJS(item));
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): AccountInfoCompany {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfoCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item);
        }
        data["managementCompany"] = this.managementCompany ? this.managementCompany.toJSON() : <any>null;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountInfoCompany {
    capabilities: CapabilityType[] | null;
    managementCompany: IManagementCompany | null;
    properties: Property[] | null;
}

export class SetUserPermissionsPayload implements ISetUserPermissionsPayload {
    managementCompanyId: string;
    userId: string;
    permissions: RooPermission[] | null;
    [immerable] = true;

    constructor(data?: ISetUserPermissionsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            else {
                this.permissions = <any>null;
            }
        }
    }

    static fromJS(data: any): SetUserPermissionsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserPermissionsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface ISetUserPermissionsPayload {
    managementCompanyId: string;
    userId: string;
    permissions: RooPermission[] | null;
}

export class CompanyUserAccount implements ICompanyUserAccount {
    userId: string;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    createdDate: Date;
    lastLogin: Date | null;
    companies: string[] | null;
    capabilities: Capability[] | null;
    role: UserRole;
    [immerable] = true;

    constructor(data?: ICompanyUserAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.capabilities) {
                this.capabilities = [];
                for (let i = 0; i < data.capabilities.length; i++) {
                    let item = data.capabilities[i];
                    this.capabilities[i] = item && !(<any>item).toJSON ? new Capability(item) : <Capability>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : <any>null;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
            else {
                this.companies = <any>null;
            }
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(Capability.fromJS(item));
            }
            else {
                this.capabilities = <any>null;
            }
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
        }
    }

    static fromJS(data: any): CompanyUserAccount {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyUserAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>null;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item.toJSON());
        }
        data["role"] = this.role !== undefined ? this.role : <any>null;
        return data;
    }
}

export interface ICompanyUserAccount {
    userId: string;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    createdDate: Date;
    lastLogin: Date | null;
    companies: string[] | null;
    capabilities: ICapability[] | null;
    role: UserRole;
}

export class CreateVendorPayload implements ICreateVendorPayload {
    companyName: string | null;
    contactFirstName: string | null;
    contactLastName: string | null;
    address: ModifyAddressPayload | null;
    email: string | null;
    cellPhone: string | null;
    workPhone: string | null;
    focusIds: number[] | null;
    managementCompanyId: string | null;
    managingVendorId: string | null;
    [immerable] = true;

    constructor(data?: ICreateVendorPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new ModifyAddressPayload(data.address) : <ModifyAddressPayload>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.contactFirstName = _data["contactFirstName"] !== undefined ? _data["contactFirstName"] : <any>null;
            this.contactLastName = _data["contactLastName"] !== undefined ? _data["contactLastName"] : <any>null;
            this.address = _data["address"] ? ModifyAddressPayload.fromJS(_data["address"]) : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.cellPhone = _data["cellPhone"] !== undefined ? _data["cellPhone"] : <any>null;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : <any>null;
            if (Array.isArray(_data["focusIds"])) {
                this.focusIds = [] as any;
                for (let item of _data["focusIds"])
                    this.focusIds!.push(item);
            }
            else {
                this.focusIds = <any>null;
            }
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            this.managingVendorId = _data["managingVendorId"] !== undefined ? _data["managingVendorId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateVendorPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVendorPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["contactFirstName"] = this.contactFirstName !== undefined ? this.contactFirstName : <any>null;
        data["contactLastName"] = this.contactLastName !== undefined ? this.contactLastName : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["cellPhone"] = this.cellPhone !== undefined ? this.cellPhone : <any>null;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : <any>null;
        if (Array.isArray(this.focusIds)) {
            data["focusIds"] = [];
            for (let item of this.focusIds)
                data["focusIds"].push(item);
        }
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        data["managingVendorId"] = this.managingVendorId !== undefined ? this.managingVendorId : <any>null;
        return data;
    }
}

export interface ICreateVendorPayload {
    companyName: string | null;
    contactFirstName: string | null;
    contactLastName: string | null;
    address: IModifyAddressPayload | null;
    email: string | null;
    cellPhone: string | null;
    workPhone: string | null;
    focusIds: number[] | null;
    managementCompanyId: string | null;
    managingVendorId: string | null;
}

export class BulkCreateVendorResult implements IBulkCreateVendorResult {
    form: BulkCreateVendorForm | null;
    status: BulkCreateVendorStatus;
    [immerable] = true;

    constructor(data?: IBulkCreateVendorResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.form = data.form && !(<any>data.form).toJSON ? new BulkCreateVendorForm(data.form) : <BulkCreateVendorForm>this.form;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.form = _data["form"] ? BulkCreateVendorForm.fromJS(_data["form"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): BulkCreateVendorResult {
        data = typeof data === 'object' ? data : {};
        let result = new BulkCreateVendorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["form"] = this.form ? this.form.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IBulkCreateVendorResult {
    form: IBulkCreateVendorForm | null;
    status: BulkCreateVendorStatus;
}

export class BulkCreateVendorForm implements IBulkCreateVendorForm {
    index: number;
    firstName: string | null;
    lastName: string | null;
    phoneNumber: string | null;
    email: string | null;
    companyName: string | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    [immerable] = true;

    constructor(data?: IBulkCreateVendorForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
        }
    }

    static fromJS(data: any): BulkCreateVendorForm {
        data = typeof data === 'object' ? data : {};
        let result = new BulkCreateVendorForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        return data;
    }
}

export interface IBulkCreateVendorForm {
    index: number;
    firstName: string | null;
    lastName: string | null;
    phoneNumber: string | null;
    email: string | null;
    companyName: string | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
}

export enum BulkCreateVendorStatus {
    Skipped = 0,
    Error = 1,
    Success = 2,
}

export class BulkCreateVendorsPayload implements IBulkCreateVendorsPayload {
    candidates: BulkCreateVendorForm[] | null;
    managementCompanyId: string;
    [immerable] = true;

    constructor(data?: IBulkCreateVendorsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.candidates) {
                this.candidates = [];
                for (let i = 0; i < data.candidates.length; i++) {
                    let item = data.candidates[i];
                    this.candidates[i] = item && !(<any>item).toJSON ? new BulkCreateVendorForm(item) : <BulkCreateVendorForm>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["candidates"])) {
                this.candidates = [] as any;
                for (let item of _data["candidates"])
                    this.candidates!.push(BulkCreateVendorForm.fromJS(item));
            }
            else {
                this.candidates = <any>null;
            }
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
        }
    }

    static fromJS(data: any): BulkCreateVendorsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new BulkCreateVendorsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.candidates)) {
            data["candidates"] = [];
            for (let item of this.candidates)
                data["candidates"].push(item.toJSON());
        }
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        return data;
    }
}

export interface IBulkCreateVendorsPayload {
    candidates: IBulkCreateVendorForm[] | null;
    managementCompanyId: string;
}

export class AddVendorMemberPayload implements IAddVendorMemberPayload {
    contactFirstName: string | null;
    contactLastName: string | null;
    vendorId: string;
    address: ModifyAddressPayload | null;
    email: string | null;
    cellPhone: string | null;
    workPhone: string | null;
    [immerable] = true;

    constructor(data?: IAddVendorMemberPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new ModifyAddressPayload(data.address) : <ModifyAddressPayload>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactFirstName = _data["contactFirstName"] !== undefined ? _data["contactFirstName"] : <any>null;
            this.contactLastName = _data["contactLastName"] !== undefined ? _data["contactLastName"] : <any>null;
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.address = _data["address"] ? ModifyAddressPayload.fromJS(_data["address"]) : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.cellPhone = _data["cellPhone"] !== undefined ? _data["cellPhone"] : <any>null;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : <any>null;
        }
    }

    static fromJS(data: any): AddVendorMemberPayload {
        data = typeof data === 'object' ? data : {};
        let result = new AddVendorMemberPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactFirstName"] = this.contactFirstName !== undefined ? this.contactFirstName : <any>null;
        data["contactLastName"] = this.contactLastName !== undefined ? this.contactLastName : <any>null;
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["cellPhone"] = this.cellPhone !== undefined ? this.cellPhone : <any>null;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : <any>null;
        return data;
    }
}

export interface IAddVendorMemberPayload {
    contactFirstName: string | null;
    contactLastName: string | null;
    vendorId: string;
    address: IModifyAddressPayload | null;
    email: string | null;
    cellPhone: string | null;
    workPhone: string | null;
}

export class RemoveVendorMemberPayload implements IRemoveVendorMemberPayload {
    userId: string;
    vendorId: string;
    [immerable] = true;

    constructor(data?: IRemoveVendorMemberPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveVendorMemberPayload {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveVendorMemberPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        return data;
    }
}

export interface IRemoveVendorMemberPayload {
    userId: string;
    vendorId: string;
}

export class UpdateVendorMemberSettingsPayload implements IUpdateVendorMemberSettingsPayload {
    vendorId: string;
    userId: string;
    isBackoffice: boolean;
    [immerable] = true;

    constructor(data?: IUpdateVendorMemberSettingsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.isBackoffice = _data["isBackoffice"] !== undefined ? _data["isBackoffice"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateVendorMemberSettingsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVendorMemberSettingsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["isBackoffice"] = this.isBackoffice !== undefined ? this.isBackoffice : <any>null;
        return data;
    }
}

export interface IUpdateVendorMemberSettingsPayload {
    vendorId: string;
    userId: string;
    isBackoffice: boolean;
}

export class VendorMember implements IVendorMember {
    vendorId: string;
    user: UserSummary | null;
    isBackoffice: boolean;
    isOwner: boolean;
    hideReports: boolean;
    hideClients: boolean;
    showCommissions: boolean;
    [immerable] = true;

    constructor(data?: IVendorMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new UserSummary(data.user) : <UserSummary>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.user = _data["user"] ? UserSummary.fromJS(_data["user"]) : <any>null;
            this.isBackoffice = _data["isBackoffice"] !== undefined ? _data["isBackoffice"] : <any>null;
            this.isOwner = _data["isOwner"] !== undefined ? _data["isOwner"] : <any>null;
            this.hideReports = _data["hideReports"] !== undefined ? _data["hideReports"] : <any>null;
            this.hideClients = _data["hideClients"] !== undefined ? _data["hideClients"] : <any>null;
            this.showCommissions = _data["showCommissions"] !== undefined ? _data["showCommissions"] : <any>null;
        }
    }

    static fromJS(data: any): VendorMember {
        data = typeof data === 'object' ? data : {};
        let result = new VendorMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["isBackoffice"] = this.isBackoffice !== undefined ? this.isBackoffice : <any>null;
        data["isOwner"] = this.isOwner !== undefined ? this.isOwner : <any>null;
        data["hideReports"] = this.hideReports !== undefined ? this.hideReports : <any>null;
        data["hideClients"] = this.hideClients !== undefined ? this.hideClients : <any>null;
        data["showCommissions"] = this.showCommissions !== undefined ? this.showCommissions : <any>null;
        return data;
    }
}

export interface IVendorMember {
    vendorId: string;
    user: IUserSummary | null;
    isBackoffice: boolean;
    isOwner: boolean;
    hideReports: boolean;
    hideClients: boolean;
    showCommissions: boolean;
}

export class PriceGuideEntry implements IPriceGuideEntry {
    id: string;
    description: string | null;
    price: number;
    [immerable] = true;

    constructor(data?: IPriceGuideEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
        }
    }

    static fromJS(data: any): PriceGuideEntry {
        data = typeof data === 'object' ? data : {};
        let result = new PriceGuideEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        return data;
    }
}

export interface IPriceGuideEntry {
    id: string;
    description: string | null;
    price: number;
}

export class UpdateVendorContactInfoPayload implements IUpdateVendorContactInfoPayload {
    vendorId: string;
    email: string | null;
    phone: string | null;
    name: string | null;
    [immerable] = true;

    constructor(data?: IUpdateVendorContactInfoPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateVendorContactInfoPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVendorContactInfoPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IUpdateVendorContactInfoPayload {
    vendorId: string;
    email: string | null;
    phone: string | null;
    name: string | null;
}

export class UpdateVendorAddressPayload implements IUpdateVendorAddressPayload {
    vendorId: string;
    addressPayload: ModifyAddressPayload | null;
    [immerable] = true;

    constructor(data?: IUpdateVendorAddressPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.addressPayload = data.addressPayload && !(<any>data.addressPayload).toJSON ? new ModifyAddressPayload(data.addressPayload) : <ModifyAddressPayload>this.addressPayload;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.addressPayload = _data["addressPayload"] ? ModifyAddressPayload.fromJS(_data["addressPayload"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateVendorAddressPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVendorAddressPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["addressPayload"] = this.addressPayload ? this.addressPayload.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateVendorAddressPayload {
    vendorId: string;
    addressPayload: IModifyAddressPayload | null;
}

export class UpdateVendorServicesPayload implements IUpdateVendorServicesPayload {
    vendorId: string;
    focusIds: number[] | null;
    [immerable] = true;

    constructor(data?: IUpdateVendorServicesPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            if (Array.isArray(_data["focusIds"])) {
                this.focusIds = [] as any;
                for (let item of _data["focusIds"])
                    this.focusIds!.push(item);
            }
            else {
                this.focusIds = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateVendorServicesPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVendorServicesPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        if (Array.isArray(this.focusIds)) {
            data["focusIds"] = [];
            for (let item of this.focusIds)
                data["focusIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateVendorServicesPayload {
    vendorId: string;
    focusIds: number[] | null;
}

export class UpdateVendorPreferencesPayload implements IUpdateVendorPreferencesPayload {
    vendorId: string;
    showInPool: boolean;
    [immerable] = true;

    constructor(data?: IUpdateVendorPreferencesPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.showInPool = _data["showInPool"] !== undefined ? _data["showInPool"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateVendorPreferencesPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVendorPreferencesPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["showInPool"] = this.showInPool !== undefined ? this.showInPool : <any>null;
        return data;
    }
}

export interface IUpdateVendorPreferencesPayload {
    vendorId: string;
    showInPool: boolean;
}

export class WorkordersForUserResult implements IWorkordersForUserResult {
    workorders: WorkorderWithIssues[] | null;
    totalItems: number;
    [immerable] = true;

    constructor(data?: IWorkordersForUserResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workorders"])) {
                this.workorders = [] as any;
                for (let item of _data["workorders"])
                    this.workorders!.push(WorkorderWithIssues.fromJS(item));
            }
            else {
                this.workorders = <any>null;
            }
            this.totalItems = _data["totalItems"] !== undefined ? _data["totalItems"] : <any>null;
        }
    }

    static fromJS(data: any): WorkordersForUserResult {
        data = typeof data === 'object' ? data : {};
        let result = new WorkordersForUserResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workorders)) {
            data["workorders"] = [];
            for (let item of this.workorders)
                data["workorders"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems !== undefined ? this.totalItems : <any>null;
        return data;
    }
}

export interface IWorkordersForUserResult {
    workorders: WorkorderWithIssues[] | null;
    totalItems: number;
}

export class WorkordersForUserPayload implements IWorkordersForUserPayload {
    sortDirection: SortDirection;
    sortField: WorkorderSortField;
    skip: number;
    take: number | null;
    filters: TasksForUsersFilter | null;
    category: DashboardStatCategory | null;
    [immerable] = true;

    constructor(data?: IWorkordersForUserPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.filters = data.filters && !(<any>data.filters).toJSON ? new TasksForUsersFilter(data.filters) : <TasksForUsersFilter>this.filters;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortDirection = _data["sortDirection"] !== undefined ? _data["sortDirection"] : <any>null;
            this.sortField = _data["sortField"] !== undefined ? _data["sortField"] : <any>null;
            this.skip = _data["skip"] !== undefined ? _data["skip"] : <any>null;
            this.take = _data["take"] !== undefined ? _data["take"] : <any>null;
            this.filters = _data["filters"] ? TasksForUsersFilter.fromJS(_data["filters"]) : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
        }
    }

    static fromJS(data: any): WorkordersForUserPayload {
        data = typeof data === 'object' ? data : {};
        let result = new WorkordersForUserPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortDirection"] = this.sortDirection !== undefined ? this.sortDirection : <any>null;
        data["sortField"] = this.sortField !== undefined ? this.sortField : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        data["take"] = this.take !== undefined ? this.take : <any>null;
        data["filters"] = this.filters ? this.filters.toJSON() : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        return data;
    }
}

export interface IWorkordersForUserPayload {
    sortDirection: SortDirection;
    sortField: WorkorderSortField;
    skip: number;
    take: number | null;
    filters: ITasksForUsersFilter | null;
    category: DashboardStatCategory | null;
}

export enum SortDirection {
    Default = 0,
    Ascending = 1,
    Descending = 2,
}

export enum WorkorderSortField {
    Default = 0,
    WorkorderId = 1,
    Address1 = 2,
    Address2 = 3,
    PrimaryPm = 4,
    Status = 5,
    CreatedAt = 6,
    ModifiedAt = 7,
    IsOccupied = 8,
    CompanyName = 9,
}

export class TasksForUsersFilter implements ITasksForUsersFilter {
    propertyId: string | null;
    isActive: boolean | null;
    friendlyId: string | null;
    address1: string | null;
    address2: string | null;
    primaryPm: string | null;
    workorderStatus: WorkorderStatus | null;
    issueStatus: IssueStatus | null;
    isOccupied: boolean | null;
    createdAt: Instant | null;
    modifiedAt: Instant | null;
    quickSearchQuery: string | null;
    companyIds: string[] | null;
    workorderId: string | null;
    issueTitle: string | null;
    vendorIds: string[] | null;
    subVendorIds: string[] | null;
    accountManagerId: string | null;
    stateCodes: string[] | null;
    city: string | null;
    startDate: Instant | null;
    endDate: Instant | null;
    onlyTopLevelIssues: boolean | null;
    [immerable] = true;

    constructor(data?: ITasksForUsersFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.createdAt = data.createdAt && !(<any>data.createdAt).toJSON ? new Instant(data.createdAt) : <Instant>this.createdAt;
            this.modifiedAt = data.modifiedAt && !(<any>data.modifiedAt).toJSON ? new Instant(data.modifiedAt) : <Instant>this.modifiedAt;
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"] !== undefined ? _data["propertyId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.primaryPm = _data["primaryPm"] !== undefined ? _data["primaryPm"] : <any>null;
            this.workorderStatus = _data["workorderStatus"] !== undefined ? _data["workorderStatus"] : <any>null;
            this.issueStatus = _data["issueStatus"] !== undefined ? _data["issueStatus"] : <any>null;
            this.isOccupied = _data["isOccupied"] !== undefined ? _data["isOccupied"] : <any>null;
            this.createdAt = _data["createdAt"] ? Instant.fromJS(_data["createdAt"]) : <any>null;
            this.modifiedAt = _data["modifiedAt"] ? Instant.fromJS(_data["modifiedAt"]) : <any>null;
            this.quickSearchQuery = _data["quickSearchQuery"] !== undefined ? _data["quickSearchQuery"] : <any>null;
            if (Array.isArray(_data["companyIds"])) {
                this.companyIds = [] as any;
                for (let item of _data["companyIds"])
                    this.companyIds!.push(item);
            }
            else {
                this.companyIds = <any>null;
            }
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
            this.issueTitle = _data["issueTitle"] !== undefined ? _data["issueTitle"] : <any>null;
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            else {
                this.vendorIds = <any>null;
            }
            if (Array.isArray(_data["subVendorIds"])) {
                this.subVendorIds = [] as any;
                for (let item of _data["subVendorIds"])
                    this.subVendorIds!.push(item);
            }
            else {
                this.subVendorIds = <any>null;
            }
            this.accountManagerId = _data["accountManagerId"] !== undefined ? _data["accountManagerId"] : <any>null;
            if (Array.isArray(_data["stateCodes"])) {
                this.stateCodes = [] as any;
                for (let item of _data["stateCodes"])
                    this.stateCodes!.push(item);
            }
            else {
                this.stateCodes = <any>null;
            }
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
            this.onlyTopLevelIssues = _data["onlyTopLevelIssues"] !== undefined ? _data["onlyTopLevelIssues"] : <any>null;
        }
    }

    static fromJS(data: any): TasksForUsersFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TasksForUsersFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId !== undefined ? this.propertyId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["primaryPm"] = this.primaryPm !== undefined ? this.primaryPm : <any>null;
        data["workorderStatus"] = this.workorderStatus !== undefined ? this.workorderStatus : <any>null;
        data["issueStatus"] = this.issueStatus !== undefined ? this.issueStatus : <any>null;
        data["isOccupied"] = this.isOccupied !== undefined ? this.isOccupied : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toJSON() : <any>null;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toJSON() : <any>null;
        data["quickSearchQuery"] = this.quickSearchQuery !== undefined ? this.quickSearchQuery : <any>null;
        if (Array.isArray(this.companyIds)) {
            data["companyIds"] = [];
            for (let item of this.companyIds)
                data["companyIds"].push(item);
        }
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        data["issueTitle"] = this.issueTitle !== undefined ? this.issueTitle : <any>null;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (Array.isArray(this.subVendorIds)) {
            data["subVendorIds"] = [];
            for (let item of this.subVendorIds)
                data["subVendorIds"].push(item);
        }
        data["accountManagerId"] = this.accountManagerId !== undefined ? this.accountManagerId : <any>null;
        if (Array.isArray(this.stateCodes)) {
            data["stateCodes"] = [];
            for (let item of this.stateCodes)
                data["stateCodes"].push(item);
        }
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        data["onlyTopLevelIssues"] = this.onlyTopLevelIssues !== undefined ? this.onlyTopLevelIssues : <any>null;
        return data;
    }
}

export interface ITasksForUsersFilter {
    propertyId: string | null;
    isActive: boolean | null;
    friendlyId: string | null;
    address1: string | null;
    address2: string | null;
    primaryPm: string | null;
    workorderStatus: WorkorderStatus | null;
    issueStatus: IssueStatus | null;
    isOccupied: boolean | null;
    createdAt: IInstant | null;
    modifiedAt: IInstant | null;
    quickSearchQuery: string | null;
    companyIds: string[] | null;
    workorderId: string | null;
    issueTitle: string | null;
    vendorIds: string[] | null;
    subVendorIds: string[] | null;
    accountManagerId: string | null;
    stateCodes: string[] | null;
    city: string | null;
    startDate: IInstant | null;
    endDate: IInstant | null;
    onlyTopLevelIssues: boolean | null;
}

export enum DashboardStatCategory {
    WkoGlobalNew = 0,
    WkoGlobalInProgress = 1,
    IssGlobalTotalOpen = 2,
    IssGlobalTotalClosed = 3,
    WkoGlobalAvgDaysOpen = 4,
    IssGlobalAvgDaysOpen = 5,
    WkoGlobalHighPriority = 6,
    WkoGlobalOver30 = 7,
    IssGlobalTimeToBidAll = 8,
    IssGlobalTimeToBidThisMonth = 9,
    IssManagerNeedsAttention = 10,
    IssManagerDraft = 11,
    IssManagerWaitingBidSubmission = 12,
    IssManagerWaitingBidReview = 13,
    IssManagerWaitingAssignmentReview = 14,
    IssManagerWaitingEstimateSubmission = 15,
    IssManagerWaitingEstimateReview = 16,
    IssManagerVendorsDeclined = 17,
    IssManagerVendorsUnresponsive = 18,
    IssManagerTenantCanceled = 19,
    IssManagerChangeReqReviewManager = 20,
    IssManagerChangeReqReviewOwner = 21,
    IssManagerSchedulingVendor = 22,
    IssManagerSchedulingTenant = 23,
    IssManagerScheduled = 24,
    IssManagerWorkInProgress = 25,
    IssManagerNeedsInvoice = 26,
    IssManagerInvoiceReview = 27,
    IssManagerWaitingInvoicesPayment = 28,
    IssVendorWaitingAssignmentReview = 29,
    IssVendorWaitingBidSubmission = 30,
    IssVendorWaitingBidReview = 31,
    IssVendorWaitingBidRevisionReview = 32,
    IssVendorWaitingEstimateSubmission = 33,
    IssVendorWaitingEstimateReview = 34,
    IssVendorEstimateRejected = 35,
    IssVendorChangeReqReview = 36,
    IssVendorSchedulingVendor = 37,
    IssVendorSchedulingTenant = 38,
    IssVendorScheduled = 39,
    IssVendorWorkInProgress = 40,
    IssVendorNeedsInvoice = 41,
    IssVendorInvoiceReview = 42,
    IssVendorInvoicePaymentPending = 43,
    IssContractorManagerNeedsAttention = 44,
    IssContractorManagerDraft = 45,
    IssContractorManagerWaitingBidSubmission = 46,
    IssContractorManagerWaitingBidReview = 47,
    IssContractorManagerWaitingAssignmentReview = 48,
    IssContractorManagerVendorsDeclined = 49,
    IssContractorManagerVendorsUnresponsive = 50,
    IssContractorManagerTenantCanceled = 51,
    IssContractorManagerChangeReqReview = 52,
    IssContractorManagerSchedulingVendor = 53,
    IssContractorManagerSchedulingTenant = 54,
    IssContractorManagerScheduled = 55,
    IssContractorManagerWorkInProgress = 56,
    IssContractorManagerNeedsInvoice = 57,
    IssContractorManagerInvoiceReview = 58,
    IssContractorManagerInvoicePaymentPending = 59,
    IssContractorVendorNeedsAttention = 60,
    IssContractorVendorWaitingAssignmentReview = 61,
    IssContractorVendorWaitingBidReview = 62,
    IssContractorVendorWaitingBidSubmission = 63,
    IssContractorVendorWaitingEstimateSubmission = 64,
    IssContractorVendorWaitingEstimateReview = 65,
    IssContractorVendorNeedsSend = 66,
    IssContractorVendorEstimateRejected = 67,
    IssContractorVendorChangeReqReview = 68,
    IssContractorVendorWorkInProgress = 69,
    IssContractorVendorNeedsInvoice = 70,
    IssContractorVendorInvoiceReview = 71,
    IssContractorVendorInvoicePaymentPending = 72,
    IssueSchedulingTenant = 73,
    IssueOwnerWaitingChangeReq = 74,
    IssueOwnerWaitingBidReview = 75,
    IssProfitLossIncome = 76,
    IssProfitLossCost = 77,
    IssProfitLossPendingIncome = 78,
    IssProfitLossPendingCost = 79,
    IssContractorManagerPartialInvoiceReview = 80,
}

export class DescribedDashboardStat implements IDescribedDashboardStat {
    category: DashboardStatCategory;
    value: number;
    delayedCount: number | null;
    entityType: DashboardStatEntity;
    displayName: string | null;
    displayDecimals: number;
    section: DashboardSection;
    order: number;
    hasDetails: boolean;
    issueType: StatIssueType;
    assigneeBadge: StatBadge | null;
    emphasized: boolean;
    [immerable] = true;

    constructor(data?: IDescribedDashboardStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.assigneeBadge = data.assigneeBadge && !(<any>data.assigneeBadge).toJSON ? new StatBadge(data.assigneeBadge) : <StatBadge>this.assigneeBadge;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.delayedCount = _data["delayedCount"] !== undefined ? _data["delayedCount"] : <any>null;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.displayDecimals = _data["displayDecimals"] !== undefined ? _data["displayDecimals"] : <any>null;
            this.section = _data["section"] !== undefined ? _data["section"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.hasDetails = _data["hasDetails"] !== undefined ? _data["hasDetails"] : <any>null;
            this.issueType = _data["issueType"] !== undefined ? _data["issueType"] : <any>null;
            this.assigneeBadge = _data["assigneeBadge"] ? StatBadge.fromJS(_data["assigneeBadge"]) : <any>null;
            this.emphasized = _data["emphasized"] !== undefined ? _data["emphasized"] : <any>null;
        }
    }

    static fromJS(data: any): DescribedDashboardStat {
        data = typeof data === 'object' ? data : {};
        let result = new DescribedDashboardStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["delayedCount"] = this.delayedCount !== undefined ? this.delayedCount : <any>null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["displayDecimals"] = this.displayDecimals !== undefined ? this.displayDecimals : <any>null;
        data["section"] = this.section !== undefined ? this.section : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["hasDetails"] = this.hasDetails !== undefined ? this.hasDetails : <any>null;
        data["issueType"] = this.issueType !== undefined ? this.issueType : <any>null;
        data["assigneeBadge"] = this.assigneeBadge ? this.assigneeBadge.toJSON() : <any>null;
        data["emphasized"] = this.emphasized !== undefined ? this.emphasized : <any>null;
        return data;
    }
}

export interface IDescribedDashboardStat {
    category: DashboardStatCategory;
    value: number;
    delayedCount: number | null;
    entityType: DashboardStatEntity;
    displayName: string | null;
    displayDecimals: number;
    section: DashboardSection;
    order: number;
    hasDetails: boolean;
    issueType: StatIssueType;
    assigneeBadge: IStatBadge | null;
    emphasized: boolean;
}

export enum DashboardStatEntity {
    Workorder = 0,
    Issue = 1,
}

export enum DashboardSection {
    Global = 0,
    Manager = 1,
    Vendor = 2,
    Owner = 3,
    Tenant = 4,
    ContractorManager = 5,
    ContractorVendor = 6,
    ProfitLoss = 7,
}

export enum StatIssueType {
    None = 0,
    Issue = 1,
    Subissue = 2,
    Either = 3,
    MostSpecific = 4,
}

export class StatBadge implements IStatBadge {
    text: string | null;
    color: UiColor;
    [immerable] = true;

    constructor(data?: IStatBadge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
        }
    }

    static fromJS(data: any): StatBadge {
        data = typeof data === 'object' ? data : {};
        let result = new StatBadge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        return data;
    }
}

export interface IStatBadge {
    text: string | null;
    color: UiColor;
}

export enum UiColor {
    Default = 0,
    Success = 1,
    Error = 2,
    Warning = 3,
    Primary = 4,
    Secondary = 5,
}

export class CreateWorkorderPayload implements ICreateWorkorderPayload {
    priority: Priority;
    propertyId: string;
    managementCompanyId: string;
    notes: string | null;
    gateCode: string | null;
    lockBox: string | null;
    externalReference: string | null;
    inspectionId: string | null;
    [immerable] = true;

    constructor(data?: ICreateWorkorderPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.propertyId = _data["propertyId"] !== undefined ? _data["propertyId"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.gateCode = _data["gateCode"] !== undefined ? _data["gateCode"] : <any>null;
            this.lockBox = _data["lockBox"] !== undefined ? _data["lockBox"] : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateWorkorderPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkorderPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["propertyId"] = this.propertyId !== undefined ? this.propertyId : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["gateCode"] = this.gateCode !== undefined ? this.gateCode : <any>null;
        data["lockBox"] = this.lockBox !== undefined ? this.lockBox : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        return data;
    }
}

export interface ICreateWorkorderPayload {
    priority: Priority;
    propertyId: string;
    managementCompanyId: string;
    notes: string | null;
    gateCode: string | null;
    lockBox: string | null;
    externalReference: string | null;
    inspectionId: string | null;
}

export class UpdateWorkorderPayload implements IUpdateWorkorderPayload {
    id: string;
    priority: Priority;
    notes: string | null;
    gateCode: string | null;
    lockBox: string | null;
    externalReference: string | null;
    [immerable] = true;

    constructor(data?: IUpdateWorkorderPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.gateCode = _data["gateCode"] !== undefined ? _data["gateCode"] : <any>null;
            this.lockBox = _data["lockBox"] !== undefined ? _data["lockBox"] : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateWorkorderPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkorderPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["gateCode"] = this.gateCode !== undefined ? this.gateCode : <any>null;
        data["lockBox"] = this.lockBox !== undefined ? this.lockBox : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        return data;
    }
}

export interface IUpdateWorkorderPayload {
    id: string;
    priority: Priority;
    notes: string | null;
    gateCode: string | null;
    lockBox: string | null;
    externalReference: string | null;
}

export class WorkorderActivityLogEntry implements IWorkorderActivityLogEntry {
    id: string;
    order: number;
    workorderId: string;
    activityType: WorkorderActivityType;
    oldStatus: WorkorderStatus;
    newStatus: WorkorderStatus;
    modifiedBy: User | null;
    modifiedAt: Date;
    [immerable] = true;

    constructor(data?: IWorkorderActivityLogEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.modifiedBy = data.modifiedBy && !(<any>data.modifiedBy).toJSON ? new User(data.modifiedBy) : <User>this.modifiedBy;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.oldStatus = _data["oldStatus"] !== undefined ? _data["oldStatus"] : <any>null;
            this.newStatus = _data["newStatus"] !== undefined ? _data["newStatus"] : <any>null;
            this.modifiedBy = _data["modifiedBy"] ? User.fromJS(_data["modifiedBy"]) : <any>null;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): WorkorderActivityLogEntry {
        data = typeof data === 'object' ? data : {};
        let result = new WorkorderActivityLogEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["oldStatus"] = this.oldStatus !== undefined ? this.oldStatus : <any>null;
        data["newStatus"] = this.newStatus !== undefined ? this.newStatus : <any>null;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>null;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IWorkorderActivityLogEntry {
    id: string;
    order: number;
    workorderId: string;
    activityType: WorkorderActivityType;
    oldStatus: WorkorderStatus;
    newStatus: WorkorderStatus;
    modifiedBy: IUser | null;
    modifiedAt: Date;
}

export enum WorkorderActivityType {
    Unknown = 0,
    Created = 1,
    Updated = 2,
    ChangedStatus = 3,
}

export class ZillowInfo implements IZillowInfo {
    zillowUrl: string | null;
    zestimate: number;
    zpId: string | null;
    bedrooms: number;
    bathrooms: number;
    yearBuilt: number;
    architecturalStyle: string | null;
    totalStories: number | null;
    lotSizeAcres: number;
    lotSizeSquareFeet: number;
    livableAreaSquareFeet: number;
    [immerable] = true;

    constructor(data?: IZillowInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zillowUrl = _data["zillowUrl"] !== undefined ? _data["zillowUrl"] : <any>null;
            this.zestimate = _data["zestimate"] !== undefined ? _data["zestimate"] : <any>null;
            this.zpId = _data["zpId"] !== undefined ? _data["zpId"] : <any>null;
            this.bedrooms = _data["bedrooms"] !== undefined ? _data["bedrooms"] : <any>null;
            this.bathrooms = _data["bathrooms"] !== undefined ? _data["bathrooms"] : <any>null;
            this.yearBuilt = _data["yearBuilt"] !== undefined ? _data["yearBuilt"] : <any>null;
            this.architecturalStyle = _data["architecturalStyle"] !== undefined ? _data["architecturalStyle"] : <any>null;
            this.totalStories = _data["totalStories"] !== undefined ? _data["totalStories"] : <any>null;
            this.lotSizeAcres = _data["lotSizeAcres"] !== undefined ? _data["lotSizeAcres"] : <any>null;
            this.lotSizeSquareFeet = _data["lotSizeSquareFeet"] !== undefined ? _data["lotSizeSquareFeet"] : <any>null;
            this.livableAreaSquareFeet = _data["livableAreaSquareFeet"] !== undefined ? _data["livableAreaSquareFeet"] : <any>null;
        }
    }

    static fromJS(data: any): ZillowInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ZillowInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zillowUrl"] = this.zillowUrl !== undefined ? this.zillowUrl : <any>null;
        data["zestimate"] = this.zestimate !== undefined ? this.zestimate : <any>null;
        data["zpId"] = this.zpId !== undefined ? this.zpId : <any>null;
        data["bedrooms"] = this.bedrooms !== undefined ? this.bedrooms : <any>null;
        data["bathrooms"] = this.bathrooms !== undefined ? this.bathrooms : <any>null;
        data["yearBuilt"] = this.yearBuilt !== undefined ? this.yearBuilt : <any>null;
        data["architecturalStyle"] = this.architecturalStyle !== undefined ? this.architecturalStyle : <any>null;
        data["totalStories"] = this.totalStories !== undefined ? this.totalStories : <any>null;
        data["lotSizeAcres"] = this.lotSizeAcres !== undefined ? this.lotSizeAcres : <any>null;
        data["lotSizeSquareFeet"] = this.lotSizeSquareFeet !== undefined ? this.lotSizeSquareFeet : <any>null;
        data["livableAreaSquareFeet"] = this.livableAreaSquareFeet !== undefined ? this.livableAreaSquareFeet : <any>null;
        return data;
    }
}

export interface IZillowInfo {
    zillowUrl: string | null;
    zestimate: number;
    zpId: string | null;
    bedrooms: number;
    bathrooms: number;
    yearBuilt: number;
    architecturalStyle: string | null;
    totalStories: number | null;
    lotSizeAcres: number;
    lotSizeSquareFeet: number;
    livableAreaSquareFeet: number;
}

export class IssueUserView implements IIssueUserView {
    issue: Issue | null;
    managementCompany: ManagementCompany | null;
    workorder: WorkorderSummary | null;
    cosmeticStatus: IssueStatus;
    participants: IssueContact[] | null;
    contacts: IssueContact[] | null;
    managingVendor: Vendor | null;
    subissues: IssueUserView[] | null;
    userRole: IssueRole;
    property: Property | null;
    boardPosts: BulletinBoardPost[] | null;
    taskList: string[] | null;
    parentIssue: IssueSummary | null;
    estimates: Estimate[] | null;
    changeRequests: ChangeRequest[] | null;
    visibleChangeRequests: ChangeRequestUserView[] | null;
    visibleBids: BidUserView[] | null;
    visibleBidSchedules: ScheduleProposal[] | null;
    visibleInvoices: Invoice[] | null;
    latestBidInvitation: Bid | null;
    myCandidacy: VendorCandidate | null;
    checklist: ChecklistLine[] | null;
    allowedActions: IssueAction[] | null;
    flags: IssueFlag[] | null;
    payments: Payment[] | null;
    formDefaults: FormDefaults | null;
    [immerable] = true;

    constructor(data?: IIssueUserView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.issue = data.issue && !(<any>data.issue).toJSON ? new Issue(data.issue) : <Issue>this.issue;
            this.managementCompany = data.managementCompany && !(<any>data.managementCompany).toJSON ? new ManagementCompany(data.managementCompany) : <ManagementCompany>this.managementCompany;
            this.workorder = data.workorder && !(<any>data.workorder).toJSON ? new WorkorderSummary(data.workorder) : <WorkorderSummary>this.workorder;
            if (data.participants) {
                this.participants = [];
                for (let i = 0; i < data.participants.length; i++) {
                    let item = data.participants[i];
                    this.participants[i] = item && !(<any>item).toJSON ? new IssueContact(item) : <IssueContact>item;
                }
            }
            if (data.contacts) {
                this.contacts = [];
                for (let i = 0; i < data.contacts.length; i++) {
                    let item = data.contacts[i];
                    this.contacts[i] = item && !(<any>item).toJSON ? new IssueContact(item) : <IssueContact>item;
                }
            }
            this.managingVendor = data.managingVendor && !(<any>data.managingVendor).toJSON ? new Vendor(data.managingVendor) : <Vendor>this.managingVendor;
            if (data.subissues) {
                this.subissues = [];
                for (let i = 0; i < data.subissues.length; i++) {
                    let item = data.subissues[i];
                    this.subissues[i] = item && !(<any>item).toJSON ? new IssueUserView(item) : <IssueUserView>item;
                }
            }
            this.property = data.property && !(<any>data.property).toJSON ? new Property(data.property) : <Property>this.property;
            if (data.boardPosts) {
                this.boardPosts = [];
                for (let i = 0; i < data.boardPosts.length; i++) {
                    let item = data.boardPosts[i];
                    this.boardPosts[i] = item && !(<any>item).toJSON ? new BulletinBoardPost(item) : <BulletinBoardPost>item;
                }
            }
            this.parentIssue = data.parentIssue && !(<any>data.parentIssue).toJSON ? new IssueSummary(data.parentIssue) : <IssueSummary>this.parentIssue;
            if (data.estimates) {
                this.estimates = [];
                for (let i = 0; i < data.estimates.length; i++) {
                    let item = data.estimates[i];
                    this.estimates[i] = item && !(<any>item).toJSON ? new Estimate(item) : <Estimate>item;
                }
            }
            if (data.changeRequests) {
                this.changeRequests = [];
                for (let i = 0; i < data.changeRequests.length; i++) {
                    let item = data.changeRequests[i];
                    this.changeRequests[i] = item && !(<any>item).toJSON ? new ChangeRequest(item) : <ChangeRequest>item;
                }
            }
            if (data.visibleChangeRequests) {
                this.visibleChangeRequests = [];
                for (let i = 0; i < data.visibleChangeRequests.length; i++) {
                    let item = data.visibleChangeRequests[i];
                    this.visibleChangeRequests[i] = item && !(<any>item).toJSON ? new ChangeRequestUserView(item) : <ChangeRequestUserView>item;
                }
            }
            if (data.visibleBids) {
                this.visibleBids = [];
                for (let i = 0; i < data.visibleBids.length; i++) {
                    let item = data.visibleBids[i];
                    this.visibleBids[i] = item && !(<any>item).toJSON ? new BidUserView(item) : <BidUserView>item;
                }
            }
            if (data.visibleBidSchedules) {
                this.visibleBidSchedules = [];
                for (let i = 0; i < data.visibleBidSchedules.length; i++) {
                    let item = data.visibleBidSchedules[i];
                    this.visibleBidSchedules[i] = item && !(<any>item).toJSON ? new ScheduleProposal(item) : <ScheduleProposal>item;
                }
            }
            this.latestBidInvitation = data.latestBidInvitation && !(<any>data.latestBidInvitation).toJSON ? new Bid(data.latestBidInvitation) : <Bid>this.latestBidInvitation;
            this.myCandidacy = data.myCandidacy && !(<any>data.myCandidacy).toJSON ? new VendorCandidate(data.myCandidacy) : <VendorCandidate>this.myCandidacy;
            if (data.checklist) {
                this.checklist = [];
                for (let i = 0; i < data.checklist.length; i++) {
                    let item = data.checklist[i];
                    this.checklist[i] = item && !(<any>item).toJSON ? new ChecklistLine(item) : <ChecklistLine>item;
                }
            }
            if (data.payments) {
                this.payments = [];
                for (let i = 0; i < data.payments.length; i++) {
                    let item = data.payments[i];
                    this.payments[i] = item && !(<any>item).toJSON ? new Payment(item) : <Payment>item;
                }
            }
            this.formDefaults = data.formDefaults && !(<any>data.formDefaults).toJSON ? new FormDefaults(data.formDefaults) : <FormDefaults>this.formDefaults;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issue = _data["issue"] ? Issue.fromJS(_data["issue"]) : <any>null;
            this.managementCompany = _data["managementCompany"] ? ManagementCompany.fromJS(_data["managementCompany"]) : <any>null;
            this.workorder = _data["workorder"] ? WorkorderSummary.fromJS(_data["workorder"]) : <any>null;
            this.cosmeticStatus = _data["cosmeticStatus"] !== undefined ? _data["cosmeticStatus"] : <any>null;
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(IssueContact.fromJS(item));
            }
            else {
                this.participants = <any>null;
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(IssueContact.fromJS(item));
            }
            else {
                this.contacts = <any>null;
            }
            this.managingVendor = _data["managingVendor"] ? Vendor.fromJS(_data["managingVendor"]) : <any>null;
            if (Array.isArray(_data["subissues"])) {
                this.subissues = [] as any;
                for (let item of _data["subissues"])
                    this.subissues!.push(IssueUserView.fromJS(item));
            }
            else {
                this.subissues = <any>null;
            }
            this.userRole = _data["userRole"] !== undefined ? _data["userRole"] : <any>null;
            this.property = _data["property"] ? Property.fromJS(_data["property"]) : <any>null;
            if (Array.isArray(_data["boardPosts"])) {
                this.boardPosts = [] as any;
                for (let item of _data["boardPosts"])
                    this.boardPosts!.push(BulletinBoardPost.fromJS(item));
            }
            else {
                this.boardPosts = <any>null;
            }
            if (Array.isArray(_data["taskList"])) {
                this.taskList = [] as any;
                for (let item of _data["taskList"])
                    this.taskList!.push(item);
            }
            else {
                this.taskList = <any>null;
            }
            this.parentIssue = _data["parentIssue"] ? IssueSummary.fromJS(_data["parentIssue"]) : <any>null;
            if (Array.isArray(_data["estimates"])) {
                this.estimates = [] as any;
                for (let item of _data["estimates"])
                    this.estimates!.push(Estimate.fromJS(item));
            }
            else {
                this.estimates = <any>null;
            }
            if (Array.isArray(_data["changeRequests"])) {
                this.changeRequests = [] as any;
                for (let item of _data["changeRequests"])
                    this.changeRequests!.push(ChangeRequest.fromJS(item));
            }
            else {
                this.changeRequests = <any>null;
            }
            if (Array.isArray(_data["visibleChangeRequests"])) {
                this.visibleChangeRequests = [] as any;
                for (let item of _data["visibleChangeRequests"])
                    this.visibleChangeRequests!.push(ChangeRequestUserView.fromJS(item));
            }
            else {
                this.visibleChangeRequests = <any>null;
            }
            if (Array.isArray(_data["visibleBids"])) {
                this.visibleBids = [] as any;
                for (let item of _data["visibleBids"])
                    this.visibleBids!.push(BidUserView.fromJS(item));
            }
            else {
                this.visibleBids = <any>null;
            }
            if (Array.isArray(_data["visibleBidSchedules"])) {
                this.visibleBidSchedules = [] as any;
                for (let item of _data["visibleBidSchedules"])
                    this.visibleBidSchedules!.push(ScheduleProposal.fromJS(item));
            }
            else {
                this.visibleBidSchedules = <any>null;
            }
            if (Array.isArray(_data["visibleInvoices"])) {
                this.visibleInvoices = [] as any;
                for (let item of _data["visibleInvoices"])
                    this.visibleInvoices!.push(Invoice.fromJS(item));
            }
            else {
                this.visibleInvoices = <any>null;
            }
            this.latestBidInvitation = _data["latestBidInvitation"] ? Bid.fromJS(_data["latestBidInvitation"]) : <any>null;
            this.myCandidacy = _data["myCandidacy"] ? VendorCandidate.fromJS(_data["myCandidacy"]) : <any>null;
            if (Array.isArray(_data["checklist"])) {
                this.checklist = [] as any;
                for (let item of _data["checklist"])
                    this.checklist!.push(ChecklistLine.fromJS(item));
            }
            else {
                this.checklist = <any>null;
            }
            if (Array.isArray(_data["allowedActions"])) {
                this.allowedActions = [] as any;
                for (let item of _data["allowedActions"])
                    this.allowedActions!.push(item);
            }
            else {
                this.allowedActions = <any>null;
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(item);
            }
            else {
                this.flags = <any>null;
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(Payment.fromJS(item));
            }
            else {
                this.payments = <any>null;
            }
            this.formDefaults = _data["formDefaults"] ? FormDefaults.fromJS(_data["formDefaults"]) : <any>null;
        }
    }

    static fromJS(data: any): IssueUserView {
        data = typeof data === 'object' ? data : {};
        let result = new IssueUserView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issue"] = this.issue ? this.issue.toJSON() : <any>null;
        data["managementCompany"] = this.managementCompany ? this.managementCompany.toJSON() : <any>null;
        data["workorder"] = this.workorder ? this.workorder.toJSON() : <any>null;
        data["cosmeticStatus"] = this.cosmeticStatus !== undefined ? this.cosmeticStatus : <any>null;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["managingVendor"] = this.managingVendor ? this.managingVendor.toJSON() : <any>null;
        if (Array.isArray(this.subissues)) {
            data["subissues"] = [];
            for (let item of this.subissues)
                data["subissues"].push(item.toJSON());
        }
        data["userRole"] = this.userRole !== undefined ? this.userRole : <any>null;
        data["property"] = this.property ? this.property.toJSON() : <any>null;
        if (Array.isArray(this.boardPosts)) {
            data["boardPosts"] = [];
            for (let item of this.boardPosts)
                data["boardPosts"].push(item.toJSON());
        }
        if (Array.isArray(this.taskList)) {
            data["taskList"] = [];
            for (let item of this.taskList)
                data["taskList"].push(item);
        }
        data["parentIssue"] = this.parentIssue ? this.parentIssue.toJSON() : <any>null;
        if (Array.isArray(this.estimates)) {
            data["estimates"] = [];
            for (let item of this.estimates)
                data["estimates"].push(item.toJSON());
        }
        if (Array.isArray(this.changeRequests)) {
            data["changeRequests"] = [];
            for (let item of this.changeRequests)
                data["changeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.visibleChangeRequests)) {
            data["visibleChangeRequests"] = [];
            for (let item of this.visibleChangeRequests)
                data["visibleChangeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.visibleBids)) {
            data["visibleBids"] = [];
            for (let item of this.visibleBids)
                data["visibleBids"].push(item.toJSON());
        }
        if (Array.isArray(this.visibleBidSchedules)) {
            data["visibleBidSchedules"] = [];
            for (let item of this.visibleBidSchedules)
                data["visibleBidSchedules"].push(item.toJSON());
        }
        if (Array.isArray(this.visibleInvoices)) {
            data["visibleInvoices"] = [];
            for (let item of this.visibleInvoices)
                data["visibleInvoices"].push(item.toJSON());
        }
        data["latestBidInvitation"] = this.latestBidInvitation ? this.latestBidInvitation.toJSON() : <any>null;
        data["myCandidacy"] = this.myCandidacy ? this.myCandidacy.toJSON() : <any>null;
        if (Array.isArray(this.checklist)) {
            data["checklist"] = [];
            for (let item of this.checklist)
                data["checklist"].push(item.toJSON());
        }
        if (Array.isArray(this.allowedActions)) {
            data["allowedActions"] = [];
            for (let item of this.allowedActions)
                data["allowedActions"].push(item);
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item);
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["formDefaults"] = this.formDefaults ? this.formDefaults.toJSON() : <any>null;
        return data;
    }
}

export interface IIssueUserView {
    issue: IIssue | null;
    managementCompany: IManagementCompany | null;
    workorder: IWorkorderSummary | null;
    cosmeticStatus: IssueStatus;
    participants: IIssueContact[] | null;
    contacts: IIssueContact[] | null;
    managingVendor: IVendor | null;
    subissues: IIssueUserView[] | null;
    userRole: IssueRole;
    property: IProperty | null;
    boardPosts: IBulletinBoardPost[] | null;
    taskList: string[] | null;
    parentIssue: IIssueSummary | null;
    estimates: IEstimate[] | null;
    changeRequests: IChangeRequest[] | null;
    visibleChangeRequests: IChangeRequestUserView[] | null;
    visibleBids: IBidUserView[] | null;
    visibleBidSchedules: IScheduleProposal[] | null;
    visibleInvoices: Invoice[] | null;
    latestBidInvitation: IBid | null;
    myCandidacy: IVendorCandidate | null;
    checklist: IChecklistLine[] | null;
    allowedActions: IssueAction[] | null;
    flags: IssueFlag[] | null;
    payments: IPayment[] | null;
    formDefaults: IFormDefaults | null;
}

export enum IssueRole {
    None = 0,
    MainPropertyManager = 1,
    AltPropertyManager = 2,
    PropertyOwner = 3,
    Tenant = 4,
    Vendor = 5,
    Bidder = 6,
    VendorCandidate = 7,
    Tech = 8,
    AdminViewer = 9,
}

export class BulletinBoardPost implements IBulletinBoardPost {
    id: string;
    createdAt: Date;
    message: string | null;
    createdBy: UserSummary | null;
    [immerable] = true;

    constructor(data?: IBulletinBoardPost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.createdBy = data.createdBy && !(<any>data.createdBy).toJSON ? new UserSummary(data.createdBy) : <UserSummary>this.createdBy;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.createdBy = _data["createdBy"] ? UserSummary.fromJS(_data["createdBy"]) : <any>null;
        }
    }

    static fromJS(data: any): BulletinBoardPost {
        data = typeof data === 'object' ? data : {};
        let result = new BulletinBoardPost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        return data;
    }
}

export interface IBulletinBoardPost {
    id: string;
    createdAt: Date;
    message: string | null;
    createdBy: IUserSummary | null;
}

export class Estimate implements IEstimate {
    id: string;
    issueId: string;
    vendor: Vendor | null;
    friendlyId: string | null;
    reviewerNotes: string | null;
    status: EstimateStatus;
    startDate: Instant | null;
    endDate: Instant | null;
    totals: DocumentTotals | null;
    referenceDate: Instant | null;
    sortDate: Instant | null;
    lines: DocumentLineItem[] | null;
    pdfId: string | null;
    pdfUrls: AttachmentUrls | null;
    split: EstimateSplitSummary | null;
    [immerable] = true;

    constructor(data?: IEstimate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.vendor = data.vendor && !(<any>data.vendor).toJSON ? new Vendor(data.vendor) : <Vendor>this.vendor;
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
            this.totals = data.totals && !(<any>data.totals).toJSON ? new DocumentTotals(data.totals) : <DocumentTotals>this.totals;
            this.referenceDate = data.referenceDate && !(<any>data.referenceDate).toJSON ? new Instant(data.referenceDate) : <Instant>this.referenceDate;
            this.sortDate = data.sortDate && !(<any>data.sortDate).toJSON ? new Instant(data.sortDate) : <Instant>this.sortDate;
            this.pdfUrls = data.pdfUrls && !(<any>data.pdfUrls).toJSON ? new AttachmentUrls(data.pdfUrls) : <AttachmentUrls>this.pdfUrls;
            this.split = data.split && !(<any>data.split).toJSON ? new EstimateSplitSummary(data.split) : <EstimateSplitSummary>this.split;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.reviewerNotes = _data["reviewerNotes"] !== undefined ? _data["reviewerNotes"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
            this.totals = _data["totals"] ? DocumentTotals.fromJS(_data["totals"]) : <any>null;
            this.referenceDate = _data["referenceDate"] ? Instant.fromJS(_data["referenceDate"]) : <any>null;
            this.sortDate = _data["sortDate"] ? Instant.fromJS(_data["sortDate"]) : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(DocumentLineItem.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
            this.pdfId = _data["pdfId"] !== undefined ? _data["pdfId"] : <any>null;
            this.pdfUrls = _data["pdfUrls"] ? AttachmentUrls.fromJS(_data["pdfUrls"]) : <any>null;
            this.split = _data["split"] ? EstimateSplitSummary.fromJS(_data["split"]) : <any>null;
        }
    }

    static fromJS(data: any): Estimate {
        data = typeof data === 'object' ? data : {};
        let result = new Estimate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["reviewerNotes"] = this.reviewerNotes !== undefined ? this.reviewerNotes : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        data["totals"] = this.totals ? this.totals.toJSON() : <any>null;
        data["referenceDate"] = this.referenceDate ? this.referenceDate.toJSON() : <any>null;
        data["sortDate"] = this.sortDate ? this.sortDate.toJSON() : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["pdfId"] = this.pdfId !== undefined ? this.pdfId : <any>null;
        data["pdfUrls"] = this.pdfUrls ? this.pdfUrls.toJSON() : <any>null;
        data["split"] = this.split ? this.split.toJSON() : <any>null;
        return data;
    }
}

export interface IEstimate {
    id: string;
    issueId: string;
    vendor: IVendor | null;
    friendlyId: string | null;
    reviewerNotes: string | null;
    status: EstimateStatus;
    startDate: IInstant | null;
    endDate: IInstant | null;
    totals: IDocumentTotals | null;
    referenceDate: IInstant | null;
    sortDate: IInstant | null;
    lines: DocumentLineItem[] | null;
    pdfId: string | null;
    pdfUrls: IAttachmentUrls | null;
    split: IEstimateSplitSummary | null;
}

export enum EstimateStatus {
    Draft = 0,
    PendingReview = 1,
    Accepted = 2,
    Rejected = 3,
    Edited = 4,
    Canceled = 5,
}

export class DocumentTotals implements IDocumentTotals {
    previousDiscount: number | null;
    partialAmount: number | null;
    partialPercent: number | null;
    taxPercent: number;
    discountPercent: number | null;
    discount: number;
    subtotal: number;
    tax: number;
    grandTotal: number;
    partialTotal: number;
    finalTotal: number;
    [immerable] = true;

    constructor(data?: IDocumentTotals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousDiscount = _data["previousDiscount"] !== undefined ? _data["previousDiscount"] : <any>null;
            this.partialAmount = _data["partialAmount"] !== undefined ? _data["partialAmount"] : <any>null;
            this.partialPercent = _data["partialPercent"] !== undefined ? _data["partialPercent"] : <any>null;
            this.taxPercent = _data["taxPercent"] !== undefined ? _data["taxPercent"] : <any>null;
            this.discountPercent = _data["discountPercent"] !== undefined ? _data["discountPercent"] : <any>null;
            this.discount = _data["discount"] !== undefined ? _data["discount"] : <any>null;
            this.subtotal = _data["subtotal"] !== undefined ? _data["subtotal"] : <any>null;
            this.tax = _data["tax"] !== undefined ? _data["tax"] : <any>null;
            this.grandTotal = _data["grandTotal"] !== undefined ? _data["grandTotal"] : <any>null;
            this.partialTotal = _data["partialTotal"] !== undefined ? _data["partialTotal"] : <any>null;
            this.finalTotal = _data["finalTotal"] !== undefined ? _data["finalTotal"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentTotals {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTotals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousDiscount"] = this.previousDiscount !== undefined ? this.previousDiscount : <any>null;
        data["partialAmount"] = this.partialAmount !== undefined ? this.partialAmount : <any>null;
        data["partialPercent"] = this.partialPercent !== undefined ? this.partialPercent : <any>null;
        data["taxPercent"] = this.taxPercent !== undefined ? this.taxPercent : <any>null;
        data["discountPercent"] = this.discountPercent !== undefined ? this.discountPercent : <any>null;
        data["discount"] = this.discount !== undefined ? this.discount : <any>null;
        data["subtotal"] = this.subtotal !== undefined ? this.subtotal : <any>null;
        data["tax"] = this.tax !== undefined ? this.tax : <any>null;
        data["grandTotal"] = this.grandTotal !== undefined ? this.grandTotal : <any>null;
        data["partialTotal"] = this.partialTotal !== undefined ? this.partialTotal : <any>null;
        data["finalTotal"] = this.finalTotal !== undefined ? this.finalTotal : <any>null;
        return data;
    }
}

export interface IDocumentTotals {
    previousDiscount: number | null;
    partialAmount: number | null;
    partialPercent: number | null;
    taxPercent: number;
    discountPercent: number | null;
    discount: number;
    subtotal: number;
    tax: number;
    grandTotal: number;
    partialTotal: number;
    finalTotal: number;
}

export class LineItemBase implements ILineItemBase {
    initialValue: number | null;
    resaleValue: number | null;
    description: string | null;
    notes: string | null;
    sourceEntityType: LineSource;
    sourceEntityId: string | null;
    [immerable] = true;

    constructor(data?: ILineItemBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initialValue = _data["initialValue"] !== undefined ? _data["initialValue"] : <any>null;
            this.resaleValue = _data["resaleValue"] !== undefined ? _data["resaleValue"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.sourceEntityType = _data["sourceEntityType"] !== undefined ? _data["sourceEntityType"] : <any>null;
            this.sourceEntityId = _data["sourceEntityId"] !== undefined ? _data["sourceEntityId"] : <any>null;
        }
    }

    static fromJS(data: any): LineItemBase {
        data = typeof data === 'object' ? data : {};
        let result = new LineItemBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialValue"] = this.initialValue !== undefined ? this.initialValue : <any>null;
        data["resaleValue"] = this.resaleValue !== undefined ? this.resaleValue : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["sourceEntityType"] = this.sourceEntityType !== undefined ? this.sourceEntityType : <any>null;
        data["sourceEntityId"] = this.sourceEntityId !== undefined ? this.sourceEntityId : <any>null;
        return data;
    }
}

export interface ILineItemBase {
    initialValue: number | null;
    resaleValue: number | null;
    description: string | null;
    notes: string | null;
    sourceEntityType: LineSource;
    sourceEntityId: string | null;
}

export class DocumentLineItem extends LineItemBase implements IDocumentLineItem {
    id: string;
    value: number;
    order: number;
    beforeFiles: AttachmentFile[] | null;
    afterFiles: AttachmentFile[] | null;
    [immerable] = true;

    constructor(data?: IDocumentLineItem) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.beforeFiles) {
                this.beforeFiles = [];
                for (let i = 0; i < data.beforeFiles.length; i++) {
                    let item = data.beforeFiles[i];
                    this.beforeFiles[i] = item && !(<any>item).toJSON ? new AttachmentFile(item) : <AttachmentFile>item;
                }
            }
            if (data.afterFiles) {
                this.afterFiles = [];
                for (let i = 0; i < data.afterFiles.length; i++) {
                    let item = data.afterFiles[i];
                    this.afterFiles[i] = item && !(<any>item).toJSON ? new AttachmentFile(item) : <AttachmentFile>item;
                }
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            if (Array.isArray(_data["beforeFiles"])) {
                this.beforeFiles = [] as any;
                for (let item of _data["beforeFiles"])
                    this.beforeFiles!.push(AttachmentFile.fromJS(item));
            }
            else {
                this.beforeFiles = <any>null;
            }
            if (Array.isArray(_data["afterFiles"])) {
                this.afterFiles = [] as any;
                for (let item of _data["afterFiles"])
                    this.afterFiles!.push(AttachmentFile.fromJS(item));
            }
            else {
                this.afterFiles = <any>null;
            }
        }
    }

    static fromJS(data: any): DocumentLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        if (Array.isArray(this.beforeFiles)) {
            data["beforeFiles"] = [];
            for (let item of this.beforeFiles)
                data["beforeFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.afterFiles)) {
            data["afterFiles"] = [];
            for (let item of this.afterFiles)
                data["afterFiles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentLineItem extends ILineItemBase {
    id: string;
    value: number;
    order: number;
    beforeFiles: IAttachmentFile[] | null;
    afterFiles: IAttachmentFile[] | null;
}

export enum LineSource {
    Unknown = 0,
    MainTask = 101,
    TaskList = 102,
    Custom = 103,
    BidLine = 201,
    EstimateLine = 202,
    ChangeRequest = 203,
    TaskLines = 204,
    InvoiceLine = 205,
    ChangeRequestLine = 206,
    InspectionIssue = 207,
    SubissueBidLine = 301,
    SubissueEstimateLine = 302,
    SubissueChangeRequest = 303,
    SubissueTaskLines = 304,
    SubissueInvoiceLine = 305,
}

export class EstimateSplitSummary implements IEstimateSplitSummary {
    splitId: string;
    ownerProjection: EstimateSplitProjection | null;
    tenantProjection: EstimateSplitProjection | null;
    [immerable] = true;

    constructor(data?: IEstimateSplitSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.ownerProjection = data.ownerProjection && !(<any>data.ownerProjection).toJSON ? new EstimateSplitProjection(data.ownerProjection) : <EstimateSplitProjection>this.ownerProjection;
            this.tenantProjection = data.tenantProjection && !(<any>data.tenantProjection).toJSON ? new EstimateSplitProjection(data.tenantProjection) : <EstimateSplitProjection>this.tenantProjection;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.splitId = _data["splitId"] !== undefined ? _data["splitId"] : <any>null;
            this.ownerProjection = _data["ownerProjection"] ? EstimateSplitProjection.fromJS(_data["ownerProjection"]) : <any>null;
            this.tenantProjection = _data["tenantProjection"] ? EstimateSplitProjection.fromJS(_data["tenantProjection"]) : <any>null;
        }
    }

    static fromJS(data: any): EstimateSplitSummary {
        data = typeof data === 'object' ? data : {};
        let result = new EstimateSplitSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["splitId"] = this.splitId !== undefined ? this.splitId : <any>null;
        data["ownerProjection"] = this.ownerProjection ? this.ownerProjection.toJSON() : <any>null;
        data["tenantProjection"] = this.tenantProjection ? this.tenantProjection.toJSON() : <any>null;
        return data;
    }
}

export interface IEstimateSplitSummary {
    splitId: string;
    ownerProjection: IEstimateSplitProjection | null;
    tenantProjection: IEstimateSplitProjection | null;
}

export class EstimateSplitProjection implements IEstimateSplitProjection {
    estimateId: string;
    splitId: string;
    friendlyId: string | null;
    party: SplitDocumentParty;
    amount: number;
    [immerable] = true;

    constructor(data?: IEstimateSplitProjection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            this.splitId = _data["splitId"] !== undefined ? _data["splitId"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.party = _data["party"] !== undefined ? _data["party"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): EstimateSplitProjection {
        data = typeof data === 'object' ? data : {};
        let result = new EstimateSplitProjection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        data["splitId"] = this.splitId !== undefined ? this.splitId : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["party"] = this.party !== undefined ? this.party : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface IEstimateSplitProjection {
    estimateId: string;
    splitId: string;
    friendlyId: string | null;
    party: SplitDocumentParty;
    amount: number;
}

export enum SplitDocumentParty {
    Owner = 0,
    Tenant = 1,
}

export class ChangeRequest implements IChangeRequest {
    id: string;
    issueId: string;
    index: number;
    friendlyId: string | null;
    status: ChangeRequestStatus;
    completionDate: Instant | null;
    lastModified: Date;
    reviewerNotes: string | null;
    notes: string | null;
    totals: DocumentTotals | null;
    lines: DocumentLineItem[] | null;
    pdfId: string | null;
    pdfUrls: AttachmentUrls | null;
    [immerable] = true;

    constructor(data?: IChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.completionDate = data.completionDate && !(<any>data.completionDate).toJSON ? new Instant(data.completionDate) : <Instant>this.completionDate;
            this.totals = data.totals && !(<any>data.totals).toJSON ? new DocumentTotals(data.totals) : <DocumentTotals>this.totals;
            this.pdfUrls = data.pdfUrls && !(<any>data.pdfUrls).toJSON ? new AttachmentUrls(data.pdfUrls) : <AttachmentUrls>this.pdfUrls;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.completionDate = _data["completionDate"] ? Instant.fromJS(_data["completionDate"]) : <any>null;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>null;
            this.reviewerNotes = _data["reviewerNotes"] !== undefined ? _data["reviewerNotes"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.totals = _data["totals"] ? DocumentTotals.fromJS(_data["totals"]) : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(DocumentLineItem.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
            this.pdfId = _data["pdfId"] !== undefined ? _data["pdfId"] : <any>null;
            this.pdfUrls = _data["pdfUrls"] ? AttachmentUrls.fromJS(_data["pdfUrls"]) : <any>null;
        }
    }

    static fromJS(data: any): ChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["completionDate"] = this.completionDate ? this.completionDate.toJSON() : <any>null;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>null;
        data["reviewerNotes"] = this.reviewerNotes !== undefined ? this.reviewerNotes : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["totals"] = this.totals ? this.totals.toJSON() : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["pdfId"] = this.pdfId !== undefined ? this.pdfId : <any>null;
        data["pdfUrls"] = this.pdfUrls ? this.pdfUrls.toJSON() : <any>null;
        return data;
    }
}

export interface IChangeRequest {
    id: string;
    issueId: string;
    index: number;
    friendlyId: string | null;
    status: ChangeRequestStatus;
    completionDate: IInstant | null;
    lastModified: Date;
    reviewerNotes: string | null;
    notes: string | null;
    totals: IDocumentTotals | null;
    lines: DocumentLineItem[] | null;
    pdfId: string | null;
    pdfUrls: IAttachmentUrls | null;
}

export enum ChangeRequestStatus {
    PendingReviewPM = 0,
    Accepted = 1,
    Declined = 2,
    Deleted = 3,
    Obsolete = 4,
    Edited = 5,
    Draft = 6,
    PendingReviewOwner = 7,
}

export class ChangeRequestUserView implements IChangeRequestUserView {
    actions: ChangeRequestAction[] | null;
    changeRequest: ChangeRequest | null;
    [immerable] = true;

    constructor(data?: IChangeRequestUserView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.changeRequest = data.changeRequest && !(<any>data.changeRequest).toJSON ? new ChangeRequest(data.changeRequest) : <ChangeRequest>this.changeRequest;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
            else {
                this.actions = <any>null;
            }
            this.changeRequest = _data["changeRequest"] ? ChangeRequest.fromJS(_data["changeRequest"]) : <any>null;
        }
    }

    static fromJS(data: any): ChangeRequestUserView {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestUserView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        data["changeRequest"] = this.changeRequest ? this.changeRequest.toJSON() : <any>null;
        return data;
    }
}

export interface IChangeRequestUserView {
    actions: ChangeRequestAction[] | null;
    changeRequest: IChangeRequest | null;
}

export enum ChangeRequestAction {
    Edit = 0,
    Delete = 1,
    Accept = 2,
    Reject = 3,
    Elevate = 4,
    Publish = 5,
    ForceAccept = 6,
}

export class BidUserView implements IBidUserView {
    bid: Bid | null;
    allowedActions: BidAction[] | null;
    [immerable] = true;

    constructor(data?: IBidUserView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.bid = data.bid && !(<any>data.bid).toJSON ? new Bid(data.bid) : <Bid>this.bid;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bid = _data["bid"] ? Bid.fromJS(_data["bid"]) : <any>null;
            if (Array.isArray(_data["allowedActions"])) {
                this.allowedActions = [] as any;
                for (let item of _data["allowedActions"])
                    this.allowedActions!.push(item);
            }
            else {
                this.allowedActions = <any>null;
            }
        }
    }

    static fromJS(data: any): BidUserView {
        data = typeof data === 'object' ? data : {};
        let result = new BidUserView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bid"] = this.bid ? this.bid.toJSON() : <any>null;
        if (Array.isArray(this.allowedActions)) {
            data["allowedActions"] = [];
            for (let item of this.allowedActions)
                data["allowedActions"].push(item);
        }
        return data;
    }
}

export interface IBidUserView {
    bid: IBid | null;
    allowedActions: BidAction[] | null;
}

export class Bid implements IBid {
    id: string;
    issueId: string;
    vendor: Vendor | null;
    status: BidStatus;
    invitationId: string | null;
    startDate: Instant | null;
    endDate: Instant | null;
    resaleTaxPercent: number | null;
    totals: DocumentTotals | null;
    lines: DocumentLineItem[] | null;
    schedule: ScheduleProposal | null;
    reviewerNotes: string | null;
    revisionNotes: string | null;
    createdDate: Date;
    invitedAt: Date | null;
    submittedAt: Date | null;
    isSubmitted: boolean;
    pdfFile: AttachmentFile | null;
    split: BidSplitSummary | null;
    [immerable] = true;

    constructor(data?: IBid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.vendor = data.vendor && !(<any>data.vendor).toJSON ? new Vendor(data.vendor) : <Vendor>this.vendor;
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
            this.totals = data.totals && !(<any>data.totals).toJSON ? new DocumentTotals(data.totals) : <DocumentTotals>this.totals;
            this.schedule = data.schedule && !(<any>data.schedule).toJSON ? new ScheduleProposal(data.schedule) : <ScheduleProposal>this.schedule;
            this.pdfFile = data.pdfFile && !(<any>data.pdfFile).toJSON ? new AttachmentFile(data.pdfFile) : <AttachmentFile>this.pdfFile;
            this.split = data.split && !(<any>data.split).toJSON ? new BidSplitSummary(data.split) : <BidSplitSummary>this.split;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.invitationId = _data["invitationId"] !== undefined ? _data["invitationId"] : <any>null;
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
            this.resaleTaxPercent = _data["resaleTaxPercent"] !== undefined ? _data["resaleTaxPercent"] : <any>null;
            this.totals = _data["totals"] ? DocumentTotals.fromJS(_data["totals"]) : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(DocumentLineItem.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
            this.schedule = _data["schedule"] ? ScheduleProposal.fromJS(_data["schedule"]) : <any>null;
            this.reviewerNotes = _data["reviewerNotes"] !== undefined ? _data["reviewerNotes"] : <any>null;
            this.revisionNotes = _data["revisionNotes"] !== undefined ? _data["revisionNotes"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.invitedAt = _data["invitedAt"] ? new Date(_data["invitedAt"].toString()) : <any>null;
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : <any>null;
            this.isSubmitted = _data["isSubmitted"] !== undefined ? _data["isSubmitted"] : <any>null;
            this.pdfFile = _data["pdfFile"] ? AttachmentFile.fromJS(_data["pdfFile"]) : <any>null;
            this.split = _data["split"] ? BidSplitSummary.fromJS(_data["split"]) : <any>null;
        }
    }

    static fromJS(data: any): Bid {
        data = typeof data === 'object' ? data : {};
        let result = new Bid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["invitationId"] = this.invitationId !== undefined ? this.invitationId : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        data["resaleTaxPercent"] = this.resaleTaxPercent !== undefined ? this.resaleTaxPercent : <any>null;
        data["totals"] = this.totals ? this.totals.toJSON() : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>null;
        data["reviewerNotes"] = this.reviewerNotes !== undefined ? this.reviewerNotes : <any>null;
        data["revisionNotes"] = this.revisionNotes !== undefined ? this.revisionNotes : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["invitedAt"] = this.invitedAt ? this.invitedAt.toISOString() : <any>null;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : <any>null;
        data["isSubmitted"] = this.isSubmitted !== undefined ? this.isSubmitted : <any>null;
        data["pdfFile"] = this.pdfFile ? this.pdfFile.toJSON() : <any>null;
        data["split"] = this.split ? this.split.toJSON() : <any>null;
        return data;
    }
}

export interface IBid {
    id: string;
    issueId: string;
    vendor: IVendor | null;
    status: BidStatus;
    invitationId: string | null;
    startDate: IInstant | null;
    endDate: IInstant | null;
    resaleTaxPercent: number | null;
    totals: IDocumentTotals | null;
    lines: DocumentLineItem[] | null;
    schedule: IScheduleProposal | null;
    reviewerNotes: string | null;
    revisionNotes: string | null;
    createdDate: Date;
    invitedAt: Date | null;
    submittedAt: Date | null;
    isSubmitted: boolean;
    pdfFile: IAttachmentFile | null;
    split: IBidSplitSummary | null;
}

export enum BidStatus {
    Requested = 0,
    PendingReviewPM = 1,
    Accepted = 2,
    Rejected = 3,
    PendingReviewOwner = 4,
    ProposedSchedule = 5,
    Scheduled = 6,
    Declined = 7,
    Uninvited = 8,
    RevisionPendingVendorReview = 9,
    Revised = 10,
    ChangeRequestPendingVendorReview = 11,
    ChangesRequested = 12,
    ChangeRequestDeclined = 13,
    Edited = 14,
    SkippedBidding = 15,
}

export class BidSplitSummary implements IBidSplitSummary {
    splitId: string;
    ownerProjection: BidSplitProjection | null;
    tenantProjection: BidSplitProjection | null;
    [immerable] = true;

    constructor(data?: IBidSplitSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.ownerProjection = data.ownerProjection && !(<any>data.ownerProjection).toJSON ? new BidSplitProjection(data.ownerProjection) : <BidSplitProjection>this.ownerProjection;
            this.tenantProjection = data.tenantProjection && !(<any>data.tenantProjection).toJSON ? new BidSplitProjection(data.tenantProjection) : <BidSplitProjection>this.tenantProjection;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.splitId = _data["splitId"] !== undefined ? _data["splitId"] : <any>null;
            this.ownerProjection = _data["ownerProjection"] ? BidSplitProjection.fromJS(_data["ownerProjection"]) : <any>null;
            this.tenantProjection = _data["tenantProjection"] ? BidSplitProjection.fromJS(_data["tenantProjection"]) : <any>null;
        }
    }

    static fromJS(data: any): BidSplitSummary {
        data = typeof data === 'object' ? data : {};
        let result = new BidSplitSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["splitId"] = this.splitId !== undefined ? this.splitId : <any>null;
        data["ownerProjection"] = this.ownerProjection ? this.ownerProjection.toJSON() : <any>null;
        data["tenantProjection"] = this.tenantProjection ? this.tenantProjection.toJSON() : <any>null;
        return data;
    }
}

export interface IBidSplitSummary {
    splitId: string;
    ownerProjection: IBidSplitProjection | null;
    tenantProjection: IBidSplitProjection | null;
}

export class BidSplitProjection implements IBidSplitProjection {
    bidId: string;
    splitId: string;
    friendlyId: string | null;
    party: SplitDocumentParty;
    amount: number;
    [immerable] = true;

    constructor(data?: IBidSplitProjection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
            this.splitId = _data["splitId"] !== undefined ? _data["splitId"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.party = _data["party"] !== undefined ? _data["party"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): BidSplitProjection {
        data = typeof data === 'object' ? data : {};
        let result = new BidSplitProjection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        data["splitId"] = this.splitId !== undefined ? this.splitId : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["party"] = this.party !== undefined ? this.party : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface IBidSplitProjection {
    bidId: string;
    splitId: string;
    friendlyId: string | null;
    party: SplitDocumentParty;
    amount: number;
}

export enum BidAction {
    ViewDetails = 0,
    Uninvite = 1,
    Edit = 2,
    Accept = 3,
    Reject = 4,
    Elevate = 5,
    Revise = 6,
    AcceptRevision = 7,
    ForceAcceptRevision = 8,
    RequestChanges = 9,
    AcceptChanges = 10,
    ForceAcceptChanges = 11,
    DeclineChanges = 12,
    Split = 13,
    UpdateSplit = 14,
}

export class InvoiceSummary implements IInvoiceSummary {
    id: string;
    issueId: string;
    isPartial: boolean;
    friendlyId: string | null;
    reviewerNotes: string | null;
    notes: string | null;
    status: InvoiceStatus;
    totals: DocumentTotals | null;
    referenceDate: Instant | null;
    createdAt: Date;
    outstanding: number | null;
    [immerable] = true;

    constructor(data?: IInvoiceSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.totals = data.totals && !(<any>data.totals).toJSON ? new DocumentTotals(data.totals) : <DocumentTotals>this.totals;
            this.referenceDate = data.referenceDate && !(<any>data.referenceDate).toJSON ? new Instant(data.referenceDate) : <Instant>this.referenceDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.isPartial = _data["isPartial"] !== undefined ? _data["isPartial"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.reviewerNotes = _data["reviewerNotes"] !== undefined ? _data["reviewerNotes"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.totals = _data["totals"] ? DocumentTotals.fromJS(_data["totals"]) : <any>null;
            this.referenceDate = _data["referenceDate"] ? Instant.fromJS(_data["referenceDate"]) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.outstanding = _data["outstanding"] !== undefined ? _data["outstanding"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceSummary {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["isPartial"] = this.isPartial !== undefined ? this.isPartial : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["reviewerNotes"] = this.reviewerNotes !== undefined ? this.reviewerNotes : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["totals"] = this.totals ? this.totals.toJSON() : <any>null;
        data["referenceDate"] = this.referenceDate ? this.referenceDate.toJSON() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["outstanding"] = this.outstanding !== undefined ? this.outstanding : <any>null;
        return data;
    }
}

export interface IInvoiceSummary {
    id: string;
    issueId: string;
    isPartial: boolean;
    friendlyId: string | null;
    reviewerNotes: string | null;
    notes: string | null;
    status: InvoiceStatus;
    totals: IDocumentTotals | null;
    referenceDate: IInstant | null;
    createdAt: Date;
    outstanding: number | null;
}

export class Invoice extends InvoiceSummary implements IInvoice {
    vendor: Vendor | null;
    lines: DocumentLineItem[] | null;
    pdfFile: AttachmentFile | null;
    split: InvoiceSplitSummary | null;
    [immerable] = true;

    constructor(data?: IInvoice) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
            this.vendor = data.vendor && !(<any>data.vendor).toJSON ? new Vendor(data.vendor) : <Vendor>this.vendor;
            this.pdfFile = data.pdfFile && !(<any>data.pdfFile).toJSON ? new AttachmentFile(data.pdfFile) : <AttachmentFile>this.pdfFile;
            this.split = data.split && !(<any>data.split).toJSON ? new InvoiceSplitSummary(data.split) : <InvoiceSplitSummary>this.split;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(DocumentLineItem.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
            this.pdfFile = _data["pdfFile"] ? AttachmentFile.fromJS(_data["pdfFile"]) : <any>null;
            this.split = _data["split"] ? InvoiceSplitSummary.fromJS(_data["split"]) : <any>null;
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["pdfFile"] = this.pdfFile ? this.pdfFile.toJSON() : <any>null;
        data["split"] = this.split ? this.split.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoice extends IInvoiceSummary {
    vendor: IVendor | null;
    lines: DocumentLineItem[] | null;
    pdfFile: IAttachmentFile | null;
    split: IInvoiceSplitSummary | null;
}

export class InvoiceSplitSummary implements IInvoiceSplitSummary {
    splitId: string;
    ownerProjection: InvoiceSplitProjection | null;
    tenantProjection: InvoiceSplitProjection | null;
    [immerable] = true;

    constructor(data?: IInvoiceSplitSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.ownerProjection = data.ownerProjection && !(<any>data.ownerProjection).toJSON ? new InvoiceSplitProjection(data.ownerProjection) : <InvoiceSplitProjection>this.ownerProjection;
            this.tenantProjection = data.tenantProjection && !(<any>data.tenantProjection).toJSON ? new InvoiceSplitProjection(data.tenantProjection) : <InvoiceSplitProjection>this.tenantProjection;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.splitId = _data["splitId"] !== undefined ? _data["splitId"] : <any>null;
            this.ownerProjection = _data["ownerProjection"] ? InvoiceSplitProjection.fromJS(_data["ownerProjection"]) : <any>null;
            this.tenantProjection = _data["tenantProjection"] ? InvoiceSplitProjection.fromJS(_data["tenantProjection"]) : <any>null;
        }
    }

    static fromJS(data: any): InvoiceSplitSummary {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSplitSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["splitId"] = this.splitId !== undefined ? this.splitId : <any>null;
        data["ownerProjection"] = this.ownerProjection ? this.ownerProjection.toJSON() : <any>null;
        data["tenantProjection"] = this.tenantProjection ? this.tenantProjection.toJSON() : <any>null;
        return data;
    }
}

export interface IInvoiceSplitSummary {
    splitId: string;
    ownerProjection: IInvoiceSplitProjection | null;
    tenantProjection: IInvoiceSplitProjection | null;
}

export class InvoiceSplitProjection implements IInvoiceSplitProjection {
    invoiceId: string;
    splitId: string;
    friendlyId: string | null;
    party: SplitDocumentParty;
    amount: number;
    [immerable] = true;

    constructor(data?: IInvoiceSplitProjection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.splitId = _data["splitId"] !== undefined ? _data["splitId"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.party = _data["party"] !== undefined ? _data["party"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceSplitProjection {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSplitProjection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["splitId"] = this.splitId !== undefined ? this.splitId : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["party"] = this.party !== undefined ? this.party : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface IInvoiceSplitProjection {
    invoiceId: string;
    splitId: string;
    friendlyId: string | null;
    party: SplitDocumentParty;
    amount: number;
}

export class ChecklistLine implements IChecklistLine {
    id: string;
    description: string | null;
    isComplete: boolean;
    notes: string | null;
    initialValue: number | null;
    value: number | null;
    order: number;
    entitySourceType: LineSource;
    entitySourceId: string | null;
    beforeFiles: AttachmentFile[] | null;
    afterFiles: AttachmentFile[] | null;
    [immerable] = true;

    constructor(data?: IChecklistLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.beforeFiles) {
                this.beforeFiles = [];
                for (let i = 0; i < data.beforeFiles.length; i++) {
                    let item = data.beforeFiles[i];
                    this.beforeFiles[i] = item && !(<any>item).toJSON ? new AttachmentFile(item) : <AttachmentFile>item;
                }
            }
            if (data.afterFiles) {
                this.afterFiles = [];
                for (let i = 0; i < data.afterFiles.length; i++) {
                    let item = data.afterFiles[i];
                    this.afterFiles[i] = item && !(<any>item).toJSON ? new AttachmentFile(item) : <AttachmentFile>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isComplete = _data["isComplete"] !== undefined ? _data["isComplete"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.initialValue = _data["initialValue"] !== undefined ? _data["initialValue"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.entitySourceType = _data["entitySourceType"] !== undefined ? _data["entitySourceType"] : <any>null;
            this.entitySourceId = _data["entitySourceId"] !== undefined ? _data["entitySourceId"] : <any>null;
            if (Array.isArray(_data["beforeFiles"])) {
                this.beforeFiles = [] as any;
                for (let item of _data["beforeFiles"])
                    this.beforeFiles!.push(AttachmentFile.fromJS(item));
            }
            else {
                this.beforeFiles = <any>null;
            }
            if (Array.isArray(_data["afterFiles"])) {
                this.afterFiles = [] as any;
                for (let item of _data["afterFiles"])
                    this.afterFiles!.push(AttachmentFile.fromJS(item));
            }
            else {
                this.afterFiles = <any>null;
            }
        }
    }

    static fromJS(data: any): ChecklistLine {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isComplete"] = this.isComplete !== undefined ? this.isComplete : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["initialValue"] = this.initialValue !== undefined ? this.initialValue : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["entitySourceType"] = this.entitySourceType !== undefined ? this.entitySourceType : <any>null;
        data["entitySourceId"] = this.entitySourceId !== undefined ? this.entitySourceId : <any>null;
        if (Array.isArray(this.beforeFiles)) {
            data["beforeFiles"] = [];
            for (let item of this.beforeFiles)
                data["beforeFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.afterFiles)) {
            data["afterFiles"] = [];
            for (let item of this.afterFiles)
                data["afterFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChecklistLine {
    id: string;
    description: string | null;
    isComplete: boolean;
    notes: string | null;
    initialValue: number | null;
    value: number | null;
    order: number;
    entitySourceType: LineSource;
    entitySourceId: string | null;
    beforeFiles: IAttachmentFile[] | null;
    afterFiles: IAttachmentFile[] | null;
}

export enum IssueAction {
    RequestBid = 0,
    ManageSubissues = 1,
    ChangeBidSchedulingReq = 2,
    AcceptAssignment = 3,
    DeclineAssignment = 4,
    SetTentativeSchedule = 5,
    SetFinalSchedule = 6,
    CreateChangeRequest = 7,
    CompleteWork = 8,
    Reschedule = 9,
    SkipEstimation = 10,
    SkipScheduling = 11,
    CreateInvoice = 12,
    VendorCancel = 13,
    AcceptMultiAssignment = 14,
    DeclineMultiAssignment = 15,
    CreateBid = 16,
    SkipBidding = 17,
    ToggleEstimateSent = 18,
    CreatePartialInvoice = 19,
}

export enum IssueFlag {
    SingleBidder = 0,
}

export class Payment implements IPayment {
    id: string;
    amount: number;
    notes: string | null;
    date: Instant | null;
    allocated: number;
    vendorId: string;
    issueId: string | null;
    invoices: PaymentInvoice[] | null;
    paymentSource: PaymentSource;
    status: PaymentStatus;
    [immerable] = true;

    constructor(data?: IPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.date = data.date && !(<any>data.date).toJSON ? new Instant(data.date) : <Instant>this.date;
            if (data.invoices) {
                this.invoices = [];
                for (let i = 0; i < data.invoices.length; i++) {
                    let item = data.invoices[i];
                    this.invoices[i] = item && !(<any>item).toJSON ? new PaymentInvoice(item) : <PaymentInvoice>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.date = _data["date"] ? Instant.fromJS(_data["date"]) : <any>null;
            this.allocated = _data["allocated"] !== undefined ? _data["allocated"] : <any>null;
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(PaymentInvoice.fromJS(item));
            }
            else {
                this.invoices = <any>null;
            }
            this.paymentSource = _data["paymentSource"] !== undefined ? _data["paymentSource"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): Payment {
        data = typeof data === 'object' ? data : {};
        let result = new Payment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["date"] = this.date ? this.date.toJSON() : <any>null;
        data["allocated"] = this.allocated !== undefined ? this.allocated : <any>null;
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["paymentSource"] = this.paymentSource !== undefined ? this.paymentSource : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IPayment {
    id: string;
    amount: number;
    notes: string | null;
    date: IInstant | null;
    allocated: number;
    vendorId: string;
    issueId: string | null;
    invoices: IPaymentInvoice[] | null;
    paymentSource: PaymentSource;
    status: PaymentStatus;
}

export class PaymentInvoice implements IPaymentInvoice {
    paymentId: string;
    invoiceId: string;
    allocatedAmount: number;
    [immerable] = true;

    constructor(data?: IPaymentInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"] !== undefined ? _data["paymentId"] : <any>null;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.allocatedAmount = _data["allocatedAmount"] !== undefined ? _data["allocatedAmount"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId !== undefined ? this.paymentId : <any>null;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["allocatedAmount"] = this.allocatedAmount !== undefined ? this.allocatedAmount : <any>null;
        return data;
    }
}

export interface IPaymentInvoice {
    paymentId: string;
    invoiceId: string;
    allocatedAmount: number;
}

export enum PaymentSource {
    Unknown = 0,
    AutomatedIssuePaid = 1,
    AutomatedInvoicePaid = 2,
    Manual = 3,
    Dwolla = 4,
    AutomatedInvoicePaidReporting = 5,
    Stripe = 6,
}

export enum PaymentStatus {
    Unknown = 0,
    PaymentSent = 1,
    Paid = 2,
    Failed = 3,
}

export class ReviewDirectAssignmentPayload implements IReviewDirectAssignmentPayload {
    issueId: string;
    action: ReviewDirectAssignmentAction;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IReviewDirectAssignmentPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): ReviewDirectAssignmentPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewDirectAssignmentPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IReviewDirectAssignmentPayload {
    issueId: string;
    action: ReviewDirectAssignmentAction;
    notes: string | null;
}

export enum ReviewDirectAssignmentAction {
    Accept = 0,
    Reject = 1,
}

export class AssignIssuePayload implements IAssignIssuePayload {
    issueId: string;
    vendorId: string;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IAssignIssuePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): AssignIssuePayload {
        data = typeof data === 'object' ? data : {};
        let result = new AssignIssuePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IAssignIssuePayload {
    issueId: string;
    vendorId: string;
    notes: string | null;
}

export class CloneIssueResult implements ICloneIssueResult {
    newIssueId: string;
    workorderId: string;
    [immerable] = true;

    constructor(data?: ICloneIssueResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newIssueId = _data["newIssueId"] !== undefined ? _data["newIssueId"] : <any>null;
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
        }
    }

    static fromJS(data: any): CloneIssueResult {
        data = typeof data === 'object' ? data : {};
        let result = new CloneIssueResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newIssueId"] = this.newIssueId !== undefined ? this.newIssueId : <any>null;
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        return data;
    }
}

export interface ICloneIssueResult {
    newIssueId: string;
    workorderId: string;
}

export class UnassignIssuePayload implements IUnassignIssuePayload {
    issueId: string;
    [immerable] = true;

    constructor(data?: IUnassignIssuePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
        }
    }

    static fromJS(data: any): UnassignIssuePayload {
        data = typeof data === 'object' ? data : {};
        let result = new UnassignIssuePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        return data;
    }
}

export interface IUnassignIssuePayload {
    issueId: string;
}

export class InviteVendorsPayload implements IInviteVendorsPayload {
    vendorIds: string[] | null;
    issueId: string;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IInviteVendorsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            else {
                this.vendorIds = <any>null;
            }
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): InviteVendorsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new InviteVendorsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IInviteVendorsPayload {
    vendorIds: string[] | null;
    issueId: string;
    notes: string | null;
}

export class ReviewCandidateInvitationPayload implements IReviewCandidateInvitationPayload {
    issueId: string;
    candidacyId: string;
    action: ReviewInvitationAction;
    [immerable] = true;

    constructor(data?: IReviewCandidateInvitationPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.candidacyId = _data["candidacyId"] !== undefined ? _data["candidacyId"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
        }
    }

    static fromJS(data: any): ReviewCandidateInvitationPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewCandidateInvitationPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["candidacyId"] = this.candidacyId !== undefined ? this.candidacyId : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        return data;
    }
}

export interface IReviewCandidateInvitationPayload {
    issueId: string;
    candidacyId: string;
    action: ReviewInvitationAction;
}

export enum ReviewInvitationAction {
    Accept = 0,
    Declined = 1,
}

export class BidDefaultsResponse implements IBidDefaultsResponse {
    startDate: Instant | null;
    endDate: Instant | null;
    meta: DocumentFormMeta | null;
    lineCollection: DocumentLineCollection | null;
    [immerable] = true;

    constructor(data?: IBidDefaultsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
            this.meta = data.meta && !(<any>data.meta).toJSON ? new DocumentFormMeta(data.meta) : <DocumentFormMeta>this.meta;
            this.lineCollection = data.lineCollection && !(<any>data.lineCollection).toJSON ? new DocumentLineCollection(data.lineCollection) : <DocumentLineCollection>this.lineCollection;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
            this.meta = _data["meta"] ? DocumentFormMeta.fromJS(_data["meta"]) : <any>null;
            this.lineCollection = _data["lineCollection"] ? DocumentLineCollection.fromJS(_data["lineCollection"]) : <any>null;
        }
    }

    static fromJS(data: any): BidDefaultsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BidDefaultsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        data["meta"] = this.meta ? this.meta.toJSON() : <any>null;
        data["lineCollection"] = this.lineCollection ? this.lineCollection.toJSON() : <any>null;
        return data;
    }
}

export interface IBidDefaultsResponse {
    startDate: IInstant | null;
    endDate: IInstant | null;
    meta: IDocumentFormMeta | null;
    lineCollection: IDocumentLineCollection | null;
}

export class DocumentFormMeta implements IDocumentFormMeta {
    previousDiscount: number | null;
    appliedMarkupPercent: number | null;
    withInitial: boolean;
    withTax: boolean;
    withResale: boolean;
    withDiscount: boolean;
    withAfterFiles: boolean;
    withPartial: boolean;
    [immerable] = true;

    constructor(data?: IDocumentFormMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousDiscount = _data["previousDiscount"] !== undefined ? _data["previousDiscount"] : <any>null;
            this.appliedMarkupPercent = _data["appliedMarkupPercent"] !== undefined ? _data["appliedMarkupPercent"] : <any>null;
            this.withInitial = _data["withInitial"] !== undefined ? _data["withInitial"] : <any>null;
            this.withTax = _data["withTax"] !== undefined ? _data["withTax"] : <any>null;
            this.withResale = _data["withResale"] !== undefined ? _data["withResale"] : <any>null;
            this.withDiscount = _data["withDiscount"] !== undefined ? _data["withDiscount"] : <any>null;
            this.withAfterFiles = _data["withAfterFiles"] !== undefined ? _data["withAfterFiles"] : <any>null;
            this.withPartial = _data["withPartial"] !== undefined ? _data["withPartial"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentFormMeta {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentFormMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousDiscount"] = this.previousDiscount !== undefined ? this.previousDiscount : <any>null;
        data["appliedMarkupPercent"] = this.appliedMarkupPercent !== undefined ? this.appliedMarkupPercent : <any>null;
        data["withInitial"] = this.withInitial !== undefined ? this.withInitial : <any>null;
        data["withTax"] = this.withTax !== undefined ? this.withTax : <any>null;
        data["withResale"] = this.withResale !== undefined ? this.withResale : <any>null;
        data["withDiscount"] = this.withDiscount !== undefined ? this.withDiscount : <any>null;
        data["withAfterFiles"] = this.withAfterFiles !== undefined ? this.withAfterFiles : <any>null;
        data["withPartial"] = this.withPartial !== undefined ? this.withPartial : <any>null;
        return data;
    }
}

export interface IDocumentFormMeta {
    previousDiscount: number | null;
    appliedMarkupPercent: number | null;
    withInitial: boolean;
    withTax: boolean;
    withResale: boolean;
    withDiscount: boolean;
    withAfterFiles: boolean;
    withPartial: boolean;
}

export class DocumentLineCollection implements IDocumentLineCollection {
    partialPercent: number | null;
    partialAmount: number | null;
    discountPercent: number | null;
    resaleTaxPercent: number | null;
    taxPercent: number | null;
    canAddLines: boolean;
    lineItems: FormDefaultsLineItem[] | null;
    [immerable] = true;

    constructor(data?: IDocumentLineCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partialPercent = _data["partialPercent"] !== undefined ? _data["partialPercent"] : <any>null;
            this.partialAmount = _data["partialAmount"] !== undefined ? _data["partialAmount"] : <any>null;
            this.discountPercent = _data["discountPercent"] !== undefined ? _data["discountPercent"] : <any>null;
            this.resaleTaxPercent = _data["resaleTaxPercent"] !== undefined ? _data["resaleTaxPercent"] : <any>null;
            this.taxPercent = _data["taxPercent"] !== undefined ? _data["taxPercent"] : <any>null;
            this.canAddLines = _data["canAddLines"] !== undefined ? _data["canAddLines"] : <any>null;
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(FormDefaultsLineItem.fromJS(item));
            }
            else {
                this.lineItems = <any>null;
            }
        }
    }

    static fromJS(data: any): DocumentLineCollection {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLineCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partialPercent"] = this.partialPercent !== undefined ? this.partialPercent : <any>null;
        data["partialAmount"] = this.partialAmount !== undefined ? this.partialAmount : <any>null;
        data["discountPercent"] = this.discountPercent !== undefined ? this.discountPercent : <any>null;
        data["resaleTaxPercent"] = this.resaleTaxPercent !== undefined ? this.resaleTaxPercent : <any>null;
        data["taxPercent"] = this.taxPercent !== undefined ? this.taxPercent : <any>null;
        data["canAddLines"] = this.canAddLines !== undefined ? this.canAddLines : <any>null;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentLineCollection {
    partialPercent: number | null;
    partialAmount: number | null;
    discountPercent: number | null;
    resaleTaxPercent: number | null;
    taxPercent: number | null;
    canAddLines: boolean;
    lineItems: FormDefaultsLineItem[] | null;
}

export class FormDefaultsLineItem extends LineItemBase implements IFormDefaultsLineItem {
    value: number | null;
    canEditDescription: boolean;
    canEditValue: boolean;
    beforeFiles: AttachmentFile[] | null;
    afterFiles: AttachmentFile[] | null;
    [immerable] = true;

    constructor(data?: IFormDefaultsLineItem) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.beforeFiles) {
                this.beforeFiles = [];
                for (let i = 0; i < data.beforeFiles.length; i++) {
                    let item = data.beforeFiles[i];
                    this.beforeFiles[i] = item && !(<any>item).toJSON ? new AttachmentFile(item) : <AttachmentFile>item;
                }
            }
            if (data.afterFiles) {
                this.afterFiles = [];
                for (let i = 0; i < data.afterFiles.length; i++) {
                    let item = data.afterFiles[i];
                    this.afterFiles[i] = item && !(<any>item).toJSON ? new AttachmentFile(item) : <AttachmentFile>item;
                }
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.canEditDescription = _data["canEditDescription"] !== undefined ? _data["canEditDescription"] : <any>null;
            this.canEditValue = _data["canEditValue"] !== undefined ? _data["canEditValue"] : <any>null;
            if (Array.isArray(_data["beforeFiles"])) {
                this.beforeFiles = [] as any;
                for (let item of _data["beforeFiles"])
                    this.beforeFiles!.push(AttachmentFile.fromJS(item));
            }
            else {
                this.beforeFiles = <any>null;
            }
            if (Array.isArray(_data["afterFiles"])) {
                this.afterFiles = [] as any;
                for (let item of _data["afterFiles"])
                    this.afterFiles!.push(AttachmentFile.fromJS(item));
            }
            else {
                this.afterFiles = <any>null;
            }
        }
    }

    static fromJS(data: any): FormDefaultsLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new FormDefaultsLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["canEditDescription"] = this.canEditDescription !== undefined ? this.canEditDescription : <any>null;
        data["canEditValue"] = this.canEditValue !== undefined ? this.canEditValue : <any>null;
        if (Array.isArray(this.beforeFiles)) {
            data["beforeFiles"] = [];
            for (let item of this.beforeFiles)
                data["beforeFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.afterFiles)) {
            data["afterFiles"] = [];
            for (let item of this.afterFiles)
                data["afterFiles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFormDefaultsLineItem extends ILineItemBase {
    value: number | null;
    canEditDescription: boolean;
    canEditValue: boolean;
    beforeFiles: IAttachmentFile[] | null;
    afterFiles: IAttachmentFile[] | null;
}

export class GetBidDefaultsPayload implements IGetBidDefaultsPayload {
    issueId: string;
    existingBidId: string;
    submissionType: BidSubmissionType;
    [immerable] = true;

    constructor(data?: IGetBidDefaultsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.existingBidId = _data["existingBidId"] !== undefined ? _data["existingBidId"] : <any>null;
            this.submissionType = _data["submissionType"] !== undefined ? _data["submissionType"] : <any>null;
        }
    }

    static fromJS(data: any): GetBidDefaultsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new GetBidDefaultsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["existingBidId"] = this.existingBidId !== undefined ? this.existingBidId : <any>null;
        data["submissionType"] = this.submissionType !== undefined ? this.submissionType : <any>null;
        return data;
    }
}

export interface IGetBidDefaultsPayload {
    issueId: string;
    existingBidId: string;
    submissionType: BidSubmissionType;
}

export enum BidSubmissionType {
    Submission = 0,
    Update = 1,
    Creation = 2,
    Revision = 3,
    ChangeRequest = 4,
}

export class BidComparison implements IBidComparison {
    lines: string[] | null;
    comparables: ComparisonEntry[] | null;
    taxPercent: number;
    discountPercent: number;
    [immerable] = true;

    constructor(data?: IBidComparison) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.comparables) {
                this.comparables = [];
                for (let i = 0; i < data.comparables.length; i++) {
                    let item = data.comparables[i];
                    this.comparables[i] = item && !(<any>item).toJSON ? new ComparisonEntry(item) : <ComparisonEntry>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(item);
            }
            else {
                this.lines = <any>null;
            }
            if (Array.isArray(_data["comparables"])) {
                this.comparables = [] as any;
                for (let item of _data["comparables"])
                    this.comparables!.push(ComparisonEntry.fromJS(item));
            }
            else {
                this.comparables = <any>null;
            }
            this.taxPercent = _data["taxPercent"] !== undefined ? _data["taxPercent"] : <any>null;
            this.discountPercent = _data["discountPercent"] !== undefined ? _data["discountPercent"] : <any>null;
        }
    }

    static fromJS(data: any): BidComparison {
        data = typeof data === 'object' ? data : {};
        let result = new BidComparison();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item);
        }
        if (Array.isArray(this.comparables)) {
            data["comparables"] = [];
            for (let item of this.comparables)
                data["comparables"].push(item.toJSON());
        }
        data["taxPercent"] = this.taxPercent !== undefined ? this.taxPercent : <any>null;
        data["discountPercent"] = this.discountPercent !== undefined ? this.discountPercent : <any>null;
        return data;
    }
}

export interface IBidComparison {
    lines: string[] | null;
    comparables: IComparisonEntry[] | null;
    taxPercent: number;
    discountPercent: number;
}

export class ComparisonEntry implements IComparisonEntry {
    vendor: VendorSummary | null;
    lines: DocumentLineItem[] | null;
    grandTotal: number;
    [immerable] = true;

    constructor(data?: IComparisonEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.vendor = data.vendor && !(<any>data.vendor).toJSON ? new VendorSummary(data.vendor) : <VendorSummary>this.vendor;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendor = _data["vendor"] ? VendorSummary.fromJS(_data["vendor"]) : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(DocumentLineItem.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
            this.grandTotal = _data["grandTotal"] !== undefined ? _data["grandTotal"] : <any>null;
        }
    }

    static fromJS(data: any): ComparisonEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ComparisonEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["grandTotal"] = this.grandTotal !== undefined ? this.grandTotal : <any>null;
        return data;
    }
}

export interface IComparisonEntry {
    vendor: IVendorSummary | null;
    lines: DocumentLineItem[] | null;
    grandTotal: number;
}

export class DeclineBidPayload implements IDeclineBidPayload {
    issueId: string;
    bidId: string;
    [immerable] = true;

    constructor(data?: IDeclineBidPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
        }
    }

    static fromJS(data: any): DeclineBidPayload {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineBidPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        return data;
    }
}

export interface IDeclineBidPayload {
    issueId: string;
    bidId: string;
}

export class SkipBiddingPayload implements ISkipBiddingPayload {
    issueId: string;
    notes: string | null;
    [immerable] = true;

    constructor(data?: ISkipBiddingPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): SkipBiddingPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SkipBiddingPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface ISkipBiddingPayload {
    issueId: string;
    notes: string | null;
}

export class UninviteBidderPayload implements IUninviteBidderPayload {
    issueId: string;
    bidId: string;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IUninviteBidderPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): UninviteBidderPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UninviteBidderPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IUninviteBidderPayload {
    issueId: string;
    bidId: string;
    notes: string | null;
}

export class SetBidSchedulePayload implements ISetBidSchedulePayload {
    proposalType: ProposalType;
    issueId: string;
    bidId: string;
    scheduledInstant: Instant | null;
    comments: string | null;
    timeBlocks: TimeBlock[] | null;
    [immerable] = true;

    constructor(data?: ISetBidSchedulePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.scheduledInstant = data.scheduledInstant && !(<any>data.scheduledInstant).toJSON ? new Instant(data.scheduledInstant) : <Instant>this.scheduledInstant;
            if (data.timeBlocks) {
                this.timeBlocks = [];
                for (let i = 0; i < data.timeBlocks.length; i++) {
                    let item = data.timeBlocks[i];
                    this.timeBlocks[i] = item && !(<any>item).toJSON ? new TimeBlock(item) : <TimeBlock>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proposalType = _data["proposalType"] !== undefined ? _data["proposalType"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
            this.scheduledInstant = _data["scheduledInstant"] ? Instant.fromJS(_data["scheduledInstant"]) : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            if (Array.isArray(_data["timeBlocks"])) {
                this.timeBlocks = [] as any;
                for (let item of _data["timeBlocks"])
                    this.timeBlocks!.push(TimeBlock.fromJS(item));
            }
            else {
                this.timeBlocks = <any>null;
            }
        }
    }

    static fromJS(data: any): SetBidSchedulePayload {
        data = typeof data === 'object' ? data : {};
        let result = new SetBidSchedulePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalType"] = this.proposalType !== undefined ? this.proposalType : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        data["scheduledInstant"] = this.scheduledInstant ? this.scheduledInstant.toJSON() : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        if (Array.isArray(this.timeBlocks)) {
            data["timeBlocks"] = [];
            for (let item of this.timeBlocks)
                data["timeBlocks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetBidSchedulePayload {
    proposalType: ProposalType;
    issueId: string;
    bidId: string;
    scheduledInstant: IInstant | null;
    comments: string | null;
    timeBlocks: ITimeBlock[] | null;
}

export class RequestBidsPayload implements IRequestBidsPayload {
    vendorIds: string[] | null;
    issueId: string;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IRequestBidsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            else {
                this.vendorIds = <any>null;
            }
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): RequestBidsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new RequestBidsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IRequestBidsPayload {
    vendorIds: string[] | null;
    issueId: string;
    notes: string | null;
}

export class SubmitBidPayload implements ISubmitBidPayload {
    bidId: string;
    submissionType: BidSubmissionType;
    issueId: string;
    startDate: Instant | null;
    endDate: Instant | null;
    taxPercent: number;
    discountPercent: number | null;
    resaleTaxPercent: number | null;
    revisionNotes: string | null;
    lineItems: FormSubmissionLineItem[] | null;
    [immerable] = true;

    constructor(data?: ISubmitBidPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
            this.submissionType = _data["submissionType"] !== undefined ? _data["submissionType"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
            this.taxPercent = _data["taxPercent"] !== undefined ? _data["taxPercent"] : <any>null;
            this.discountPercent = _data["discountPercent"] !== undefined ? _data["discountPercent"] : <any>null;
            this.resaleTaxPercent = _data["resaleTaxPercent"] !== undefined ? _data["resaleTaxPercent"] : <any>null;
            this.revisionNotes = _data["revisionNotes"] !== undefined ? _data["revisionNotes"] : <any>null;
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(FormSubmissionLineItem.fromJS(item));
            }
            else {
                this.lineItems = <any>null;
            }
        }
    }

    static fromJS(data: any): SubmitBidPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitBidPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        data["submissionType"] = this.submissionType !== undefined ? this.submissionType : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        data["taxPercent"] = this.taxPercent !== undefined ? this.taxPercent : <any>null;
        data["discountPercent"] = this.discountPercent !== undefined ? this.discountPercent : <any>null;
        data["resaleTaxPercent"] = this.resaleTaxPercent !== undefined ? this.resaleTaxPercent : <any>null;
        data["revisionNotes"] = this.revisionNotes !== undefined ? this.revisionNotes : <any>null;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubmitBidPayload {
    bidId: string;
    submissionType: BidSubmissionType;
    issueId: string;
    startDate: IInstant | null;
    endDate: IInstant | null;
    taxPercent: number;
    discountPercent: number | null;
    resaleTaxPercent: number | null;
    revisionNotes: string | null;
    lineItems: FormSubmissionLineItem[] | null;
}

export class FormSubmissionLineItem extends LineItemBase implements IFormSubmissionLineItem {
    value: number;
    order: number;
    beforeFileIds: string[] | null;
    afterFileIds: string[] | null;
    [immerable] = true;

    constructor(data?: IFormSubmissionLineItem) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            if (Array.isArray(_data["beforeFileIds"])) {
                this.beforeFileIds = [] as any;
                for (let item of _data["beforeFileIds"])
                    this.beforeFileIds!.push(item);
            }
            else {
                this.beforeFileIds = <any>null;
            }
            if (Array.isArray(_data["afterFileIds"])) {
                this.afterFileIds = [] as any;
                for (let item of _data["afterFileIds"])
                    this.afterFileIds!.push(item);
            }
            else {
                this.afterFileIds = <any>null;
            }
        }
    }

    static fromJS(data: any): FormSubmissionLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new FormSubmissionLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        if (Array.isArray(this.beforeFileIds)) {
            data["beforeFileIds"] = [];
            for (let item of this.beforeFileIds)
                data["beforeFileIds"].push(item);
        }
        if (Array.isArray(this.afterFileIds)) {
            data["afterFileIds"] = [];
            for (let item of this.afterFileIds)
                data["afterFileIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFormSubmissionLineItem extends ILineItemBase {
    value: number;
    order: number;
    beforeFileIds: string[] | null;
    afterFileIds: string[] | null;
}

export class ReviewBidPayload implements IReviewBidPayload {
    issueId: string;
    bidId: string;
    action: ReviewBidAction;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IReviewBidPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): ReviewBidPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewBidPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IReviewBidPayload {
    issueId: string;
    bidId: string;
    action: ReviewBidAction;
    notes: string | null;
}

export enum ReviewBidAction {
    Accept = 0,
    AcceptRevision = 1,
    AcceptChanges = 2,
    DeclineChanges = 3,
    Reject = 4,
    Elevate = 5,
    ForceAcceptRevision = 6,
    ForceAcceptChanges = 7,
}

export class SetRequireScheduleBeforeBidPayload implements ISetRequireScheduleBeforeBidPayload {
    issueId: string;
    enabled: boolean;
    [immerable] = true;

    constructor(data?: ISetRequireScheduleBeforeBidPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : <any>null;
        }
    }

    static fromJS(data: any): SetRequireScheduleBeforeBidPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SetRequireScheduleBeforeBidPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        return data;
    }
}

export interface ISetRequireScheduleBeforeBidPayload {
    issueId: string;
    enabled: boolean;
}

export class UpdateBidSplitPayload implements IUpdateBidSplitPayload {
    bidId: string;
    existingSplitId: string | null;
    lines: BidSplitLineWriteModel[] | null;
    [immerable] = true;

    constructor(data?: IUpdateBidSplitPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.lines) {
                this.lines = [];
                for (let i = 0; i < data.lines.length; i++) {
                    let item = data.lines[i];
                    this.lines[i] = item && !(<any>item).toJSON ? new BidSplitLineWriteModel(item) : <BidSplitLineWriteModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
            this.existingSplitId = _data["existingSplitId"] !== undefined ? _data["existingSplitId"] : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(BidSplitLineWriteModel.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateBidSplitPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBidSplitPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        data["existingSplitId"] = this.existingSplitId !== undefined ? this.existingSplitId : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateBidSplitPayload {
    bidId: string;
    existingSplitId: string | null;
    lines: IBidSplitLineWriteModel[] | null;
}

export class BidSplitLineWriteModel implements IBidSplitLineWriteModel {
    lineId: string;
    lineDescription: string | null;
    isOwner: boolean;
    isTenant: boolean;
    amount: number;
    [immerable] = true;

    constructor(data?: IBidSplitLineWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"] !== undefined ? _data["lineId"] : <any>null;
            this.lineDescription = _data["lineDescription"] !== undefined ? _data["lineDescription"] : <any>null;
            this.isOwner = _data["isOwner"] !== undefined ? _data["isOwner"] : <any>null;
            this.isTenant = _data["isTenant"] !== undefined ? _data["isTenant"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): BidSplitLineWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new BidSplitLineWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId !== undefined ? this.lineId : <any>null;
        data["lineDescription"] = this.lineDescription !== undefined ? this.lineDescription : <any>null;
        data["isOwner"] = this.isOwner !== undefined ? this.isOwner : <any>null;
        data["isTenant"] = this.isTenant !== undefined ? this.isTenant : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface IBidSplitLineWriteModel {
    lineId: string;
    lineDescription: string | null;
    isOwner: boolean;
    isTenant: boolean;
    amount: number;
}

export class GetDataForBidSplitResponse implements IGetDataForBidSplitResponse {
    existingSplitId: string | null;
    bidId: string;
    lines: BidSplitLineReadModel[] | null;
    [immerable] = true;

    constructor(data?: IGetDataForBidSplitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.lines) {
                this.lines = [];
                for (let i = 0; i < data.lines.length; i++) {
                    let item = data.lines[i];
                    this.lines[i] = item && !(<any>item).toJSON ? new BidSplitLineReadModel(item) : <BidSplitLineReadModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.existingSplitId = _data["existingSplitId"] !== undefined ? _data["existingSplitId"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(BidSplitLineReadModel.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDataForBidSplitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataForBidSplitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existingSplitId"] = this.existingSplitId !== undefined ? this.existingSplitId : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDataForBidSplitResponse {
    existingSplitId: string | null;
    bidId: string;
    lines: IBidSplitLineReadModel[] | null;
}

export class BidSplitLineReadModel implements IBidSplitLineReadModel {
    lineId: string;
    description: string | null;
    amount: number;
    isOwner: boolean | null;
    isTenant: boolean | null;
    [immerable] = true;

    constructor(data?: IBidSplitLineReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"] !== undefined ? _data["lineId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.isOwner = _data["isOwner"] !== undefined ? _data["isOwner"] : <any>null;
            this.isTenant = _data["isTenant"] !== undefined ? _data["isTenant"] : <any>null;
        }
    }

    static fromJS(data: any): BidSplitLineReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new BidSplitLineReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId !== undefined ? this.lineId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["isOwner"] = this.isOwner !== undefined ? this.isOwner : <any>null;
        data["isTenant"] = this.isTenant !== undefined ? this.isTenant : <any>null;
        return data;
    }
}

export interface IBidSplitLineReadModel {
    lineId: string;
    description: string | null;
    amount: number;
    isOwner: boolean | null;
    isTenant: boolean | null;
}

export class ChangeRequestDefaultsResponse implements IChangeRequestDefaultsResponse {
    changeRequestId: string | null;
    notes: string | null;
    completionDate: Instant | null;
    meta: DocumentFormMeta | null;
    lineCollection: ChangeRequestLineCollection | null;
    [immerable] = true;

    constructor(data?: IChangeRequestDefaultsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.completionDate = data.completionDate && !(<any>data.completionDate).toJSON ? new Instant(data.completionDate) : <Instant>this.completionDate;
            this.meta = data.meta && !(<any>data.meta).toJSON ? new DocumentFormMeta(data.meta) : <DocumentFormMeta>this.meta;
            this.lineCollection = data.lineCollection && !(<any>data.lineCollection).toJSON ? new ChangeRequestLineCollection(data.lineCollection) : <ChangeRequestLineCollection>this.lineCollection;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.completionDate = _data["completionDate"] ? Instant.fromJS(_data["completionDate"]) : <any>null;
            this.meta = _data["meta"] ? DocumentFormMeta.fromJS(_data["meta"]) : <any>null;
            this.lineCollection = _data["lineCollection"] ? ChangeRequestLineCollection.fromJS(_data["lineCollection"]) : <any>null;
        }
    }

    static fromJS(data: any): ChangeRequestDefaultsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestDefaultsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["completionDate"] = this.completionDate ? this.completionDate.toJSON() : <any>null;
        data["meta"] = this.meta ? this.meta.toJSON() : <any>null;
        data["lineCollection"] = this.lineCollection ? this.lineCollection.toJSON() : <any>null;
        return data;
    }
}

export interface IChangeRequestDefaultsResponse {
    changeRequestId: string | null;
    notes: string | null;
    completionDate: IInstant | null;
    meta: IDocumentFormMeta | null;
    lineCollection: IChangeRequestLineCollection | null;
}

export class ChangeRequestLineCollection implements IChangeRequestLineCollection {
    discountPercent: number | null;
    taxPercent: number | null;
    lineItems: FormDefaultsLineItem[] | null;
    [immerable] = true;

    constructor(data?: IChangeRequestLineCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discountPercent = _data["discountPercent"] !== undefined ? _data["discountPercent"] : <any>null;
            this.taxPercent = _data["taxPercent"] !== undefined ? _data["taxPercent"] : <any>null;
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(FormDefaultsLineItem.fromJS(item));
            }
            else {
                this.lineItems = <any>null;
            }
        }
    }

    static fromJS(data: any): ChangeRequestLineCollection {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestLineCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountPercent"] = this.discountPercent !== undefined ? this.discountPercent : <any>null;
        data["taxPercent"] = this.taxPercent !== undefined ? this.taxPercent : <any>null;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChangeRequestLineCollection {
    discountPercent: number | null;
    taxPercent: number | null;
    lineItems: FormDefaultsLineItem[] | null;
}

export class GetChangeRequestDefaultsPayload implements IGetChangeRequestDefaultsPayload {
    issueId: string;
    existingChangeRequestId: string | null;
    includedDocuments: IncludedDocument[] | null;
    [immerable] = true;

    constructor(data?: IGetChangeRequestDefaultsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.includedDocuments) {
                this.includedDocuments = [];
                for (let i = 0; i < data.includedDocuments.length; i++) {
                    let item = data.includedDocuments[i];
                    this.includedDocuments[i] = item && !(<any>item).toJSON ? new IncludedDocument(item) : <IncludedDocument>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.existingChangeRequestId = _data["existingChangeRequestId"] !== undefined ? _data["existingChangeRequestId"] : <any>null;
            if (Array.isArray(_data["includedDocuments"])) {
                this.includedDocuments = [] as any;
                for (let item of _data["includedDocuments"])
                    this.includedDocuments!.push(IncludedDocument.fromJS(item));
            }
            else {
                this.includedDocuments = <any>null;
            }
        }
    }

    static fromJS(data: any): GetChangeRequestDefaultsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new GetChangeRequestDefaultsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["existingChangeRequestId"] = this.existingChangeRequestId !== undefined ? this.existingChangeRequestId : <any>null;
        if (Array.isArray(this.includedDocuments)) {
            data["includedDocuments"] = [];
            for (let item of this.includedDocuments)
                data["includedDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetChangeRequestDefaultsPayload {
    issueId: string;
    existingChangeRequestId: string | null;
    includedDocuments: IIncludedDocument[] | null;
}

export class IncludedDocument implements IIncludedDocument {
    documentType: DocumentType;
    documentId: string;
    [immerable] = true;

    constructor(data?: IIncludedDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.documentId = _data["documentId"] !== undefined ? _data["documentId"] : <any>null;
        }
    }

    static fromJS(data: any): IncludedDocument {
        data = typeof data === 'object' ? data : {};
        let result = new IncludedDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["documentId"] = this.documentId !== undefined ? this.documentId : <any>null;
        return data;
    }
}

export interface IIncludedDocument {
    documentType: DocumentType;
    documentId: string;
}

export enum DocumentType {
    Bid = 3,
    Invoice = 4,
    ChangeRequest = 5,
    Estimate = 9,
}

export class ChangeRequestIncludeCandidate implements IChangeRequestIncludeCandidate {
    type: DocumentType;
    documentId: string;
    issueId: string;
    documentFriendlyId: string | null;
    issueFriendlyId: string | null;
    totals: DocumentTotals | null;
    lineCount: number;
    [immerable] = true;

    constructor(data?: IChangeRequestIncludeCandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.totals = data.totals && !(<any>data.totals).toJSON ? new DocumentTotals(data.totals) : <DocumentTotals>this.totals;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.documentId = _data["documentId"] !== undefined ? _data["documentId"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.documentFriendlyId = _data["documentFriendlyId"] !== undefined ? _data["documentFriendlyId"] : <any>null;
            this.issueFriendlyId = _data["issueFriendlyId"] !== undefined ? _data["issueFriendlyId"] : <any>null;
            this.totals = _data["totals"] ? DocumentTotals.fromJS(_data["totals"]) : <any>null;
            this.lineCount = _data["lineCount"] !== undefined ? _data["lineCount"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeRequestIncludeCandidate {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestIncludeCandidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["documentId"] = this.documentId !== undefined ? this.documentId : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["documentFriendlyId"] = this.documentFriendlyId !== undefined ? this.documentFriendlyId : <any>null;
        data["issueFriendlyId"] = this.issueFriendlyId !== undefined ? this.issueFriendlyId : <any>null;
        data["totals"] = this.totals ? this.totals.toJSON() : <any>null;
        data["lineCount"] = this.lineCount !== undefined ? this.lineCount : <any>null;
        return data;
    }
}

export interface IChangeRequestIncludeCandidate {
    type: DocumentType;
    documentId: string;
    issueId: string;
    documentFriendlyId: string | null;
    issueFriendlyId: string | null;
    totals: IDocumentTotals | null;
    lineCount: number;
}

export class CreateOrUpdateChangeRequestPayload implements ICreateOrUpdateChangeRequestPayload {
    issueId: string;
    changeRequestId: string | null;
    taxPercent: number;
    discountPercent: number | null;
    notes: string | null;
    action: ModifyChangeRequestAction;
    completionDate: Instant | null;
    lines: FormSubmissionLineItem[] | null;
    [immerable] = true;

    constructor(data?: ICreateOrUpdateChangeRequestPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.completionDate = data.completionDate && !(<any>data.completionDate).toJSON ? new Instant(data.completionDate) : <Instant>this.completionDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
            this.taxPercent = _data["taxPercent"] !== undefined ? _data["taxPercent"] : <any>null;
            this.discountPercent = _data["discountPercent"] !== undefined ? _data["discountPercent"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.completionDate = _data["completionDate"] ? Instant.fromJS(_data["completionDate"]) : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(FormSubmissionLineItem.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateChangeRequestPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateChangeRequestPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        data["taxPercent"] = this.taxPercent !== undefined ? this.taxPercent : <any>null;
        data["discountPercent"] = this.discountPercent !== undefined ? this.discountPercent : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["completionDate"] = this.completionDate ? this.completionDate.toJSON() : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateChangeRequestPayload {
    issueId: string;
    changeRequestId: string | null;
    taxPercent: number;
    discountPercent: number | null;
    notes: string | null;
    action: ModifyChangeRequestAction;
    completionDate: IInstant | null;
    lines: FormSubmissionLineItem[] | null;
}

export enum ModifyChangeRequestAction {
    SaveDraft = 0,
    SavePublished = 1,
}

export class PublishChangeRequestPayload implements IPublishChangeRequestPayload {
    changeRequestId: string;
    issueId: string;
    [immerable] = true;

    constructor(data?: IPublishChangeRequestPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
        }
    }

    static fromJS(data: any): PublishChangeRequestPayload {
        data = typeof data === 'object' ? data : {};
        let result = new PublishChangeRequestPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        return data;
    }
}

export interface IPublishChangeRequestPayload {
    changeRequestId: string;
    issueId: string;
}

export class ReviewChangeRequestPayload implements IReviewChangeRequestPayload {
    changeRequestId: string;
    issueId: string;
    action: ReviewChangeRequestAction;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IReviewChangeRequestPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): ReviewChangeRequestPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewChangeRequestPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IReviewChangeRequestPayload {
    changeRequestId: string;
    issueId: string;
    action: ReviewChangeRequestAction;
    notes: string | null;
}

export enum ReviewChangeRequestAction {
    Accept = 0,
    Reject = 1,
    Elevate = 2,
    ForceAccept = 3,
}

export class DeleteChangeRequestPayload implements IDeleteChangeRequestPayload {
    issueId: string;
    changeRequestId: string;
    [immerable] = true;

    constructor(data?: IDeleteChangeRequestPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteChangeRequestPayload {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteChangeRequestPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        return data;
    }
}

export interface IDeleteChangeRequestPayload {
    issueId: string;
    changeRequestId: string;
}

export class CreateOrUpdateEstimatePayload implements ICreateOrUpdateEstimatePayload {
    issueId: string;
    estimateId: string | null;
    discountPercent: number | null;
    taxPercent: number;
    lines: FormSubmissionLineItem[] | null;
    startDate: Instant | null;
    endDate: Instant | null;
    [immerable] = true;

    constructor(data?: ICreateOrUpdateEstimatePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            this.discountPercent = _data["discountPercent"] !== undefined ? _data["discountPercent"] : <any>null;
            this.taxPercent = _data["taxPercent"] !== undefined ? _data["taxPercent"] : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(FormSubmissionLineItem.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateOrUpdateEstimatePayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEstimatePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        data["discountPercent"] = this.discountPercent !== undefined ? this.discountPercent : <any>null;
        data["taxPercent"] = this.taxPercent !== undefined ? this.taxPercent : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateOrUpdateEstimatePayload {
    issueId: string;
    estimateId: string | null;
    discountPercent: number | null;
    taxPercent: number;
    lines: FormSubmissionLineItem[] | null;
    startDate: IInstant | null;
    endDate: IInstant | null;
}

export class PublishEstimatePayload implements IPublishEstimatePayload {
    estimateId: string;
    issueId: string;
    [immerable] = true;

    constructor(data?: IPublishEstimatePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
        }
    }

    static fromJS(data: any): PublishEstimatePayload {
        data = typeof data === 'object' ? data : {};
        let result = new PublishEstimatePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        return data;
    }
}

export interface IPublishEstimatePayload {
    estimateId: string;
    issueId: string;
}

export class ReviewEstimatePayload implements IReviewEstimatePayload {
    issueId: string;
    estimateId: string;
    action: ReviewEstimateAction;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IReviewEstimatePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): ReviewEstimatePayload {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewEstimatePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IReviewEstimatePayload {
    issueId: string;
    estimateId: string;
    action: ReviewEstimateAction;
    notes: string | null;
}

export enum ReviewEstimateAction {
    Accept = 0,
    Reject = 1,
    ForceAccept = 2,
}

export class SkipEstimationPayload implements ISkipEstimationPayload {
    issueId: string;
    notes: string | null;
    [immerable] = true;

    constructor(data?: ISkipEstimationPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): SkipEstimationPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SkipEstimationPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface ISkipEstimationPayload {
    issueId: string;
    notes: string | null;
}

export class UpdateEstimateSplitPayload implements IUpdateEstimateSplitPayload {
    estimateId: string;
    existingSplitId: string | null;
    lines: EstimateSplitLineWriteModel[] | null;
    [immerable] = true;

    constructor(data?: IUpdateEstimateSplitPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.lines) {
                this.lines = [];
                for (let i = 0; i < data.lines.length; i++) {
                    let item = data.lines[i];
                    this.lines[i] = item && !(<any>item).toJSON ? new EstimateSplitLineWriteModel(item) : <EstimateSplitLineWriteModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            this.existingSplitId = _data["existingSplitId"] !== undefined ? _data["existingSplitId"] : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(EstimateSplitLineWriteModel.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateEstimateSplitPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEstimateSplitPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        data["existingSplitId"] = this.existingSplitId !== undefined ? this.existingSplitId : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateEstimateSplitPayload {
    estimateId: string;
    existingSplitId: string | null;
    lines: IEstimateSplitLineWriteModel[] | null;
}

export class EstimateSplitLineWriteModel implements IEstimateSplitLineWriteModel {
    lineId: string;
    lineDescription: string | null;
    isOwner: boolean;
    isTenant: boolean;
    amount: number;
    [immerable] = true;

    constructor(data?: IEstimateSplitLineWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"] !== undefined ? _data["lineId"] : <any>null;
            this.lineDescription = _data["lineDescription"] !== undefined ? _data["lineDescription"] : <any>null;
            this.isOwner = _data["isOwner"] !== undefined ? _data["isOwner"] : <any>null;
            this.isTenant = _data["isTenant"] !== undefined ? _data["isTenant"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): EstimateSplitLineWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new EstimateSplitLineWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId !== undefined ? this.lineId : <any>null;
        data["lineDescription"] = this.lineDescription !== undefined ? this.lineDescription : <any>null;
        data["isOwner"] = this.isOwner !== undefined ? this.isOwner : <any>null;
        data["isTenant"] = this.isTenant !== undefined ? this.isTenant : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface IEstimateSplitLineWriteModel {
    lineId: string;
    lineDescription: string | null;
    isOwner: boolean;
    isTenant: boolean;
    amount: number;
}

export class GetDataForEstimateSplitResponse implements IGetDataForEstimateSplitResponse {
    existingSplitId: string | null;
    estimateId: string;
    lines: EstimateSplitLineReadModel[] | null;
    [immerable] = true;

    constructor(data?: IGetDataForEstimateSplitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.lines) {
                this.lines = [];
                for (let i = 0; i < data.lines.length; i++) {
                    let item = data.lines[i];
                    this.lines[i] = item && !(<any>item).toJSON ? new EstimateSplitLineReadModel(item) : <EstimateSplitLineReadModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.existingSplitId = _data["existingSplitId"] !== undefined ? _data["existingSplitId"] : <any>null;
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(EstimateSplitLineReadModel.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDataForEstimateSplitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataForEstimateSplitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existingSplitId"] = this.existingSplitId !== undefined ? this.existingSplitId : <any>null;
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDataForEstimateSplitResponse {
    existingSplitId: string | null;
    estimateId: string;
    lines: IEstimateSplitLineReadModel[] | null;
}

export class EstimateSplitLineReadModel implements IEstimateSplitLineReadModel {
    lineId: string;
    description: string | null;
    amount: number;
    isOwner: boolean | null;
    isTenant: boolean | null;
    [immerable] = true;

    constructor(data?: IEstimateSplitLineReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"] !== undefined ? _data["lineId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.isOwner = _data["isOwner"] !== undefined ? _data["isOwner"] : <any>null;
            this.isTenant = _data["isTenant"] !== undefined ? _data["isTenant"] : <any>null;
        }
    }

    static fromJS(data: any): EstimateSplitLineReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new EstimateSplitLineReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId !== undefined ? this.lineId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["isOwner"] = this.isOwner !== undefined ? this.isOwner : <any>null;
        data["isTenant"] = this.isTenant !== undefined ? this.isTenant : <any>null;
        return data;
    }
}

export interface IEstimateSplitLineReadModel {
    lineId: string;
    description: string | null;
    amount: number;
    isOwner: boolean | null;
    isTenant: boolean | null;
}

export class InvoiceDefaultsResponse implements IInvoiceDefaultsResponse {
    invoiceId: string | null;
    notes: string | null;
    meta: DocumentFormMeta | null;
    lineCollection: DocumentLineCollection | null;
    [immerable] = true;

    constructor(data?: IInvoiceDefaultsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.meta = data.meta && !(<any>data.meta).toJSON ? new DocumentFormMeta(data.meta) : <DocumentFormMeta>this.meta;
            this.lineCollection = data.lineCollection && !(<any>data.lineCollection).toJSON ? new DocumentLineCollection(data.lineCollection) : <DocumentLineCollection>this.lineCollection;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.meta = _data["meta"] ? DocumentFormMeta.fromJS(_data["meta"]) : <any>null;
            this.lineCollection = _data["lineCollection"] ? DocumentLineCollection.fromJS(_data["lineCollection"]) : <any>null;
        }
    }

    static fromJS(data: any): InvoiceDefaultsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDefaultsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["meta"] = this.meta ? this.meta.toJSON() : <any>null;
        data["lineCollection"] = this.lineCollection ? this.lineCollection.toJSON() : <any>null;
        return data;
    }
}

export interface IInvoiceDefaultsResponse {
    invoiceId: string | null;
    notes: string | null;
    meta: IDocumentFormMeta | null;
    lineCollection: IDocumentLineCollection | null;
}

export class GetInvoiceDefaultsPayload implements IGetInvoiceDefaultsPayload {
    isPartial: boolean | null;
    issueId: string;
    allowImplicitLines: boolean;
    existingInvoiceId: string | null;
    [immerable] = true;

    constructor(data?: IGetInvoiceDefaultsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPartial = _data["isPartial"] !== undefined ? _data["isPartial"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.allowImplicitLines = _data["allowImplicitLines"] !== undefined ? _data["allowImplicitLines"] : <any>null;
            this.existingInvoiceId = _data["existingInvoiceId"] !== undefined ? _data["existingInvoiceId"] : <any>null;
        }
    }

    static fromJS(data: any): GetInvoiceDefaultsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoiceDefaultsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPartial"] = this.isPartial !== undefined ? this.isPartial : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["allowImplicitLines"] = this.allowImplicitLines !== undefined ? this.allowImplicitLines : <any>null;
        data["existingInvoiceId"] = this.existingInvoiceId !== undefined ? this.existingInvoiceId : <any>null;
        return data;
    }
}

export interface IGetInvoiceDefaultsPayload {
    isPartial: boolean | null;
    issueId: string;
    allowImplicitLines: boolean;
    existingInvoiceId: string | null;
}

export class CreateOrUpdateInvoiceResult implements ICreateOrUpdateInvoiceResult {
    invoiceId: string;
    issueView: IssueUserView | null;
    [immerable] = true;

    constructor(data?: ICreateOrUpdateInvoiceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.issueView = data.issueView && !(<any>data.issueView).toJSON ? new IssueUserView(data.issueView) : <IssueUserView>this.issueView;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.issueView = _data["issueView"] ? IssueUserView.fromJS(_data["issueView"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateOrUpdateInvoiceResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateInvoiceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["issueView"] = this.issueView ? this.issueView.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateOrUpdateInvoiceResult {
    invoiceId: string;
    issueView: IIssueUserView | null;
}

export class CreateOrUpdateInvoicePayload implements ICreateOrUpdateInvoicePayload {
    isPartial: boolean | null;
    issueId: string;
    invoiceId: string | null;
    action: ChangeInvoiceAction;
    previousDiscount: number | null;
    discountPercent: number | null;
    taxPercent: number;
    partialAmount: number | null;
    partialPercent: number | null;
    notes: string | null;
    lines: FormSubmissionLineItem[] | null;
    [immerable] = true;

    constructor(data?: ICreateOrUpdateInvoicePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPartial = _data["isPartial"] !== undefined ? _data["isPartial"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.previousDiscount = _data["previousDiscount"] !== undefined ? _data["previousDiscount"] : <any>null;
            this.discountPercent = _data["discountPercent"] !== undefined ? _data["discountPercent"] : <any>null;
            this.taxPercent = _data["taxPercent"] !== undefined ? _data["taxPercent"] : <any>null;
            this.partialAmount = _data["partialAmount"] !== undefined ? _data["partialAmount"] : <any>null;
            this.partialPercent = _data["partialPercent"] !== undefined ? _data["partialPercent"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(FormSubmissionLineItem.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateInvoicePayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateInvoicePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPartial"] = this.isPartial !== undefined ? this.isPartial : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["previousDiscount"] = this.previousDiscount !== undefined ? this.previousDiscount : <any>null;
        data["discountPercent"] = this.discountPercent !== undefined ? this.discountPercent : <any>null;
        data["taxPercent"] = this.taxPercent !== undefined ? this.taxPercent : <any>null;
        data["partialAmount"] = this.partialAmount !== undefined ? this.partialAmount : <any>null;
        data["partialPercent"] = this.partialPercent !== undefined ? this.partialPercent : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateInvoicePayload {
    isPartial: boolean | null;
    issueId: string;
    invoiceId: string | null;
    action: ChangeInvoiceAction;
    previousDiscount: number | null;
    discountPercent: number | null;
    taxPercent: number;
    partialAmount: number | null;
    partialPercent: number | null;
    notes: string | null;
    lines: FormSubmissionLineItem[] | null;
}

export enum ChangeInvoiceAction {
    SaveDraft = 0,
    SavePublished = 1,
}

export class PublishInvoicePayload implements IPublishInvoicePayload {
    invoiceId: string;
    issueId: string;
    [immerable] = true;

    constructor(data?: IPublishInvoicePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
        }
    }

    static fromJS(data: any): PublishInvoicePayload {
        data = typeof data === 'object' ? data : {};
        let result = new PublishInvoicePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        return data;
    }
}

export interface IPublishInvoicePayload {
    invoiceId: string;
    issueId: string;
}

export class ReviewInvoicePayload implements IReviewInvoicePayload {
    issueId: string;
    invoiceId: string;
    action: ReviewInvoiceAction;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IReviewInvoicePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): ReviewInvoicePayload {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewInvoicePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IReviewInvoicePayload {
    issueId: string;
    invoiceId: string;
    action: ReviewInvoiceAction;
    notes: string | null;
}

export enum ReviewInvoiceAction {
    Accept = 0,
    Reject = 1,
}

export class PayInvoicePayload implements IPayInvoicePayload {
    invoiceId: string;
    issueId: string;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IPayInvoicePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): PayInvoicePayload {
        data = typeof data === 'object' ? data : {};
        let result = new PayInvoicePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IPayInvoicePayload {
    invoiceId: string;
    issueId: string;
    notes: string | null;
}

export class UpdateInvoiceSplitPayload implements IUpdateInvoiceSplitPayload {
    invoiceId: string;
    existingSplitId: string | null;
    lines: InvoiceSplitLineWriteModel[] | null;
    [immerable] = true;

    constructor(data?: IUpdateInvoiceSplitPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.lines) {
                this.lines = [];
                for (let i = 0; i < data.lines.length; i++) {
                    let item = data.lines[i];
                    this.lines[i] = item && !(<any>item).toJSON ? new InvoiceSplitLineWriteModel(item) : <InvoiceSplitLineWriteModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.existingSplitId = _data["existingSplitId"] !== undefined ? _data["existingSplitId"] : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(InvoiceSplitLineWriteModel.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateInvoiceSplitPayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceSplitPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["existingSplitId"] = this.existingSplitId !== undefined ? this.existingSplitId : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateInvoiceSplitPayload {
    invoiceId: string;
    existingSplitId: string | null;
    lines: IInvoiceSplitLineWriteModel[] | null;
}

export class InvoiceSplitLineWriteModel implements IInvoiceSplitLineWriteModel {
    lineId: string;
    lineDescription: string | null;
    isOwner: boolean;
    isTenant: boolean;
    amount: number;
    [immerable] = true;

    constructor(data?: IInvoiceSplitLineWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"] !== undefined ? _data["lineId"] : <any>null;
            this.lineDescription = _data["lineDescription"] !== undefined ? _data["lineDescription"] : <any>null;
            this.isOwner = _data["isOwner"] !== undefined ? _data["isOwner"] : <any>null;
            this.isTenant = _data["isTenant"] !== undefined ? _data["isTenant"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceSplitLineWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSplitLineWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId !== undefined ? this.lineId : <any>null;
        data["lineDescription"] = this.lineDescription !== undefined ? this.lineDescription : <any>null;
        data["isOwner"] = this.isOwner !== undefined ? this.isOwner : <any>null;
        data["isTenant"] = this.isTenant !== undefined ? this.isTenant : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface IInvoiceSplitLineWriteModel {
    lineId: string;
    lineDescription: string | null;
    isOwner: boolean;
    isTenant: boolean;
    amount: number;
}

export class GetDataForInvoiceSplitResponse implements IGetDataForInvoiceSplitResponse {
    existingSplitId: string | null;
    invoiceId: string;
    lines: InvoiceSplitLineReadModel[] | null;
    [immerable] = true;

    constructor(data?: IGetDataForInvoiceSplitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.lines) {
                this.lines = [];
                for (let i = 0; i < data.lines.length; i++) {
                    let item = data.lines[i];
                    this.lines[i] = item && !(<any>item).toJSON ? new InvoiceSplitLineReadModel(item) : <InvoiceSplitLineReadModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.existingSplitId = _data["existingSplitId"] !== undefined ? _data["existingSplitId"] : <any>null;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(InvoiceSplitLineReadModel.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDataForInvoiceSplitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataForInvoiceSplitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existingSplitId"] = this.existingSplitId !== undefined ? this.existingSplitId : <any>null;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDataForInvoiceSplitResponse {
    existingSplitId: string | null;
    invoiceId: string;
    lines: IInvoiceSplitLineReadModel[] | null;
}

export class InvoiceSplitLineReadModel implements IInvoiceSplitLineReadModel {
    lineId: string;
    description: string | null;
    amount: number;
    isOwner: boolean | null;
    isTenant: boolean | null;
    [immerable] = true;

    constructor(data?: IInvoiceSplitLineReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"] !== undefined ? _data["lineId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.isOwner = _data["isOwner"] !== undefined ? _data["isOwner"] : <any>null;
            this.isTenant = _data["isTenant"] !== undefined ? _data["isTenant"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceSplitLineReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSplitLineReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId !== undefined ? this.lineId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["isOwner"] = this.isOwner !== undefined ? this.isOwner : <any>null;
        data["isTenant"] = this.isTenant !== undefined ? this.isTenant : <any>null;
        return data;
    }
}

export interface IInvoiceSplitLineReadModel {
    lineId: string;
    description: string | null;
    amount: number;
    isOwner: boolean | null;
    isTenant: boolean | null;
}

export class IssuesForUserResult implements IIssuesForUserResult {
    issues: IssueForGrid[] | null;
    totalItems: number;
    [immerable] = true;

    constructor(data?: IIssuesForUserResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.issues) {
                this.issues = [];
                for (let i = 0; i < data.issues.length; i++) {
                    let item = data.issues[i];
                    this.issues[i] = item && !(<any>item).toJSON ? new IssueForGrid(item) : <IssueForGrid>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(IssueForGrid.fromJS(item));
            }
            else {
                this.issues = <any>null;
            }
            this.totalItems = _data["totalItems"] !== undefined ? _data["totalItems"] : <any>null;
        }
    }

    static fromJS(data: any): IssuesForUserResult {
        data = typeof data === 'object' ? data : {};
        let result = new IssuesForUserResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems !== undefined ? this.totalItems : <any>null;
        return data;
    }
}

export interface IIssuesForUserResult {
    issues: IIssueForGrid[] | null;
    totalItems: number;
}

export class IssueForGrid implements IIssueForGrid {
    issue: IssueSummary | null;
    cosmeticStatus: IssueStatus;
    property: PropertySummary | null;
    managementCompany: ManagementCompany | null;
    statValue: number | null;
    secondaryValue: number | null;
    subtotal: number;
    [immerable] = true;

    constructor(data?: IIssueForGrid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.issue = data.issue && !(<any>data.issue).toJSON ? new IssueSummary(data.issue) : <IssueSummary>this.issue;
            this.property = data.property && !(<any>data.property).toJSON ? new PropertySummary(data.property) : <PropertySummary>this.property;
            this.managementCompany = data.managementCompany && !(<any>data.managementCompany).toJSON ? new ManagementCompany(data.managementCompany) : <ManagementCompany>this.managementCompany;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issue = _data["issue"] ? IssueSummary.fromJS(_data["issue"]) : <any>null;
            this.cosmeticStatus = _data["cosmeticStatus"] !== undefined ? _data["cosmeticStatus"] : <any>null;
            this.property = _data["property"] ? PropertySummary.fromJS(_data["property"]) : <any>null;
            this.managementCompany = _data["managementCompany"] ? ManagementCompany.fromJS(_data["managementCompany"]) : <any>null;
            this.statValue = _data["statValue"] !== undefined ? _data["statValue"] : <any>null;
            this.secondaryValue = _data["secondaryValue"] !== undefined ? _data["secondaryValue"] : <any>null;
            this.subtotal = _data["subtotal"] !== undefined ? _data["subtotal"] : <any>null;
        }
    }

    static fromJS(data: any): IssueForGrid {
        data = typeof data === 'object' ? data : {};
        let result = new IssueForGrid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issue"] = this.issue ? this.issue.toJSON() : <any>null;
        data["cosmeticStatus"] = this.cosmeticStatus !== undefined ? this.cosmeticStatus : <any>null;
        data["property"] = this.property ? this.property.toJSON() : <any>null;
        data["managementCompany"] = this.managementCompany ? this.managementCompany.toJSON() : <any>null;
        data["statValue"] = this.statValue !== undefined ? this.statValue : <any>null;
        data["secondaryValue"] = this.secondaryValue !== undefined ? this.secondaryValue : <any>null;
        data["subtotal"] = this.subtotal !== undefined ? this.subtotal : <any>null;
        return data;
    }
}

export interface IIssueForGrid {
    issue: IIssueSummary | null;
    cosmeticStatus: IssueStatus;
    property: IPropertySummary | null;
    managementCompany: IManagementCompany | null;
    statValue: number | null;
    secondaryValue: number | null;
    subtotal: number;
}

export class IssuesForUserPayload implements IIssuesForUserPayload {
    sortDirection: SortDirection;
    sortField: IssuesSortField;
    skip: number;
    take: number | null;
    filters: TasksForUsersFilter | null;
    category: DashboardStatCategory | null;
    [immerable] = true;

    constructor(data?: IIssuesForUserPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.filters = data.filters && !(<any>data.filters).toJSON ? new TasksForUsersFilter(data.filters) : <TasksForUsersFilter>this.filters;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortDirection = _data["sortDirection"] !== undefined ? _data["sortDirection"] : <any>null;
            this.sortField = _data["sortField"] !== undefined ? _data["sortField"] : <any>null;
            this.skip = _data["skip"] !== undefined ? _data["skip"] : <any>null;
            this.take = _data["take"] !== undefined ? _data["take"] : <any>null;
            this.filters = _data["filters"] ? TasksForUsersFilter.fromJS(_data["filters"]) : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
        }
    }

    static fromJS(data: any): IssuesForUserPayload {
        data = typeof data === 'object' ? data : {};
        let result = new IssuesForUserPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortDirection"] = this.sortDirection !== undefined ? this.sortDirection : <any>null;
        data["sortField"] = this.sortField !== undefined ? this.sortField : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        data["take"] = this.take !== undefined ? this.take : <any>null;
        data["filters"] = this.filters ? this.filters.toJSON() : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        return data;
    }
}

export interface IIssuesForUserPayload {
    sortDirection: SortDirection;
    sortField: IssuesSortField;
    skip: number;
    take: number | null;
    filters: ITasksForUsersFilter | null;
    category: DashboardStatCategory | null;
}

export enum IssuesSortField {
    Default = 0,
    IssueId = 1,
    Address1 = 2,
    Address2 = 3,
    PrimaryPm = 4,
    Status = 5,
    CreatedAt = 6,
    ModifiedAt = 7,
    IsOccupied = 8,
    CompanyName = 9,
    Title = 10,
}

export class CreateIssuePayload implements ICreateIssuePayload {
    workorderId: string;
    managementCompanyId: string;
    propertyId: string;
    locationType: LocationType;
    interiorLocationId: number | null;
    exteriorLocationId: number | null;
    workTypeId: number | null;
    description: string | null;
    title: string | null;
    parentId: string | null;
    inspectionId: string | null;
    [immerable] = true;

    constructor(data?: ICreateIssuePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
            this.managementCompanyId = _data["managementCompanyId"] !== undefined ? _data["managementCompanyId"] : <any>null;
            this.propertyId = _data["propertyId"] !== undefined ? _data["propertyId"] : <any>null;
            this.locationType = _data["locationType"] !== undefined ? _data["locationType"] : <any>null;
            this.interiorLocationId = _data["interiorLocationId"] !== undefined ? _data["interiorLocationId"] : <any>null;
            this.exteriorLocationId = _data["exteriorLocationId"] !== undefined ? _data["exteriorLocationId"] : <any>null;
            this.workTypeId = _data["workTypeId"] !== undefined ? _data["workTypeId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : <any>null;
            this.inspectionId = _data["inspectionId"] !== undefined ? _data["inspectionId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateIssuePayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIssuePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        data["managementCompanyId"] = this.managementCompanyId !== undefined ? this.managementCompanyId : <any>null;
        data["propertyId"] = this.propertyId !== undefined ? this.propertyId : <any>null;
        data["locationType"] = this.locationType !== undefined ? this.locationType : <any>null;
        data["interiorLocationId"] = this.interiorLocationId !== undefined ? this.interiorLocationId : <any>null;
        data["exteriorLocationId"] = this.exteriorLocationId !== undefined ? this.exteriorLocationId : <any>null;
        data["workTypeId"] = this.workTypeId !== undefined ? this.workTypeId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["parentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        data["inspectionId"] = this.inspectionId !== undefined ? this.inspectionId : <any>null;
        return data;
    }
}

export interface ICreateIssuePayload {
    workorderId: string;
    managementCompanyId: string;
    propertyId: string;
    locationType: LocationType;
    interiorLocationId: number | null;
    exteriorLocationId: number | null;
    workTypeId: number | null;
    description: string | null;
    title: string | null;
    parentId: string | null;
    inspectionId: string | null;
}

export class UpdateIssuePayload implements IUpdateIssuePayload {
    id: string;
    title: string | null;
    description: string | null;
    locationType: LocationType;
    interiorLocationId: number | null;
    exteriorLocationId: number | null;
    workTypeId: number | null;
    [immerable] = true;

    constructor(data?: IUpdateIssuePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.locationType = _data["locationType"] !== undefined ? _data["locationType"] : <any>null;
            this.interiorLocationId = _data["interiorLocationId"] !== undefined ? _data["interiorLocationId"] : <any>null;
            this.exteriorLocationId = _data["exteriorLocationId"] !== undefined ? _data["exteriorLocationId"] : <any>null;
            this.workTypeId = _data["workTypeId"] !== undefined ? _data["workTypeId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateIssuePayload {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIssuePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["locationType"] = this.locationType !== undefined ? this.locationType : <any>null;
        data["interiorLocationId"] = this.interiorLocationId !== undefined ? this.interiorLocationId : <any>null;
        data["exteriorLocationId"] = this.exteriorLocationId !== undefined ? this.exteriorLocationId : <any>null;
        data["workTypeId"] = this.workTypeId !== undefined ? this.workTypeId : <any>null;
        return data;
    }
}

export interface IUpdateIssuePayload {
    id: string;
    title: string | null;
    description: string | null;
    locationType: LocationType;
    interiorLocationId: number | null;
    exteriorLocationId: number | null;
    workTypeId: number | null;
}

export class SetIssueNotificationStatusPayload implements ISetIssueNotificationStatusPayload {
    issueId: string;
    enabled: boolean;
    [immerable] = true;

    constructor(data?: ISetIssueNotificationStatusPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : <any>null;
        }
    }

    static fromJS(data: any): SetIssueNotificationStatusPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SetIssueNotificationStatusPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        return data;
    }
}

export interface ISetIssueNotificationStatusPayload {
    issueId: string;
    enabled: boolean;
}

export class IssueActivityLogEntry implements IIssueActivityLogEntry {
    id: string;
    order: number;
    issueId: string;
    vendor: Vendor | null;
    notes: string | null;
    activityType: IssueActivityType;
    oldStatus: IssueStatus;
    newStatus: IssueStatus;
    scheduleProposal: ScheduleProposal | null;
    issueActivityMeta: IssueActivityMetaBase | null;
    modifiedBy: User | null;
    modifiedAt: Date;
    [immerable] = true;

    constructor(data?: IIssueActivityLogEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.vendor = data.vendor && !(<any>data.vendor).toJSON ? new Vendor(data.vendor) : <Vendor>this.vendor;
            this.scheduleProposal = data.scheduleProposal && !(<any>data.scheduleProposal).toJSON ? new ScheduleProposal(data.scheduleProposal) : <ScheduleProposal>this.scheduleProposal;
            this.modifiedBy = data.modifiedBy && !(<any>data.modifiedBy).toJSON ? new User(data.modifiedBy) : <User>this.modifiedBy;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.oldStatus = _data["oldStatus"] !== undefined ? _data["oldStatus"] : <any>null;
            this.newStatus = _data["newStatus"] !== undefined ? _data["newStatus"] : <any>null;
            this.scheduleProposal = _data["scheduleProposal"] ? ScheduleProposal.fromJS(_data["scheduleProposal"]) : <any>null;
            this.issueActivityMeta = _data["issueActivityMeta"] ? IssueActivityMetaBase.fromJS(_data["issueActivityMeta"]) : <any>null;
            this.modifiedBy = _data["modifiedBy"] ? User.fromJS(_data["modifiedBy"]) : <any>null;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): IssueActivityLogEntry {
        data = typeof data === 'object' ? data : {};
        let result = new IssueActivityLogEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["oldStatus"] = this.oldStatus !== undefined ? this.oldStatus : <any>null;
        data["newStatus"] = this.newStatus !== undefined ? this.newStatus : <any>null;
        data["scheduleProposal"] = this.scheduleProposal ? this.scheduleProposal.toJSON() : <any>null;
        data["issueActivityMeta"] = this.issueActivityMeta ? this.issueActivityMeta.toJSON() : <any>null;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>null;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IIssueActivityLogEntry {
    id: string;
    order: number;
    issueId: string;
    vendor: IVendor | null;
    notes: string | null;
    activityType: IssueActivityType;
    oldStatus: IssueStatus;
    newStatus: IssueStatus;
    scheduleProposal: IScheduleProposal | null;
    issueActivityMeta: IssueActivityMetaBase | null;
    modifiedBy: IUser | null;
    modifiedAt: Date;
}

export enum IssueActivityType {
    Unknown = 0,
    Created = 1,
    AssignedVendor = 2,
    UnassignedVendor = 3,
    Updated = 4,
    ChangedStatus = 5,
    Scheduled = 6,
    AddedMessage = 7,
    ProposedSchedule = 8,
    AddedChangeRequest = 9,
    AcceptedChangeRequest = 10,
    RejectedChangeRequest = 11,
    ElevatedChangeRequest = 12,
    RequestedBids = 13,
    SubmitBid = 14,
    AcceptBid = 15,
    RejectBid = 16,
    InvitedVendors = 17,
    InvitationAccepted = 18,
    InvitationRejected = 19,
    InvitationExpired = 20,
    ElevatedBid = 21,
    VendorCancelSchedule = 22,
    TenantCancelSchedule = 23,
    TenantCancelIssue = 24,
    VendorCancelIssue = 25,
    MarkVendorUnresponsive = 26,
    BidProposedSchedule = 27,
    BidScheduled = 28,
    DeclineBid = 29,
    MarkVendorDeclined = 30,
    PublishedInvoice = 31,
    UpdatedChangeRequest = 32,
    DeletedChangeRequest = 33,
    ModifiedPublishedInvoice = 34,
    AcceptedInvoice = 35,
    RejectedInvoice = 36,
    PaidInvoice = 37,
    DeclinedAssignment = 38,
    AcceptedAssignment = 39,
    AssignedTech = 40,
    UnassignedTech = 41,
    AcceptedIssueSchedule = 42,
    RejectedIssueSchedule = 43,
    CreatedBoardPost = 44,
    UpdateBid = 45,
    PublishedEstimate = 46,
    ModifiedPublishedEstimate = 47,
    AcceptedEstimate = 48,
    RejectedEstimate = 49,
    SkippedEstimation = 50,
    SkippedScheduling = 51,
    DeletedBoardPost = 52,
    CompletedWork = 53,
    Closed = 54,
    ForceAcceptedEstimate = 55,
    UninvitedBidder = 56,
    CreatedBid = 57,
    RevisedBid = 58,
    AcceptedRevisedBid = 59,
    ForceAcceptedRevisedBid = 60,
    Canceled = 61,
    MarkedIssuePaid = 62,
    AddedPayment = 63,
    EditedPayment = 64,
    DeletedPayment = 65,
    ClonedSource = 66,
    ClonedDestination = 67,
    SystemMarkedPaid = 68,
    RequestedChangesBid = 69,
    AcceptedChangedBid = 70,
    ForceAcceptedChangedBid = 71,
    DeclinedChangedBid = 72,
    ForceAcceptedChangeRequest = 73,
    InvitationNoLongerAvailable = 74,
    MarkedEstimateSent = 75,
    MarkedEstimateNotSent = 76,
    SkippedBidding = 77,
    SystemMarkedNotPaid = 78,
    SplitInvoice = 79,
    SplitEstimate = 80,
    SplitBid = 81,
}

export abstract class IssueActivityMetaBase implements IIssueActivityMetaBase {
    oldStatus: IssueStatus | null;
    newStatus: IssueStatus | null;
    notes: string | null;
    isSystemAction: boolean;
    [immerable] = true;
    protected _discriminator: string;

    constructor(data?: IIssueActivityMetaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "IssueActivityMetaBase";
    }

    init(_data?: any) {
        if (_data) {
            this.oldStatus = _data["oldStatus"] !== undefined ? _data["oldStatus"] : <any>null;
            this.newStatus = _data["newStatus"] !== undefined ? _data["newStatus"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.isSystemAction = _data["isSystemAction"] !== undefined ? _data["isSystemAction"] : <any>null;
        }
    }

    static fromJS(data: any): IssueActivityMetaBase {
        data = typeof data === 'object' ? data : {};
        if (data["ActivityType"] === "27") {
            let result = new BidProposedScheduleMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "28") {
            let result = new BidScheduledMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "15") {
            let result = new IssueAcceptBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "39") {
            let result = new IssueAcceptedAssignmentMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "70") {
            let result = new IssueAcceptedChangedBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "10") {
            let result = new IssueAcceptedChangeRequestMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "48") {
            let result = new IssueAcceptedEstimateMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "18") {
            let result = new IssueAcceptedInvitationMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "35") {
            let result = new IssueAcceptedInvoiceMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "59") {
            let result = new IssueAcceptRevisedBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "9") {
            let result = new IssueAddedChangeRequestMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "7") {
            let result = new IssueAddedMessageMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "63") {
            let result = new IssueAddedPaymentMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "30") {
            let result = new IssueAllVendorsDeclinedMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "40") {
            let result = new IssueAssignedTechMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "2") {
            let result = new IssueAssignedVendorMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "61") {
            let result = new IssueCanceledMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "5") {
            let result = new IssueChangedStatusMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "67") {
            let result = new IssueClonedDestinationMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "66") {
            let result = new IssueClonedSourceMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "54") {
            let result = new IssueClosedMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "53") {
            let result = new IssueCompletedWorkMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "57") {
            let result = new IssueCreateBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "44") {
            let result = new IssueCreatedBoardPostMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "29") {
            let result = new IssueDeclineBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "38") {
            let result = new IssueDeclinedAssignmentMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "72") {
            let result = new IssueDeclinedChangedBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "19") {
            let result = new IssueDeclinedInvitationMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "52") {
            let result = new IssueDeletedBoardPostMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "33") {
            let result = new IssueDeletedChangeRequestMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "65") {
            let result = new IssueDeletedPaymentMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "64") {
            let result = new IssueEditedPaymentMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "21") {
            let result = new IssueElevateBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "12") {
            let result = new IssueElevatedChangeRequestMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "71") {
            let result = new IssueForceAcceptedChangedBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "73") {
            let result = new IssueForceAcceptedChangeRequestMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "55") {
            let result = new IssueForceAcceptedEstimateMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "60") {
            let result = new IssueForceAcceptRevisedBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "17") {
            let result = new IssueInvitedVendorsMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "76") {
            let result = new IssueMarkedEstimateNotSentMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "75") {
            let result = new IssueMarkedEstimateSentMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "26") {
            let result = new IssueMarkedVendorUnresponsiveMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "47") {
            let result = new IssueModifiedPublishedEstimateMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "34") {
            let result = new IssueModifiedPublishedInvoiceMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "37") {
            let result = new IssuePaidInvoiceMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "8") {
            let result = new IssueProposedScheduleMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "46") {
            let result = new IssuePublishedEstimateMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "31") {
            let result = new IssuePublishedInvoiceMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "16") {
            let result = new IssueRejectBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "11") {
            let result = new IssueRejectedChangeRequestMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "49") {
            let result = new IssueRejectedEstimateMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "36") {
            let result = new IssueRejectedInvoiceMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "13") {
            let result = new IssueRequestBidsMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "69") {
            let result = new IssueRequestedBidChangesMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "58") {
            let result = new IssueReviseBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "42") {
            let result = new IssueScheduleAcceptedMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "6") {
            let result = new IssueScheduledMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "43") {
            let result = new IssueScheduleRejectedMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "77") {
            let result = new IssueSkippedBiddingMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "50") {
            let result = new IssueSkippedEstimationMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "51") {
            let result = new IssueSkippedSchedulingMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "81") {
            let result = new IssueSplitBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "80") {
            let result = new IssueSplitEstimateMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "79") {
            let result = new IssueSplitInvoiceMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "14") {
            let result = new IssueSubmitBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "24") {
            let result = new IssueTenantCancelIssueMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "23") {
            let result = new IssueTenantCancelScheduleMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "41") {
            let result = new IssueUnassignedTechMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "3") {
            let result = new IssueUnassignedVendorMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "56") {
            let result = new IssueUninviteBidderMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "45") {
            let result = new IssueUpdateBidMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "32") {
            let result = new IssueUpdatedChangeRequestMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "4") {
            let result = new IssueUpdatedMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "25") {
            let result = new IssueVendorCancelIssueMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "22") {
            let result = new IssueVendorCancelScheduleMeta();
            result.init(data);
            return result;
        }
        if (data["ActivityType"] === "62") {
            let result = new MarkedIssuePaidMeta();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'IssueActivityMetaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ActivityType"] = this._discriminator;
        data["oldStatus"] = this.oldStatus !== undefined ? this.oldStatus : <any>null;
        data["newStatus"] = this.newStatus !== undefined ? this.newStatus : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["isSystemAction"] = this.isSystemAction !== undefined ? this.isSystemAction : <any>null;
        return data;
    }
}

export interface IIssueActivityMetaBase {
    oldStatus: IssueStatus | null;
    newStatus: IssueStatus | null;
    notes: string | null;
    isSystemAction: boolean;
}

export class BidProposedScheduleMeta extends IssueActivityMetaBase implements IBidProposedScheduleMeta {
    activityType: IssueActivityType;
    bidId: string;
    scheduleProposalId: string;
    [immerable] = true;

    constructor(data?: IBidProposedScheduleMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "27";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
            this.scheduleProposalId = _data["scheduleProposalId"] !== undefined ? _data["scheduleProposalId"] : <any>null;
        }
    }

    static fromJS(data: any): BidProposedScheduleMeta {
        data = typeof data === 'object' ? data : {};
        let result = new BidProposedScheduleMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        data["scheduleProposalId"] = this.scheduleProposalId !== undefined ? this.scheduleProposalId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBidProposedScheduleMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    bidId: string;
    scheduleProposalId: string;
}

export class BidScheduledMeta extends IssueActivityMetaBase implements IBidScheduledMeta {
    activityType: IssueActivityType;
    scheduleProposalId: string;
    bidId: string;
    [immerable] = true;

    constructor(data?: IBidScheduledMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "28";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.scheduleProposalId = _data["scheduleProposalId"] !== undefined ? _data["scheduleProposalId"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
        }
    }

    static fromJS(data: any): BidScheduledMeta {
        data = typeof data === 'object' ? data : {};
        let result = new BidScheduledMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["scheduleProposalId"] = this.scheduleProposalId !== undefined ? this.scheduleProposalId : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBidScheduledMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    scheduleProposalId: string;
    bidId: string;
}

export class IssueAcceptBidMeta extends IssueActivityMetaBase implements IIssueAcceptBidMeta {
    activityType: IssueActivityType;
    submittedBidId: string;
    vendorId: string;
    [immerable] = true;

    constructor(data?: IIssueAcceptBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "15";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.submittedBidId = _data["submittedBidId"] !== undefined ? _data["submittedBidId"] : <any>null;
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAcceptBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAcceptBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["submittedBidId"] = this.submittedBidId !== undefined ? this.submittedBidId : <any>null;
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAcceptBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    submittedBidId: string;
    vendorId: string;
}

export class IssueAcceptedAssignmentMeta extends IssueActivityMetaBase implements IIssueAcceptedAssignmentMeta {
    activityType: IssueActivityType;
    assignmentId: string;
    [immerable] = true;

    constructor(data?: IIssueAcceptedAssignmentMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "39";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.assignmentId = _data["assignmentId"] !== undefined ? _data["assignmentId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAcceptedAssignmentMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAcceptedAssignmentMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["assignmentId"] = this.assignmentId !== undefined ? this.assignmentId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAcceptedAssignmentMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    assignmentId: string;
}

export class IssueAcceptedChangedBidMeta extends IssueActivityMetaBase implements IIssueAcceptedChangedBidMeta {
    activityType: IssueActivityType;
    bidId: string;
    [immerable] = true;

    constructor(data?: IIssueAcceptedChangedBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "70";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAcceptedChangedBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAcceptedChangedBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAcceptedChangedBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    bidId: string;
}

export class IssueAcceptedChangeRequestMeta extends IssueActivityMetaBase implements IIssueAcceptedChangeRequestMeta {
    activityType: IssueActivityType;
    changeRequestId: string;
    [immerable] = true;

    constructor(data?: IIssueAcceptedChangeRequestMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "10";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAcceptedChangeRequestMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAcceptedChangeRequestMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAcceptedChangeRequestMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    changeRequestId: string;
}

export class IssueAcceptedEstimateMeta extends IssueActivityMetaBase implements IIssueAcceptedEstimateMeta {
    activityType: IssueActivityType;
    estimateId: string;
    fileId: string | null;
    [immerable] = true;

    constructor(data?: IIssueAcceptedEstimateMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "48";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAcceptedEstimateMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAcceptedEstimateMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAcceptedEstimateMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    estimateId: string;
    fileId: string | null;
}

export class IssueAcceptedInvitationMeta extends IssueActivityMetaBase implements IIssueAcceptedInvitationMeta {
    activityType: IssueActivityType;
    vendorId: string;
    candidacyId: string;
    invalidatedCandidacies: string[] | null;
    [immerable] = true;

    constructor(data?: IIssueAcceptedInvitationMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "18";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.candidacyId = _data["candidacyId"] !== undefined ? _data["candidacyId"] : <any>null;
            if (Array.isArray(_data["invalidatedCandidacies"])) {
                this.invalidatedCandidacies = [] as any;
                for (let item of _data["invalidatedCandidacies"])
                    this.invalidatedCandidacies!.push(item);
            }
            else {
                this.invalidatedCandidacies = <any>null;
            }
        }
    }

    static fromJS(data: any): IssueAcceptedInvitationMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAcceptedInvitationMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["candidacyId"] = this.candidacyId !== undefined ? this.candidacyId : <any>null;
        if (Array.isArray(this.invalidatedCandidacies)) {
            data["invalidatedCandidacies"] = [];
            for (let item of this.invalidatedCandidacies)
                data["invalidatedCandidacies"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAcceptedInvitationMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    vendorId: string;
    candidacyId: string;
    invalidatedCandidacies: string[] | null;
}

export class IssueAcceptedInvoiceMeta extends IssueActivityMetaBase implements IIssueAcceptedInvoiceMeta {
    activityType: IssueActivityType;
    invoiceId: string;
    fileId: string | null;
    [immerable] = true;

    constructor(data?: IIssueAcceptedInvoiceMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "35";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAcceptedInvoiceMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAcceptedInvoiceMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAcceptedInvoiceMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    invoiceId: string;
    fileId: string | null;
}

export class IssueAcceptRevisedBidMeta extends IssueActivityMetaBase implements IIssueAcceptRevisedBidMeta {
    activityType: IssueActivityType;
    bidId: string;
    [immerable] = true;

    constructor(data?: IIssueAcceptRevisedBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "59";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAcceptRevisedBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAcceptRevisedBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAcceptRevisedBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    bidId: string;
}

export class IssueAddedChangeRequestMeta extends IssueActivityMetaBase implements IIssueAddedChangeRequestMeta {
    activityType: IssueActivityType;
    changeRequestId: string;
    fileId: string | null;
    [immerable] = true;

    constructor(data?: IIssueAddedChangeRequestMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "9";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAddedChangeRequestMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAddedChangeRequestMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAddedChangeRequestMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    changeRequestId: string;
    fileId: string | null;
}

export class IssueAddedMessageMeta extends IssueActivityMetaBase implements IIssueAddedMessageMeta {
    activityType: IssueActivityType;
    messageId: string;
    [immerable] = true;

    constructor(data?: IIssueAddedMessageMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "7";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.messageId = _data["messageId"] !== undefined ? _data["messageId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAddedMessageMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAddedMessageMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["messageId"] = this.messageId !== undefined ? this.messageId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAddedMessageMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    messageId: string;
}

export class IssueAddedPaymentMeta extends IssueActivityMetaBase implements IIssueAddedPaymentMeta {
    activityType: IssueActivityType;
    paymentId: string;
    [immerable] = true;

    constructor(data?: IIssueAddedPaymentMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "63";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.paymentId = _data["paymentId"] !== undefined ? _data["paymentId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAddedPaymentMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAddedPaymentMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["paymentId"] = this.paymentId !== undefined ? this.paymentId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAddedPaymentMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    paymentId: string;
}

export class IssueAllVendorsDeclinedMeta extends IssueActivityMetaBase implements IIssueAllVendorsDeclinedMeta {
    activityType: IssueActivityType;
    vendorIds: string[] | null;
    [immerable] = true;

    constructor(data?: IIssueAllVendorsDeclinedMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "30";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            else {
                this.vendorIds = <any>null;
            }
        }
    }

    static fromJS(data: any): IssueAllVendorsDeclinedMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAllVendorsDeclinedMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAllVendorsDeclinedMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    vendorIds: string[] | null;
}

export class IssueAssignedTechMeta extends IssueActivityMetaBase implements IIssueAssignedTechMeta {
    activityType: IssueActivityType;
    vendorId: string;
    techId: string;
    [immerable] = true;

    constructor(data?: IIssueAssignedTechMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "40";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.techId = _data["techId"] !== undefined ? _data["techId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAssignedTechMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAssignedTechMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["techId"] = this.techId !== undefined ? this.techId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAssignedTechMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    vendorId: string;
    techId: string;
}

export class IssueAssignedVendorMeta extends IssueActivityMetaBase implements IIssueAssignedVendorMeta {
    activityType: IssueActivityType;
    vendorId: string | null;
    [immerable] = true;

    constructor(data?: IIssueAssignedVendorMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "2";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueAssignedVendorMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAssignedVendorMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueAssignedVendorMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    vendorId: string | null;
}

export class IssueCanceledMeta extends IssueActivityMetaBase implements IIssueCanceledMeta {
    activityType: IssueActivityType;
    [immerable] = true;

    constructor(data?: IIssueCanceledMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "61";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
        }
    }

    static fromJS(data: any): IssueCanceledMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueCanceledMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueCanceledMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
}

export class IssueChangedStatusMeta extends IssueActivityMetaBase implements IIssueChangedStatusMeta {
    activityType: IssueActivityType;
    [immerable] = true;

    constructor(data?: IIssueChangedStatusMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "5";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
        }
    }

    static fromJS(data: any): IssueChangedStatusMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueChangedStatusMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueChangedStatusMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
}

export class IssueClonedDestinationMeta extends IssueActivityMetaBase implements IIssueClonedDestinationMeta {
    activityType: IssueActivityType;
    sourceId: string;
    sourceFriendlyId: string | null;
    workorderId: string;
    [immerable] = true;

    constructor(data?: IIssueClonedDestinationMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "67";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : <any>null;
            this.sourceFriendlyId = _data["sourceFriendlyId"] !== undefined ? _data["sourceFriendlyId"] : <any>null;
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueClonedDestinationMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueClonedDestinationMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : <any>null;
        data["sourceFriendlyId"] = this.sourceFriendlyId !== undefined ? this.sourceFriendlyId : <any>null;
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueClonedDestinationMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    sourceId: string;
    sourceFriendlyId: string | null;
    workorderId: string;
}

export class IssueClonedSourceMeta extends IssueActivityMetaBase implements IIssueClonedSourceMeta {
    activityType: IssueActivityType;
    destinationId: string;
    destinationFriendlyId: string | null;
    workorderId: string;
    [immerable] = true;

    constructor(data?: IIssueClonedSourceMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "66";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.destinationId = _data["destinationId"] !== undefined ? _data["destinationId"] : <any>null;
            this.destinationFriendlyId = _data["destinationFriendlyId"] !== undefined ? _data["destinationFriendlyId"] : <any>null;
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueClonedSourceMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueClonedSourceMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["destinationId"] = this.destinationId !== undefined ? this.destinationId : <any>null;
        data["destinationFriendlyId"] = this.destinationFriendlyId !== undefined ? this.destinationFriendlyId : <any>null;
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueClonedSourceMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    destinationId: string;
    destinationFriendlyId: string | null;
    workorderId: string;
}

export class IssueClosedMeta extends IssueActivityMetaBase implements IIssueClosedMeta {
    activityType: IssueActivityType;
    [immerable] = true;

    constructor(data?: IIssueClosedMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "54";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
        }
    }

    static fromJS(data: any): IssueClosedMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueClosedMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueClosedMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
}

export class IssueCompletedWorkMeta extends IssueActivityMetaBase implements IIssueCompletedWorkMeta {
    activityType: IssueActivityType;
    [immerable] = true;

    constructor(data?: IIssueCompletedWorkMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "53";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
        }
    }

    static fromJS(data: any): IssueCompletedWorkMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueCompletedWorkMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueCompletedWorkMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
}

export class IssueCreateBidMeta extends IssueActivityMetaBase implements IIssueCreateBidMeta {
    activityType: IssueActivityType;
    createdBidId: string;
    invitationBidId: string;
    fileId: string;
    [immerable] = true;

    constructor(data?: IIssueCreateBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "57";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.createdBidId = _data["createdBidId"] !== undefined ? _data["createdBidId"] : <any>null;
            this.invitationBidId = _data["invitationBidId"] !== undefined ? _data["invitationBidId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueCreateBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueCreateBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["createdBidId"] = this.createdBidId !== undefined ? this.createdBidId : <any>null;
        data["invitationBidId"] = this.invitationBidId !== undefined ? this.invitationBidId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueCreateBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    createdBidId: string;
    invitationBidId: string;
    fileId: string;
}

export class IssueCreatedBoardPostMeta extends IssueActivityMetaBase implements IIssueCreatedBoardPostMeta {
    activityType: IssueActivityType;
    postId: string;
    [immerable] = true;

    constructor(data?: IIssueCreatedBoardPostMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "44";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.postId = _data["postId"] !== undefined ? _data["postId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueCreatedBoardPostMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueCreatedBoardPostMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["postId"] = this.postId !== undefined ? this.postId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueCreatedBoardPostMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    postId: string;
}

export class IssueDeclineBidMeta extends IssueActivityMetaBase implements IIssueDeclineBidMeta {
    activityType: IssueActivityType;
    submittedBidId: string;
    declinedBids: string[] | null;
    vendorId: string;
    [immerable] = true;

    constructor(data?: IIssueDeclineBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "29";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.submittedBidId = _data["submittedBidId"] !== undefined ? _data["submittedBidId"] : <any>null;
            if (Array.isArray(_data["declinedBids"])) {
                this.declinedBids = [] as any;
                for (let item of _data["declinedBids"])
                    this.declinedBids!.push(item);
            }
            else {
                this.declinedBids = <any>null;
            }
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueDeclineBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueDeclineBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["submittedBidId"] = this.submittedBidId !== undefined ? this.submittedBidId : <any>null;
        if (Array.isArray(this.declinedBids)) {
            data["declinedBids"] = [];
            for (let item of this.declinedBids)
                data["declinedBids"].push(item);
        }
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueDeclineBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    submittedBidId: string;
    declinedBids: string[] | null;
    vendorId: string;
}

export class IssueDeclinedAssignmentMeta extends IssueActivityMetaBase implements IIssueDeclinedAssignmentMeta {
    activityType: IssueActivityType;
    assignmentId: string;
    [immerable] = true;

    constructor(data?: IIssueDeclinedAssignmentMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "38";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.assignmentId = _data["assignmentId"] !== undefined ? _data["assignmentId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueDeclinedAssignmentMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueDeclinedAssignmentMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["assignmentId"] = this.assignmentId !== undefined ? this.assignmentId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueDeclinedAssignmentMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    assignmentId: string;
}

export class IssueDeclinedChangedBidMeta extends IssueActivityMetaBase implements IIssueDeclinedChangedBidMeta {
    activityType: IssueActivityType;
    bidId: string;
    [immerable] = true;

    constructor(data?: IIssueDeclinedChangedBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "72";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueDeclinedChangedBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueDeclinedChangedBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueDeclinedChangedBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    bidId: string;
}

export class IssueDeclinedInvitationMeta extends IssueActivityMetaBase implements IIssueDeclinedInvitationMeta {
    activityType: IssueActivityType;
    candidacyId: string;
    vendorId: string;
    [immerable] = true;

    constructor(data?: IIssueDeclinedInvitationMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "19";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.candidacyId = _data["candidacyId"] !== undefined ? _data["candidacyId"] : <any>null;
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueDeclinedInvitationMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueDeclinedInvitationMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["candidacyId"] = this.candidacyId !== undefined ? this.candidacyId : <any>null;
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueDeclinedInvitationMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    candidacyId: string;
    vendorId: string;
}

export class IssueDeletedBoardPostMeta extends IssueActivityMetaBase implements IIssueDeletedBoardPostMeta {
    activityType: IssueActivityType;
    postId: string;
    [immerable] = true;

    constructor(data?: IIssueDeletedBoardPostMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "52";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.postId = _data["postId"] !== undefined ? _data["postId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueDeletedBoardPostMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueDeletedBoardPostMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["postId"] = this.postId !== undefined ? this.postId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueDeletedBoardPostMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    postId: string;
}

export class IssueDeletedChangeRequestMeta extends IssueActivityMetaBase implements IIssueDeletedChangeRequestMeta {
    activityType: IssueActivityType;
    changeRequestId: string;
    [immerable] = true;

    constructor(data?: IIssueDeletedChangeRequestMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "33";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueDeletedChangeRequestMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueDeletedChangeRequestMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueDeletedChangeRequestMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    changeRequestId: string;
}

export class IssueDeletedPaymentMeta extends IssueActivityMetaBase implements IIssueDeletedPaymentMeta {
    activityType: IssueActivityType;
    paymentId: string;
    [immerable] = true;

    constructor(data?: IIssueDeletedPaymentMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "65";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.paymentId = _data["paymentId"] !== undefined ? _data["paymentId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueDeletedPaymentMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueDeletedPaymentMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["paymentId"] = this.paymentId !== undefined ? this.paymentId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueDeletedPaymentMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    paymentId: string;
}

export class IssueEditedPaymentMeta extends IssueActivityMetaBase implements IIssueEditedPaymentMeta {
    activityType: IssueActivityType;
    paymentId: string;
    oldPaymentJson: string | null;
    newPaymentJson: string | null;
    [immerable] = true;

    constructor(data?: IIssueEditedPaymentMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "64";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.paymentId = _data["paymentId"] !== undefined ? _data["paymentId"] : <any>null;
            this.oldPaymentJson = _data["oldPaymentJson"] !== undefined ? _data["oldPaymentJson"] : <any>null;
            this.newPaymentJson = _data["newPaymentJson"] !== undefined ? _data["newPaymentJson"] : <any>null;
        }
    }

    static fromJS(data: any): IssueEditedPaymentMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueEditedPaymentMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["paymentId"] = this.paymentId !== undefined ? this.paymentId : <any>null;
        data["oldPaymentJson"] = this.oldPaymentJson !== undefined ? this.oldPaymentJson : <any>null;
        data["newPaymentJson"] = this.newPaymentJson !== undefined ? this.newPaymentJson : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueEditedPaymentMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    paymentId: string;
    oldPaymentJson: string | null;
    newPaymentJson: string | null;
}

export class IssueElevateBidMeta extends IssueActivityMetaBase implements IIssueElevateBidMeta {
    activityType: IssueActivityType;
    submittedBidId: string;
    [immerable] = true;

    constructor(data?: IIssueElevateBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "21";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.submittedBidId = _data["submittedBidId"] !== undefined ? _data["submittedBidId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueElevateBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueElevateBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["submittedBidId"] = this.submittedBidId !== undefined ? this.submittedBidId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueElevateBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    submittedBidId: string;
}

export class IssueElevatedChangeRequestMeta extends IssueActivityMetaBase implements IIssueElevatedChangeRequestMeta {
    activityType: IssueActivityType;
    changeRequestId: string;
    [immerable] = true;

    constructor(data?: IIssueElevatedChangeRequestMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "12";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueElevatedChangeRequestMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueElevatedChangeRequestMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueElevatedChangeRequestMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    changeRequestId: string;
}

export class IssueForceAcceptedChangedBidMeta extends IssueActivityMetaBase implements IIssueForceAcceptedChangedBidMeta {
    activityType: IssueActivityType;
    bidId: string;
    [immerable] = true;

    constructor(data?: IIssueForceAcceptedChangedBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "71";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueForceAcceptedChangedBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueForceAcceptedChangedBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueForceAcceptedChangedBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    bidId: string;
}

export class IssueForceAcceptedChangeRequestMeta extends IssueActivityMetaBase implements IIssueForceAcceptedChangeRequestMeta {
    activityType: IssueActivityType;
    changeRequestId: string;
    [immerable] = true;

    constructor(data?: IIssueForceAcceptedChangeRequestMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "73";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueForceAcceptedChangeRequestMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueForceAcceptedChangeRequestMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueForceAcceptedChangeRequestMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    changeRequestId: string;
}

export class IssueForceAcceptedEstimateMeta extends IssueActivityMetaBase implements IIssueForceAcceptedEstimateMeta {
    activityType: IssueActivityType;
    estimateId: string;
    fileId: string | null;
    [immerable] = true;

    constructor(data?: IIssueForceAcceptedEstimateMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "55";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueForceAcceptedEstimateMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueForceAcceptedEstimateMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueForceAcceptedEstimateMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    estimateId: string;
    fileId: string | null;
}

export class IssueForceAcceptRevisedBidMeta extends IssueActivityMetaBase implements IIssueForceAcceptRevisedBidMeta {
    activityType: IssueActivityType;
    bidId: string;
    [immerable] = true;

    constructor(data?: IIssueForceAcceptRevisedBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "60";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueForceAcceptRevisedBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueForceAcceptRevisedBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueForceAcceptRevisedBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    bidId: string;
}

export class IssueInvitedVendorsMeta extends IssueActivityMetaBase implements IIssueInvitedVendorsMeta {
    activityType: IssueActivityType;
    createdCandidacies: string[] | null;
    [immerable] = true;

    constructor(data?: IIssueInvitedVendorsMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "17";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            if (Array.isArray(_data["createdCandidacies"])) {
                this.createdCandidacies = [] as any;
                for (let item of _data["createdCandidacies"])
                    this.createdCandidacies!.push(item);
            }
            else {
                this.createdCandidacies = <any>null;
            }
        }
    }

    static fromJS(data: any): IssueInvitedVendorsMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueInvitedVendorsMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        if (Array.isArray(this.createdCandidacies)) {
            data["createdCandidacies"] = [];
            for (let item of this.createdCandidacies)
                data["createdCandidacies"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIssueInvitedVendorsMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    createdCandidacies: string[] | null;
}

export class IssueMarkedEstimateNotSentMeta extends IssueActivityMetaBase implements IIssueMarkedEstimateNotSentMeta {
    activityType: IssueActivityType;
    [immerable] = true;

    constructor(data?: IIssueMarkedEstimateNotSentMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "76";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
        }
    }

    static fromJS(data: any): IssueMarkedEstimateNotSentMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueMarkedEstimateNotSentMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueMarkedEstimateNotSentMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
}

export class IssueMarkedEstimateSentMeta extends IssueActivityMetaBase implements IIssueMarkedEstimateSentMeta {
    activityType: IssueActivityType;
    [immerable] = true;

    constructor(data?: IIssueMarkedEstimateSentMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "75";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
        }
    }

    static fromJS(data: any): IssueMarkedEstimateSentMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueMarkedEstimateSentMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueMarkedEstimateSentMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
}

export class IssueMarkedVendorUnresponsiveMeta extends IssueActivityMetaBase implements IIssueMarkedVendorUnresponsiveMeta {
    activityType: IssueActivityType;
    activeCandidacies: string[] | null;
    [immerable] = true;

    constructor(data?: IIssueMarkedVendorUnresponsiveMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "26";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            if (Array.isArray(_data["activeCandidacies"])) {
                this.activeCandidacies = [] as any;
                for (let item of _data["activeCandidacies"])
                    this.activeCandidacies!.push(item);
            }
            else {
                this.activeCandidacies = <any>null;
            }
        }
    }

    static fromJS(data: any): IssueMarkedVendorUnresponsiveMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueMarkedVendorUnresponsiveMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        if (Array.isArray(this.activeCandidacies)) {
            data["activeCandidacies"] = [];
            for (let item of this.activeCandidacies)
                data["activeCandidacies"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIssueMarkedVendorUnresponsiveMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    activeCandidacies: string[] | null;
}

export class IssueModifiedPublishedEstimateMeta extends IssueActivityMetaBase implements IIssueModifiedPublishedEstimateMeta {
    activityType: IssueActivityType;
    estimateId: string;
    fileId: string;
    [immerable] = true;

    constructor(data?: IIssueModifiedPublishedEstimateMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "47";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueModifiedPublishedEstimateMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueModifiedPublishedEstimateMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueModifiedPublishedEstimateMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    estimateId: string;
    fileId: string;
}

export class IssueModifiedPublishedInvoiceMeta extends IssueActivityMetaBase implements IIssueModifiedPublishedInvoiceMeta {
    activityType: IssueActivityType;
    invoiceId: string;
    fileId: string;
    [immerable] = true;

    constructor(data?: IIssueModifiedPublishedInvoiceMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "34";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueModifiedPublishedInvoiceMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueModifiedPublishedInvoiceMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueModifiedPublishedInvoiceMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    invoiceId: string;
    fileId: string;
}

export class IssuePaidInvoiceMeta extends IssueActivityMetaBase implements IIssuePaidInvoiceMeta {
    activityType: IssueActivityType;
    invoiceId: string;
    [immerable] = true;

    constructor(data?: IIssuePaidInvoiceMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "37";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
        }
    }

    static fromJS(data: any): IssuePaidInvoiceMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssuePaidInvoiceMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssuePaidInvoiceMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    invoiceId: string;
}

export class IssueProposedScheduleMeta extends IssueActivityMetaBase implements IIssueProposedScheduleMeta {
    activityType: IssueActivityType;
    scheduleProposalId: string;
    [immerable] = true;

    constructor(data?: IIssueProposedScheduleMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "8";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.scheduleProposalId = _data["scheduleProposalId"] !== undefined ? _data["scheduleProposalId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueProposedScheduleMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueProposedScheduleMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["scheduleProposalId"] = this.scheduleProposalId !== undefined ? this.scheduleProposalId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueProposedScheduleMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    scheduleProposalId: string;
}

export class IssuePublishedEstimateMeta extends IssueActivityMetaBase implements IIssuePublishedEstimateMeta {
    activityType: IssueActivityType;
    estimateId: string;
    fileId: string;
    [immerable] = true;

    constructor(data?: IIssuePublishedEstimateMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "46";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssuePublishedEstimateMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssuePublishedEstimateMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssuePublishedEstimateMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    estimateId: string;
    fileId: string;
}

export class IssuePublishedInvoiceMeta extends IssueActivityMetaBase implements IIssuePublishedInvoiceMeta {
    activityType: IssueActivityType;
    invoiceId: string;
    fileId: string;
    [immerable] = true;

    constructor(data?: IIssuePublishedInvoiceMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "31";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssuePublishedInvoiceMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssuePublishedInvoiceMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssuePublishedInvoiceMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    invoiceId: string;
    fileId: string;
}

export class IssueRejectBidMeta extends IssueActivityMetaBase implements IIssueRejectBidMeta {
    activityType: IssueActivityType;
    submittedBidId: string;
    [immerable] = true;

    constructor(data?: IIssueRejectBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "16";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.submittedBidId = _data["submittedBidId"] !== undefined ? _data["submittedBidId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueRejectBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueRejectBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["submittedBidId"] = this.submittedBidId !== undefined ? this.submittedBidId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueRejectBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    submittedBidId: string;
}

export class IssueRejectedChangeRequestMeta extends IssueActivityMetaBase implements IIssueRejectedChangeRequestMeta {
    activityType: IssueActivityType;
    changeRequestId: string;
    [immerable] = true;

    constructor(data?: IIssueRejectedChangeRequestMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "11";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueRejectedChangeRequestMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueRejectedChangeRequestMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueRejectedChangeRequestMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    changeRequestId: string;
}

export class IssueRejectedEstimateMeta extends IssueActivityMetaBase implements IIssueRejectedEstimateMeta {
    activityType: IssueActivityType;
    estimateId: string;
    fileId: string | null;
    [immerable] = true;

    constructor(data?: IIssueRejectedEstimateMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "49";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueRejectedEstimateMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueRejectedEstimateMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueRejectedEstimateMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    estimateId: string;
    fileId: string | null;
}

export class IssueRejectedInvoiceMeta extends IssueActivityMetaBase implements IIssueRejectedInvoiceMeta {
    activityType: IssueActivityType;
    invoiceId: string;
    fileId: string | null;
    [immerable] = true;

    constructor(data?: IIssueRejectedInvoiceMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "36";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueRejectedInvoiceMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueRejectedInvoiceMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueRejectedInvoiceMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    invoiceId: string;
    fileId: string | null;
}

export class IssueRequestBidsMeta extends IssueActivityMetaBase implements IIssueRequestBidsMeta {
    activityType: IssueActivityType;
    requestedBidIds: string[] | null;
    [immerable] = true;

    constructor(data?: IIssueRequestBidsMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "13";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            if (Array.isArray(_data["requestedBidIds"])) {
                this.requestedBidIds = [] as any;
                for (let item of _data["requestedBidIds"])
                    this.requestedBidIds!.push(item);
            }
            else {
                this.requestedBidIds = <any>null;
            }
        }
    }

    static fromJS(data: any): IssueRequestBidsMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueRequestBidsMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        if (Array.isArray(this.requestedBidIds)) {
            data["requestedBidIds"] = [];
            for (let item of this.requestedBidIds)
                data["requestedBidIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIssueRequestBidsMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    requestedBidIds: string[] | null;
}

export class IssueRequestedBidChangesMeta extends IssueActivityMetaBase implements IIssueRequestedBidChangesMeta {
    activityType: IssueActivityType;
    originalBidId: string;
    revisedBidId: string;
    fileId: string;
    [immerable] = true;

    constructor(data?: IIssueRequestedBidChangesMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "69";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.originalBidId = _data["originalBidId"] !== undefined ? _data["originalBidId"] : <any>null;
            this.revisedBidId = _data["revisedBidId"] !== undefined ? _data["revisedBidId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueRequestedBidChangesMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueRequestedBidChangesMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["originalBidId"] = this.originalBidId !== undefined ? this.originalBidId : <any>null;
        data["revisedBidId"] = this.revisedBidId !== undefined ? this.revisedBidId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueRequestedBidChangesMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    originalBidId: string;
    revisedBidId: string;
    fileId: string;
}

export class IssueReviseBidMeta extends IssueActivityMetaBase implements IIssueReviseBidMeta {
    activityType: IssueActivityType;
    originalBidId: string;
    revisedBidId: string;
    fileId: string;
    [immerable] = true;

    constructor(data?: IIssueReviseBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "58";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.originalBidId = _data["originalBidId"] !== undefined ? _data["originalBidId"] : <any>null;
            this.revisedBidId = _data["revisedBidId"] !== undefined ? _data["revisedBidId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueReviseBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueReviseBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["originalBidId"] = this.originalBidId !== undefined ? this.originalBidId : <any>null;
        data["revisedBidId"] = this.revisedBidId !== undefined ? this.revisedBidId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueReviseBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    originalBidId: string;
    revisedBidId: string;
    fileId: string;
}

export class IssueScheduleAcceptedMeta extends IssueActivityMetaBase implements IIssueScheduleAcceptedMeta {
    activityType: IssueActivityType;
    scheduleProposalId: string;
    [immerable] = true;

    constructor(data?: IIssueScheduleAcceptedMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "42";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.scheduleProposalId = _data["scheduleProposalId"] !== undefined ? _data["scheduleProposalId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueScheduleAcceptedMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueScheduleAcceptedMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["scheduleProposalId"] = this.scheduleProposalId !== undefined ? this.scheduleProposalId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueScheduleAcceptedMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    scheduleProposalId: string;
}

export class IssueScheduledMeta extends IssueActivityMetaBase implements IIssueScheduledMeta {
    activityType: IssueActivityType;
    scheduleProposalId: string;
    [immerable] = true;

    constructor(data?: IIssueScheduledMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "6";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.scheduleProposalId = _data["scheduleProposalId"] !== undefined ? _data["scheduleProposalId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueScheduledMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueScheduledMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["scheduleProposalId"] = this.scheduleProposalId !== undefined ? this.scheduleProposalId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueScheduledMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    scheduleProposalId: string;
}

export class IssueScheduleRejectedMeta extends IssueActivityMetaBase implements IIssueScheduleRejectedMeta {
    activityType: IssueActivityType;
    scheduleProposalId: string;
    [immerable] = true;

    constructor(data?: IIssueScheduleRejectedMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "43";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.scheduleProposalId = _data["scheduleProposalId"] !== undefined ? _data["scheduleProposalId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueScheduleRejectedMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueScheduleRejectedMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["scheduleProposalId"] = this.scheduleProposalId !== undefined ? this.scheduleProposalId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueScheduleRejectedMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    scheduleProposalId: string;
}

export class IssueSkippedBiddingMeta extends IssueActivityMetaBase implements IIssueSkippedBiddingMeta {
    activityType: IssueActivityType;
    [immerable] = true;

    constructor(data?: IIssueSkippedBiddingMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "77";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
        }
    }

    static fromJS(data: any): IssueSkippedBiddingMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSkippedBiddingMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueSkippedBiddingMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
}

export class IssueSkippedEstimationMeta extends IssueActivityMetaBase implements IIssueSkippedEstimationMeta {
    activityType: IssueActivityType;
    [immerable] = true;

    constructor(data?: IIssueSkippedEstimationMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "50";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
        }
    }

    static fromJS(data: any): IssueSkippedEstimationMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSkippedEstimationMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueSkippedEstimationMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
}

export class IssueSkippedSchedulingMeta extends IssueActivityMetaBase implements IIssueSkippedSchedulingMeta {
    activityType: IssueActivityType;
    [immerable] = true;

    constructor(data?: IIssueSkippedSchedulingMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "51";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
        }
    }

    static fromJS(data: any): IssueSkippedSchedulingMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSkippedSchedulingMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueSkippedSchedulingMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
}

export class IssueSplitBidMeta extends IssueActivityMetaBase implements IIssueSplitBidMeta {
    activityType: IssueActivityType;
    splitId: string;
    bidId: string;
    splitMeta: string | null;
    [immerable] = true;

    constructor(data?: IIssueSplitBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "81";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.splitId = _data["splitId"] !== undefined ? _data["splitId"] : <any>null;
            this.bidId = _data["bidId"] !== undefined ? _data["bidId"] : <any>null;
            this.splitMeta = _data["splitMeta"] !== undefined ? _data["splitMeta"] : <any>null;
        }
    }

    static fromJS(data: any): IssueSplitBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSplitBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["splitId"] = this.splitId !== undefined ? this.splitId : <any>null;
        data["bidId"] = this.bidId !== undefined ? this.bidId : <any>null;
        data["splitMeta"] = this.splitMeta !== undefined ? this.splitMeta : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueSplitBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    splitId: string;
    bidId: string;
    splitMeta: string | null;
}

export class IssueSplitEstimateMeta extends IssueActivityMetaBase implements IIssueSplitEstimateMeta {
    activityType: IssueActivityType;
    splitId: string;
    estimateId: string;
    splitMeta: string | null;
    [immerable] = true;

    constructor(data?: IIssueSplitEstimateMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "80";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.splitId = _data["splitId"] !== undefined ? _data["splitId"] : <any>null;
            this.estimateId = _data["estimateId"] !== undefined ? _data["estimateId"] : <any>null;
            this.splitMeta = _data["splitMeta"] !== undefined ? _data["splitMeta"] : <any>null;
        }
    }

    static fromJS(data: any): IssueSplitEstimateMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSplitEstimateMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["splitId"] = this.splitId !== undefined ? this.splitId : <any>null;
        data["estimateId"] = this.estimateId !== undefined ? this.estimateId : <any>null;
        data["splitMeta"] = this.splitMeta !== undefined ? this.splitMeta : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueSplitEstimateMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    splitId: string;
    estimateId: string;
    splitMeta: string | null;
}

export class IssueSplitInvoiceMeta extends IssueActivityMetaBase implements IIssueSplitInvoiceMeta {
    activityType: IssueActivityType;
    splitId: string;
    invoiceId: string;
    splitMeta: string | null;
    [immerable] = true;

    constructor(data?: IIssueSplitInvoiceMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "79";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.splitId = _data["splitId"] !== undefined ? _data["splitId"] : <any>null;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.splitMeta = _data["splitMeta"] !== undefined ? _data["splitMeta"] : <any>null;
        }
    }

    static fromJS(data: any): IssueSplitInvoiceMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSplitInvoiceMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["splitId"] = this.splitId !== undefined ? this.splitId : <any>null;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["splitMeta"] = this.splitMeta !== undefined ? this.splitMeta : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueSplitInvoiceMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    splitId: string;
    invoiceId: string;
    splitMeta: string | null;
}

export class IssueSubmitBidMeta extends IssueActivityMetaBase implements IIssueSubmitBidMeta {
    activityType: IssueActivityType;
    submittedBidId: string;
    fileId: string;
    [immerable] = true;

    constructor(data?: IIssueSubmitBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "14";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.submittedBidId = _data["submittedBidId"] !== undefined ? _data["submittedBidId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueSubmitBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSubmitBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["submittedBidId"] = this.submittedBidId !== undefined ? this.submittedBidId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueSubmitBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    submittedBidId: string;
    fileId: string;
}

export class IssueTenantCancelIssueMeta extends IssueActivityMetaBase implements IIssueTenantCancelIssueMeta {
    activityType: IssueActivityType;
    canceledScheduleId: string | null;
    [immerable] = true;

    constructor(data?: IIssueTenantCancelIssueMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "24";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.canceledScheduleId = _data["canceledScheduleId"] !== undefined ? _data["canceledScheduleId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueTenantCancelIssueMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueTenantCancelIssueMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["canceledScheduleId"] = this.canceledScheduleId !== undefined ? this.canceledScheduleId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueTenantCancelIssueMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    canceledScheduleId: string | null;
}

export class IssueTenantCancelScheduleMeta extends IssueActivityMetaBase implements IIssueTenantCancelScheduleMeta {
    activityType: IssueActivityType;
    canceledScheduleId: string;
    [immerable] = true;

    constructor(data?: IIssueTenantCancelScheduleMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "23";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.canceledScheduleId = _data["canceledScheduleId"] !== undefined ? _data["canceledScheduleId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueTenantCancelScheduleMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueTenantCancelScheduleMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["canceledScheduleId"] = this.canceledScheduleId !== undefined ? this.canceledScheduleId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueTenantCancelScheduleMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    canceledScheduleId: string;
}

export class IssueUnassignedTechMeta extends IssueActivityMetaBase implements IIssueUnassignedTechMeta {
    activityType: IssueActivityType;
    vendorId: string;
    techId: string;
    [immerable] = true;

    constructor(data?: IIssueUnassignedTechMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "41";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.techId = _data["techId"] !== undefined ? _data["techId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueUnassignedTechMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueUnassignedTechMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["techId"] = this.techId !== undefined ? this.techId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueUnassignedTechMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    vendorId: string;
    techId: string;
}

export class IssueUnassignedVendorMeta extends IssueActivityMetaBase implements IIssueUnassignedVendorMeta {
    activityType: IssueActivityType;
    vendorId: string;
    [immerable] = true;

    constructor(data?: IIssueUnassignedVendorMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "3";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueUnassignedVendorMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueUnassignedVendorMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueUnassignedVendorMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    vendorId: string;
}

export class IssueUninviteBidderMeta extends IssueActivityMetaBase implements IIssueUninviteBidderMeta {
    activityType: IssueActivityType;
    submittedBidId: string;
    uninvitedBids: string[] | null;
    vendorId: string;
    [immerable] = true;

    constructor(data?: IIssueUninviteBidderMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "56";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.submittedBidId = _data["submittedBidId"] !== undefined ? _data["submittedBidId"] : <any>null;
            if (Array.isArray(_data["uninvitedBids"])) {
                this.uninvitedBids = [] as any;
                for (let item of _data["uninvitedBids"])
                    this.uninvitedBids!.push(item);
            }
            else {
                this.uninvitedBids = <any>null;
            }
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueUninviteBidderMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueUninviteBidderMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["submittedBidId"] = this.submittedBidId !== undefined ? this.submittedBidId : <any>null;
        if (Array.isArray(this.uninvitedBids)) {
            data["uninvitedBids"] = [];
            for (let item of this.uninvitedBids)
                data["uninvitedBids"].push(item);
        }
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueUninviteBidderMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    submittedBidId: string;
    uninvitedBids: string[] | null;
    vendorId: string;
}

export class IssueUpdateBidMeta extends IssueActivityMetaBase implements IIssueUpdateBidMeta {
    activityType: IssueActivityType;
    submittedBidId: string;
    fileId: string;
    [immerable] = true;

    constructor(data?: IIssueUpdateBidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "45";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.submittedBidId = _data["submittedBidId"] !== undefined ? _data["submittedBidId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueUpdateBidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueUpdateBidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["submittedBidId"] = this.submittedBidId !== undefined ? this.submittedBidId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueUpdateBidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    submittedBidId: string;
    fileId: string;
}

export class IssueUpdatedChangeRequestMeta extends IssueActivityMetaBase implements IIssueUpdatedChangeRequestMeta {
    activityType: IssueActivityType;
    changeRequestId: string;
    fileId: string | null;
    [immerable] = true;

    constructor(data?: IIssueUpdatedChangeRequestMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "32";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.changeRequestId = _data["changeRequestId"] !== undefined ? _data["changeRequestId"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueUpdatedChangeRequestMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueUpdatedChangeRequestMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["changeRequestId"] = this.changeRequestId !== undefined ? this.changeRequestId : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueUpdatedChangeRequestMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    changeRequestId: string;
    fileId: string | null;
}

export class IssueUpdatedMeta extends IssueActivityMetaBase implements IIssueUpdatedMeta {
    activityType: IssueActivityType;
    [immerable] = true;

    constructor(data?: IIssueUpdatedMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "4";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
        }
    }

    static fromJS(data: any): IssueUpdatedMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueUpdatedMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueUpdatedMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
}

export class IssueVendorCancelIssueMeta extends IssueActivityMetaBase implements IIssueVendorCancelIssueMeta {
    activityType: IssueActivityType;
    canceledScheduleId: string | null;
    unassignedVendorId: string;
    [immerable] = true;

    constructor(data?: IIssueVendorCancelIssueMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "25";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.canceledScheduleId = _data["canceledScheduleId"] !== undefined ? _data["canceledScheduleId"] : <any>null;
            this.unassignedVendorId = _data["unassignedVendorId"] !== undefined ? _data["unassignedVendorId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueVendorCancelIssueMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueVendorCancelIssueMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["canceledScheduleId"] = this.canceledScheduleId !== undefined ? this.canceledScheduleId : <any>null;
        data["unassignedVendorId"] = this.unassignedVendorId !== undefined ? this.unassignedVendorId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueVendorCancelIssueMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    canceledScheduleId: string | null;
    unassignedVendorId: string;
}

export class IssueVendorCancelScheduleMeta extends IssueActivityMetaBase implements IIssueVendorCancelScheduleMeta {
    activityType: IssueActivityType;
    canceledScheduleId: string;
    [immerable] = true;

    constructor(data?: IIssueVendorCancelScheduleMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "22";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
            this.canceledScheduleId = _data["canceledScheduleId"] !== undefined ? _data["canceledScheduleId"] : <any>null;
        }
    }

    static fromJS(data: any): IssueVendorCancelScheduleMeta {
        data = typeof data === 'object' ? data : {};
        let result = new IssueVendorCancelScheduleMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        data["canceledScheduleId"] = this.canceledScheduleId !== undefined ? this.canceledScheduleId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueVendorCancelScheduleMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
    canceledScheduleId: string;
}

export class MarkedIssuePaidMeta extends IssueActivityMetaBase implements IMarkedIssuePaidMeta {
    activityType: IssueActivityType;
    [immerable] = true;

    constructor(data?: IMarkedIssuePaidMeta) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "62";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : <any>null;
        }
    }

    static fromJS(data: any): MarkedIssuePaidMeta {
        data = typeof data === 'object' ? data : {};
        let result = new MarkedIssuePaidMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType !== undefined ? this.activityType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMarkedIssuePaidMeta extends IIssueActivityMetaBase {
    activityType: IssueActivityType;
}

export class SentNotificationSummary implements ISentNotificationSummary {
    id: string;
    user: UserSummary | null;
    sentAt: Date;
    sentSuccess: boolean;
    theirAddress: string | null;
    method: CommunicationMethod;
    [immerable] = true;

    constructor(data?: ISentNotificationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new UserSummary(data.user) : <UserSummary>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.user = _data["user"] ? UserSummary.fromJS(_data["user"]) : <any>null;
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : <any>null;
            this.sentSuccess = _data["sentSuccess"] !== undefined ? _data["sentSuccess"] : <any>null;
            this.theirAddress = _data["theirAddress"] !== undefined ? _data["theirAddress"] : <any>null;
            this.method = _data["method"] !== undefined ? _data["method"] : <any>null;
        }
    }

    static fromJS(data: any): SentNotificationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new SentNotificationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["sentAt"] = this.sentAt ? this.sentAt.toISOString() : <any>null;
        data["sentSuccess"] = this.sentSuccess !== undefined ? this.sentSuccess : <any>null;
        data["theirAddress"] = this.theirAddress !== undefined ? this.theirAddress : <any>null;
        data["method"] = this.method !== undefined ? this.method : <any>null;
        return data;
    }
}

export interface ISentNotificationSummary {
    id: string;
    user: IUserSummary | null;
    sentAt: Date;
    sentSuccess: boolean;
    theirAddress: string | null;
    method: CommunicationMethod;
}

export enum CommunicationMethod {
    Unknown = 0,
    Sms = 1,
    Email = 2,
}

export class SentNotificationDetails extends SentNotificationSummary implements ISentNotificationDetails {
    htmlBody: string | null;
    plaintextBody: string | null;
    subject: string | null;
    attachments: AttachmentFile[] | null;
    [immerable] = true;

    constructor(data?: ISentNotificationDetails) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property) )
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.attachments) {
                this.attachments = [];
                for (let i = 0; i < data.attachments.length; i++) {
                    let item = data.attachments[i];
                    this.attachments[i] = item && !(<any>item).toJSON ? new AttachmentFile(item) : <AttachmentFile>item;
                }
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.htmlBody = _data["htmlBody"] !== undefined ? _data["htmlBody"] : <any>null;
            this.plaintextBody = _data["plaintextBody"] !== undefined ? _data["plaintextBody"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentFile.fromJS(item));
            }
            else {
                this.attachments = <any>null;
            }
        }
    }

    static fromJS(data: any): SentNotificationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SentNotificationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["htmlBody"] = this.htmlBody !== undefined ? this.htmlBody : <any>null;
        data["plaintextBody"] = this.plaintextBody !== undefined ? this.plaintextBody : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISentNotificationDetails extends ISentNotificationSummary {
    htmlBody: string | null;
    plaintextBody: string | null;
    subject: string | null;
    attachments: IAttachmentFile[] | null;
}

export class TenantCancelIssuePayload implements ITenantCancelIssuePayload {
    issueId: string;
    comments: string | null;
    [immerable] = true;

    constructor(data?: ITenantCancelIssuePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
        }
    }

    static fromJS(data: any): TenantCancelIssuePayload {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCancelIssuePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        return data;
    }
}

export interface ITenantCancelIssuePayload {
    issueId: string;
    comments: string | null;
}

export class VendorCancelIssuePayload implements IVendorCancelIssuePayload {
    issueId: string;
    comments: string | null;
    [immerable] = true;

    constructor(data?: IVendorCancelIssuePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
        }
    }

    static fromJS(data: any): VendorCancelIssuePayload {
        data = typeof data === 'object' ? data : {};
        let result = new VendorCancelIssuePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        return data;
    }
}

export interface IVendorCancelIssuePayload {
    issueId: string;
    comments: string | null;
}

export class CreateBoardPostPayload implements ICreateBoardPostPayload {
    issueId: string;
    message: string | null;
    [immerable] = true;

    constructor(data?: ICreateBoardPostPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): CreateBoardPostPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBoardPostPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }
}

export interface ICreateBoardPostPayload {
    issueId: string;
    message: string | null;
}

export class DeleteBoardPostPayload implements IDeleteBoardPostPayload {
    postId: string;
    [immerable] = true;

    constructor(data?: IDeleteBoardPostPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postId = _data["postId"] !== undefined ? _data["postId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteBoardPostPayload {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBoardPostPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postId"] = this.postId !== undefined ? this.postId : <any>null;
        return data;
    }
}

export interface IDeleteBoardPostPayload {
    postId: string;
}

export class AddOrUpdatePaymentPayload implements IAddOrUpdatePaymentPayload {
    id: string | null;
    date: Date;
    amount: number;
    notes: string | null;
    issueId: string;
    invoices: Invoice2[] | null;
    useDwolla: boolean;
    [immerable] = true;

    constructor(data?: IAddOrUpdatePaymentPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.invoices) {
                this.invoices = [];
                for (let i = 0; i < data.invoices.length; i++) {
                    let item = data.invoices[i];
                    this.invoices[i] = item && !(<any>item).toJSON ? new Invoice2(item) : <Invoice2>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(Invoice2.fromJS(item));
            }
            else {
                this.invoices = <any>null;
            }
            this.useDwolla = _data["useDwolla"] !== undefined ? _data["useDwolla"] : <any>null;
        }
    }

    static fromJS(data: any): AddOrUpdatePaymentPayload {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdatePaymentPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["useDwolla"] = this.useDwolla !== undefined ? this.useDwolla : <any>null;
        return data;
    }
}

export interface IAddOrUpdatePaymentPayload {
    id: string | null;
    date: Date;
    amount: number;
    notes: string | null;
    issueId: string;
    invoices: IInvoice2[] | null;
    useDwolla: boolean;
}

export class Invoice2 implements IInvoice2 {
    invoiceId: string;
    allocatedAmount: number;
    [immerable] = true;

    constructor(data?: IInvoice2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : <any>null;
            this.allocatedAmount = _data["allocatedAmount"] !== undefined ? _data["allocatedAmount"] : <any>null;
        }
    }

    static fromJS(data: any): Invoice2 {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : <any>null;
        data["allocatedAmount"] = this.allocatedAmount !== undefined ? this.allocatedAmount : <any>null;
        return data;
    }
}

export interface IInvoice2 {
    invoiceId: string;
    allocatedAmount: number;
}

export class ProfitLossStatement implements IProfitLossStatement {
    assets: number;
    liabilities: number;
    potentialAssets: number;
    potentialLiabilities: number;
    startDate: Instant | null;
    endDate: Instant | null;
    stateCodes: string[] | null;
    vendorIds: string[] | null;
    companyIds: string[] | null;
    accountManagerId: string | null;
    grandTotal: number;
    [immerable] = true;

    constructor(data?: IProfitLossStatement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assets = _data["assets"] !== undefined ? _data["assets"] : <any>null;
            this.liabilities = _data["liabilities"] !== undefined ? _data["liabilities"] : <any>null;
            this.potentialAssets = _data["potentialAssets"] !== undefined ? _data["potentialAssets"] : <any>null;
            this.potentialLiabilities = _data["potentialLiabilities"] !== undefined ? _data["potentialLiabilities"] : <any>null;
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
            if (Array.isArray(_data["stateCodes"])) {
                this.stateCodes = [] as any;
                for (let item of _data["stateCodes"])
                    this.stateCodes!.push(item);
            }
            else {
                this.stateCodes = <any>null;
            }
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            else {
                this.vendorIds = <any>null;
            }
            if (Array.isArray(_data["companyIds"])) {
                this.companyIds = [] as any;
                for (let item of _data["companyIds"])
                    this.companyIds!.push(item);
            }
            else {
                this.companyIds = <any>null;
            }
            this.accountManagerId = _data["accountManagerId"] !== undefined ? _data["accountManagerId"] : <any>null;
            this.grandTotal = _data["grandTotal"] !== undefined ? _data["grandTotal"] : <any>null;
        }
    }

    static fromJS(data: any): ProfitLossStatement {
        data = typeof data === 'object' ? data : {};
        let result = new ProfitLossStatement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assets"] = this.assets !== undefined ? this.assets : <any>null;
        data["liabilities"] = this.liabilities !== undefined ? this.liabilities : <any>null;
        data["potentialAssets"] = this.potentialAssets !== undefined ? this.potentialAssets : <any>null;
        data["potentialLiabilities"] = this.potentialLiabilities !== undefined ? this.potentialLiabilities : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        if (Array.isArray(this.stateCodes)) {
            data["stateCodes"] = [];
            for (let item of this.stateCodes)
                data["stateCodes"].push(item);
        }
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (Array.isArray(this.companyIds)) {
            data["companyIds"] = [];
            for (let item of this.companyIds)
                data["companyIds"].push(item);
        }
        data["accountManagerId"] = this.accountManagerId !== undefined ? this.accountManagerId : <any>null;
        data["grandTotal"] = this.grandTotal !== undefined ? this.grandTotal : <any>null;
        return data;
    }
}

export interface IProfitLossStatement {
    assets: number;
    liabilities: number;
    potentialAssets: number;
    potentialLiabilities: number;
    startDate: IInstant | null;
    endDate: IInstant | null;
    stateCodes: string[] | null;
    vendorIds: string[] | null;
    companyIds: string[] | null;
    accountManagerId: string | null;
    grandTotal: number;
}

export class GetProfitLossPayload implements IGetProfitLossPayload {
    startDate: Instant | null;
    endDate: Instant | null;
    stateCodes: string[] | null;
    vendorIds: string[] | null;
    companyIds: string[] | null;
    accountManagerId: string | null;
    [immerable] = true;

    constructor(data?: IGetProfitLossPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
            if (Array.isArray(_data["stateCodes"])) {
                this.stateCodes = [] as any;
                for (let item of _data["stateCodes"])
                    this.stateCodes!.push(item);
            }
            else {
                this.stateCodes = <any>null;
            }
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            else {
                this.vendorIds = <any>null;
            }
            if (Array.isArray(_data["companyIds"])) {
                this.companyIds = [] as any;
                for (let item of _data["companyIds"])
                    this.companyIds!.push(item);
            }
            else {
                this.companyIds = <any>null;
            }
            this.accountManagerId = _data["accountManagerId"] !== undefined ? _data["accountManagerId"] : <any>null;
        }
    }

    static fromJS(data: any): GetProfitLossPayload {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfitLossPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        if (Array.isArray(this.stateCodes)) {
            data["stateCodes"] = [];
            for (let item of this.stateCodes)
                data["stateCodes"].push(item);
        }
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (Array.isArray(this.companyIds)) {
            data["companyIds"] = [];
            for (let item of this.companyIds)
                data["companyIds"].push(item);
        }
        data["accountManagerId"] = this.accountManagerId !== undefined ? this.accountManagerId : <any>null;
        return data;
    }
}

export interface IGetProfitLossPayload {
    startDate: IInstant | null;
    endDate: IInstant | null;
    stateCodes: string[] | null;
    vendorIds: string[] | null;
    companyIds: string[] | null;
    accountManagerId: string | null;
}

export class PaymentGroup implements IPaymentGroup {
    entries: PaymentGroupEntry[] | null;
    potentialInvoices: number;
    [immerable] = true;

    constructor(data?: IPaymentGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.entries) {
                this.entries = [];
                for (let i = 0; i < data.entries.length; i++) {
                    let item = data.entries[i];
                    this.entries[i] = item && !(<any>item).toJSON ? new PaymentGroupEntry(item) : <PaymentGroupEntry>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(PaymentGroupEntry.fromJS(item));
            }
            else {
                this.entries = <any>null;
            }
            this.potentialInvoices = _data["potentialInvoices"] !== undefined ? _data["potentialInvoices"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentGroup {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        data["potentialInvoices"] = this.potentialInvoices !== undefined ? this.potentialInvoices : <any>null;
        return data;
    }
}

export interface IPaymentGroup {
    entries: IPaymentGroupEntry[] | null;
    potentialInvoices: number;
}

export class PaymentGroupEntry implements IPaymentGroupEntry {
    companyId: string;
    companyName: string | null;
    invoices: PayableInvoiceInfo[] | null;
    noAge: number;
    age0: number;
    age15: number;
    age30: number;
    age60: number;
    ageMax: number;
    total: number;
    [immerable] = true;

    constructor(data?: IPaymentGroupEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.invoices) {
                this.invoices = [];
                for (let i = 0; i < data.invoices.length; i++) {
                    let item = data.invoices[i];
                    this.invoices[i] = item && !(<any>item).toJSON ? new PayableInvoiceInfo(item) : <PayableInvoiceInfo>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(PayableInvoiceInfo.fromJS(item));
            }
            else {
                this.invoices = <any>null;
            }
            this.noAge = _data["noAge"] !== undefined ? _data["noAge"] : <any>null;
            this.age0 = _data["age0"] !== undefined ? _data["age0"] : <any>null;
            this.age15 = _data["age15"] !== undefined ? _data["age15"] : <any>null;
            this.age30 = _data["age30"] !== undefined ? _data["age30"] : <any>null;
            this.age60 = _data["age60"] !== undefined ? _data["age60"] : <any>null;
            this.ageMax = _data["ageMax"] !== undefined ? _data["ageMax"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentGroupEntry {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGroupEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["noAge"] = this.noAge !== undefined ? this.noAge : <any>null;
        data["age0"] = this.age0 !== undefined ? this.age0 : <any>null;
        data["age15"] = this.age15 !== undefined ? this.age15 : <any>null;
        data["age30"] = this.age30 !== undefined ? this.age30 : <any>null;
        data["age60"] = this.age60 !== undefined ? this.age60 : <any>null;
        data["ageMax"] = this.ageMax !== undefined ? this.ageMax : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        return data;
    }
}

export interface IPaymentGroupEntry {
    companyId: string;
    companyName: string | null;
    invoices: IPayableInvoiceInfo[] | null;
    noAge: number;
    age0: number;
    age15: number;
    age30: number;
    age60: number;
    ageMax: number;
    total: number;
}

export class PayableInvoiceInfo implements IPayableInvoiceInfo {
    invoice: Invoice | null;
    issue: PayableIssueInfo | null;
    age: number | null;
    [immerable] = true;

    constructor(data?: IPayableInvoiceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.invoice = data.invoice && !(<any>data.invoice).toJSON ? new Invoice(data.invoice) : <Invoice>this.invoice;
            this.issue = data.issue && !(<any>data.issue).toJSON ? new PayableIssueInfo(data.issue) : <PayableIssueInfo>this.issue;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>null;
            this.issue = _data["issue"] ? PayableIssueInfo.fromJS(_data["issue"]) : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
        }
    }

    static fromJS(data: any): PayableInvoiceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PayableInvoiceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>null;
        data["issue"] = this.issue ? this.issue.toJSON() : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        return data;
    }
}

export interface IPayableInvoiceInfo {
    invoice: IInvoice | null;
    issue: IPayableIssueInfo | null;
    age: number | null;
}

export class PayableIssueInfo implements IPayableIssueInfo {
    id: string;
    workorderId: string;
    property: PropertySummary | null;
    manager: UserSummary | null;
    title: string | null;
    friendlyId: string | null;
    status: IssueStatus;
    [immerable] = true;

    constructor(data?: IPayableIssueInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.property = data.property && !(<any>data.property).toJSON ? new PropertySummary(data.property) : <PropertySummary>this.property;
            this.manager = data.manager && !(<any>data.manager).toJSON ? new UserSummary(data.manager) : <UserSummary>this.manager;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.workorderId = _data["workorderId"] !== undefined ? _data["workorderId"] : <any>null;
            this.property = _data["property"] ? PropertySummary.fromJS(_data["property"]) : <any>null;
            this.manager = _data["manager"] ? UserSummary.fromJS(_data["manager"]) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): PayableIssueInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PayableIssueInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["workorderId"] = this.workorderId !== undefined ? this.workorderId : <any>null;
        data["property"] = this.property ? this.property.toJSON() : <any>null;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IPayableIssueInfo {
    id: string;
    workorderId: string;
    property: IPropertySummary | null;
    manager: IUserSummary | null;
    title: string | null;
    friendlyId: string | null;
    status: IssueStatus;
}

export class PayeeInfo implements IPayeeInfo {
    vendor: Vendor | null;
    payments: PayeePayment[] | null;
    user: UserSummary | null;
    totalPayments: number;
    totalFees: number;
    jobCount: number;
    [immerable] = true;

    constructor(data?: IPayeeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.vendor = data.vendor && !(<any>data.vendor).toJSON ? new Vendor(data.vendor) : <Vendor>this.vendor;
            if (data.payments) {
                this.payments = [];
                for (let i = 0; i < data.payments.length; i++) {
                    let item = data.payments[i];
                    this.payments[i] = item && !(<any>item).toJSON ? new PayeePayment(item) : <PayeePayment>item;
                }
            }
            this.user = data.user && !(<any>data.user).toJSON ? new UserSummary(data.user) : <UserSummary>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>null;
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(PayeePayment.fromJS(item));
            }
            else {
                this.payments = <any>null;
            }
            this.user = _data["user"] ? UserSummary.fromJS(_data["user"]) : <any>null;
            this.totalPayments = _data["totalPayments"] !== undefined ? _data["totalPayments"] : <any>null;
            this.totalFees = _data["totalFees"] !== undefined ? _data["totalFees"] : <any>null;
            this.jobCount = _data["jobCount"] !== undefined ? _data["jobCount"] : <any>null;
        }
    }

    static fromJS(data: any): PayeeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PayeeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>null;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["totalPayments"] = this.totalPayments !== undefined ? this.totalPayments : <any>null;
        data["totalFees"] = this.totalFees !== undefined ? this.totalFees : <any>null;
        data["jobCount"] = this.jobCount !== undefined ? this.jobCount : <any>null;
        return data;
    }
}

export interface IPayeeInfo {
    vendor: IVendor | null;
    payments: IPayeePayment[] | null;
    user: IUserSummary | null;
    totalPayments: number;
    totalFees: number;
    jobCount: number;
}

export class PayeePayment implements IPayeePayment {
    date: Date;
    amount: number;
    fee: number;
    issue: Issue | null;
    method: PaymentMethod;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IPayeePayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.issue = data.issue && !(<any>data.issue).toJSON ? new Issue(data.issue) : <Issue>this.issue;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.fee = _data["fee"] !== undefined ? _data["fee"] : <any>null;
            this.issue = _data["issue"] ? Issue.fromJS(_data["issue"]) : <any>null;
            this.method = _data["method"] !== undefined ? _data["method"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): PayeePayment {
        data = typeof data === 'object' ? data : {};
        let result = new PayeePayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["fee"] = this.fee !== undefined ? this.fee : <any>null;
        data["issue"] = this.issue ? this.issue.toJSON() : <any>null;
        data["method"] = this.method !== undefined ? this.method : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IPayeePayment {
    date: Date;
    amount: number;
    fee: number;
    issue: IIssue | null;
    method: PaymentMethod;
    notes: string | null;
}

export enum PaymentMethod {
    Internal = 0,
    Dwolla = 1,
    Stripe = 2,
}

export class ListForPayeePagePayload implements IListForPayeePagePayload {
    vendorId: string | null;
    startDate: Instant | null;
    endDate: Instant | null;
    [immerable] = true;

    constructor(data?: IListForPayeePagePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
        }
    }

    static fromJS(data: any): ListForPayeePagePayload {
        data = typeof data === 'object' ? data : {};
        let result = new ListForPayeePagePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        return data;
    }
}

export interface IListForPayeePagePayload {
    vendorId: string | null;
    startDate: IInstant | null;
    endDate: IInstant | null;
}

export class ExportPayeesPdfPayload implements IExportPayeesPdfPayload {
    vendorId: string | null;
    startDate: Instant | null;
    endDate: Instant | null;
    [immerable] = true;

    constructor(data?: IExportPayeesPdfPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"] !== undefined ? _data["vendorId"] : <any>null;
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
        }
    }

    static fromJS(data: any): ExportPayeesPdfPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPayeesPdfPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        return data;
    }
}

export interface IExportPayeesPdfPayload {
    vendorId: string | null;
    startDate: IInstant | null;
    endDate: IInstant | null;
}

export class ExportPayeesCsvPayload implements IExportPayeesCsvPayload {
    startDate: Instant | null;
    endDate: Instant | null;
    [immerable] = true;

    constructor(data?: IExportPayeesCsvPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.startDate = data.startDate && !(<any>data.startDate).toJSON ? new Instant(data.startDate) : <Instant>this.startDate;
            this.endDate = data.endDate && !(<any>data.endDate).toJSON ? new Instant(data.endDate) : <Instant>this.endDate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? Instant.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? Instant.fromJS(_data["endDate"]) : <any>null;
        }
    }

    static fromJS(data: any): ExportPayeesCsvPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPayeesCsvPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>null;
        return data;
    }
}

export interface IExportPayeesCsvPayload {
    startDate: IInstant | null;
    endDate: IInstant | null;
}

export class ExportAccountsReceivablePayload implements IExportAccountsReceivablePayload {
    companyId: string;
    [immerable] = true;

    constructor(data?: IExportAccountsReceivablePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : <any>null;
        }
    }

    static fromJS(data: any): ExportAccountsReceivablePayload {
        data = typeof data === 'object' ? data : {};
        let result = new ExportAccountsReceivablePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : <any>null;
        return data;
    }
}

export interface IExportAccountsReceivablePayload {
    companyId: string;
}

export class SetIssueSchedulePayload implements ISetIssueSchedulePayload {
    proposalType: ProposalType;
    issueId: string;
    scheduledInstant: Instant | null;
    comments: string | null;
    timeBlocks: TimeBlock[] | null;
    [immerable] = true;

    constructor(data?: ISetIssueSchedulePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.scheduledInstant = data.scheduledInstant && !(<any>data.scheduledInstant).toJSON ? new Instant(data.scheduledInstant) : <Instant>this.scheduledInstant;
            if (data.timeBlocks) {
                this.timeBlocks = [];
                for (let i = 0; i < data.timeBlocks.length; i++) {
                    let item = data.timeBlocks[i];
                    this.timeBlocks[i] = item && !(<any>item).toJSON ? new TimeBlock(item) : <TimeBlock>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proposalType = _data["proposalType"] !== undefined ? _data["proposalType"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.scheduledInstant = _data["scheduledInstant"] ? Instant.fromJS(_data["scheduledInstant"]) : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            if (Array.isArray(_data["timeBlocks"])) {
                this.timeBlocks = [] as any;
                for (let item of _data["timeBlocks"])
                    this.timeBlocks!.push(TimeBlock.fromJS(item));
            }
            else {
                this.timeBlocks = <any>null;
            }
        }
    }

    static fromJS(data: any): SetIssueSchedulePayload {
        data = typeof data === 'object' ? data : {};
        let result = new SetIssueSchedulePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalType"] = this.proposalType !== undefined ? this.proposalType : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["scheduledInstant"] = this.scheduledInstant ? this.scheduledInstant.toJSON() : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        if (Array.isArray(this.timeBlocks)) {
            data["timeBlocks"] = [];
            for (let item of this.timeBlocks)
                data["timeBlocks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetIssueSchedulePayload {
    proposalType: ProposalType;
    issueId: string;
    scheduledInstant: IInstant | null;
    comments: string | null;
    timeBlocks: ITimeBlock[] | null;
}

export class SkipSchedulingPayload implements ISkipSchedulingPayload {
    issueId: string;
    notes: string | null;
    [immerable] = true;

    constructor(data?: ISkipSchedulingPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): SkipSchedulingPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SkipSchedulingPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface ISkipSchedulingPayload {
    issueId: string;
    notes: string | null;
}

export class CancelIssueSchedulePayload implements ICancelIssueSchedulePayload {
    capabilityType: CapabilityType;
    issueId: string;
    comments: string | null;
    [immerable] = true;

    constructor(data?: ICancelIssueSchedulePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.capabilityType = _data["capabilityType"] !== undefined ? _data["capabilityType"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
        }
    }

    static fromJS(data: any): CancelIssueSchedulePayload {
        data = typeof data === 'object' ? data : {};
        let result = new CancelIssueSchedulePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capabilityType"] = this.capabilityType !== undefined ? this.capabilityType : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        return data;
    }
}

export interface ICancelIssueSchedulePayload {
    capabilityType: CapabilityType;
    issueId: string;
    comments: string | null;
}

export class ReviewIssueSchedulePayload implements IReviewIssueSchedulePayload {
    issueId: string;
    action: ReviewIssueScheduleAction;
    notes: string | null;
    [immerable] = true;

    constructor(data?: IReviewIssueSchedulePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): ReviewIssueSchedulePayload {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewIssueSchedulePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IReviewIssueSchedulePayload {
    issueId: string;
    action: ReviewIssueScheduleAction;
    notes: string | null;
}

export enum ReviewIssueScheduleAction {
    Accept = 0,
    Reject = 1,
}

export class ChecklistDefaultsResponse implements IChecklistDefaultsResponse {
    lines: ChecklistFormLine[] | null;
    [immerable] = true;

    constructor(data?: IChecklistDefaultsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.lines) {
                this.lines = [];
                for (let i = 0; i < data.lines.length; i++) {
                    let item = data.lines[i];
                    this.lines[i] = item && !(<any>item).toJSON ? new ChecklistFormLine(item) : <ChecklistFormLine>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(ChecklistFormLine.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): ChecklistDefaultsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDefaultsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChecklistDefaultsResponse {
    lines: IChecklistFormLine[] | null;
}

export class ChecklistFormLine implements IChecklistFormLine {
    description: string | null;
    isComplete: boolean | null;
    notes: string | null;
    value: number | null;
    initialValue: number | null;
    beforeFiles: AttachmentFile[] | null;
    afterFiles: AttachmentFile[] | null;
    sourceEntityType: LineSource;
    sourceEntityId: string | null;
    [immerable] = true;

    constructor(data?: IChecklistFormLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.beforeFiles) {
                this.beforeFiles = [];
                for (let i = 0; i < data.beforeFiles.length; i++) {
                    let item = data.beforeFiles[i];
                    this.beforeFiles[i] = item && !(<any>item).toJSON ? new AttachmentFile(item) : <AttachmentFile>item;
                }
            }
            if (data.afterFiles) {
                this.afterFiles = [];
                for (let i = 0; i < data.afterFiles.length; i++) {
                    let item = data.afterFiles[i];
                    this.afterFiles[i] = item && !(<any>item).toJSON ? new AttachmentFile(item) : <AttachmentFile>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isComplete = _data["isComplete"] !== undefined ? _data["isComplete"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.initialValue = _data["initialValue"] !== undefined ? _data["initialValue"] : <any>null;
            if (Array.isArray(_data["beforeFiles"])) {
                this.beforeFiles = [] as any;
                for (let item of _data["beforeFiles"])
                    this.beforeFiles!.push(AttachmentFile.fromJS(item));
            }
            else {
                this.beforeFiles = <any>null;
            }
            if (Array.isArray(_data["afterFiles"])) {
                this.afterFiles = [] as any;
                for (let item of _data["afterFiles"])
                    this.afterFiles!.push(AttachmentFile.fromJS(item));
            }
            else {
                this.afterFiles = <any>null;
            }
            this.sourceEntityType = _data["sourceEntityType"] !== undefined ? _data["sourceEntityType"] : <any>null;
            this.sourceEntityId = _data["sourceEntityId"] !== undefined ? _data["sourceEntityId"] : <any>null;
        }
    }

    static fromJS(data: any): ChecklistFormLine {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistFormLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isComplete"] = this.isComplete !== undefined ? this.isComplete : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["initialValue"] = this.initialValue !== undefined ? this.initialValue : <any>null;
        if (Array.isArray(this.beforeFiles)) {
            data["beforeFiles"] = [];
            for (let item of this.beforeFiles)
                data["beforeFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.afterFiles)) {
            data["afterFiles"] = [];
            for (let item of this.afterFiles)
                data["afterFiles"].push(item.toJSON());
        }
        data["sourceEntityType"] = this.sourceEntityType !== undefined ? this.sourceEntityType : <any>null;
        data["sourceEntityId"] = this.sourceEntityId !== undefined ? this.sourceEntityId : <any>null;
        return data;
    }
}

export interface IChecklistFormLine {
    description: string | null;
    isComplete: boolean | null;
    notes: string | null;
    value: number | null;
    initialValue: number | null;
    beforeFiles: IAttachmentFile[] | null;
    afterFiles: IAttachmentFile[] | null;
    sourceEntityType: LineSource;
    sourceEntityId: string | null;
}

export class ChecklistDefaultsPayload implements IChecklistDefaultsPayload {
    issueId: string;
    [immerable] = true;

    constructor(data?: IChecklistDefaultsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
        }
    }

    static fromJS(data: any): ChecklistDefaultsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDefaultsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        return data;
    }
}

export interface IChecklistDefaultsPayload {
    issueId: string;
}

export class MarkWorkCompleteResult implements IMarkWorkCompleteResult {
    createdInvoiceId: string | null;
    issueView: IssueUserView | null;
    [immerable] = true;

    constructor(data?: IMarkWorkCompleteResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.issueView = data.issueView && !(<any>data.issueView).toJSON ? new IssueUserView(data.issueView) : <IssueUserView>this.issueView;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdInvoiceId = _data["createdInvoiceId"] !== undefined ? _data["createdInvoiceId"] : <any>null;
            this.issueView = _data["issueView"] ? IssueUserView.fromJS(_data["issueView"]) : <any>null;
        }
    }

    static fromJS(data: any): MarkWorkCompleteResult {
        data = typeof data === 'object' ? data : {};
        let result = new MarkWorkCompleteResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdInvoiceId"] = this.createdInvoiceId !== undefined ? this.createdInvoiceId : <any>null;
        data["issueView"] = this.issueView ? this.issueView.toJSON() : <any>null;
        return data;
    }
}

export interface IMarkWorkCompleteResult {
    createdInvoiceId: string | null;
    issueView: IIssueUserView | null;
}

export class MarkWorkCompletePayload implements IMarkWorkCompletePayload {
    issueId: string;
    oldStatus: IssueStatus;
    lines: ChecklistLinePayload[] | null;
    [immerable] = true;

    constructor(data?: IMarkWorkCompletePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.lines) {
                this.lines = [];
                for (let i = 0; i < data.lines.length; i++) {
                    let item = data.lines[i];
                    this.lines[i] = item && !(<any>item).toJSON ? new ChecklistLinePayload(item) : <ChecklistLinePayload>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.oldStatus = _data["oldStatus"] !== undefined ? _data["oldStatus"] : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(ChecklistLinePayload.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): MarkWorkCompletePayload {
        data = typeof data === 'object' ? data : {};
        let result = new MarkWorkCompletePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["oldStatus"] = this.oldStatus !== undefined ? this.oldStatus : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkWorkCompletePayload {
    issueId: string;
    oldStatus: IssueStatus;
    lines: IChecklistLinePayload[] | null;
}

export class ChecklistLinePayload implements IChecklistLinePayload {
    description: string | null;
    isComplete: boolean;
    sourceEntityType: LineSource;
    sourceEntityId: string | null;
    value: number | null;
    initialValue: number | null;
    notes: string | null;
    beforeFileIds: string[] | null;
    afterFileIds: string[] | null;
    [immerable] = true;

    constructor(data?: IChecklistLinePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isComplete = _data["isComplete"] !== undefined ? _data["isComplete"] : <any>null;
            this.sourceEntityType = _data["sourceEntityType"] !== undefined ? _data["sourceEntityType"] : <any>null;
            this.sourceEntityId = _data["sourceEntityId"] !== undefined ? _data["sourceEntityId"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.initialValue = _data["initialValue"] !== undefined ? _data["initialValue"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            if (Array.isArray(_data["beforeFileIds"])) {
                this.beforeFileIds = [] as any;
                for (let item of _data["beforeFileIds"])
                    this.beforeFileIds!.push(item);
            }
            else {
                this.beforeFileIds = <any>null;
            }
            if (Array.isArray(_data["afterFileIds"])) {
                this.afterFileIds = [] as any;
                for (let item of _data["afterFileIds"])
                    this.afterFileIds!.push(item);
            }
            else {
                this.afterFileIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ChecklistLinePayload {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistLinePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isComplete"] = this.isComplete !== undefined ? this.isComplete : <any>null;
        data["sourceEntityType"] = this.sourceEntityType !== undefined ? this.sourceEntityType : <any>null;
        data["sourceEntityId"] = this.sourceEntityId !== undefined ? this.sourceEntityId : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["initialValue"] = this.initialValue !== undefined ? this.initialValue : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        if (Array.isArray(this.beforeFileIds)) {
            data["beforeFileIds"] = [];
            for (let item of this.beforeFileIds)
                data["beforeFileIds"].push(item);
        }
        if (Array.isArray(this.afterFileIds)) {
            data["afterFileIds"] = [];
            for (let item of this.afterFileIds)
                data["afterFileIds"].push(item);
        }
        return data;
    }
}

export interface IChecklistLinePayload {
    description: string | null;
    isComplete: boolean;
    sourceEntityType: LineSource;
    sourceEntityId: string | null;
    value: number | null;
    initialValue: number | null;
    notes: string | null;
    beforeFileIds: string[] | null;
    afterFileIds: string[] | null;
}

export class StatusAvailabilityMeta implements IStatusAvailabilityMeta {
    status: IssueStatus;
    canEnter: boolean;
    reason: string | null;
    [immerable] = true;

    constructor(data?: IStatusAvailabilityMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.canEnter = _data["canEnter"] !== undefined ? _data["canEnter"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
        }
    }

    static fromJS(data: any): StatusAvailabilityMeta {
        data = typeof data === 'object' ? data : {};
        let result = new StatusAvailabilityMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["canEnter"] = this.canEnter !== undefined ? this.canEnter : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        return data;
    }
}

export interface IStatusAvailabilityMeta {
    status: IssueStatus;
    canEnter: boolean;
    reason: string | null;
}

export class GetAvailableJumpStatusesPayload implements IGetAvailableJumpStatusesPayload {
    issueId: string;
    [immerable] = true;

    constructor(data?: IGetAvailableJumpStatusesPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
        }
    }

    static fromJS(data: any): GetAvailableJumpStatusesPayload {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableJumpStatusesPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        return data;
    }
}

export interface IGetAvailableJumpStatusesPayload {
    issueId: string;
}

export class SetIssueStatusPayload implements ISetIssueStatusPayload {
    notes: string | null;
    issueId: string;
    oldStatus: IssueStatus;
    newStatus: IssueStatus;
    [immerable] = true;

    constructor(data?: ISetIssueStatusPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.oldStatus = _data["oldStatus"] !== undefined ? _data["oldStatus"] : <any>null;
            this.newStatus = _data["newStatus"] !== undefined ? _data["newStatus"] : <any>null;
        }
    }

    static fromJS(data: any): SetIssueStatusPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SetIssueStatusPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["oldStatus"] = this.oldStatus !== undefined ? this.oldStatus : <any>null;
        data["newStatus"] = this.newStatus !== undefined ? this.newStatus : <any>null;
        return data;
    }
}

export interface ISetIssueStatusPayload {
    notes: string | null;
    issueId: string;
    oldStatus: IssueStatus;
    newStatus: IssueStatus;
}

export class CloseIssuePayload implements ICloseIssuePayload {
    oldStatus: IssueStatus;
    notes: string | null;
    issueId: string;
    rating: number | null;
    [immerable] = true;

    constructor(data?: ICloseIssuePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldStatus = _data["oldStatus"] !== undefined ? _data["oldStatus"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
        }
    }

    static fromJS(data: any): CloseIssuePayload {
        data = typeof data === 'object' ? data : {};
        let result = new CloseIssuePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldStatus"] = this.oldStatus !== undefined ? this.oldStatus : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        return data;
    }
}

export interface ICloseIssuePayload {
    oldStatus: IssueStatus;
    notes: string | null;
    issueId: string;
    rating: number | null;
}

export class MarkIssuePaidPayload implements IMarkIssuePaidPayload {
    oldStatus: IssueStatus;
    notes: string | null;
    issueId: string;
    rating: number | null;
    [immerable] = true;

    constructor(data?: IMarkIssuePaidPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldStatus = _data["oldStatus"] !== undefined ? _data["oldStatus"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
        }
    }

    static fromJS(data: any): MarkIssuePaidPayload {
        data = typeof data === 'object' ? data : {};
        let result = new MarkIssuePaidPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldStatus"] = this.oldStatus !== undefined ? this.oldStatus : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        return data;
    }
}

export interface IMarkIssuePaidPayload {
    oldStatus: IssueStatus;
    notes: string | null;
    issueId: string;
    rating: number | null;
}

export class CancelIssuePayload implements ICancelIssuePayload {
    oldStatus: IssueStatus;
    newStatus: IssueStatus;
    notes: string | null;
    issueId: string;
    rating: number | null;
    [immerable] = true;

    constructor(data?: ICancelIssuePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldStatus = _data["oldStatus"] !== undefined ? _data["oldStatus"] : <any>null;
            this.newStatus = _data["newStatus"] !== undefined ? _data["newStatus"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : <any>null;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
        }
    }

    static fromJS(data: any): CancelIssuePayload {
        data = typeof data === 'object' ? data : {};
        let result = new CancelIssuePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldStatus"] = this.oldStatus !== undefined ? this.oldStatus : <any>null;
        data["newStatus"] = this.newStatus !== undefined ? this.newStatus : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["issueId"] = this.issueId !== undefined ? this.issueId : <any>null;
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        return data;
    }
}

export interface ICancelIssuePayload {
    oldStatus: IssueStatus;
    newStatus: IssueStatus;
    notes: string | null;
    issueId: string;
    rating: number | null;
}

export class ContactFormSubmissionPayload implements IContactFormSubmissionPayload {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    message: string | null;
    [immerable] = true;

    constructor(data?: IContactFormSubmissionPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): ContactFormSubmissionPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ContactFormSubmissionPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }
}

export interface IContactFormSubmissionPayload {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    message: string | null;
}

export class PayInvoiceInfo implements IPayInvoiceInfo {
    friendlyId: string | null;
    status: InvoiceStatus;
    paymentOptions: PaymentOption[] | null;
    [immerable] = true;

    constructor(data?: IPayInvoiceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.paymentOptions) {
                this.paymentOptions = [];
                for (let i = 0; i < data.paymentOptions.length; i++) {
                    let item = data.paymentOptions[i];
                    this.paymentOptions[i] = item && !(<any>item).toJSON ? new PaymentOption(item) : <PaymentOption>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendlyId = _data["friendlyId"] !== undefined ? _data["friendlyId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["paymentOptions"])) {
                this.paymentOptions = [] as any;
                for (let item of _data["paymentOptions"])
                    this.paymentOptions!.push(PaymentOption.fromJS(item));
            }
            else {
                this.paymentOptions = <any>null;
            }
        }
    }

    static fromJS(data: any): PayInvoiceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PayInvoiceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendlyId"] = this.friendlyId !== undefined ? this.friendlyId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.paymentOptions)) {
            data["paymentOptions"] = [];
            for (let item of this.paymentOptions)
                data["paymentOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPayInvoiceInfo {
    friendlyId: string | null;
    status: InvoiceStatus;
    paymentOptions: IPaymentOption[] | null;
}

export class PaymentOption implements IPaymentOption {
    chargeAmount: number;
    method: string | null;
    methodName: string | null;
    [immerable] = true;

    constructor(data?: IPaymentOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargeAmount = _data["chargeAmount"] !== undefined ? _data["chargeAmount"] : <any>null;
            this.method = _data["method"] !== undefined ? _data["method"] : <any>null;
            this.methodName = _data["methodName"] !== undefined ? _data["methodName"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentOption {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargeAmount"] = this.chargeAmount !== undefined ? this.chargeAmount : <any>null;
        data["method"] = this.method !== undefined ? this.method : <any>null;
        data["methodName"] = this.methodName !== undefined ? this.methodName : <any>null;
        return data;
    }
}

export interface IPaymentOption {
    chargeAmount: number;
    method: string | null;
    methodName: string | null;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}